(function () {
  var DEFAULT_CLARITY_PROJECT_ID = 'uvskaqorur';
  var eventDedupCache = {};
  var eventDedupTtlMs = 15 * 60 * 1000;
  var SUPPRESS_BROWSER_POPUPS = true;
  var HIDE_COOKIE_BANNER_IN_PREVIEW = true;

  function installUserPromptGuards() {
    if (!SUPPRESS_BROWSER_POPUPS || typeof window === 'undefined') return;

    try {
      window.alert = function () {};
    } catch (_errAlert) {
      // noop
    }

    try {
      window.confirm = function () {
        return false;
      };
    } catch (_errConfirm) {
      // noop
    }

    try {
      window.prompt = function () {
        return null;
      };
    } catch (_errPrompt) {
      // noop
    }

    try {
      if ('Notification' in window && window.Notification && typeof window.Notification.requestPermission === 'function') {
        window.Notification.requestPermission = function (callback) {
          if (typeof callback === 'function') {
            try {
              callback('denied');
            } catch (_errCb) {
              // noop
            }
          }
          return Promise.resolve('denied');
        };
      }
    } catch (_errNotification) {
      // noop
    }

    try {
      document.documentElement.classList.add('nb-suppress-popups');
    } catch (_errHtmlClass) {
      // noop
    }

    if (document.body) {
      try {
        document.body.classList.add('nb-suppress-popups');
      } catch (_errBodyClass) {
        // noop
      }
      return;
    }

    document.addEventListener('DOMContentLoaded', function () {
      if (!document.body) return;
      try {
        document.body.classList.add('nb-suppress-popups');
      } catch (_errBodyReadyClass) {
        // noop
      }
    }, { once: true });
  }

  installUserPromptGuards();

  function getLocaleRoot() {
    var pathParts = (window.location.pathname || '').split('/').filter(Boolean);
    if (pathParts.length) {
      return String(pathParts[0]).toLowerCase().split('-')[0];
    }
    return String(document.documentElement.getAttribute('lang') || '').toLowerCase().split('-')[0];
  }

  function isEnglishStorefront() {
    if (getLocaleRoot() === 'en') return true;
    try {
      return !!(window.Shopify && String(window.Shopify.locale || '').toLowerCase() === 'en');
    } catch (_errEnglishLocale) {
      return false;
    }
  }

  function normalizeGermanPolicyCopy(scope) {
    if (!scope || !window.NodeFilter || !document.createTreeWalker) return;

    var replacements = [
      {
        pattern: /Vor 23:00 Uhr bestellt,\s*morgen geliefert/gi,
        value: 'Vor 17 Uhr bestellt: Versand noch heute.'
      },
      {
        pattern: /\b1-2 Werktage\b/gi,
        value: 'Versand am selben Tag'
      },
      {
        pattern: /\bSchnelle Lieferung(?:\s+aus\s+den\s+Niederlanden)?\b/gi,
        value: 'Versand am selben Tag'
      },
      {
        pattern: /\bÜber 20 Physiopraxen angeschlossen\b/gi,
        value: 'Wird in über 20 Physiopraxen genutzt'
      },
      {
        pattern: /\b20\+\s*Physiopraxen angeschlossen\b/gi,
        value: 'Wird in über 20 Physiopraxen genutzt'
      }
    ];

    var walker = document.createTreeWalker(scope, NodeFilter.SHOW_TEXT);
    var node;
    while ((node = walker.nextNode())) {
      if (!node || !node.parentElement) continue;
      var parentTag = (node.parentElement.tagName || '').toUpperCase();
      if (
        parentTag === 'SCRIPT' ||
        parentTag === 'STYLE' ||
        parentTag === 'NOSCRIPT' ||
        parentTag === 'TEMPLATE' ||
        parentTag === 'TEXTAREA'
      ) {
        continue;
      }
      var original = node.nodeValue || '';
      if (!original) continue;
      var normalized = original;
      for (var i = 0; i < replacements.length; i += 1) {
        normalized = normalized.replace(replacements[i].pattern, replacements[i].value);
      }
      if (normalized !== original) {
        node.nodeValue = normalized;
      }
    }
  }

  function installGermanCopyGuards() {
    if (typeof window === 'undefined' || typeof document === 'undefined') return;
    if (getLocaleRoot() !== 'de') return;

    var selectorFixes = [
      {
        selector: '.nb-header__microproof-pill span',
        expected: 'Vor 17 Uhr bestellt: Versand noch heute.',
        bad: ['Vor 23:00 Uhr bestellt, morgen geliefert', 'Voor 23:00 besteld, morgen in huis']
      },
      {
        selector: '.nb-feature-split__stats .nb-stat:nth-child(3) strong',
        expected: 'Versand am selben Tag',
        bad: ['1-2 Werktage', 'Schnelle Lieferung', 'Fast delivery']
      },
      {
        selector: '.nb-feature-split__proof span:nth-child(3)',
        expected: 'Wird in über 20 Physiopraxen genutzt',
        bad: ['Über 20 Physiopraxen angeschlossen', '20+ Physiopraxen angeschlossen']
      },
      {
        selector: '[data-nb-proof-practice], .nb-proof-strip .nb-proof-chip:last-child',
        expected: 'Im Einsatz in über 20 Physiopraxen',
        bad: ['Über 20 Physiopraxen angeschlossen', '20+ Physiopraxen angeschlossen']
      },
      {
        selector: '[data-nb-product-trust-shipping], .nb-trust-list li:nth-child(3) span:last-child',
        expected: 'Versand am selben Tag',
        bad: ['Schnelle Lieferung', 'Fast delivery', 'Snelle levering', 'Snelle levering vanuit Nederland']
      }
    ];

    var scheduled = false;
    var syncGermanCopy = function () {
      var root = document;
      for (var i = 0; i < selectorFixes.length; i += 1) {
        var fix = selectorFixes[i];
        var nodes = root.querySelectorAll(fix.selector);
        for (var j = 0; j < nodes.length; j += 1) {
          var current = (nodes[j].textContent || '').trim();
          if (fix.bad.indexOf(current) > -1) {
            nodes[j].textContent = fix.expected;
          }
        }
      }
      normalizeGermanPolicyCopy(document.body || document.documentElement);
    };

    var scheduleSync = function () {
      if (scheduled) return;
      scheduled = true;
      window.requestAnimationFrame(function () {
        scheduled = false;
        syncGermanCopy();
      });
    };

    var start = function () {
      syncGermanCopy();
      if (!document.body || !window.MutationObserver) return;
      var observer = new MutationObserver(function () {
        scheduleSync();
      });
      observer.observe(document.body, {
        childList: true,
        subtree: true,
        characterData: true
      });
      window.addEventListener('pagehide', function () {
        observer.disconnect();
      }, { once: true });
      window.setTimeout(syncGermanCopy, 300);
      window.setTimeout(syncGermanCopy, 1200);
      window.setTimeout(syncGermanCopy, 2500);
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', start, { once: true });
    } else {
      start();
    }

    window.addEventListener('load', function () {
      syncGermanCopy();
    }, { once: true });
  }

  installGermanCopyGuards();

  function rewriteFrenchLocalizedLinks(scope) {
    if (!scope || !scope.querySelectorAll) return;

    var links = scope.querySelectorAll('a[href*="nordbelt.nl"]');
    for (var i = 0; i < links.length; i += 1) {
      var href = links[i].getAttribute('href') || '';
      if (!href) continue;

      try {
        var parsed = new URL(href, window.location.origin);
        if (!/nordbelt\.nl$/i.test(parsed.hostname)) continue;

        var nextPath = parsed.pathname || '/';
        if (!/^\/fr(?:-fr)?(\/|$)/i.test(nextPath)) {
          nextPath = '/fr-fr' + (nextPath === '/' ? '' : nextPath);
        }

        parsed.protocol = window.location.protocol;
        parsed.hostname = window.location.hostname;
        parsed.port = window.location.port;
        parsed.pathname = nextPath;
        links[i].setAttribute('href', parsed.toString());
      } catch (_errFrenchLink) {
        // noop
      }
    }
  }

  function normalizeFrenchPolicyCopy(scope) {
    if (!scope || !window.NodeFilter || !document.createTreeWalker) return;

    var exactReplacements = {
      '1-2 jours ouvrables': 'Expédition le jour même',
      'Livraison rapide': 'Expédition le jour même',
      'Livraison rapide.': 'Expédition le jour même.',
      'Immédiatement disponible': 'Disponible',
      'Livré immédiatement, paiement sécurisé sans détour': 'Ajout direct à la commande, paiement sécurisé sans détour',
      'Livré directement avec votre commande': 'Ajouté directement à votre commande',
      'Request a quote': 'Demander un devis',
      'For Medical Staff': 'Professionnels de la santé',
      'Nordbelt for healthcare professionals': "Nordbelt aide les kinésithérapeutes, préparateurs physiques et équipes médicales à mettre en place un travail progressif des ischio-jambiers dans un cadre reproductible.",
      'Welcome to Nordbelt, the premier solution for enhancing your athletes’ hamstring strength with the innovative Nordic Hamstring Curl. Whether you’re a coach seeking to equip an entire football team or a physiotherapist aiming to provide superior care to your clients, we are here to meet your needs.': "Vous souhaitez équiper un cabinet, une équipe ou une organisation avec Nordbelt ? Envoyez-nous votre demande et nous vous répondrons avec une proposition claire, adaptée à votre contexte.",
      'Safety report following ISO-20957 guidelines': 'Rapport de sécurité (ISO 20957)',
      'At Nordbelt we highly think of quality. Our Nordbelt can support up to 1780 Newton meters of pulling force wich is 6 times more then needed for a person of 122,8kg. Check here more about safety!': "Chez Nordbelt, la sécurité du produit est un point central. Nordbelt supporte jusqu'à 1 780 newtons de force de traction, soit une marge largement suffisante pour l'usage prévu dans le cadre des exercices de type Nordic Hamstring Curl.",
      'Sliders to perform eccentric hamstring bridges at home.': "Les Sliders Nordbelt permettent de réaliser des ponts ischio-jambiers excentriques et d'autres variations de contrôle à la maison.",
      'Cordon': 'Ischio-jambiers',
      'Nouvelles': 'Actualités'
    };

    var walker = document.createTreeWalker(scope, NodeFilter.SHOW_TEXT);
    var node;
    while ((node = walker.nextNode())) {
      if (!node || !node.parentElement) continue;
      var parentTag = (node.parentElement.tagName || '').toUpperCase();
      if (
        parentTag === 'SCRIPT' ||
        parentTag === 'STYLE' ||
        parentTag === 'NOSCRIPT' ||
        parentTag === 'TEMPLATE' ||
        parentTag === 'TEXTAREA'
      ) {
        continue;
      }

      var original = node.nodeValue || '';
      var trimmed = original.trim();
      if (!trimmed || !exactReplacements[trimmed]) continue;

      node.nodeValue = original.replace(trimmed, exactReplacements[trimmed]);
    }
  }

  var frenchOverrideAssetState = {
    loading: false,
    loaded: false,
    failed: false,
    callbacks: []
  };

  var germanOverrideAssetState = {
    loading: false,
    loaded: false,
    failed: false,
    callbacks: []
  };

  var englishOverrideAssetState = {
    loading: false,
    loaded: false,
    failed: false,
    callbacks: []
  };

  var swedishOverrideAssetState = {
    loading: false,
    loaded: false,
    failed: false,
    callbacks: []
  };

  var estonianOverrideAssetState = {
    loading: false,
    loaded: false,
    failed: false,
    callbacks: []
  };

  var finnishOverrideAssetState = {
    loading: false,
    loaded: false,
    failed: false,
    callbacks: []
  };

  var norwegianOverrideAssetState = {
    loading: false,
    loaded: false,
    failed: false,
    callbacks: []
  };

  var danishOverrideAssetState = {
    loading: false,
    loaded: false,
    failed: false,
    callbacks: []
  };

  var spanishOverrideAssetState = {
    loading: false,
    loaded: false,
    failed: false,
    callbacks: []
  };

  var italianOverrideAssetState = {
    loading: false,
    loaded: false,
    failed: false,
    callbacks: []
  };

  function resolveThemeSiblingAssetUrl(fileName) {
    if (!fileName) return '';

    var scripts = document.querySelectorAll('script[src]');
    var source = '';
    for (var i = 0; i < scripts.length; i += 1) {
      var src = scripts[i].getAttribute('src') || '';
      if (/\/assets\/theme-r45\.js(?:\?|$)/i.test(src)) {
        source = src;
        break;
      }
    }

    if (!source && document.currentScript && document.currentScript.src) {
      source = document.currentScript.src;
    }
    if (!source) return '';

    try {
      var parsed = new URL(source, window.location.href);
      parsed.pathname = parsed.pathname.replace(/\/assets\/[^/?#]+$/i, '/assets/' + fileName);
      if (!parsed.search) {
        parsed.search = '?nbv=20260506-blog-overrides-r3';
      }
      parsed.hash = '';
      return parsed.toString();
    } catch (_errThemeAssetUrl) {
      return '';
    }
  }

  function flushFrenchOverrideCallbacks() {
    if (!frenchOverrideAssetState.callbacks.length) return;
    var callbacks = frenchOverrideAssetState.callbacks.slice();
    frenchOverrideAssetState.callbacks = [];
    for (var i = 0; i < callbacks.length; i += 1) {
      try {
        callbacks[i]();
      } catch (_errFrenchOverrideCallback) {
        // noop
      }
    }
  }

  function ensureFrenchOverrideAsset(onReady) {
    if (typeof onReady === 'function') {
      frenchOverrideAssetState.callbacks.push(onReady);
    }

    if (window.NordbeltFrenchArticleOverrides) {
      frenchOverrideAssetState.loaded = true;
      flushFrenchOverrideCallbacks();
      return;
    }

    if (frenchOverrideAssetState.loaded || frenchOverrideAssetState.failed) {
      flushFrenchOverrideCallbacks();
      return;
    }

    if (frenchOverrideAssetState.loading) return;

    var assetUrl = resolveThemeSiblingAssetUrl('fr-article-overrides.js');
    if (!assetUrl) {
      frenchOverrideAssetState.failed = true;
      flushFrenchOverrideCallbacks();
      return;
    }

    frenchOverrideAssetState.loading = true;

    var script = document.createElement('script');
    script.src = assetUrl;
    script.async = true;
    script.setAttribute('data-nb-fr-overrides', 'true');
    script.onload = function () {
      frenchOverrideAssetState.loading = false;
      frenchOverrideAssetState.loaded = true;
      flushFrenchOverrideCallbacks();
    };
    script.onerror = function () {
      frenchOverrideAssetState.loading = false;
      frenchOverrideAssetState.failed = true;
      flushFrenchOverrideCallbacks();
    };
    document.head.appendChild(script);
  }

  function flushGermanOverrideCallbacks() {
    if (!germanOverrideAssetState.callbacks.length) return;
    var callbacks = germanOverrideAssetState.callbacks.slice();
    germanOverrideAssetState.callbacks = [];
    for (var i = 0; i < callbacks.length; i += 1) {
      try {
        callbacks[i]();
      } catch (_errGermanOverrideCallback) {
        // noop
      }
    }
  }

  function ensureGermanOverrideAsset(onReady) {
    if (typeof onReady === 'function') {
      germanOverrideAssetState.callbacks.push(onReady);
    }

    if (window.NordbeltGermanArticleOverrides) {
      germanOverrideAssetState.loaded = true;
      flushGermanOverrideCallbacks();
      return;
    }

    if (germanOverrideAssetState.loaded || germanOverrideAssetState.failed) {
      flushGermanOverrideCallbacks();
      return;
    }

    if (germanOverrideAssetState.loading) return;

    var assetUrl = resolveThemeSiblingAssetUrl('de-article-overrides.js');
    if (!assetUrl) {
      germanOverrideAssetState.failed = true;
      flushGermanOverrideCallbacks();
      return;
    }

    germanOverrideAssetState.loading = true;

    var script = document.createElement('script');
    script.src = assetUrl;
    script.async = true;
    script.setAttribute('data-nb-de-overrides', 'true');
    script.onload = function () {
      germanOverrideAssetState.loading = false;
      germanOverrideAssetState.loaded = true;
      flushGermanOverrideCallbacks();
    };
    script.onerror = function () {
      germanOverrideAssetState.loading = false;
      germanOverrideAssetState.failed = true;
      flushGermanOverrideCallbacks();
    };
    document.head.appendChild(script);
  }

  function flushEnglishOverrideCallbacks() {
    if (!englishOverrideAssetState.callbacks.length) return;
    var callbacks = englishOverrideAssetState.callbacks.slice();
    englishOverrideAssetState.callbacks = [];
    for (var i = 0; i < callbacks.length; i += 1) {
      try {
        callbacks[i]();
      } catch (_errEnglishOverrideCallback) {
        // noop
      }
    }
  }

  function ensureEnglishOverrideAsset(onReady) {
    if (typeof onReady === 'function') {
      englishOverrideAssetState.callbacks.push(onReady);
    }

    if (window.NordbeltEnglishArticleOverrides) {
      englishOverrideAssetState.loaded = true;
      flushEnglishOverrideCallbacks();
      return;
    }

    if (englishOverrideAssetState.loaded || englishOverrideAssetState.failed) {
      flushEnglishOverrideCallbacks();
      return;
    }

    if (englishOverrideAssetState.loading) return;

    var assetUrl = resolveThemeSiblingAssetUrl('en-article-overrides.js');
    if (!assetUrl) {
      englishOverrideAssetState.failed = true;
      flushEnglishOverrideCallbacks();
      return;
    }

    if (assetUrl.indexOf('nbcb=') === -1) {
      assetUrl += (assetUrl.indexOf('?') === -1 ? '?' : '&') + 'nbcb=' + String(Date.now());
    }

    englishOverrideAssetState.loading = true;

    var script = document.createElement('script');
    script.src = assetUrl;
    script.async = true;
    script.setAttribute('data-nb-en-overrides', 'true');
    script.onload = function () {
      englishOverrideAssetState.loading = false;
      englishOverrideAssetState.loaded = true;
      flushEnglishOverrideCallbacks();
    };
    script.onerror = function () {
      englishOverrideAssetState.loading = false;
      englishOverrideAssetState.failed = true;
      flushEnglishOverrideCallbacks();
    };
    document.head.appendChild(script);
  }

  function flushSwedishOverrideCallbacks() {
    if (!swedishOverrideAssetState.callbacks.length) return;
    var callbacks = swedishOverrideAssetState.callbacks.slice();
    swedishOverrideAssetState.callbacks = [];
    for (var i = 0; i < callbacks.length; i += 1) {
      try {
        callbacks[i]();
      } catch (_errSwedishOverrideCallback) {
        // noop
      }
    }
  }

  function ensureSwedishOverrideAsset(onReady) {
    if (typeof onReady === 'function') {
      swedishOverrideAssetState.callbacks.push(onReady);
    }

    if (window.NordbeltSwedishArticleOverrides) {
      swedishOverrideAssetState.loaded = true;
      flushSwedishOverrideCallbacks();
      return;
    }

    if (swedishOverrideAssetState.loaded || swedishOverrideAssetState.failed) {
      flushSwedishOverrideCallbacks();
      return;
    }

    if (swedishOverrideAssetState.loading) return;

    var assetUrl = resolveThemeSiblingAssetUrl('sv-article-overrides.js');
    if (!assetUrl) {
      swedishOverrideAssetState.failed = true;
      flushSwedishOverrideCallbacks();
      return;
    }

    if (assetUrl.indexOf('nbcb=') === -1) {
      assetUrl += (assetUrl.indexOf('?') === -1 ? '?' : '&') + 'nbcb=' + String(Date.now());
    }

    swedishOverrideAssetState.loading = true;

    var script = document.createElement('script');
    script.src = assetUrl;
    script.async = true;
    script.setAttribute('data-nb-sv-overrides', 'true');
    script.onload = function () {
      swedishOverrideAssetState.loading = false;
      swedishOverrideAssetState.loaded = true;
      flushSwedishOverrideCallbacks();
    };
    script.onerror = function () {
      swedishOverrideAssetState.loading = false;
      swedishOverrideAssetState.failed = true;
      flushSwedishOverrideCallbacks();
    };
    document.head.appendChild(script);
  }

  function flushDanishOverrideCallbacks() {
    if (!danishOverrideAssetState.callbacks.length) return;
    var callbacks = danishOverrideAssetState.callbacks.slice();
    danishOverrideAssetState.callbacks = [];
    for (var i = 0; i < callbacks.length; i += 1) {
      try {
        callbacks[i]();
      } catch (_errDanishOverrideCallback) {
        // noop
      }
    }
  }

  function ensureDanishOverrideAsset(onReady) {
    if (typeof onReady === 'function') {
      danishOverrideAssetState.callbacks.push(onReady);
    }

    if (window.NordbeltDanishArticleOverrides) {
      danishOverrideAssetState.loaded = true;
      flushDanishOverrideCallbacks();
      return;
    }

    if (danishOverrideAssetState.loaded || danishOverrideAssetState.failed) {
      flushDanishOverrideCallbacks();
      return;
    }

    if (danishOverrideAssetState.loading) return;

    var assetUrl = resolveThemeSiblingAssetUrl('da-article-overrides.js');
    if (!assetUrl) {
      danishOverrideAssetState.failed = true;
      flushDanishOverrideCallbacks();
      return;
    }

    if (assetUrl.indexOf('nbcb=') === -1) {
      assetUrl += (assetUrl.indexOf('?') === -1 ? '?' : '&') + 'nbcb=' + String(Date.now());
    }

    danishOverrideAssetState.loading = true;

    var script = document.createElement('script');
    script.src = assetUrl;
    script.async = true;
    script.setAttribute('data-nb-da-overrides', 'true');
    script.onload = function () {
      danishOverrideAssetState.loading = false;
      danishOverrideAssetState.loaded = true;
      flushDanishOverrideCallbacks();
    };
    script.onerror = function () {
      danishOverrideAssetState.loading = false;
      danishOverrideAssetState.failed = true;
      flushDanishOverrideCallbacks();
    };
    document.head.appendChild(script);
  }

  function flushEstonianOverrideCallbacks() {
    if (!estonianOverrideAssetState.callbacks.length) return;
    var callbacks = estonianOverrideAssetState.callbacks.slice();
    estonianOverrideAssetState.callbacks = [];
    for (var i = 0; i < callbacks.length; i += 1) {
      try {
        callbacks[i]();
      } catch (_errEstonianOverrideCallback) {
        // noop
      }
    }
  }

  function ensureEstonianOverrideAsset(onReady) {
    if (typeof onReady === 'function') {
      estonianOverrideAssetState.callbacks.push(onReady);
    }

    if (window.NordbeltEstonianArticleOverrides) {
      estonianOverrideAssetState.loaded = true;
      flushEstonianOverrideCallbacks();
      return;
    }

    if (estonianOverrideAssetState.loaded || estonianOverrideAssetState.failed) {
      flushEstonianOverrideCallbacks();
      return;
    }

    if (estonianOverrideAssetState.loading) return;

    var assetUrl = resolveThemeSiblingAssetUrl('et-article-overrides.js');
    if (!assetUrl) {
      estonianOverrideAssetState.failed = true;
      flushEstonianOverrideCallbacks();
      return;
    }

    if (assetUrl.indexOf('nbcb=') === -1) {
      assetUrl += (assetUrl.indexOf('?') === -1 ? '?' : '&') + 'nbcb=' + String(Date.now());
    }

    estonianOverrideAssetState.loading = true;

    var script = document.createElement('script');
    script.src = assetUrl;
    script.async = true;
    script.setAttribute('data-nb-et-overrides', 'true');
    script.onload = function () {
      estonianOverrideAssetState.loading = false;
      estonianOverrideAssetState.loaded = true;
      flushEstonianOverrideCallbacks();
    };
    script.onerror = function () {
      estonianOverrideAssetState.loading = false;
      estonianOverrideAssetState.failed = true;
      flushEstonianOverrideCallbacks();
    };
    document.head.appendChild(script);
  }

  function flushSpanishOverrideCallbacks() {
    if (!spanishOverrideAssetState.callbacks.length) return;
    var callbacks = spanishOverrideAssetState.callbacks.slice();
    spanishOverrideAssetState.callbacks = [];
    for (var i = 0; i < callbacks.length; i += 1) {
      try {
        callbacks[i]();
      } catch (_errSpanishOverrideCallback) {
        // noop
      }
    }
  }

  function flushFinnishOverrideCallbacks() {
    if (!finnishOverrideAssetState.callbacks.length) return;
    var callbacks = finnishOverrideAssetState.callbacks.slice();
    finnishOverrideAssetState.callbacks = [];
    for (var i = 0; i < callbacks.length; i += 1) {
      try {
        callbacks[i]();
      } catch (_errFinnishOverrideCallback) {
        // noop
      }
    }
  }

  function ensureFinnishOverrideAsset(onReady) {
    if (typeof onReady === 'function') {
      finnishOverrideAssetState.callbacks.push(onReady);
    }

    if (window.NordbeltFinnishArticleOverrides) {
      finnishOverrideAssetState.loaded = true;
      flushFinnishOverrideCallbacks();
      return;
    }

    if (finnishOverrideAssetState.loaded || finnishOverrideAssetState.failed) {
      flushFinnishOverrideCallbacks();
      return;
    }

    if (finnishOverrideAssetState.loading) return;

    var assetUrl = resolveThemeSiblingAssetUrl('fi-article-overrides.js');
    if (!assetUrl) {
      finnishOverrideAssetState.failed = true;
      flushFinnishOverrideCallbacks();
      return;
    }

    if (assetUrl.indexOf('nbcb=') === -1) {
      assetUrl += (assetUrl.indexOf('?') === -1 ? '?' : '&') + 'nbcb=' + String(Date.now());
    }

    finnishOverrideAssetState.loading = true;

    var script = document.createElement('script');
    script.src = assetUrl;
    script.async = true;
    script.setAttribute('data-nb-fi-overrides', 'true');
    script.onload = function () {
      finnishOverrideAssetState.loading = false;
      finnishOverrideAssetState.loaded = true;
      flushFinnishOverrideCallbacks();
    };
    script.onerror = function () {
      finnishOverrideAssetState.loading = false;
      finnishOverrideAssetState.failed = true;
      flushFinnishOverrideCallbacks();
    };
    document.head.appendChild(script);
  }

  function flushNorwegianOverrideCallbacks() {
    if (!norwegianOverrideAssetState.callbacks.length) return;
    var callbacks = norwegianOverrideAssetState.callbacks.slice();
    norwegianOverrideAssetState.callbacks = [];
    for (var i = 0; i < callbacks.length; i += 1) {
      try {
        callbacks[i]();
      } catch (_errNorwegianOverrideCallback) {
        // noop
      }
    }
  }

  function ensureNorwegianOverrideAsset(onReady) {
    if (typeof onReady === 'function') {
      norwegianOverrideAssetState.callbacks.push(onReady);
    }

    if (window.NordbeltNorwegianArticleOverrides) {
      norwegianOverrideAssetState.loaded = true;
      flushNorwegianOverrideCallbacks();
      return;
    }

    if (norwegianOverrideAssetState.loaded || norwegianOverrideAssetState.failed) {
      flushNorwegianOverrideCallbacks();
      return;
    }

    if (norwegianOverrideAssetState.loading) return;

    var assetUrl = resolveThemeSiblingAssetUrl('nb-article-overrides.js');
    if (!assetUrl) {
      norwegianOverrideAssetState.failed = true;
      flushNorwegianOverrideCallbacks();
      return;
    }

    if (assetUrl.indexOf('nbcb=') === -1) {
      assetUrl += (assetUrl.indexOf('?') === -1 ? '?' : '&') + 'nbcb=' + String(Date.now());
    }

    norwegianOverrideAssetState.loading = true;

    var script = document.createElement('script');
    script.src = assetUrl;
    script.async = true;
    script.setAttribute('data-nb-nb-overrides', 'true');
    script.onload = function () {
      norwegianOverrideAssetState.loading = false;
      norwegianOverrideAssetState.loaded = true;
      flushNorwegianOverrideCallbacks();
    };
    script.onerror = function () {
      norwegianOverrideAssetState.loading = false;
      norwegianOverrideAssetState.failed = true;
      flushNorwegianOverrideCallbacks();
    };
    document.head.appendChild(script);
  }

  function ensureSpanishOverrideAsset(onReady) {
    if (typeof onReady === 'function') {
      spanishOverrideAssetState.callbacks.push(onReady);
    }

    if (window.NordbeltSpanishArticleOverrides) {
      spanishOverrideAssetState.loaded = true;
      flushSpanishOverrideCallbacks();
      return;
    }

    if (spanishOverrideAssetState.loaded || spanishOverrideAssetState.failed) {
      flushSpanishOverrideCallbacks();
      return;
    }

    if (spanishOverrideAssetState.loading) return;

    var assetUrl = resolveThemeSiblingAssetUrl('es-article-overrides.js');
    if (!assetUrl) {
      spanishOverrideAssetState.failed = true;
      flushSpanishOverrideCallbacks();
      return;
    }

    if (assetUrl.indexOf('nbcb=') === -1) {
      assetUrl += (assetUrl.indexOf('?') === -1 ? '?' : '&') + 'nbcb=' + String(Date.now());
    }

    spanishOverrideAssetState.loading = true;

    var script = document.createElement('script');
    script.src = assetUrl;
    script.async = true;
    script.setAttribute('data-nb-es-overrides', 'true');
    script.onload = function () {
      spanishOverrideAssetState.loading = false;
      spanishOverrideAssetState.loaded = true;
      flushSpanishOverrideCallbacks();
    };
    script.onerror = function () {
      spanishOverrideAssetState.loading = false;
      spanishOverrideAssetState.failed = true;
      flushSpanishOverrideCallbacks();
    };
    document.head.appendChild(script);
  }

  function flushItalianOverrideCallbacks() {
    if (!italianOverrideAssetState.callbacks.length) return;
    var callbacks = italianOverrideAssetState.callbacks.slice();
    italianOverrideAssetState.callbacks = [];
    for (var i = 0; i < callbacks.length; i += 1) {
      try {
        callbacks[i]();
      } catch (_errItalianOverrideCallback) {
        // noop
      }
    }
  }

  function ensureItalianOverrideAsset(onReady) {
    if (typeof onReady === 'function') {
      italianOverrideAssetState.callbacks.push(onReady);
    }

    if (window.NordbeltItalianArticleOverrides) {
      italianOverrideAssetState.loaded = true;
      flushItalianOverrideCallbacks();
      return;
    }

    if (italianOverrideAssetState.loaded || italianOverrideAssetState.failed) {
      flushItalianOverrideCallbacks();
      return;
    }

    if (italianOverrideAssetState.loading) return;

    var assetUrl = resolveThemeSiblingAssetUrl('it-article-overrides.js');
    if (!assetUrl) {
      italianOverrideAssetState.failed = true;
      flushItalianOverrideCallbacks();
      return;
    }

    if (assetUrl.indexOf('nbcb=') === -1) {
      assetUrl += (assetUrl.indexOf('?') === -1 ? '?' : '&') + 'nbcb=' + String(Date.now());
    }

    italianOverrideAssetState.loading = true;

    var script = document.createElement('script');
    script.src = assetUrl;
    script.async = true;
    script.setAttribute('data-nb-it-overrides', 'true');
    script.onload = function () {
      italianOverrideAssetState.loading = false;
      italianOverrideAssetState.loaded = true;
      flushItalianOverrideCallbacks();
    };
    script.onerror = function () {
      italianOverrideAssetState.loading = false;
      italianOverrideAssetState.failed = true;
      flushItalianOverrideCallbacks();
    };
    document.head.appendChild(script);
  }

  function setNodeText(node, value) {
    if (!node || value == null) return;
    var next = String(value);
    if ((node.textContent || '').trim() === next.trim()) return;
    node.textContent = next;
  }

  var NB_PRACTICE_SEO_COPY = {
    nl: {
      anchors: {
        nhc: 'Nordic Hamstring Curl voor fysiopraktijken',
        physio: 'Nordbelt voor fysiotherapeuten',
        packages: 'praktijkpakketten voor fysiopraktijken',
        home: 'thuispakket voor hamstringrevalidatie'
      },
      sentences: {
        professional: ['Voor zorgprofessionals die deze oefening begeleid willen inzetten is er ook ', '.'],
        physioSetup: ['Voor praktijkgebruik en thuisopbouw kan ', ' daarbij als vaste setup dienen.'],
        practicePackages: ['Voor praktijken die dezelfde opbouw in behandelkamer en thuis willen borgen zijn er ook ', '.'],
        homeRehab: ['Wanneer de oefening onderdeel is van begeleide revalidatie, sluit dit ook aan op een ', '.'],
        laterPhase: ['In een latere fase kan ', ' helpen om praktijkbegeleiding en gecontroleerde thuisopbouw te verbinden.']
      }
    },
    en: {
      anchors: {
        nhc: 'Nordic Hamstring Curl for clinics',
        physio: 'Nordbelt for physiotherapists',
        packages: 'practice packages for clinics',
        home: 'home kit for hamstring rehabilitation'
      },
      sentences: {
        professional: ['For professional use, ', ' gives clinics a practical route from explanation to implementation.'],
        physioSetup: ['For supervised use in clinic and at home, ', ' keeps the setup consistent.'],
        practicePackages: ['For clinics that want to keep the same progression in treatment and at home, ', ' are the business route.'],
        homeRehab: ['When the exercise is part of supervised rehab, a ', ' helps keep the home setup consistent.'],
        laterPhase: ['In a later phase, ', ' can help bridge clinic guidance and controlled home progression.']
      }
    },
    de: {
      anchors: {
        nhc: 'Nordic Hamstring Curl für Praxen',
        physio: 'Nordbelt für Physiotherapiepraxen',
        packages: 'Praxispakete für Physiotherapiepraxen',
        home: 'Heimset für die Hamstring-Rehabilitation'
      },
      sentences: {
        professional: ['Für den professionellen Einsatz bietet ', ' Praxen einen klaren Weg von der Erklärung zur Umsetzung.'],
        physioSetup: ['Für betreute Anwendung in Praxis und Zuhause sorgt ', ' für eine einheitliche Übungsumgebung.'],
        practicePackages: ['Für Praxen, die denselben Aufbau in Behandlung und Heimtraining sichern wollen, sind ', ' der passende Geschäftsweg.'],
        homeRehab: ['Wenn die Übung Teil einer betreuten Reha ist, hilft ein ', ', das Heimtraining konsistent umzusetzen.'],
        laterPhase: ['In einer späteren Phase kann ', ' helfen, Praxisanleitung und kontrollierten Aufbau zu Hause zu verbinden.']
      }
    },
    fr: {
      anchors: {
        nhc: 'Nordic Hamstring Curl pour les cabinets',
        physio: 'Nordbelt pour les cabinets de kinésithérapie',
        packages: 'packs cabinet pour kinésithérapeutes',
        home: 'kit à domicile pour la rééducation des ischio-jambiers'
      },
      sentences: {
        professional: ["Pour un usage professionnel, ", " aide les cabinets à passer de l'explication à la mise en pratique."],
        physioSetup: ['Pour une utilisation encadrée au cabinet et à domicile, ', ' garde la même logique de setup.'],
        practicePackages: ['Pour les cabinets qui veulent garder la même progression entre séance et domicile, les ', ' sont la route professionnelle.'],
        homeRehab: ["Lorsque l'exercice fait partie d'une rééducation encadrée, un ", ' aide à garder un setup cohérent à domicile.'],
        laterPhase: ['Dans une phase ultérieure, ', ' peut relier les consignes du cabinet à une progression contrôlée à domicile.']
      }
    },
    sv: {
      anchors: {
        nhc: 'Nordic Hamstring Curl för kliniker',
        physio: 'Nordbelt för fysioterapeuter',
        packages: 'klinikpaket för fysioterapeuter',
        home: 'hemmapaket för hamstringrehabilitering'
      },
      sentences: {
        professional: ['För professionell användning ger ', ' kliniker en praktisk väg från förklaring till genomförande.'],
        physioSetup: ['För handledd användning på klinik och hemma håller ', ' setupen konsekvent.'],
        practicePackages: ['För kliniker som vill behålla samma progression i behandling och hemmaträning är ', ' den praktiska vägen.'],
        homeRehab: ['När övningen ingår i handledd rehab hjälper ett ', ' till att hålla hemmauppsättningen konsekvent.'],
        laterPhase: ['I en senare fas kan ', ' koppla ihop klinikens vägledning med kontrollerad progression hemma.']
      }
    },
    da: {
      anchors: {
        nhc: 'Nordic Hamstring Curl til klinikker',
        physio: 'Nordbelt til fysioterapeuter',
        packages: 'klinikpakker til fysioterapeuter',
        home: 'hjemmepakke til hamstringrehabilitering'
      },
      sentences: {
        professional: ['Til professionel brug giver ', ' klinikker en praktisk vej fra forklaring til implementering.'],
        physioSetup: ['Til superviseret brug i klinikken og hjemme holder ', ' opsætningen ensartet.'],
        practicePackages: ['For klinikker, der vil bevare samme progression i behandling og hjemmetræning, er ', ' den praktiske løsning.'],
        homeRehab: ['Når øvelsen er del af superviseret genoptræning, hjælper en ', ' med at holde hjemmeopsætningen ensartet.'],
        laterPhase: ['I en senere fase kan ', ' forbinde klinisk vejledning med kontrolleret progression hjemme.']
      }
    },
    nb: {
      anchors: {
        nhc: 'Nordic Hamstring Curl for klinikker',
        physio: 'Nordbelt for fysioterapeuter',
        packages: 'klinikkpakker for fysioterapeuter',
        home: 'hjemmepakke for hamstringrehabilitering'
      },
      sentences: {
        professional: ['For profesjonell bruk gir ', ' klinikker en praktisk vei fra forklaring til gjennomføring.'],
        physioSetup: ['For veiledet bruk på klinikk og hjemme holder ', ' oppsettet konsekvent.'],
        practicePackages: ['For klinikker som vil beholde samme progresjon i behandling og hjemmetrening, er ', ' den praktiske løsningen.'],
        homeRehab: ['Når øvelsen er en del av veiledet rehabilitering, hjelper en ', ' med å holde hjemmeoppsettet konsekvent.'],
        laterPhase: ['I en senere fase kan ', ' koble klinikkens veiledning med kontrollert progresjon hjemme.']
      }
    },
    fi: {
      anchors: {
        nhc: 'Nordic Hamstring Curl fysioterapiaklinikoille',
        physio: 'Nordbelt fysioterapeuteille',
        packages: 'klinikkapaketit fysioterapeuteille',
        home: 'kotipaketti hamstring-kuntoutukseen'
      },
      sentences: {
        professional: ['Ammattilaiskäytössä ', ' auttaa klinikoita viemään ohjeet käytännön toteutukseen.'],
        physioSetup: ['Ohjatussa käytössä klinikalla ja kotona ', ' pitää harjoitusasetelman yhtenäisenä.'],
        practicePackages: ['Klinikoille, jotka haluavat säilyttää saman progression hoidossa ja kotiharjoittelussa, ', ' ovat käytännöllinen ratkaisu.'],
        homeRehab: ['Kun harjoitus on osa ohjattua kuntoutusta, ', ' auttaa pitämään kotiharjoittelun asetelman yhtenäisenä.'],
        laterPhase: ['Myöhemmässä vaiheessa ', ' voi yhdistää klinikan ohjeistuksen ja hallitun kotiprogression.']
      }
    },
    et: {
      anchors: {
        nhc: 'Nordic Hamstring Curl füsioteraapiakliinikutele',
        physio: 'Nordbelt füsioterapeutidele',
        packages: 'kliinikupaketid füsioterapeutidele',
        home: 'kodupakett hamstringu taastusraviks'
      },
      sentences: {
        professional: ['Professionaalses kasutuses aitab ', ' kliinikutel liikuda selgitusest praktilise rakenduseni.'],
        physioSetup: ['Juhendatud kasutuses kliinikus ja kodus hoiab ', ' harjutuse ülesehituse ühtlasena.'],
        practicePackages: ['Kliinikutele, kes tahavad hoida sama progressiooni ravis ja koduses harjutamises, sobivad ', '.'],
        homeRehab: ['Kui harjutus on osa juhendatud taastusravist, aitab ', ' koduse ülesehituse ühtlasena hoida.'],
        laterPhase: ['Hilisemas faasis aitab ', ' siduda kliiniku juhendamise kontrollitud koduse arenguga.']
      }
    },
    es: {
      anchors: {
        nhc: 'Nordic Hamstring Curl para clínicas',
        physio: 'Nordbelt para fisioterapeutas',
        packages: 'packs para clínicas de fisioterapia',
        home: 'kit para rehabilitación de isquiotibiales en casa'
      },
      sentences: {
        professional: ['Para uso profesional, ', ' ayuda a las clínicas a pasar de la explicación a la aplicación práctica.'],
        physioSetup: ['Para uso supervisado en clínica y en casa, ', ' mantiene una configuración constante.'],
        practicePackages: ['Para clínicas que quieren mantener la misma progresión en tratamiento y trabajo en casa, los ', ' son la ruta profesional.'],
        homeRehab: ['Cuando el ejercicio forma parte de una rehabilitación supervisada, un ', ' ayuda a mantener constante la configuración en casa.'],
        laterPhase: ['En una fase posterior, ', ' puede conectar la guía clínica con una progresión controlada en casa.']
      }
    },
    it: {
      anchors: {
        nhc: 'Nordic Hamstring Curl per studi di fisioterapia',
        physio: 'Nordbelt per fisioterapisti',
        packages: 'pacchetti per studi di fisioterapia',
        home: 'kit domestico per la riabilitazione degli hamstring'
      },
      sentences: {
        professional: ["Per l'uso professionale, ", " aiuta gli studi a passare dalla spiegazione all'applicazione pratica."],
        physioSetup: ['Per un uso guidato in studio e a casa, ', ' mantiene coerente il setup.'],
        practicePackages: ['Per gli studi che vogliono mantenere la stessa progressione tra trattamento e lavoro a casa, i ', ' sono il percorso professionale.'],
        homeRehab: ["Quando l'esercizio fa parte di una riabilitazione guidata, un ", ' aiuta a mantenere coerente il setup domestico.'],
        laterPhase: ['In una fase successiva, ', ' può collegare la guida dello studio alla progressione controllata a casa.']
      }
    },
    pt: {
      anchors: {
        nhc: 'Nordic Hamstring Curl para clínicas',
        physio: 'Nordbelt para fisioterapeutas',
        packages: 'pacotes para clínicas de fisioterapia',
        home: 'kit doméstico para reabilitação dos isquiotibiais'
      },
      sentences: {
        professional: ['Para uso profissional, ', ' ajuda as clínicas a passar da explicação à aplicação prática.'],
        physioSetup: ['Para uso supervisionado na clínica e em casa, ', ' mantém a configuração consistente.'],
        practicePackages: ['Para clínicas que querem manter a mesma progressão no tratamento e no trabalho em casa, os ', ' são a rota profissional.'],
        homeRehab: ['Quando o exercício faz parte de uma reabilitação supervisionada, um ', ' ajuda a manter a configuração em casa consistente.'],
        laterPhase: ['Numa fase posterior, ', ' pode ligar a orientação clínica a uma progressão controlada em casa.']
      }
    }
  };

  var NB_PRACTICE_SEO_ARTICLES = {
    'alles-over-de-nordic-hamstring-curl-en-hamstring-curls': {
      anchor: 'nhc',
      sentence: 'professional',
      terms: ['physio', 'fysio', 'fisioter', 'kiné', 'klinik', 'clinic', 'prax', 'praksis', 'therap', 'terapeut', 'profession', 'kliin', 'kuntout', 'taast', 'reabilit', 'rehab']
    },
    'behandeling-van-hamstringblessures-eerste-hulp-herstel-en-oefeningen': {
      anchor: 'physio',
      sentence: 'physioSetup',
      terms: ['fysiotherapie', 'physiotherapy', 'physiotherapist', 'fisioterapia', 'fisioterapeuta', 'fisioterapista', 'kinésithérapie', 'kinésithérapeute', 'fysioterapi', 'fysioterapeut', 'physio', 'therap', 'terapeut']
    },
    'hamstring-tendinopathie-en-hamstring-tendinitis-behandeling-en-herstel': {
      anchor: 'packages',
      sentence: 'practicePackages',
      terms: ['controlled loading', 'belasting', 'belastung', 'charge', 'carga', 'carico', 'progress', 'reha', 'rehab', 'revalid', 'kuntout', 'taast', 'reabilit', 'clinic', 'klinik', 'prax', 'praksis']
    },
    'nordic-hamstring-curl-thuis-veilige-setup': {
      anchor: 'home',
      sentence: 'homeRehab',
      terms: ['home', 'thuis', 'zuhause', 'domicile', 'hemma', 'hjemme', 'hjem', 'koti', 'kodus', 'casa', 'domest', 'rehab', 'revalid', 'reabilit']
    },
    'nordic-hamstring-curl-zonder-partner': {
      anchor: 'physio',
      sentence: 'physioSetup',
      terms: ['partner', 'progress', 'regression', 'variant', 'setup', 'opsætning', 'oppsett', 'uppsättning', 'configuración', 'configuração', 'klin', 'clinic', 'prax', 'fysio', 'physio', 'fisioter']
    },
    'hamstring-oefeningen-thuis-4-week-schema': {
      anchor: 'home',
      sentence: 'homeRehab',
      terms: ['home', 'thuis', 'zuhause', 'domicile', 'hemma', 'hjemme', 'hjem', 'koti', 'kodus', 'casa', 'domest', 'schema', 'plan', 'program', 'programme', 'progress']
    },
    'hamstring-blessure-wat-te-doen-eerste-48-uur': {
      anchor: 'home',
      sentence: 'laterPhase',
      terms: ['later', 'latere', 'später', 'ultérieur', 'senare', 'senere', 'myöhem', 'hilisem', 'posterior', 'successiva', 'fysi', 'physio', 'doctor', 'arts', 'arzt', 'médecin', 'médico', 'lääkäri']
    },
    'hamstring-oefeningen-bij-pijn': {
      anchor: 'packages',
      sentence: 'practicePackages',
      terms: ['pain', 'pijn', 'schmerz', 'douleur', 'smärta', 'smerte', 'kipu', 'valu', 'dolor', 'dor', 'progress', 'strength', 'kracht', 'styrke', 'força', 'fuerza', 'forza']
    }
  };

  function getArticlePathPrefix() {
    var pathParts = (window.location.pathname || '').split('/').filter(Boolean);
    if (!pathParts.length) return '';
    var first = String(pathParts[0] || '').toLowerCase();
    if (!first || /^(blogs|pages|products|collections|cart|search|policies)$/i.test(first)) return '';
    return '/' + first;
  }

  function getPracticePagePathPrefix() {
    var prefix = getArticlePathPrefix();
    var key = prefix.replace(/^\//, '').toLowerCase();
    var fallbackPrefixes = {
      de: '/de-de',
      sv: '/sv-se',
      da: '/da-dk',
      fi: '/fi-fi',
      pt: '/pt-pt',
      'de-lu': '/de-de',
      'en-ch': '',
      'nl-be': ''
    };
    if (Object.prototype.hasOwnProperty.call(fallbackPrefixes, key)) {
      return fallbackPrefixes[key];
    }
    return prefix;
  }

  function getLocalizedPracticePageHref() {
    return getPracticePagePathPrefix() + '/pages/fysiopraktijken';
  }

  function getPracticeSeoLocaleRoot() {
    var prefix = getArticlePathPrefix();
    if (prefix) {
      return prefix.replace(/^\//, '').toLowerCase().split('-')[0];
    }
    var lang = String(document.documentElement.getAttribute('lang') || '').toLowerCase().split('-')[0];
    if (NB_PRACTICE_SEO_COPY[lang]) return lang;
    try {
      var shopifyLocale = String(window.Shopify && window.Shopify.locale ? window.Shopify.locale : '').toLowerCase().split('-')[0];
      if (NB_PRACTICE_SEO_COPY[shopifyLocale]) return shopifyLocale;
    } catch (_errPracticeLocale) {
      // noop
    }
    return isEnglishStorefront() ? 'en' : 'nl';
  }

  function getPracticeSeoCopy() {
    var localeRoot = getPracticeSeoLocaleRoot();
    return NB_PRACTICE_SEO_COPY[localeRoot] || NB_PRACTICE_SEO_COPY.en;
  }

  function getCurrentArticleHandle() {
    var articleRoot = document.querySelector('[data-nb-article-slug], [data-article-handle], article[data-handle]');
    var rawHandle = articleRoot && (
      articleRoot.getAttribute('data-nb-article-slug') ||
      articleRoot.getAttribute('data-article-handle') ||
      articleRoot.getAttribute('data-handle')
    );
    if (rawHandle) return String(rawHandle).trim();
    var pathParts = (window.location.pathname || '').split('/').filter(Boolean);
    if (!pathParts.length) return '';
    return String(pathParts[pathParts.length - 1] || '').replace(/\.html?$/i, '').trim();
  }

  function escapePracticeSeoHtml(value) {
    return String(value == null ? '' : value)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  function normalizePracticeSeoParagraphText(html) {
    return String(html || '')
      .replace(/<script[\s\S]*?<\/script>/gi, ' ')
      .replace(/<style[\s\S]*?<\/style>/gi, ' ')
      .replace(/<[^>]+>/g, ' ')
      .replace(/&nbsp;/gi, ' ')
      .replace(/&amp;/gi, '&')
      .replace(/\s+/g, ' ')
      .toLowerCase();
  }

  function paragraphMatchesPracticeSeoRule(paragraphHtml, rule) {
    if (!paragraphHtml || !rule || !rule.terms || !rule.terms.length) return false;
    var text = normalizePracticeSeoParagraphText(paragraphHtml);
    for (var i = 0; i < rule.terms.length; i += 1) {
      var term = String(rule.terms[i] || '').toLowerCase();
      if (term && text.indexOf(term) !== -1) return true;
    }
    return false;
  }

  function buildPracticeSeoSentence(rule) {
    var copy = getPracticeSeoCopy();
    if (!copy || !rule) return '';
    var anchorText = copy.anchors && copy.anchors[rule.anchor];
    var sentenceParts = copy.sentences && copy.sentences[rule.sentence];
    if (!anchorText || !sentenceParts || sentenceParts.length < 2) return '';
    var href = getLocalizedPracticePageHref();
    var linkHtml = '<a href="' + escapePracticeSeoHtml(href) + '" data-nb-practice-seo-link="true">' + escapePracticeSeoHtml(anchorText) + '</a>';
    return escapePracticeSeoHtml(sentenceParts[0]) + linkHtml + escapePracticeSeoHtml(sentenceParts[1]);
  }

  function appendPracticeSeoSentence(paragraphHtml, sentenceHtml) {
    if (!paragraphHtml || !sentenceHtml) return paragraphHtml;
    return paragraphHtml.replace(/<\/p>\s*$/i, ' ' + sentenceHtml + '</p>');
  }

  function addLocalizedPracticeSeoLinkToHtml(html, articleHandle) {
    if (!html) return html;
    var next = String(html);
    if (/href=["'][^"']*\/pages\/fysiopraktijken(?:["'#?\/]|$)/i.test(next)) return next;
    if (/\/pages\/fysiopratijken/i.test(next)) {
      next = next.replace(/\/pages\/fysiopratijken/gi, '/pages/fysiopraktijken');
    }
    var handle = String(articleHandle || getCurrentArticleHandle() || '').trim();
    var rule = NB_PRACTICE_SEO_ARTICLES[handle];
    if (!rule) return next;
    var sentenceHtml = buildPracticeSeoSentence(rule);
    if (!sentenceHtml) return next;

    var changed = false;
    var paragraphPattern = /<p\b[^>]*>[\s\S]*?<\/p>/gi;
    var matched = next.replace(paragraphPattern, function (paragraphHtml) {
      if (changed || !paragraphMatchesPracticeSeoRule(paragraphHtml, rule)) return paragraphHtml;
      changed = true;
      return appendPracticeSeoSentence(paragraphHtml, sentenceHtml);
    });
    if (changed) return matched;

    return next.replace(paragraphPattern, function (paragraphHtml) {
      if (changed) return paragraphHtml;
      changed = true;
      return appendPracticeSeoSentence(paragraphHtml, sentenceHtml);
    });
  }

  function syncLocalizedPracticeArticleLink() {
    sanitizeArticleDataAttributes(document);
    var rte = document.querySelector('.nb-article__rte');
    if (!rte) return;
    var current = rte.innerHTML || '';
    var next = addLocalizedPracticeSeoLinkToHtml(current, getCurrentArticleHandle());
    if (next && !articleBodyBaseHtmlMatches(rte, next) && next.trim() !== current.trim()) {
      rte.innerHTML = next;
      refreshArticleBodyEnhancements(rte);
    }
  }

  function installLocalizedPracticeArticleLinks() {
    var scheduleSync = function () {
      var raf = window.requestAnimationFrame || function (callback) {
        window.setTimeout(callback, 16);
      };
      raf(syncLocalizedPracticeArticleLink);
    };

    var start = function () {
      syncLocalizedPracticeArticleLink();
      if (!document.body || !window.MutationObserver) return;
      var observer = new MutationObserver(function () {
        scheduleSync();
      });
      observer.observe(document.body, {
        childList: true,
        subtree: true,
        characterData: true,
        attributes: true,
        attributeFilter: ['href']
      });
      window.addEventListener('pagehide', function () {
        observer.disconnect();
      }, { once: true });
      window.setTimeout(syncLocalizedPracticeArticleLink, 400);
      window.setTimeout(syncLocalizedPracticeArticleLink, 1400);
      window.setTimeout(syncLocalizedPracticeArticleLink, 3200);
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', start, { once: true });
    } else {
      start();
    }
  }

  function setNodeHtml(node, value) {
    if (!node || value == null) return;
    var next = String(value);
    var isArticleBody = !!(node.classList && node.classList.contains('nb-article__rte'));
    if (node.classList && node.classList.contains('nb-article__rte')) {
      next = addLocalizedPracticeSeoLinkToHtml(next, getCurrentArticleHandle());
    }
    if (isArticleBody && articleBodyBaseHtmlMatches(node, next)) return;
    if ((node.innerHTML || '').trim() === next.trim()) return;
    node.innerHTML = next;
    if (isArticleBody) {
      refreshArticleBodyEnhancements(node);
    }
  }

  function articleBodyBaseHtmlMatches(node, nextHtml) {
    if (!node) return false;
    var clone = node.cloneNode(true);
    var generated = clone.querySelectorAll('[data-nb-generated], .nb-article-toc, .nb-article-inline-conversion, .nb-article-faq');
    for (var i = 0; i < generated.length; i += 1) {
      if (generated[i] && generated[i].parentNode) {
        generated[i].parentNode.removeChild(generated[i]);
      }
    }
    return String(clone.innerHTML || '').trim() === String(nextHtml || '').trim();
  }

  function refreshArticleBodyEnhancements(node) {
    if (!node || !node.closest) return;
    var articleRoot = node.closest('[data-nb-article-conversion]');
    if (!articleRoot) return;

    delete articleRoot.dataset.nbEditorialNoiseCleaned;
    delete articleRoot.dataset.nbTocInjected;
    delete articleRoot.dataset.nbEditorialCalloutsEnhanced;
    delete articleRoot.dataset.nbInlineBlocksInjected;
    delete articleRoot.dataset.nbArticleFaqEnhanced;

    window.requestAnimationFrame(function () {
      cleanupArticleEditorialNoise(articleRoot);
      initArticleEditorialMedia(articleRoot);
      initArticleEditorialCallouts(articleRoot);
      initArticleTableOfContents(articleRoot);
      initArticleInlineConversionBlocks(articleRoot);
      initArticleFaqEnhancements(articleRoot);
      initArticleInlineProductLinkTracking(articleRoot);
      initCtaTracking();
      initBlogConversionTracking(articleRoot);
    });
  }

  function setMetaContent(selector, value) {
    if (!selector || value == null) return;
    var nodes = document.querySelectorAll(selector);
    if (!nodes || !nodes.length) return;
    for (var i = 0; i < nodes.length; i += 1) {
      var node = nodes[i];
      if (!node) continue;
      if ((node.getAttribute('content') || '') === value) continue;
      node.setAttribute('content', value);
    }
  }

  function updateDocumentTitle(value) {
    if (!value) return;
    if (document.title === value) return;
    document.title = value;
  }

  function applySeoHeadContent(titleValue, descriptionValue) {
    if (titleValue) {
      updateDocumentTitle(titleValue);
    }
    if (!descriptionValue) return;
    setMetaContent('meta[name="description"]', descriptionValue);
    setMetaContent('meta[property="og:description"]', descriptionValue);
    setMetaContent('meta[name="twitter:description"]', descriptionValue);
  }

  function scheduleSeoHeadReapply(titleValue, descriptionValue) {
    applySeoHeadContent(titleValue, descriptionValue);
    var delays = [0, 250, 1200];
    for (var i = 0; i < delays.length; i += 1) {
      (function (delay) {
        window.setTimeout(function () {
          applySeoHeadContent(titleValue, descriptionValue);
        }, delay);
      })(delays[i]);
    }
  }

  function extractBlogArticleHandle(href) {
    var input = String(href || '');
    if (!input) return '';
    try {
      var parsed = new URL(input, window.location.origin);
      var match = (parsed.pathname || '').match(/\/blogs\/[^/]+\/([^/?#]+)\/?$/i);
      return match ? decodeURIComponent(match[1]) : '';
    } catch (_errFrenchHandle) {
      var directMatch = input.match(/\/blogs\/[^/]+\/([^/?#]+)\/?$/i);
      return directMatch ? decodeURIComponent(directMatch[1]) : '';
    }
  }

  function ensureNordbeltSuffix(title) {
    var value = String(title || '').trim();
    if (!value) return 'Nordbelt™';
    if (/\|\s*Nordbelt™$/i.test(value)) return value;
    return value + ' | Nordbelt™';
  }

  function normalizeShopifyFilesHtml(html) {
    var value = String(html || '');
    if (!value) return value;

    var baseOrigin = '';
    try {
      baseOrigin = String(window.location.origin || '').replace(/\/$/, '');
    } catch (_errShopifyFilesOrigin) {
      baseOrigin = '';
    }
    if (!baseOrigin) baseOrigin = 'https://www.nordbelt.nl';

    value = value.replace(/(?:https?:)?\/\/[^"'`\s<>]+\/cdn\/shop\/files\/([^"'`\s<>?]+(?:\/[^"'`\s<>?]+)?)\?v=[^"'`\s<>]*/g, function (_match, filePath) {
      return baseOrigin + '/cdn/shop/files/' + filePath;
    });

    value = value.replace(/(<img\b[^>]*\bsrc=")((?!(?:[a-z][a-z0-9+.-]*:|\/\/))[^"/][^"]*\.(?:png|jpe?g|webp|gif|svg|avif))(")/gi, function (_match, prefix, filePath, suffix) {
      return prefix + baseOrigin + '/cdn/shop/files/' + filePath;
    });

    return value;
  }

  function applyFrenchArticleAndBlogOverrides() {
    var articleOverrides = window.NordbeltFrenchArticleOverrides || {};
    var blogOverrides = window.NordbeltFrenchBlogOverrides || {};
    var path = (window.location.pathname || '').toLowerCase();

    var articleMatch = path.match(/\/blogs\/[^/]+\/([^/?#]+)\/?$/i);
    if (articleMatch && path.indexOf('/blogs/blog-posts') > -1 && path.split('/').length > 4) {
      var articleHandle = decodeURIComponent(articleMatch[1] || '');
      var articleData = articleOverrides[articleHandle];
      if (articleData) {
        var articleSeoTitle = ensureNordbeltSuffix(articleData.metaTitle || articleData.title);
        var articleSeoDescription = articleData.metaDescription || articleData.excerpt || '';
        setNodeText(document.querySelector('.nb-article__title'), articleData.title);
        setNodeText(document.querySelector('.nb-article__deck'), articleData.excerpt);
        setNodeHtml(document.querySelector('.nb-article__rte'), normalizeShopifyFilesHtml(articleData.html));
        if (articleData.dateText) {
          setNodeText(document.querySelector('.nb-article-meta-pill.is-date'), articleData.dateText);
        }
        scheduleSeoHeadReapply(articleSeoTitle, articleSeoDescription);
        setMetaContent('meta[property="og:title"]', articleSeoTitle);
        setMetaContent('meta[name="twitter:title"]', articleSeoTitle);
      }
    }

    var blogMatch = path.match(/\/blogs\/([^/?#]+)\/?$/i);
    if (blogMatch) {
      var blogHandle = decodeURIComponent(blogMatch[1] || '');
      var blogData = blogOverrides[blogHandle];
      if (blogData) {
        var blogSeoTitle = ensureNordbeltSuffix(blogData.metaTitle || blogData.title);
        var blogSeoDescription = blogData.metaDescription || blogData.subtitle || '';
        setNodeText(document.querySelector('.nb-page-title'), blogData.title);
        setNodeText(document.querySelector('.nb-subtitle'), blogData.subtitle);
        scheduleSeoHeadReapply(blogSeoTitle, blogSeoDescription);
        setMetaContent('meta[property="og:title"]', blogSeoTitle);
        setMetaContent('meta[name="twitter:title"]', blogSeoTitle);
      }
    }

    var blogCards = document.querySelectorAll('.nb-blog-card');
    for (var i = 0; i < blogCards.length; i += 1) {
      var link = blogCards[i].querySelector('a[href*="/blogs/"]');
      if (!link) continue;
      var handle = extractBlogArticleHandle(link.getAttribute('href'));
      if (!handle) continue;
      var cardData = articleOverrides[handle];
      if (!cardData) continue;
      setNodeText(blogCards[i].querySelector('.nb-card-title'), cardData.title);
      setNodeText(blogCards[i].querySelector('.nb-card-copy'), cardData.excerpt);
      var cardImage = blogCards[i].querySelector('img');
      if (cardImage && cardData.title) {
        cardImage.setAttribute('alt', cardData.title);
      }
    }

    var productDescriptionNodes = document.querySelectorAll('[data-product-description-content], .nb-product-description__content');
    for (var k = 0; k < productDescriptionNodes.length; k += 1) {
      var descriptionNode = productDescriptionNodes[k];
      if (!descriptionNode) continue;
      var currentHtml = String(descriptionNode.innerHTML || '');
      var normalizedHtml = currentHtml
        .replace(/uten dyr maskin eller treningspartner\./g, 'uten dyrt utstyr eller treningspartner.')
        .replace(/uten partner eller dyr maskin\./g, 'uten partner eller dyrt utstyr.');
      if (normalizedHtml !== currentHtml) {
        descriptionNode.innerHTML = normalizedHtml;
      }
    }

    var norwegianSelectorFixes = [
      {
        selector: '.nb-footer__chips span',
        expected: '30 dagers returrett',
        bad: ['30-dagers returperiode']
      },
      {
        selector: '.nb-footer__muted',
        expected: 'Rotterdam, Nederland',
        bad: ['Nederland, Rotterdam 🇳🇱']
      }
    ];

    for (var m = 0; m < norwegianSelectorFixes.length; m += 1) {
      var fix = norwegianSelectorFixes[m];
      var nodes = document.querySelectorAll(fix.selector);
      for (var n = 0; n < nodes.length; n += 1) {
        var current = (nodes[n].textContent || '').trim();
        if (fix.bad.indexOf(current) > -1) {
          nodes[n].textContent = fix.expected;
        }
      }
    }
  }

  function applyGermanArticleOverrides() {
    var articleOverrides = window.NordbeltGermanArticleOverrides || {};
    var path = (window.location.pathname || '').toLowerCase();
    var articleMatch = path.match(/\/blogs\/[^/]+\/([^/?#]+)\/?$/i);
    if (articleMatch && path.indexOf('/blogs/blog-posts') > -1 && path.split('/').length > 4) {
      var articleHandle = decodeURIComponent(articleMatch[1] || '');
      var articleData = articleOverrides[articleHandle];
      if (articleData) {
        var articleSeoTitle = ensureNordbeltSuffix(articleData.metaTitle || articleData.title);
        var articleSeoDescription = articleData.metaDescription || articleData.excerpt || '';
        setNodeText(document.querySelector('.nb-article__title'), articleData.title);
        setNodeText(document.querySelector('.nb-article__deck'), articleData.excerpt);
        setNodeHtml(document.querySelector('.nb-article__rte'), normalizeShopifyFilesHtml(articleData.html));
        if (articleData.dateText) {
          setNodeText(document.querySelector('.nb-article-meta-pill.is-date'), articleData.dateText);
        }
        scheduleSeoHeadReapply(articleSeoTitle, articleSeoDescription);
        setMetaContent('meta[property="og:title"]', articleSeoTitle);
        setMetaContent('meta[name="twitter:title"]', articleSeoTitle);
      }
    }

    var blogCards = document.querySelectorAll('.nb-blog-card');
    for (var i = 0; i < blogCards.length; i += 1) {
      var link = blogCards[i].querySelector('a[href*="/blogs/"]');
      if (!link) continue;
      var handle = extractBlogArticleHandle(link.getAttribute('href'));
      if (!handle) continue;
      var cardData = articleOverrides[handle];
      if (!cardData) continue;
      setNodeText(blogCards[i].querySelector('.nb-card-title'), cardData.title);
      setNodeText(blogCards[i].querySelector('.nb-card-copy'), cardData.excerpt);
      if (cardData.dateText) {
        setNodeText(blogCards[i].querySelector('.nb-blog-card__meta span:first-child'), cardData.dateText);
      }
      var cardImage = blogCards[i].querySelector('img');
      if (cardImage && cardData.title) {
        cardImage.setAttribute('alt', cardData.title);
      }
    }
  }

  function applyEnglishArticleOverrides() {
    var articleOverrides = window.NordbeltEnglishArticleOverrides || {};
    var path = (window.location.pathname || '').toLowerCase();
    var articleMatch = path.match(/\/blogs\/[^/]+\/([^/?#]+)\/?$/i);
    if (articleMatch && path.indexOf('/blogs/blog-posts') > -1 && path.split('/').length > 3) {
      var articleHandle = decodeURIComponent(articleMatch[1] || '');
      var articleData = articleOverrides[articleHandle];
      if (articleData) {
        var articleSeoTitle = ensureNordbeltSuffix(articleData.metaTitle || articleData.title);
        var articleSeoDescription = articleData.metaDescription || articleData.excerpt || '';
        setNodeText(document.querySelector('.nb-article__title'), articleData.title);
        setNodeText(document.querySelector('.nb-article__deck'), articleData.excerpt);
        setNodeHtml(document.querySelector('.nb-article__rte'), normalizeShopifyFilesHtml(articleData.html));
        if (articleData.dateText) {
          setNodeText(document.querySelector('.nb-article-meta-pill.is-date'), articleData.dateText);
        }
        scheduleSeoHeadReapply(articleSeoTitle, articleSeoDescription);
        setMetaContent('meta[property="og:title"]', articleSeoTitle);
        setMetaContent('meta[name="twitter:title"]', articleSeoTitle);
      }
    }

    var blogCards = document.querySelectorAll('.nb-blog-card');
    for (var i = 0; i < blogCards.length; i += 1) {
      var link = blogCards[i].querySelector('a[href*="/blogs/"]');
      if (!link) continue;
      var handle = extractBlogArticleHandle(link.getAttribute('href'));
      if (!handle) continue;
      var cardData = articleOverrides[handle];
      if (!cardData) continue;
      setNodeText(blogCards[i].querySelector('.nb-card-title'), cardData.title);
      setNodeText(blogCards[i].querySelector('.nb-card-copy'), cardData.excerpt);
      if (cardData.dateText) {
        setNodeText(blogCards[i].querySelector('.nb-blog-card__meta span:first-child'), cardData.dateText);
      }
      var cardImage = blogCards[i].querySelector('img');
      if (cardImage && cardData.title) {
        cardImage.setAttribute('alt', cardData.title);
      }
    }
  }

  function applySwedishArticleOverrides() {
    var articleOverrides = window.NordbeltSwedishArticleOverrides || {};
    var path = (window.location.pathname || '').toLowerCase();
    var articleMatch = path.match(/\/blogs\/[^/]+\/([^/?#]+)\/?$/i);
    if (articleMatch && path.indexOf('/blogs/blog-posts') > -1 && path.split('/').length > 4) {
      var articleHandle = decodeURIComponent(articleMatch[1] || '');
      var articleData = articleOverrides[articleHandle];
      if (articleData) {
        var articleSeoTitle = ensureNordbeltSuffix(articleData.metaTitle || articleData.title);
        var articleSeoDescription = articleData.metaDescription || articleData.excerpt || '';
        setNodeText(document.querySelector('.nb-article__title'), articleData.title);
        setNodeText(document.querySelector('.nb-article__deck'), articleData.excerpt);
        setNodeHtml(document.querySelector('.nb-article__rte'), normalizeShopifyFilesHtml(articleData.html));
        if (articleData.dateText) {
          setNodeText(document.querySelector('.nb-article-meta-pill.is-date'), articleData.dateText);
        }
        scheduleSeoHeadReapply(articleSeoTitle, articleSeoDescription);
        setMetaContent('meta[property="og:title"]', articleSeoTitle);
        setMetaContent('meta[name="twitter:title"]', articleSeoTitle);
      }
    }

    var blogCards = document.querySelectorAll('.nb-blog-card');
    for (var i = 0; i < blogCards.length; i += 1) {
      var link = blogCards[i].querySelector('a[href*="/blogs/"]');
      if (!link) continue;
      var handle = extractBlogArticleHandle(link.getAttribute('href'));
      if (!handle) continue;
      var cardData = articleOverrides[handle];
      if (!cardData) continue;
      setNodeText(blogCards[i].querySelector('.nb-card-title'), cardData.title);
      setNodeText(blogCards[i].querySelector('.nb-card-copy'), cardData.excerpt);
      if (cardData.dateText) {
        setNodeText(blogCards[i].querySelector('.nb-blog-card__meta span:first-child'), cardData.dateText);
      }
      var cardImage = blogCards[i].querySelector('img');
      if (cardImage && cardData.title) {
        cardImage.setAttribute('alt', cardData.title);
      }
    }
  }

  function applyDanishArticleOverrides() {
    var articleOverrides = window.NordbeltDanishArticleOverrides || {};
    var path = (window.location.pathname || '').toLowerCase();
    var articleMatch = path.match(/\/blogs\/[^/]+\/([^/?#]+)\/?$/i);
    if (articleMatch && path.indexOf('/blogs/blog-posts') > -1 && path.split('/').length > 4) {
      var articleHandle = decodeURIComponent(articleMatch[1] || '');
      var articleData = articleOverrides[articleHandle];
      if (articleData) {
        var articleSeoTitle = ensureNordbeltSuffix(articleData.metaTitle || articleData.title);
        var articleSeoDescription = articleData.metaDescription || articleData.excerpt || '';
        setNodeText(document.querySelector('.nb-article__title'), articleData.title);
        setNodeText(document.querySelector('.nb-article__deck'), articleData.excerpt);
        setNodeHtml(document.querySelector('.nb-article__rte'), normalizeShopifyFilesHtml(articleData.html));
        if (articleData.dateText) {
          setNodeText(document.querySelector('.nb-article-meta-pill.is-date'), articleData.dateText);
        }
        scheduleSeoHeadReapply(articleSeoTitle, articleSeoDescription);
        setMetaContent('meta[property="og:title"]', articleSeoTitle);
        setMetaContent('meta[name="twitter:title"]', articleSeoTitle);
      }
    }

    var blogCards = document.querySelectorAll('.nb-blog-card');
    for (var i = 0; i < blogCards.length; i += 1) {
      var link = blogCards[i].querySelector('a[href*="/blogs/"]');
      if (!link) continue;
      var handle = extractBlogArticleHandle(link.getAttribute('href'));
      if (!handle) continue;
      var cardData = articleOverrides[handle];
      if (!cardData) continue;
      setNodeText(blogCards[i].querySelector('.nb-card-title'), cardData.title);
      setNodeText(blogCards[i].querySelector('.nb-card-copy'), cardData.excerpt);
      if (cardData.dateText) {
        setNodeText(blogCards[i].querySelector('.nb-blog-card__meta span:first-child'), cardData.dateText);
      }
      var cardImage = blogCards[i].querySelector('img');
      if (cardImage && cardData.title) {
        cardImage.setAttribute('alt', cardData.title);
      }
    }
  }

  function applyEstonianArticleOverrides() {
    var articleOverrides = window.NordbeltEstonianArticleOverrides || {};
    var path = (window.location.pathname || '').toLowerCase();
    var articleMatch = path.match(/\/blogs\/[^/]+\/([^/?#]+)\/?$/i);
    if (articleMatch && path.indexOf('/blogs/blog-posts') > -1 && path.split('/').length > 4) {
      var articleHandle = decodeURIComponent(articleMatch[1] || '');
      var articleData = articleOverrides[articleHandle];
      if (articleData) {
        var articleSeoTitle = ensureNordbeltSuffix(articleData.metaTitle || articleData.title);
        var articleSeoDescription = articleData.metaDescription || articleData.excerpt || '';
        setNodeText(document.querySelector('.nb-article__title'), articleData.title);
        setNodeText(document.querySelector('.nb-article__deck'), articleData.excerpt);
        setNodeHtml(document.querySelector('.nb-article__rte'), normalizeShopifyFilesHtml(articleData.html));
        if (articleData.dateText) {
          setNodeText(document.querySelector('.nb-article-meta-pill.is-date'), articleData.dateText);
        }
        scheduleSeoHeadReapply(articleSeoTitle, articleSeoDescription);
        setMetaContent('meta[property="og:title"]', articleSeoTitle);
        setMetaContent('meta[name="twitter:title"]', articleSeoTitle);
      }
    }

    var blogCards = document.querySelectorAll('.nb-blog-card');
    for (var i = 0; i < blogCards.length; i += 1) {
      var link = blogCards[i].querySelector('a[href*="/blogs/"]');
      if (!link) continue;
      var handle = extractBlogArticleHandle(link.getAttribute('href'));
      if (!handle) continue;
      var cardData = articleOverrides[handle];
      if (!cardData) continue;
      setNodeText(blogCards[i].querySelector('.nb-card-title'), cardData.title);
      setNodeText(blogCards[i].querySelector('.nb-card-copy'), cardData.excerpt);
      if (cardData.dateText) {
        setNodeText(blogCards[i].querySelector('.nb-blog-card__meta span:first-child'), cardData.dateText);
      }
      var cardImage = blogCards[i].querySelector('img');
      if (cardImage && cardData.title) {
        cardImage.setAttribute('alt', cardData.title);
      }
    }
  }

  function applySpanishArticleOverrides() {
    var articleOverrides = window.NordbeltSpanishArticleOverrides || {};
    var path = (window.location.pathname || '').toLowerCase();
    var articleMatch = path.match(/\/blogs\/[^/]+\/([^/?#]+)\/?$/i);
    if (articleMatch && path.indexOf('/blogs/blog-posts') > -1 && path.split('/').length > 4) {
      var articleHandle = decodeURIComponent(articleMatch[1] || '');
      var articleData = articleOverrides[articleHandle];
      if (articleData) {
        var articleSeoTitle = ensureNordbeltSuffix(articleData.metaTitle || articleData.title);
        var articleSeoDescription = articleData.metaDescription || articleData.excerpt || '';
        setNodeText(document.querySelector('.nb-article__title'), articleData.title);
        setNodeText(document.querySelector('.nb-article__deck'), articleData.excerpt);
        setNodeHtml(document.querySelector('.nb-article__rte'), normalizeShopifyFilesHtml(articleData.html));
        if (articleData.dateText) {
          setNodeText(document.querySelector('.nb-article-meta-pill.is-date'), articleData.dateText);
        }
        scheduleSeoHeadReapply(articleSeoTitle, articleSeoDescription);
        setMetaContent('meta[property="og:title"]', articleSeoTitle);
        setMetaContent('meta[name="twitter:title"]', articleSeoTitle);
      }
    }

    var blogCards = document.querySelectorAll('.nb-blog-card');
    for (var i = 0; i < blogCards.length; i += 1) {
      var link = blogCards[i].querySelector('a[href*="/blogs/"]');
      if (!link) continue;
      var handle = extractBlogArticleHandle(link.getAttribute('href'));
      if (!handle) continue;
      var cardData = articleOverrides[handle];
      if (!cardData) continue;
      setNodeText(blogCards[i].querySelector('.nb-card-title'), cardData.title);
      setNodeText(blogCards[i].querySelector('.nb-card-copy'), cardData.excerpt);
      if (cardData.dateText) {
        setNodeText(blogCards[i].querySelector('.nb-blog-card__meta span:first-child'), cardData.dateText);
      }
      var cardImage = blogCards[i].querySelector('img');
      if (cardImage && cardData.title) {
        cardImage.setAttribute('alt', cardData.title);
      }
    }
  }

  function applyItalianArticleOverrides() {
    var articleOverrides = window.NordbeltItalianArticleOverrides || {};
    var path = (window.location.pathname || '').toLowerCase();
    var articleMatch = path.match(/\/blogs\/[^/]+\/([^/?#]+)\/?$/i);
    if (articleMatch && path.indexOf('/blogs/blog-posts') > -1 && path.split('/').length > 4) {
      var articleHandle = decodeURIComponent(articleMatch[1] || '');
      var articleData = articleOverrides[articleHandle];
      if (articleData) {
        var articleSeoTitle = ensureNordbeltSuffix(articleData.metaTitle || articleData.title);
        var articleSeoDescription = articleData.metaDescription || articleData.excerpt || '';
        setNodeText(document.querySelector('.nb-article__title'), articleData.title);
        setNodeText(document.querySelector('.nb-article__deck'), articleData.excerpt);
        setNodeHtml(document.querySelector('.nb-article__rte'), normalizeShopifyFilesHtml(articleData.html));
        if (articleData.dateText) {
          setNodeText(document.querySelector('.nb-article-meta-pill.is-date'), articleData.dateText);
        }
        scheduleSeoHeadReapply(articleSeoTitle, articleSeoDescription);
        setMetaContent('meta[property="og:title"]', articleSeoTitle);
        setMetaContent('meta[name="twitter:title"]', articleSeoTitle);
      }
    }

    var blogCards = document.querySelectorAll('.nb-blog-card');
    for (var i = 0; i < blogCards.length; i += 1) {
      var link = blogCards[i].querySelector('a[href*="/blogs/"]');
      if (!link) continue;
      var handle = extractBlogArticleHandle(link.getAttribute('href'));
      if (!handle) continue;
      var cardData = articleOverrides[handle];
      if (!cardData) continue;
      setNodeText(blogCards[i].querySelector('.nb-card-title'), cardData.title);
      setNodeText(blogCards[i].querySelector('.nb-card-copy'), cardData.excerpt);
      if (cardData.dateText) {
        setNodeText(blogCards[i].querySelector('.nb-blog-card__meta span:first-child'), cardData.dateText);
      }
      var cardImage = blogCards[i].querySelector('img');
      if (cardImage && cardData.title) {
        cardImage.setAttribute('alt', cardData.title);
      }
    }
  }

  function applyFinnishArticleOverrides() {
    var articleOverrides = window.NordbeltFinnishArticleOverrides || {};
    var path = (window.location.pathname || '').toLowerCase();
    var articleMatch = path.match(/\/blogs\/[^/]+\/([^/?#]+)\/?$/i);
    if (articleMatch && path.indexOf('/blogs/blog-posts') > -1 && path.split('/').length > 4) {
      var articleHandle = decodeURIComponent(articleMatch[1] || '');
      var articleData = articleOverrides[articleHandle];
      if (articleData) {
        var articleSeoTitle = ensureNordbeltSuffix(articleData.metaTitle || articleData.title);
        var articleSeoDescription = articleData.metaDescription || articleData.excerpt || '';
        setNodeText(document.querySelector('.nb-article__title'), articleData.title);
        setNodeText(document.querySelector('.nb-article__deck'), articleData.excerpt);
        setNodeHtml(document.querySelector('.nb-article__rte'), normalizeShopifyFilesHtml(articleData.html));
        if (articleData.dateText) {
          setNodeText(document.querySelector('.nb-article-meta-pill.is-date'), articleData.dateText);
        }
        scheduleSeoHeadReapply(articleSeoTitle, articleSeoDescription);
        setMetaContent('meta[property="og:title"]', articleSeoTitle);
        setMetaContent('meta[name="twitter:title"]', articleSeoTitle);
      }
    }

    var blogCards = document.querySelectorAll('.nb-blog-card');
    for (var i = 0; i < blogCards.length; i += 1) {
      var link = blogCards[i].querySelector('a[href*="/blogs/"]');
      if (!link) continue;
      var handle = extractBlogArticleHandle(link.getAttribute('href'));
      if (!handle) continue;
      var cardData = articleOverrides[handle];
      if (!cardData) continue;
      setNodeText(blogCards[i].querySelector('.nb-card-title'), cardData.title);
      setNodeText(blogCards[i].querySelector('.nb-card-copy'), cardData.excerpt);
      if (cardData.dateText) {
        setNodeText(blogCards[i].querySelector('.nb-blog-card__meta span:first-child'), cardData.dateText);
      }
      var cardImage = blogCards[i].querySelector('img');
      if (cardImage && cardData.title) {
        cardImage.setAttribute('alt', cardData.title);
      }
    }
  }

  function applyNorwegianArticleOverrides() {
    var articleOverrides = window.NordbeltNorwegianArticleOverrides || {};
    var path = (window.location.pathname || '').toLowerCase();
    var articleMatch = path.match(/\/blogs\/[^/]+\/([^/?#]+)\/?$/i);
    if (articleMatch && path.indexOf('/blogs/blog-posts') > -1 && path.split('/').length > 4) {
      var articleHandle = decodeURIComponent(articleMatch[1] || '');
      var articleData = articleOverrides[articleHandle];
      if (articleData) {
        var articleSeoTitle = ensureNordbeltSuffix(articleData.metaTitle || articleData.title);
        var articleSeoDescription = articleData.metaDescription || articleData.excerpt || '';
        setNodeText(document.querySelector('.nb-article__title'), articleData.title);
        setNodeText(document.querySelector('.nb-article__deck'), articleData.excerpt);
        setNodeHtml(document.querySelector('.nb-article__rte'), normalizeShopifyFilesHtml(articleData.html));
        if (articleData.dateText) {
          setNodeText(document.querySelector('.nb-article-meta-pill.is-date'), articleData.dateText);
        }
        scheduleSeoHeadReapply(articleSeoTitle, articleSeoDescription);
        setMetaContent('meta[property="og:title"]', articleSeoTitle);
        setMetaContent('meta[name="twitter:title"]', articleSeoTitle);
      }
    }

    var blogCards = document.querySelectorAll('.nb-blog-card');
    for (var i = 0; i < blogCards.length; i += 1) {
      var link = blogCards[i].querySelector('a[href*="/blogs/"]');
      if (!link) continue;
      var handle = extractBlogArticleHandle(link.getAttribute('href'));
      if (!handle) continue;
      var cardData = articleOverrides[handle];
      if (!cardData) continue;
      setNodeText(blogCards[i].querySelector('.nb-card-title'), cardData.title);
      setNodeText(blogCards[i].querySelector('.nb-card-copy'), cardData.excerpt);
      if (cardData.dateText) {
        setNodeText(blogCards[i].querySelector('.nb-blog-card__meta span:first-child'), cardData.dateText);
      }
      var cardImage = blogCards[i].querySelector('img');
      if (cardImage && cardData.title) {
        cardImage.setAttribute('alt', cardData.title);
      }
    }
  }

  function installFrenchCopyGuards() {
    if (typeof window === 'undefined' || typeof document === 'undefined') return;
    if (getLocaleRoot() !== 'fr') return;

    var selectorFixes = [
      {
        selector: '.nb-feature-split__stats .nb-stat:nth-child(3) strong',
        expected: 'Expédition le jour même',
        bad: ['1-2 jours ouvrables', 'Livraison rapide']
      },
      {
        selector: '[data-nb-product-trust-shipping], .nb-trust-list li:nth-child(3) span:last-child',
        expected: 'Expédition le jour même',
        bad: ['Livraison rapide', '1-2 jours ouvrables']
      },
      {
        selector: '.nb-card-bullet, .nb-chip, .nb-proof-chip, .nb-trust-chip',
        expected: 'Expédition le jour même',
        bad: ['Livraison rapide', '1-2 jours ouvrables']
      },
      {
        selector: '.nb-product__status-row .nb-kicker',
        expected: 'Disponible',
        bad: ['Immédiatement disponible']
      }
    ];

    var applyFrenchPathOverrides = function () {
      var path = (window.location.pathname || '').toLowerCase();
      var titleNode = document.querySelector('.nb-page-shell__title');
      var rteNode = document.querySelector('.nb-page-shell__rte');

      if (path.indexOf('/pages/request-a-quote') > -1) {
        if (titleNode) {
          titleNode.textContent = 'Demander un devis';
        }
        if (rteNode) {
          rteNode.innerHTML = '<p>Vous souhaitez équiper un cabinet, une équipe ou une organisation avec Nordbelt ? Envoyez-nous votre demande et nous vous répondrons avec une proposition claire, adaptée à votre contexte.</p><p>Nous pouvons vous aider pour les quantités, l\'usage prévu, le déploiement pratique et les questions de facturation. L\'objectif est simple : vous permettre de démarrer rapidement avec une solution fiable pour l\'entraînement des ischio-jambiers.</p>';
        }
      }

      if (path.indexOf('/pages/healthcare-professionals') > -1) {
        if (titleNode) {
          titleNode.textContent = 'Professionnels de la santé';
        }
        if (rteNode) {
          rteNode.innerHTML = '<p>Nordbelt aide les kinésithérapeutes, préparateurs physiques et équipes médicales à mettre en place un travail progressif des ischio-jambiers dans un cadre reproductible.</p><p>L\'outil est rapide à installer, facile à doser et simple à intégrer dans des protocoles de reprise, de prévention et de renforcement. Pour une demande cabinet ou équipe, utilisez la page de devis afin que nous puissions vous répondre de manière ciblée.</p>';
        }
      }

      if (path.indexOf('/pages/safety-report-following-iso-20957-guidelines') > -1) {
        if (titleNode) {
          titleNode.textContent = 'Rapport de sécurité (ISO 20957)';
        }
        if (rteNode) {
          rteNode.innerHTML = '<p>Chez Nordbelt, la sécurité du produit est un point central. Nordbelt supporte jusqu\'à <strong>1 780 newtons</strong> de force de traction, soit une marge largement suffisante pour l\'usage prévu dans le cadre des exercices de type Nordic Hamstring Curl.</p><p>Cette page résume le contexte des tests, les conditions d\'utilisation et les précautions pratiques en lien avec les lignes directrices ISO 20957. Une fixation correcte, un support stable et une progression adaptée restent essentiels pour un usage sûr.</p>';
        }
      }

      if (path.indexOf('/products/sliders') > -1) {
        var slidersDescription = document.querySelector('.nb-product-description__content');
        if (slidersDescription && /Sliders to perform eccentric hamstring bridges at home/i.test(slidersDescription.textContent || '')) {
          slidersDescription.innerHTML = '<p>Les Sliders Nordbelt permettent de réaliser des ponts ischio-jambiers excentriques et d\'autres variations de contrôle à la maison, en salle ou sur le terrain.</p><p>Ils sont compacts, simples à emporter et particulièrement utiles pour l\'échauffement, le travail de gainage et les exercices d\'assistance autour des ischio-jambiers.</p>';
        }
      }
    };

    var scheduled = false;
    var syncFrenchCopy = function () {
      var root = document;
      for (var i = 0; i < selectorFixes.length; i += 1) {
        var fix = selectorFixes[i];
        var nodes = root.querySelectorAll(fix.selector);
        for (var j = 0; j < nodes.length; j += 1) {
          var current = (nodes[j].textContent || '').trim();
          if (fix.bad.indexOf(current) > -1) {
            nodes[j].textContent = fix.expected;
          }
        }
      }

      normalizeFrenchPolicyCopy(document.body || document.documentElement);
      rewriteFrenchLocalizedLinks(document);
      applyFrenchPathOverrides();
      applyFrenchArticleAndBlogOverrides();
    };

    var scheduleSync = function () {
      if (scheduled) return;
      scheduled = true;
      window.requestAnimationFrame(function () {
        scheduled = false;
        syncFrenchCopy();
      });
    };

    var start = function () {
      ensureFrenchOverrideAsset(scheduleSync);
      syncFrenchCopy();
      if (!document.body || !window.MutationObserver) return;
      var observer = new MutationObserver(function () {
        scheduleSync();
      });
      observer.observe(document.body, {
        childList: true,
        subtree: true,
        characterData: true,
        attributes: true,
        attributeFilter: ['href']
      });
      window.addEventListener('pagehide', function () {
        observer.disconnect();
      }, { once: true });
      window.setTimeout(syncFrenchCopy, 300);
      window.setTimeout(syncFrenchCopy, 1200);
      window.setTimeout(syncFrenchCopy, 2500);
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', start, { once: true });
    } else {
      start();
    }

    window.addEventListener('load', function () {
      syncFrenchCopy();
    }, { once: true });
  }

  installFrenchCopyGuards();

  function installGermanArticleGuards() {
    if (typeof window === 'undefined' || typeof document === 'undefined') return;
    if (getLocaleRoot() !== 'de') return;

    var scheduled = false;
    var syncGermanCopy = function () {
      applyGermanArticleOverrides();
    };

    var scheduleSync = function () {
      if (scheduled) return;
      scheduled = true;
      window.requestAnimationFrame(function () {
        scheduled = false;
        syncGermanCopy();
      });
    };

    var start = function () {
      ensureGermanOverrideAsset(scheduleSync);
      syncGermanCopy();
      if (!document.body || !window.MutationObserver) return;
      var observer = new MutationObserver(function () {
        scheduleSync();
      });
      observer.observe(document.body, {
        childList: true,
        subtree: true,
        characterData: true,
        attributes: true,
        attributeFilter: ['href']
      });
      window.addEventListener('pagehide', function () {
        observer.disconnect();
      }, { once: true });
      window.setTimeout(syncGermanCopy, 300);
      window.setTimeout(syncGermanCopy, 1200);
      window.setTimeout(syncGermanCopy, 2500);
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', start, { once: true });
    } else {
      start();
    }

    window.addEventListener('load', function () {
      syncGermanCopy();
    }, { once: true });
  }

  installGermanArticleGuards();

  function installEnglishArticleGuards() {
    if (typeof window === 'undefined' || typeof document === 'undefined') return;
    if (!isEnglishStorefront()) return;

    var scheduled = false;
    var syncEnglishCopy = function () {
      applyEnglishArticleOverrides();
    };

    var scheduleSync = function () {
      if (scheduled) return;
      scheduled = true;
      window.requestAnimationFrame(function () {
        scheduled = false;
        syncEnglishCopy();
      });
    };

    var start = function () {
      ensureEnglishOverrideAsset(scheduleSync);
      syncEnglishCopy();
      if (!document.body || !window.MutationObserver) return;
      var observer = new MutationObserver(function () {
        scheduleSync();
      });
      observer.observe(document.body, {
        childList: true,
        subtree: true,
        characterData: true,
        attributes: true,
        attributeFilter: ['href']
      });
      window.addEventListener('pagehide', function () {
        observer.disconnect();
      }, { once: true });
      window.setTimeout(syncEnglishCopy, 300);
      window.setTimeout(syncEnglishCopy, 1200);
      window.setTimeout(syncEnglishCopy, 2500);
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', start, { once: true });
    } else {
      start();
    }

    window.addEventListener('load', function () {
      syncEnglishCopy();
    }, { once: true });
  }

  installEnglishArticleGuards();

  function installSwedishArticleGuards() {
    if (typeof window === 'undefined' || typeof document === 'undefined') return;
    if (!isSwedishLocaleActive()) return;

    var scheduled = false;
    var syncSwedishCopy = function () {
      applySwedishArticleOverrides();
    };

    var scheduleSync = function () {
      if (scheduled) return;
      scheduled = true;
      window.requestAnimationFrame(function () {
        scheduled = false;
        syncSwedishCopy();
      });
    };

    var start = function () {
      ensureSwedishOverrideAsset(scheduleSync);
      syncSwedishCopy();
      if (!document.body || !window.MutationObserver) return;
      var observer = new MutationObserver(function () {
        scheduleSync();
      });
      observer.observe(document.body, {
        childList: true,
        subtree: true,
        characterData: true,
        attributes: true,
        attributeFilter: ['href']
      });
      window.addEventListener('pagehide', function () {
        observer.disconnect();
      }, { once: true });
      window.setTimeout(syncSwedishCopy, 300);
      window.setTimeout(syncSwedishCopy, 1200);
      window.setTimeout(syncSwedishCopy, 2500);
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', start, { once: true });
    } else {
      start();
    }

    window.addEventListener('load', function () {
      syncSwedishCopy();
    }, { once: true });
  }

  installSwedishArticleGuards();

  function installDanishArticleGuards() {
    if (typeof window === 'undefined' || typeof document === 'undefined') return;
    if (!isDanishLocaleActive()) return;

    var scheduled = false;
    var syncDanishCopy = function () {
      applyDanishArticleOverrides();
    };

    var scheduleSync = function () {
      if (scheduled) return;
      scheduled = true;
      window.requestAnimationFrame(function () {
        scheduled = false;
        syncDanishCopy();
      });
    };

    var start = function () {
      ensureDanishOverrideAsset(scheduleSync);
      syncDanishCopy();
      if (!document.body || !window.MutationObserver) return;
      var observer = new MutationObserver(function () {
        scheduleSync();
      });
      observer.observe(document.body, {
        childList: true,
        subtree: true,
        characterData: true,
        attributes: true,
        attributeFilter: ['href']
      });
      window.addEventListener('pagehide', function () {
        observer.disconnect();
      }, { once: true });
      window.setTimeout(syncDanishCopy, 300);
      window.setTimeout(syncDanishCopy, 1200);
      window.setTimeout(syncDanishCopy, 2500);
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', start, { once: true });
    } else {
      start();
    }

    window.addEventListener('load', function () {
      syncDanishCopy();
    }, { once: true });
  }

  installDanishArticleGuards();

  function installEstonianArticleGuards() {
    if (typeof window === 'undefined' || typeof document === 'undefined') return;
    if (!isEstonianLocaleActive()) return;

    var scheduled = false;
    var syncEstonianCopy = function () {
      applyEstonianArticleOverrides();
    };

    var scheduleSync = function () {
      if (scheduled) return;
      scheduled = true;
      window.requestAnimationFrame(function () {
        scheduled = false;
        syncEstonianCopy();
      });
    };

    var start = function () {
      ensureEstonianOverrideAsset(scheduleSync);
      syncEstonianCopy();
      if (!document.body || !window.MutationObserver) return;
      var observer = new MutationObserver(function () {
        scheduleSync();
      });
      observer.observe(document.body, {
        childList: true,
        subtree: true,
        characterData: true,
        attributes: true,
        attributeFilter: ['href']
      });
      window.addEventListener('pagehide', function () {
        observer.disconnect();
      }, { once: true });
      window.setTimeout(syncEstonianCopy, 300);
      window.setTimeout(syncEstonianCopy, 1200);
      window.setTimeout(syncEstonianCopy, 2500);
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', start, { once: true });
    } else {
      start();
    }

    window.addEventListener('load', function () {
      syncEstonianCopy();
    }, { once: true });
  }

  installEstonianArticleGuards();

  function installSpanishArticleGuards() {
    if (typeof window === 'undefined' || typeof document === 'undefined') return;
    if (!isSpanishLocaleActive()) return;

    var scheduled = false;
    var syncSpanishCopy = function () {
      applySpanishArticleOverrides();
    };

    var scheduleSync = function () {
      if (scheduled) return;
      scheduled = true;
      window.requestAnimationFrame(function () {
        scheduled = false;
        syncSpanishCopy();
      });
    };

    var start = function () {
      ensureSpanishOverrideAsset(scheduleSync);
      syncSpanishCopy();
      if (!document.body || !window.MutationObserver) return;
      var observer = new MutationObserver(function () {
        scheduleSync();
      });
      observer.observe(document.body, {
        childList: true,
        subtree: true,
        characterData: true,
        attributes: true,
        attributeFilter: ['href']
      });
      window.addEventListener('pagehide', function () {
        observer.disconnect();
      }, { once: true });
      window.setTimeout(syncSpanishCopy, 300);
      window.setTimeout(syncSpanishCopy, 1200);
      window.setTimeout(syncSpanishCopy, 2500);
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', start, { once: true });
    } else {
      start();
    }

    window.addEventListener('load', function () {
      syncSpanishCopy();
    }, { once: true });
  }

  installSpanishArticleGuards();

  function installItalianArticleGuards() {
    if (typeof window === 'undefined' || typeof document === 'undefined') return;
    if (!isItalianLocaleActive()) return;

    var scheduled = false;
    var syncItalianCopy = function () {
      applyItalianArticleOverrides();
    };

    var scheduleSync = function () {
      if (scheduled) return;
      scheduled = true;
      window.requestAnimationFrame(function () {
        scheduled = false;
        syncItalianCopy();
      });
    };

    var start = function () {
      ensureItalianOverrideAsset(scheduleSync);
      syncItalianCopy();
      if (!document.body || !window.MutationObserver) return;
      var observer = new MutationObserver(function () {
        scheduleSync();
      });
      observer.observe(document.body, {
        childList: true,
        subtree: true,
        characterData: true,
        attributes: true,
        attributeFilter: ['href']
      });
      window.addEventListener('pagehide', function () {
        observer.disconnect();
      }, { once: true });
      window.setTimeout(syncItalianCopy, 300);
      window.setTimeout(syncItalianCopy, 1200);
      window.setTimeout(syncItalianCopy, 2500);
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', start, { once: true });
    } else {
      start();
    }

    window.addEventListener('load', function () {
      syncItalianCopy();
    }, { once: true });
  }

  installItalianArticleGuards();

  function installFinnishArticleGuards() {
    if (typeof window === 'undefined' || typeof document === 'undefined') return;
    if (!isFinnishLocaleActive()) return;

    var scheduled = false;
    var syncFinnishCopy = function () {
      applyFinnishArticleOverrides();
    };

    var scheduleSync = function () {
      if (scheduled) return;
      scheduled = true;
      window.requestAnimationFrame(function () {
        scheduled = false;
        syncFinnishCopy();
      });
    };

    var start = function () {
      ensureFinnishOverrideAsset(scheduleSync);
      syncFinnishCopy();
      if (!document.body || !window.MutationObserver) return;
      var observer = new MutationObserver(function () {
        scheduleSync();
      });
      observer.observe(document.body, {
        childList: true,
        subtree: true,
        characterData: true,
        attributes: true,
        attributeFilter: ['href']
      });
      window.addEventListener('pagehide', function () {
        observer.disconnect();
      }, { once: true });
      window.setTimeout(syncFinnishCopy, 300);
      window.setTimeout(syncFinnishCopy, 1200);
      window.setTimeout(syncFinnishCopy, 2500);
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', start, { once: true });
    } else {
      start();
    }

    window.addEventListener('load', function () {
      syncFinnishCopy();
    }, { once: true });
  }

  installFinnishArticleGuards();

  function installNorwegianArticleGuards() {
    if (typeof window === 'undefined' || typeof document === 'undefined') return;
    if (!isNorwegianLocaleActive()) return;

    var scheduled = false;
    var syncNorwegianCopy = function () {
      applyNorwegianArticleOverrides();
    };

    var scheduleSync = function () {
      if (scheduled) return;
      scheduled = true;
      window.requestAnimationFrame(function () {
        scheduled = false;
        syncNorwegianCopy();
      });
    };

    var start = function () {
      ensureNorwegianOverrideAsset(scheduleSync);
      syncNorwegianCopy();
      if (!document.body || !window.MutationObserver) return;
      var observer = new MutationObserver(function () {
        scheduleSync();
      });
      observer.observe(document.body, {
        childList: true,
        subtree: true,
        characterData: true,
        attributes: true,
        attributeFilter: ['href']
      });
      window.addEventListener('pagehide', function () {
        observer.disconnect();
      }, { once: true });
      window.setTimeout(syncNorwegianCopy, 300);
      window.setTimeout(syncNorwegianCopy, 1200);
      window.setTimeout(syncNorwegianCopy, 2500);
      window.setTimeout(syncNorwegianCopy, 3300);
      window.setTimeout(syncNorwegianCopy, 5000);
      window.setTimeout(syncNorwegianCopy, 8000);
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', start, { once: true });
    } else {
      start();
    }

    window.addEventListener('load', function () {
      syncNorwegianCopy();
    }, { once: true });
  }

  installNorwegianArticleGuards();
  installLocalizedPracticeArticleLinks();

  function cleanEventDedupCache() {
    var now = Date.now();
    Object.keys(eventDedupCache).forEach(function (key) {
      if (now - eventDedupCache[key] > eventDedupTtlMs) {
        delete eventDedupCache[key];
      }
    });
  }

  function buildEventDedupKey(payload) {
    if (!payload || !payload.event_id || !payload.event) return '';
    return String(payload.event) + '::' + String(payload.event_id);
  }

  function markEventSeen(payload) {
    var key = buildEventDedupKey(payload);
    if (!key) return true;
    cleanEventDedupCache();
    if (eventDedupCache[key]) return false;
    eventDedupCache[key] = Date.now();
    return true;
  }

  function createEventId(prefix) {
    return (prefix || 'nb') + '_' + Date.now() + '_' + Math.random().toString(36).slice(2, 10);
  }

  function withEventMeta(payload, prefix) {
    var eventName = payload && payload.event ? String(payload.event) : '';
    if (!eventName) return payload;
    if (!payload.event_id) payload.event_id = createEventId(prefix || eventName);
    if (!payload.event_time) payload.event_time = new Date().toISOString();
    return payload;
  }

  function isBlogCtaGa4MeasurementEvent(eventName) {
    return String(eventName || '').indexOf('blog_cta_') === 0 || eventName === 'blog_home_tail_engaged_view';
  }

  function buildBlogCtaGa4Payload(payload) {
    var allowedKeys = [
      'event_id', 'article_slug', 'article_locale_root', 'cro_profile', 'product_relevance',
      'query_family_id', 'blog_cta_experiment_id', 'blog_cta_experiment_signature',
      'blog_cta_experiment_registry_version', 'blog_cta_experiment_arm', 'blog_cta_experiment_variant',
      'blog_cta_traffic_scope', 'blog_cta_message_id',
      'blog_cta_assignment_id', 'blog_cta_exposure_id', 'blog_cta_creative_id', 'blog_cta_format',
      'blog_cta_assignment_device_class', 'blog_cta_device_class', 'blog_cta_experiment_enrolled',
      'blog_cta_qa_override', 'slot_id', 'slot_type', 'destination',
      'exposure_basis', 'measurement_contract_version'
    ];
    var flat = {};
    allowedKeys.forEach(function (key) {
      if (!Object.prototype.hasOwnProperty.call(payload, key)) return;
      var value = payload[key];
      if (typeof value !== 'string' && typeof value !== 'number' && typeof value !== 'boolean') return;
      flat[key] = typeof value === 'string' ? value.slice(0, 100) : value;
    });
    return flat;
  }

  function sendBlogCtaGa4Event(payload) {
    if (!payload || payload.analytics_consent_granted !== true || !isBlogCtaGa4MeasurementEvent(payload.event)) return;
    window.nbCtaDataLayer = window.nbCtaDataLayer || [];
    if (typeof window.nbCtaGtag !== 'function') {
      window.nbCtaGtag = function () {
        window.nbCtaDataLayer.push(arguments);
      };
      window.nbCtaGtag('js', new Date());
      window.nbCtaGtag('consent', 'update', { analytics_storage: 'granted' });
      window.nbCtaGtag('config', 'G-3K6ERKL9JD', {
        send_page_view: false,
        transport_type: 'beacon'
      });
    }
    if (!document.getElementById('nb-blog-cta-ga4-bridge')) {
      var script = document.createElement('script');
      script.id = 'nb-blog-cta-ga4-bridge';
      script.async = true;
      script.src = 'https://www.googletagmanager.com/gtag/js?id=G-3K6ERKL9JD&l=nbCtaDataLayer';
      (document.head || document.documentElement).appendChild(script);
    }
    window.nbCtaGtag('event', String(payload.event), buildBlogCtaGa4Payload(payload));
  }

  function pushEvent(payload) {
    if (!payload || typeof payload !== 'object') return;
    var attribution = captureAttribution();
    if (attribution && !payload.attribution) {
      payload.attribution = attribution;
    }
    appendStoredBlogOriginContext(payload);
    if (!payload.context_path) {
      payload.context_path = window.location.pathname || '';
    }
    if (!payload.page_type) {
      payload.page_type = document.body ? (document.body.getAttribute('data-page-type') || '') : '';
    }
    if (!payload.template_name) {
      payload.template_name = document.body ? (document.body.getAttribute('data-template-name') || '') : '';
    }
    if (typeof payload.analytics_consent_granted !== 'boolean') {
      payload.analytics_consent_granted = hasAttributionStorageConsent();
    }
    withEventMeta(payload);
    if (!markEventSeen(payload)) return payload.event_id || '';
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(payload);
    sendBlogCtaGa4Event(payload);
    try {
      if (
        window.Shopify &&
        window.Shopify.analytics &&
        typeof window.Shopify.analytics.publish === 'function'
      ) {
        window.Shopify.analytics.publish('nb_custom_tracking', payload);
      }
    } catch (_err) {
      // noop
    }
    document.dispatchEvent(new CustomEvent('nb:tracking', { detail: payload }));
    pushBlogCtaAssistedFunnelEvent(payload);
    return payload.event_id || '';
  }

  function pushBlogCtaAssistedFunnelEvent(sourcePayload) {
    if (!sourcePayload || !hasAttributionStorageConsent()) return;
    var eventMap = {
      view_item: 'blog_cta_assisted_product_view',
      add_to_cart: 'blog_cta_assisted_add_to_cart',
      begin_checkout: 'blog_cta_assisted_begin_checkout'
    };
    var assistedEventName = eventMap[String(sourcePayload.event || '')];
    if (!assistedEventName) return;
    var origin = readBlogOrigin();
    if (!origin || !origin.cta_experiment_id || !origin.cta_experiment_signature || !origin.cta_assignment_id) return;
    pushEvent({
      event: assistedEventName,
      event_id: String(sourcePayload.event_id || createEventId(sourcePayload.event || 'funnel')) + '_cta_assist',
      context_path: sourcePayload.context_path || window.location.pathname || '',
      article_slug: origin.first_blog_handle || origin.last_blog_handle || '',
      article_locale_root: localeBaseCode(origin.article_locale || ''),
      cro_profile: origin.cta_profile || origin.cro_variant || '',
      product_relevance: origin.product_relevance || '',
      query_family_id: origin.query_family_id || '',
      primary_destination: origin.primary_destination || '',
      blog_cta_experiment_id: origin.cta_experiment_id,
      blog_cta_experiment_signature: origin.cta_experiment_signature,
      blog_cta_experiment_registry_version: origin.cta_registry_version || '',
      blog_cta_traffic_scope: origin.cta_traffic_scope || '',
      blog_cta_message_id: origin.cta_message_id || '',
      blog_cta_experiment_arm: origin.cta_experiment_arm || '',
      blog_cta_experiment_variant: origin.cta_experiment_variant || '',
      blog_cta_assignment_id: origin.cta_assignment_id,
      blog_cta_assigned_at: origin.cta_assigned_at || '',
      blog_cta_exposure_id: origin.cta_exposure_id || '',
      blog_cta_creative_id: origin.cta_creative_id || '',
      blog_cta_format: origin.cta_format || '',
      blog_cta_assignment_device_class: origin.cta_device_class || '',
      blog_cta_device_class: getBlogCtaDeviceClass(),
      blog_cta_experiment_enrolled: true,
      blog_cta_qa_override: false,
      measurement_contract_version: BLOG_CTA_MEASUREMENT_CONTRACT_VERSION
    });
  }

  function toFiniteNumber(value, fallback) {
    if (typeof value === 'number') {
      return Number.isFinite(value) ? value : fallback;
    }
    if (typeof value === 'string') {
      var normalized = value.trim();
      if (!normalized) return fallback;

      // Keep only numeric separators/sign and normalize locale-specific formats.
      normalized = normalized.replace(/\s+/g, '').replace(/[^\d,.\-]/g, '');
      if (!normalized) return fallback;

      var lastComma = normalized.lastIndexOf(',');
      var lastDot = normalized.lastIndexOf('.');

      if (lastComma > -1 && lastDot > -1) {
        if (lastComma > lastDot) {
          normalized = normalized.replace(/\./g, '').replace(',', '.');
        } else {
          normalized = normalized.replace(/,/g, '');
        }
      } else if (lastComma > -1) {
        normalized = normalized.replace(',', '.');
      } else {
        normalized = normalized.replace(/,/g, '');
      }

      var parsedString = Number(normalized);
      return Number.isFinite(parsedString) ? parsedString : fallback;
    }

    if (value && typeof value === 'object') {
      if (Object.prototype.hasOwnProperty.call(value, 'amount')) {
        return toFiniteNumber(value.amount, fallback);
      }
      if (Object.prototype.hasOwnProperty.call(value, 'value')) {
        return toFiniteNumber(value.value, fallback);
      }
    }

    var parsed = Number(value);
    return Number.isFinite(parsed) ? parsed : fallback;
  }

  function getActiveShopCurrency() {
    var shopifyCurrency = window.Shopify && window.Shopify.currency
      ? window.Shopify.currency.active
      : '';
    var currencyNode = document.querySelector('[data-cart-currency], [data-shopify-market-currency]');
    var nodeCurrency = currencyNode
      ? (currencyNode.getAttribute('data-cart-currency') || currencyNode.getAttribute('data-shopify-market-currency'))
      : '';
    return String(shopifyCurrency || nodeCurrency || '').trim().toUpperCase();
  }

  function normalizeCheckoutItems(items) {
    if (!Array.isArray(items)) return [];
    return items
      .map(function (item) {
        var raw = item || {};
        var quantity = toFiniteNumber(raw.quantity, 1);
        if (quantity < 1) quantity = 1;
        var price = toFiniteNumber(raw.price, 0);
        if (price < 0) price = 0;
        var normalized = {
          item_id: raw.item_id ? String(raw.item_id) : '',
          item_name: raw.item_name ? String(raw.item_name) : '',
          item_brand: raw.item_brand ? String(raw.item_brand) : 'Nordbelt',
          item_category: raw.item_category ? String(raw.item_category) : 'Nordic Curl Tool',
          price: Number(price.toFixed(2)),
          quantity: quantity
        };
        ['item_variant', 'variant_id', 'package_size'].forEach(function (key) {
          if (raw[key] == null || raw[key] === '') return;
          normalized[key] = String(raw[key]);
        });
        if (!normalized.item_id && !normalized.item_name) return null;
        return normalized;
      })
      .filter(function (item) {
        return !!item;
      });
  }

  function contentIdsFromItems(items) {
    return (items || [])
      .map(function (item) {
        if (!item || !item.item_id) return '';
        return String(item.item_id);
      })
      .filter(function (id) {
        return !!id;
      });
  }

  function getRuntimeBridge(name) {
    if (window && window[name]) return window[name];
    if (window.top && window.top !== window) {
      try {
        return window.top[name];
      } catch (_err) {
        return null;
      }
    }
    return null;
  }

  function getTrackingConfig() {
    var cfg = window.NordbeltTrackingConfig || {};
    if (typeof cfg !== 'object' || cfg === null) return {};
    return cfg;
  }

  function inferClarityProjectIdFromScripts() {
    var scripts = document.getElementsByTagName('script');
    for (var i = 0; i < scripts.length; i += 1) {
      var src = scripts[i] && scripts[i].src ? String(scripts[i].src) : '';
      if (!src || src.indexOf('clarity.ms/tag/') === -1) continue;
      var match = src.match(/clarity\.ms\/tag\/(?:shopify\/)?([a-z0-9]+)/i);
      if (match && match[1]) return String(match[1]).trim();
    }
    return '';
  }

  function hasStandardClarityScript(projectId) {
    if (!projectId) return false;
    var needle = 'clarity.ms/tag/' + projectId;
    var scripts = document.getElementsByTagName('script');
    for (var i = 0; i < scripts.length; i += 1) {
      var src = scripts[i] && scripts[i].src ? String(scripts[i].src) : '';
      if (!src || src.indexOf(needle) === -1) continue;
      if (src.indexOf('/tag/shopify/') === -1) return true;
    }
    return false;
  }

  function resolveClarityProjectId() {
    var cfg = getTrackingConfig();
    var configured = cfg && cfg.clarityProjectId ? String(cfg.clarityProjectId).trim() : '';
    if (configured) return configured;
    var inferred = inferClarityProjectIdFromScripts();
    if (inferred) return inferred;
    return DEFAULT_CLARITY_PROJECT_ID;
  }

  function initClarityRuntimeBridge() {
    var cfg = getTrackingConfig();
    if (cfg.clarityBridgeEnabled === false) return;
    var projectId = resolveClarityProjectId();
    if (!projectId) return;
    if (!cfg.clarityProjectId) cfg.clarityProjectId = projectId;

    if (typeof window.clarity !== 'function') {
      window.clarity = function () {
        window.clarity.q = window.clarity.q || [];
        window.clarity.q.push(arguments);
      };
    }

    function loadClarityScript() {
      if (clarityScriptRequested) return;
      clarityScriptRequested = true;
      if (window.NordbeltClarityLoaderRequested || hasStandardClarityScript(projectId)) return;
      if (document.querySelector('script[data-nb-clarity-loader]')) return;
      window.NordbeltClarityLoaderRequested = true;

      var script = document.createElement('script');
      script.async = true;
      script.src = 'https://www.clarity.ms/tag/' + projectId;
      script.setAttribute('data-nb-clarity-loader', '1');

      var firstScript = document.getElementsByTagName('script')[0];
      if (firstScript && firstScript.parentNode) {
        firstScript.parentNode.insertBefore(script, firstScript);
      } else if (document.head) {
        document.head.appendChild(script);
      } else {
        document.documentElement.appendChild(script);
      }
    }

    var clarityLoadScheduled = false;
    var clarityScriptRequested = false;

    function queueClarityLoad(timeoutMs, delayMs) {
      if (clarityLoadScheduled) return;
      clarityLoadScheduled = true;
      window.setTimeout(function () {
        if ('requestIdleCallback' in window) {
          window.requestIdleCallback(loadClarityScript, { timeout: timeoutMs || 3600 });
        } else {
          window.setTimeout(loadClarityScript, timeoutMs ? Math.min(timeoutMs, 1600) : 1100);
        }
      }, Math.max(0, Number(delayMs || 0)));
    }

    function removeClarityInteractionListeners() {
      window.removeEventListener('pointerdown', handleClarityFirstInteraction);
      window.removeEventListener('keydown', handleClarityFirstInteraction);
      window.removeEventListener('touchstart', handleClarityFirstInteraction);
      window.removeEventListener('scroll', handleClarityFirstInteraction);
    }

    function handleClarityFirstInteraction() {
      removeClarityInteractionListeners();
      queueClarityLoad(isMobileArticleRuntime() ? 4600 : 3000, isMobileArticleRuntime() ? 2600 : 1000);
    }

    window.addEventListener('pointerdown', handleClarityFirstInteraction, { once: true, passive: true });
    window.addEventListener('keydown', handleClarityFirstInteraction, { once: true });
    window.addEventListener('touchstart', handleClarityFirstInteraction, { once: true, passive: true });
    window.addEventListener('scroll', handleClarityFirstInteraction, { once: true, passive: true });

    if (document.readyState === 'complete') {
      queueClarityLoad(isMobileArticleRuntime() ? 4200 : 2600, isMobileArticleRuntime() ? 2800 : 1400);
    } else {
      window.addEventListener('load', function () {
        queueClarityLoad(isMobileArticleRuntime() ? 4600 : 3000, isMobileArticleRuntime() ? 3000 : 1600);
      }, { once: true });
    }
  }

  function safeParseJson(value, fallback) {
    try {
      return JSON.parse(value);
    } catch (_err) {
      return fallback;
    }
  }

  var runtimeI18nCache = null;

  function getRuntimeI18n() {
    if (runtimeI18nCache) return runtimeI18nCache;
    if (window.NordbeltI18n && typeof window.NordbeltI18n === 'object') {
      runtimeI18nCache = window.NordbeltI18n;
      return runtimeI18nCache;
    }

    var node = document.getElementById('nb-i18n-runtime');
    if (!node) {
      runtimeI18nCache = {};
      window.NordbeltI18n = runtimeI18nCache;
      return runtimeI18nCache;
    }

    runtimeI18nCache = safeParseJson(node.textContent || '{}', {});
    if (!runtimeI18nCache || typeof runtimeI18nCache !== 'object') {
      runtimeI18nCache = {};
    }
    window.NordbeltI18n = runtimeI18nCache;
    return runtimeI18nCache;
  }

  function getI18nValue(path) {
    if (!path) return '';
    var root = getRuntimeI18n();
    var segments = String(path).split('.');
    var cursor = root;
    for (var index = 0; index < segments.length; index += 1) {
      var segment = segments[index];
      if (!cursor || typeof cursor !== 'object' || !(segment in cursor)) return '';
      cursor = cursor[segment];
    }
    return cursor;
  }

  function interpolateI18n(template, vars) {
    var source = String(template || '');
    if (!vars || typeof vars !== 'object') return source;
    return source.replace(/\{\{\s*([a-zA-Z0-9_]+)\s*\}\}/g, function (_match, token) {
      if (!(token in vars)) return '';
      var value = vars[token];
      return value === null || value === undefined ? '' : String(value);
    });
  }

  function i18n(path, fallback, vars) {
    var fallbackText = fallback === null || fallback === undefined ? '' : String(fallback);
    var resolved = getI18nValue(path);
    var template = typeof resolved === 'string' && resolved ? resolved : fallbackText;
    return interpolateI18n(template, vars);
  }

  function isSwedishLocaleActive() {
    var htmlLang = normalizeLocaleCode(document.documentElement.getAttribute('lang') || '');
    if (htmlLang === 'sv' || localeBaseCode(htmlLang) === 'sv') return true;
    var cfg = window.NordbeltLocaleConfig || {};
    var currentLocale = normalizeLocaleCode(cfg.currentLocale || '');
    return currentLocale === 'sv' || localeBaseCode(currentLocale) === 'sv';
  }

  function isEstonianLocaleActive() {
    var htmlLang = normalizeLocaleCode(document.documentElement.getAttribute('lang') || '');
    if (htmlLang === 'et' || localeBaseCode(htmlLang) === 'et') return true;
    var cfg = window.NordbeltLocaleConfig || {};
    var currentLocale = normalizeLocaleCode(cfg.currentLocale || '');
    return currentLocale === 'et' || localeBaseCode(currentLocale) === 'et';
  }

  function isDanishLocaleActive() {
    var htmlLang = normalizeLocaleCode(document.documentElement.getAttribute('lang') || '');
    if (htmlLang === 'da' || localeBaseCode(htmlLang) === 'da') return true;
    var cfg = window.NordbeltLocaleConfig || {};
    var currentLocale = normalizeLocaleCode(cfg.currentLocale || '');
    return currentLocale === 'da' || localeBaseCode(currentLocale) === 'da';
  }

  function isSpanishLocaleActive() {
    var htmlLang = normalizeLocaleCode(document.documentElement.getAttribute('lang') || '');
    if (htmlLang === 'es' || localeBaseCode(htmlLang) === 'es') return true;
    var cfg = window.NordbeltLocaleConfig || {};
    var currentLocale = normalizeLocaleCode(cfg.currentLocale || '');
    return currentLocale === 'es' || localeBaseCode(currentLocale) === 'es';
  }

  function isItalianLocaleActive() {
    var htmlLang = normalizeLocaleCode(document.documentElement.getAttribute('lang') || '');
    if (htmlLang === 'it' || localeBaseCode(htmlLang) === 'it') return true;
    var cfg = window.NordbeltLocaleConfig || {};
    var currentLocale = normalizeLocaleCode(cfg.currentLocale || '');
    return currentLocale === 'it' || localeBaseCode(currentLocale) === 'it';
  }

  function isFinnishLocaleActive() {
    var htmlLang = normalizeLocaleCode(document.documentElement.getAttribute('lang') || '');
    if (htmlLang === 'fi' || localeBaseCode(htmlLang) === 'fi') return true;
    var cfg = window.NordbeltLocaleConfig || {};
    var currentLocale = normalizeLocaleCode(cfg.currentLocale || '');
    return currentLocale === 'fi' || localeBaseCode(currentLocale) === 'fi';
  }

  function isNorwegianLocaleActive() {
    var htmlLang = normalizeLocaleCode(document.documentElement.getAttribute('lang') || '');
    if (htmlLang === 'nb' || localeBaseCode(htmlLang) === 'nb') return true;
    var cfg = window.NordbeltLocaleConfig || {};
    var currentLocale = normalizeLocaleCode(cfg.currentLocale || '');
    return currentLocale === 'nb' || localeBaseCode(currentLocale) === 'nb';
  }

  function normalizeSwedishKronaText(text) {
    var source = String(text || '');
    if (!source) return source;
    return source.replace(/(\d{1,3}(?:[.\s\u00A0]\d{3})*)\.(\d{2})\s*kr\b/gi, function (_match, intPart, decimals) {
      return String(intPart || '').replace(/\u00A0/g, ' ') + ',' + String(decimals || '') + ' kr';
    });
  }

  function shouldSkipSwedishPriceNode(node) {
    if (!node || !node.parentElement) return true;
    var tag = (node.parentElement.tagName || '').toUpperCase();
    if (tag === 'SCRIPT' || tag === 'STYLE' || tag === 'NOSCRIPT' || tag === 'TEMPLATE' || tag === 'TEXTAREA') {
      return true;
    }
    return false;
  }

  function normalizeSwedishKronaPricesInScope(scopeNode) {
    if (!isSwedishLocaleActive()) return;
    var scope = scopeNode || document.body;
    if (!scope) return;

    if (scope.nodeType === Node.TEXT_NODE) {
      if (shouldSkipSwedishPriceNode(scope)) return;
      var normalizedSingle = normalizeSwedishKronaText(scope.nodeValue || '');
      if (normalizedSingle !== scope.nodeValue) {
        scope.nodeValue = normalizedSingle;
      }
      return;
    }

    var walker = document.createTreeWalker(scope, NodeFilter.SHOW_TEXT);
    var textNode;
    while ((textNode = walker.nextNode())) {
      if (shouldSkipSwedishPriceNode(textNode)) continue;
      var original = textNode.nodeValue || '';
      if (original.indexOf('kr') === -1 && original.indexOf('KR') === -1) continue;
      var normalized = normalizeSwedishKronaText(original);
      if (normalized !== original) {
        textNode.nodeValue = normalized;
      }
    }
  }

  function initSwedishKronaPriceFormatting() {
    if (!isSwedishLocaleActive() || !window.MutationObserver || !document.body) return;

    var scheduled = false;
    function scheduleNormalize(scope) {
      if (scheduled) return;
      scheduled = true;
      window.requestAnimationFrame(function () {
        scheduled = false;
        normalizeSwedishKronaPricesInScope(scope || document.body);
      });
    }

    normalizeSwedishKronaPricesInScope(document.body);

    var observer = new MutationObserver(function (mutations) {
      var target = document.body;
      for (var i = 0; i < mutations.length; i += 1) {
        var mutation = mutations[i];
        if (mutation.type === 'characterData' && mutation.target) {
          target = mutation.target.parentElement || document.body;
          break;
        }
        if (mutation.addedNodes && mutation.addedNodes.length) {
          target = mutation.addedNodes[0];
          break;
        }
      }
      scheduleNormalize(target);
    });

    observer.observe(document.body, {
      subtree: true,
      childList: true,
      characterData: true
    });
  }

  var ATTRIBUTION_STORAGE_KEY = 'nb_attribution_v1';
  var ATTRIBUTION_TTL_MS = 90 * 24 * 60 * 60 * 1000;
  var BLOG_ORIGIN_STORAGE_KEY = 'nb_blog_origin_v1';
  var BLOG_ORIGIN_SESSION_KEY = 'nb_blog_session_v1';
  var BLOG_ORIGIN_TTL_MS = 28 * 24 * 60 * 60 * 1000;
  var attributionCache = null;
  var blogOriginCache = null;

  function readStorageItem(storage, key) {
    if (!storage || !key) return '';
    try {
      return storage.getItem(key) || '';
    } catch (_err) {
      return '';
    }
  }

  function writeStorageItem(storage, key, value) {
    if (!storage || !key) return;
    try {
      storage.setItem(key, value);
    } catch (_err) {
      // noop
    }
  }

  var RESERVE_PANEL_NOTICE_KEY = 'nb_reserve_panel_notice_v1';

  function armReservePanelNotice() {
    writeStorageItem(window.sessionStorage, RESERVE_PANEL_NOTICE_KEY, '1');
  }

  function clearReservePanelNotice() {
    if (!window.sessionStorage) return;
    try {
      window.sessionStorage.removeItem(RESERVE_PANEL_NOTICE_KEY);
    } catch (_err) {
      // noop
    }
  }

  function consumeReservePanelNotice() {
    if (readStorageItem(window.sessionStorage, RESERVE_PANEL_NOTICE_KEY) !== '1') return false;
    clearReservePanelNotice();
    return true;
  }

  function buildAttributionFromUrl() {
    var params = new URLSearchParams(window.location.search);
    var fields = [
      'utm_id',
      'utm_source',
      'utm_medium',
      'utm_campaign',
      'utm_term',
      'utm_content',
      'gclid',
      'gbraid',
      'wbraid',
      'gad_source',
      'gad_campaignid',
      'dclid',
      'fbclid',
      'msclkid',
      'ttclid'
    ];
    var source = {};
    var hasValue = false;

    fields.forEach(function (field) {
      var val = String(params.get(field) || '').trim();
      if (!val) return;
      source[field] = val;
      hasValue = true;
    });

    if (!hasValue) return null;

    source.landing_path = window.location.pathname || '';
    source.landing_query = window.location.search || '';
    source.landing_url = window.location.href || '';
    source.first_seen_at = new Date().toISOString();
    source.last_seen_at = source.first_seen_at;
    source.session_id = createEventId('attr');
    return source;
  }

  function readConsentStorageChoice() {
    var raw = readStorageItem(window.localStorage, 'nb_cookie_consent_v1') || readStorageItem(window.sessionStorage, 'nb_cookie_consent_v1');
    if (!raw) return '';
    if (raw === 'accepted' || raw === 'essential') return raw;
    var parsed = safeParseJson(raw, null);
    if (!parsed || typeof parsed !== 'object') return '';
    var choice = String(parsed.choice || '').toLowerCase();
    return (choice === 'accepted' || choice === 'essential') ? choice : '';
  }

  function hasAttributionStorageConsent() {
    if (readStorageItem(window.localStorage, 'nb_force_consent_migrated_v1')) return false;
    var privacyApi = window.Shopify && window.Shopify.customerPrivacy;
    if (privacyApi && typeof privacyApi.currentVisitorConsent === 'function') {
      try {
        var consent = privacyApi.currentVisitorConsent();
        if (consent && typeof consent === 'object') {
          var keys = ['analytics', 'marketing', 'preferences', 'sale_of_data'];
          var hasExplicit = keys.some(function (key) {
            return typeof consent[key] === 'boolean';
          });
          if (hasExplicit) return !!(consent.analytics || consent.marketing);
        }
      } catch (_err) {
        // Fall through to the local banner choice.
      }
    }

    return readConsentStorageChoice() === 'accepted';
  }

  function removeStorageItem(storage, key) {
    if (!storage || !key) return;
    try {
      storage.removeItem(key);
    } catch (_err) {}
  }

  function clearBlogOriginStorage() {
    blogOriginCache = null;
    removeStorageItem(window.localStorage, BLOG_ORIGIN_STORAGE_KEY);
    removeStorageItem(window.sessionStorage, BLOG_ORIGIN_STORAGE_KEY);
    removeStorageItem(window.sessionStorage, BLOG_ORIGIN_SESSION_KEY);
  }

  function readBlogOrigin() {
    if (!hasAttributionStorageConsent()) {
      clearBlogOriginStorage();
      return null;
    }
    if (blogOriginCache) return blogOriginCache;
    var raw = readStorageItem(window.localStorage, BLOG_ORIGIN_STORAGE_KEY) || readStorageItem(window.sessionStorage, BLOG_ORIGIN_STORAGE_KEY);
    if (!raw) return null;
    var parsed = safeParseJson(raw, null);
    if (!parsed || typeof parsed !== 'object') return null;
    var firstSeenAt = Date.parse(parsed.first_seen_at || '');
    if (!firstSeenAt || Date.now() - firstSeenAt > BLOG_ORIGIN_TTL_MS) {
      clearBlogOriginStorage();
      return null;
    }
    blogOriginCache = parsed;
    return parsed;
  }

  function writeBlogOrigin(origin) {
    if (!origin || typeof origin !== 'object' || !hasAttributionStorageConsent()) return null;
    blogOriginCache = origin;
    var payload = JSON.stringify(origin);
    writeStorageItem(window.localStorage, BLOG_ORIGIN_STORAGE_KEY, payload);
    writeStorageItem(window.sessionStorage, BLOG_ORIGIN_STORAGE_KEY, payload);
    return origin;
  }

  function blogOriginSessionId() {
    var existing = readStorageItem(window.sessionStorage, BLOG_ORIGIN_SESSION_KEY);
    if (existing) return existing;
    var sessionId = createEventId('blog');
    writeStorageItem(window.sessionStorage, BLOG_ORIGIN_SESSION_KEY, sessionId);
    return sessionId;
  }

  function trimBlogOriginValue(value, maxLength) {
    var normalized = String(value || '').replace(/\s+/g, ' ').trim();
    if (!normalized) return '';
    return normalized.slice(0, maxLength || 180);
  }

  function persistBlogOrigin(articleRoot, options) {
    if (!articleRoot || !hasAttributionStorageConsent()) {
      if (!hasAttributionStorageConsent()) clearBlogOriginStorage();
      return null;
    }
    var context = getArticleAnalyticsContext(articleRoot);
    if (!context || !context.slug) return null;
    var existing = readBlogOrigin();
    var now = new Date().toISOString();
    var settings = options || {};
    var next = existing && typeof existing === 'object' ? Object.assign({}, existing) : {};
    var sameCtaAssignment = !!(
      existing &&
      context.cta_experiment_enrolled &&
      existing.cta_experiment_id === context.cta_experiment_id &&
      existing.cta_experiment_signature === context.cta_experiment_signature &&
      existing.cta_assignment_id === context.cta_assignment_id
    );
    var preserveMutexAttribution = !!(
      existing &&
      existing.cta_assignment_id &&
      !context.cta_experiment_enrolled &&
      context.cta_exclusion_reason === 'global_experiment_mutex'
    );
    next.first_blog_handle = trimBlogOriginValue(next.first_blog_handle || context.slug, 120);
    next.last_blog_handle = trimBlogOriginValue(context.slug, 120);
    next.article_locale = trimBlogOriginValue(context.locale, 24);
    next.product_relevance = trimBlogOriginValue(context.product_relevance, 32);
    next.query_family_id = trimBlogOriginValue(context.query_family_id, 160);
    next.hypothesis_id = trimBlogOriginValue(context.hypothesis_id, 160);
    next.cro_variant = trimBlogOriginValue(context.cro_variant, 40);
    if (context.cta_experiment_enrolled) {
      next.cta_experiment_id = trimBlogOriginValue(context.cta_experiment_id, 120);
      next.cta_experiment_signature = trimBlogOriginValue(context.cta_experiment_signature, 120);
      next.cta_experiment_variant = trimBlogOriginValue(context.cta_experiment_variant, 40);
      next.cta_experiment_arm = trimBlogOriginValue(context.cta_experiment_arm, 12);
      next.cta_assignment_id = trimBlogOriginValue(context.cta_assignment_id, 120);
      next.cta_assigned_at = trimBlogOriginValue(context.cta_assigned_at, 40);
      next.cta_exposure_id = trimBlogOriginValue(
        settings.exposure_id || context.cta_exposure_id || (sameCtaAssignment ? next.cta_exposure_id : ''),
        120
      );
      next.cta_creative_id = trimBlogOriginValue(context.cta_creative_id, 80);
      next.cta_format = trimBlogOriginValue(context.cta_format, 32);
      next.cta_profile = trimBlogOriginValue(context.cro_variant, 40);
      next.cta_device_class = trimBlogOriginValue(context.cta_assignment_device_class || context.cta_device_class, 24);
      next.cta_registry_version = trimBlogOriginValue(context.cta_experiment_registry_version, 40);
      next.cta_traffic_scope = trimBlogOriginValue(context.cta_traffic_scope, 40);
      next.cta_message_id = trimBlogOriginValue(context.cta_message_id, 80);
    } else if (!preserveMutexAttribution) {
      next.cta_experiment_id = '';
      next.cta_experiment_signature = '';
      next.cta_experiment_variant = '';
      next.cta_experiment_arm = '';
      next.cta_assignment_id = '';
      next.cta_assigned_at = '';
      next.cta_exposure_id = '';
      next.cta_creative_id = '';
      next.cta_format = '';
      next.cta_profile = '';
      next.cta_device_class = '';
      next.cta_registry_version = '';
      next.cta_traffic_scope = '';
      next.cta_message_id = trimBlogOriginValue(context.cta_message_id, 80);
    }
    next.primary_destination = trimBlogOriginValue(context.primary_destination, 24);
    next.cta_slot = trimBlogOriginValue(settings.slot_id || next.cta_slot, 120);
    next.surface_source = trimBlogOriginValue(settings.surface_source || next.surface_source || 'article', 32);
    next.session_id = trimBlogOriginValue(next.session_id || blogOriginSessionId(), 120);
    next.first_seen_at = next.first_seen_at || now;
    next.last_seen_at = now;
    return writeBlogOrigin(next);
  }

  function appendStoredBlogOriginContext(payload) {
    if (!payload || typeof payload !== 'object') return payload;
    var origin = readBlogOrigin();
    if (!origin) return payload;
    payload.blog_first_handle = origin.first_blog_handle || '';
    payload.blog_last_handle = origin.last_blog_handle || '';
    payload.blog_session_id = origin.session_id || '';
    if (!payload.hypothesis_id && origin.hypothesis_id) payload.hypothesis_id = origin.hypothesis_id;
    if (!payload.query_family_id && origin.query_family_id) payload.query_family_id = origin.query_family_id;
    if (!payload.product_relevance && origin.product_relevance) payload.product_relevance = origin.product_relevance;
    if (!payload.cro_variant && origin.cro_variant) payload.cro_variant = origin.cro_variant;
    if (!payload.blog_cta_experiment_id && origin.cta_experiment_id) payload.blog_cta_experiment_id = origin.cta_experiment_id;
    if (!payload.blog_cta_experiment_signature && origin.cta_experiment_signature) payload.blog_cta_experiment_signature = origin.cta_experiment_signature;
    if (!payload.blog_cta_experiment_variant && origin.cta_experiment_variant) payload.blog_cta_experiment_variant = origin.cta_experiment_variant;
    if (!payload.blog_cta_experiment_arm && origin.cta_experiment_arm) payload.blog_cta_experiment_arm = origin.cta_experiment_arm;
    if (!payload.blog_cta_assignment_id && origin.cta_assignment_id) payload.blog_cta_assignment_id = origin.cta_assignment_id;
    if (!payload.blog_cta_assigned_at && origin.cta_assigned_at) payload.blog_cta_assigned_at = origin.cta_assigned_at;
    if (!payload.blog_cta_exposure_id && origin.cta_exposure_id) payload.blog_cta_exposure_id = origin.cta_exposure_id;
    if (!payload.blog_cta_creative_id && origin.cta_creative_id) payload.blog_cta_creative_id = origin.cta_creative_id;
    if (!payload.blog_cta_format && origin.cta_format) payload.blog_cta_format = origin.cta_format;
    if (!payload.cro_profile && origin.cta_profile) payload.cro_profile = origin.cta_profile;
    if (!payload.blog_cta_assignment_device_class && origin.cta_device_class) payload.blog_cta_assignment_device_class = origin.cta_device_class;
    if (!payload.blog_cta_experiment_registry_version && origin.cta_registry_version) payload.blog_cta_experiment_registry_version = origin.cta_registry_version;
    if (!payload.blog_cta_traffic_scope && origin.cta_traffic_scope) payload.blog_cta_traffic_scope = origin.cta_traffic_scope;
    if (!payload.blog_cta_message_id && origin.cta_message_id) payload.blog_cta_message_id = origin.cta_message_id;
    if (!payload.slot_id && origin.cta_slot) payload.slot_id = origin.cta_slot;
    payload.blog_origin = Object.assign({}, origin);
    return payload;
  }

  function syncBlogOriginToCart(originOverride) {
    if (!window.fetch || !hasAttributionStorageConsent()) return Promise.resolve(false);
    var origin = originOverride || readBlogOrigin();
    if (!origin || !origin.first_blog_handle) return Promise.resolve(false);
    var attributes = {
      __nb_first_blog: trimBlogOriginValue(origin.first_blog_handle, 120),
      __nb_last_blog: trimBlogOriginValue(origin.last_blog_handle, 120),
      __nb_cta_slot: trimBlogOriginValue(origin.cta_slot, 120),
      __nb_hypothesis_id: trimBlogOriginValue(origin.hypothesis_id, 160),
      __nb_blog_session_id: trimBlogOriginValue(origin.session_id, 120),
      __nb_query_family_id: trimBlogOriginValue(origin.query_family_id, 160),
      __nb_cta_test_id: trimBlogOriginValue(origin.cta_experiment_id, 120),
      __nb_cta_test_signature: trimBlogOriginValue(origin.cta_experiment_signature, 120),
      __nb_cta_test_arm: trimBlogOriginValue(origin.cta_experiment_arm, 12),
      __nb_cta_test_variant: trimBlogOriginValue(origin.cta_experiment_variant, 40),
      __nb_cta_assignment_id: trimBlogOriginValue(origin.cta_assignment_id, 120),
      __nb_cta_assigned_at: trimBlogOriginValue(origin.cta_assigned_at, 40),
      __nb_cta_exposure_id: trimBlogOriginValue(origin.cta_exposure_id, 120),
      __nb_cta_creative_id: trimBlogOriginValue(origin.cta_creative_id, 80),
      __nb_cta_profile: trimBlogOriginValue(origin.cta_profile, 40),
      __nb_cta_device: trimBlogOriginValue(origin.cta_device_class, 24),
      __nb_cta_locale: trimBlogOriginValue(origin.article_locale, 24),
      __nb_cta_registry_version: trimBlogOriginValue(origin.cta_registry_version, 40),
      __nb_cta_traffic_scope: trimBlogOriginValue(origin.cta_traffic_scope, 40),
      __nb_cta_message_id: trimBlogOriginValue(origin.cta_message_id, 80)
    };
    return fetch(buildCartEndpointPathWithPreview('/cart/update.js'), {
      method: 'POST',
      credentials: 'same-origin',
      keepalive: true,
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json'
      },
      body: JSON.stringify({ attributes: attributes })
    }).then(function (response) {
      return !!(response && response.ok);
    }).catch(function () {
      return false;
    });
  }

  function readAttribution() {
    if (attributionCache) return attributionCache;
    var raw = readStorageItem(window.localStorage, ATTRIBUTION_STORAGE_KEY) || readStorageItem(window.sessionStorage, ATTRIBUTION_STORAGE_KEY);
    if (!raw) return null;
    var parsed = safeParseJson(raw, null);
    if (!parsed || typeof parsed !== 'object') return null;
    var createdAt = Date.parse(parsed.first_seen_at || '');
    if (!createdAt || (Date.now() - createdAt) > ATTRIBUTION_TTL_MS) {
      return null;
    }
    attributionCache = parsed;
    return parsed;
  }

  function writeAttribution(nextAttribution) {
    if (!nextAttribution || typeof nextAttribution !== 'object') return;
    attributionCache = nextAttribution;
    var payload = JSON.stringify(nextAttribution);
    writeStorageItem(window.localStorage, ATTRIBUTION_STORAGE_KEY, payload);
    writeStorageItem(window.sessionStorage, ATTRIBUTION_STORAGE_KEY, payload);
  }

  function mergeAttribution(existing, incoming) {
    if (!existing) return incoming || null;
    if (!incoming) return existing;

    var merged = {};
    Object.keys(existing).forEach(function (key) {
      merged[key] = existing[key];
    });
    Object.keys(incoming).forEach(function (key) {
      if (incoming[key]) merged[key] = incoming[key];
    });
    merged.last_seen_at = new Date().toISOString();
    if (!merged.session_id) merged.session_id = createEventId('attr');
    if (!merged.first_seen_at) merged.first_seen_at = merged.last_seen_at;
    return merged;
  }

  function captureAttribution() {
    var cfg = getTrackingConfig();
    if (cfg.attributionEnabled === false) return null;
    var canStoreAttribution = hasAttributionStorageConsent();
    var existing = canStoreAttribution ? readAttribution() : null;
    var fromUrl = buildAttributionFromUrl();
    var next = mergeAttribution(existing, fromUrl);
    if (next && canStoreAttribution) writeAttribution(next);
    return next;
  }

  function isCheckoutPath(pathname) {
    var path = String(pathname || '').toLowerCase();
    return path.indexOf('/checkout') !== -1;
  }

  function trackBeginCheckout(options) {
    var settings = options || {};
    var value = toFiniteNumber(settings.value, 0);
    if (value < 0) value = 0;
    var items = normalizeCheckoutItems(settings.items || []);
    var contentIds = Array.isArray(settings.content_ids) ? settings.content_ids : contentIdsFromItems(items);
    var payload = {
      event: 'begin_checkout',
      event_id: settings.event_id || createEventId('begin_checkout'),
      context_path: settings.context_path || window.location.pathname || '',
      checkout_entrypoint: settings.checkout_entrypoint || 'unknown',
      checkout_redirect_attempt: toFiniteNumber(settings.checkout_redirect_attempt, 1),
      checkout_redirect_result: settings.checkout_redirect_result || 'initiated',
      currency: settings.currency || getActiveShopCurrency(),
      value: Number(value.toFixed(2)),
      ecommerce: {
        currency: settings.currency || getActiveShopCurrency(),
        value: Number(value.toFixed(2))
      }
    };
    ['page_type', 'audience', 'item_name', 'item_id', 'variant_id', 'package_size', 'price'].forEach(function (key) {
      if (settings[key] == null || settings[key] === '') return;
      payload[key] = settings[key];
    });
    if (items.length) payload.ecommerce.items = items;
    if (contentIds.length) {
      payload.content_ids = contentIds;
      payload.content_type = settings.content_type || 'product';
    }
    syncBlogOriginToCart();
    pushEvent(payload);
    return payload.event_id;
  }

  function trackCheckoutRedirectFailure(options) {
    var settings = options || {};
    var payload = {
      event: 'checkout_redirect_failed',
      event_id: settings.event_id || createEventId('checkout_redirect_failed'),
      context_path: settings.context_path || window.location.pathname || '',
      checkout_entrypoint: settings.checkout_entrypoint || 'unknown',
      checkout_redirect_attempt: toFiniteNumber(settings.checkout_redirect_attempt, 1),
      checkout_redirect_result: settings.checkout_redirect_result || 'failed',
      browser_name: navigator.userAgentData && navigator.userAgentData.brands && navigator.userAgentData.brands.length
        ? navigator.userAgentData.brands.map(function (brand) { return brand.brand; }).join(', ')
        : '',
      browser_user_agent: navigator.userAgent || '',
      browser_platform: navigator.platform || '',
      browser_language: navigator.language || '',
      cart_item_count: toFiniteNumber(settings.cart_item_count, 0)
    };
    if (settings.cart_snapshot && typeof settings.cart_snapshot === 'object') {
      payload.cart_snapshot = settings.cart_snapshot;
    }
    var value = toFiniteNumber(settings.value, NaN);
    if (Number.isFinite(value)) {
      payload.ecommerce = {
        currency: settings.currency || getActiveShopCurrency(),
        value: Number(Math.max(0, value).toFixed(2)),
        items: normalizeCheckoutItems(settings.items || [])
      };
    }
    pushEvent(payload);
    return payload.event_id;
  }

  window.NordbeltTheme = window.NordbeltTheme || {};
  window.NordbeltTheme.createEventId = createEventId;
  window.NordbeltTheme.pushEvent = pushEvent;
  window.NordbeltTheme.buildShopifyPathWithPreview = buildShopifyPathWithPreview;
  window.NordbeltTheme.buildCartEndpointPathWithPreview = buildCartEndpointPathWithPreview;
  window.NordbeltTheme.trackBeginCheckout = trackBeginCheckout;
  window.NordbeltTheme.trackCheckoutRedirectFailure = trackCheckoutRedirectFailure;
  window.NordbeltTheme.captureAttribution = captureAttribution;
  window.NordbeltTheme.readAttribution = readAttribution;
  window.NordbeltTheme.readBlogOrigin = readBlogOrigin;
  window.NordbeltTheme.syncBlogOriginToCart = syncBlogOriginToCart;
  window.NordbeltTheme.readDirectCheckoutCartBridge = readDirectCheckoutCartBridge;
  window.NordbeltTheme.clearDirectCheckoutCartBridge = clearDirectCheckoutCartBridge;

  function initViewItemTracking() {
    var node = document.querySelector('[data-nb-view-item]');
    if (!node) return;
    var parsed;
    try {
      parsed = JSON.parse(node.textContent || '{}');
    } catch (_err) {
      parsed = null;
    }
    if (parsed) pushEvent(parsed);
  }

  function initCartViewTracking() {
    var form = document.querySelector('[data-nb-cart-form]');
    if (!form) return;
    var itemNodes = Array.prototype.slice.call(form.querySelectorAll('[data-nb-cart-item]'));
    if (!itemNodes.length) return;

    var items = itemNodes
      .map(function (itemNode) {
        var quantity = toFiniteNumber(itemNode.getAttribute('data-item-quantity'), 1);
        if (quantity < 1) quantity = 1;
        var price = toFiniteNumber(itemNode.getAttribute('data-item-price'), 0);
        if (price < 0) price = 0;
        return {
          item_id: itemNode.getAttribute('data-item-id') || '',
          item_name: itemNode.getAttribute('data-item-name') || '',
          item_brand: 'Nordbelt',
          item_category: 'Nordic Curl Tool',
          price: Number(price.toFixed(2)),
          quantity: quantity
        };
      })
      .filter(function (item) {
        return Boolean(item.item_id || item.item_name);
      });
    if (!items.length) return;

    var total = toFiniteNumber(form.getAttribute('data-cart-total'), 0);
    if (total < 0) total = 0;
    pushEvent({
      event: 'view_cart',
      ecommerce: {
        currency: form.getAttribute('data-cart-currency') || getActiveShopCurrency(),
        value: Number(total.toFixed(2)),
        items: items
      },
      content_ids: contentIdsFromItems(items),
      content_type: 'product'
    });
  }

  function initSearchTracking() {
    var body = document.body;
    if (!body || (body.getAttribute('data-page-type') || '') !== 'search') return;
    var params = new URLSearchParams(window.location.search);
    var term = String(params.get('q') || '').trim();
    if (!term) return;
    pushEvent({
      event: 'search',
      search_term: term
    });
  }

  function initPurchaseTrackingFallback() {
    var checkout = window.Shopify && window.Shopify.checkout ? window.Shopify.checkout : null;
    if (!checkout || typeof checkout !== 'object') return;
    var transactionId = checkout.order_id || checkout.order_number || '';
    if (!transactionId) return;

    var dedupeKey = 'nb_purchase_tracked_' + String(transactionId);
    if (readStorageItem(window.sessionStorage, dedupeKey) === '1') return;

    var lineItems = Array.isArray(checkout.line_items) ? checkout.line_items : [];
    var items = lineItems
      .map(function (item) {
        if (!item) return null;
        var quantity = toFiniteNumber(item.quantity, 1);
        if (quantity < 1) quantity = 1;
        var price = toFiniteNumber(item.price, 0);
        if (price < 0) price = 0;
        return {
          item_id: item.product_id ? String(item.product_id) : (item.variant_id ? String(item.variant_id) : ''),
          item_name: item.title ? String(item.title) : '',
          item_brand: item.vendor ? String(item.vendor) : 'Nordbelt',
          item_category: 'Nordic Curl Tool',
          price: Number(price.toFixed(2)),
          quantity: quantity
        };
      })
      .filter(function (item) {
        return !!item;
      });

    var rawCheckoutTotal = checkout.total_price != null ? checkout.total_price : checkout.subtotal_price;
    var value = toFiniteNumber(rawCheckoutTotal, 0);

    if (typeof rawCheckoutTotal === 'string') {
      var totalRawText = rawCheckoutTotal.trim();
      // Shopify payloads without decimal separators are typically minor units (cents).
      if (totalRawText && totalRawText.indexOf('.') === -1 && totalRawText.indexOf(',') === -1) {
        value = value / 100;
      }
    } else if (typeof rawCheckoutTotal === 'number' && Number.isInteger(rawCheckoutTotal) && rawCheckoutTotal >= 1000) {
      value = value / 100;
    }

    if (!(value > 0) && items.length) {
      value = items.reduce(function (sum, item) {
        var price = toFiniteNumber(item && item.price, 0);
        var quantity = toFiniteNumber(item && item.quantity, 1);
        if (quantity < 1) quantity = 1;
        return sum + (price * quantity);
      }, 0);
    }

    pushEvent({
      event: 'purchase',
      transaction_id: String(transactionId),
      ecommerce: {
        currency: checkout.currency || getActiveShopCurrency(),
        value: Number(Math.max(0, value).toFixed(2)),
        items: items
      },
      content_ids: contentIdsFromItems(items),
      content_type: 'product'
    });
    writeStorageItem(window.sessionStorage, dedupeKey, '1');
  }

  function setAtcButtonState(button, state) {
    if (!button) return;
    if (!button.dataset.originalLabel) {
      button.dataset.originalLabel = button.textContent || i18n('atc.default', 'Aan winkelwagen toevoegen');
    }

    if (state === 'loading') {
      button.disabled = true;
      button.textContent = i18n('atc.loading', 'Toevoegen...');
      return;
    }

    if (state === 'success') {
      button.disabled = false;
      button.textContent = i18n('atc.success', 'Toegevoegd');
      window.setTimeout(function () {
        button.textContent = button.dataset.originalLabel;
      }, 1400);
      return;
    }

    if (state === 'error') {
      button.disabled = false;
      button.textContent = i18n('atc.error', 'Probeer opnieuw');
      window.setTimeout(function () {
        button.textContent = button.dataset.originalLabel;
      }, 1800);
      return;
    }

    button.disabled = false;
    button.textContent = button.dataset.originalLabel;
  }

  function updateCartBadge(count) {
    var normalizedCount = Math.max(0, Math.round(toFiniteNumber(count, 0)));
    var cartLinks = document.querySelectorAll('a[href$="/cart"], a[href="/cart"]');
    cartLinks.forEach(function (link) {
      var badge = link.querySelector('.nb-cart-badge');
      if (!badge && normalizedCount > 0) {
        badge = document.createElement('span');
        badge.className = 'nb-cart-badge';
        link.style.position = 'relative';
        link.appendChild(badge);
      }
      if (badge) {
        if (normalizedCount > 0) {
          badge.textContent = String(normalizedCount);
        } else {
          badge.remove();
        }
      }
    });

    var header = document.querySelector('[data-nb-header]');
    if (header) {
      header.setAttribute('data-cart-count', String(normalizedCount));
    }

    document.dispatchEvent(new CustomEvent('nb:cart-count-updated', {
      detail: { count: normalizedCount }
    }));
  }

  function buildShopifyPathWithPreview(pathname) {
    var nextUrl = new URL(pathname, window.location.origin);
    var localizedPath = buildLocalizedStorefrontPath(nextUrl.pathname || '/');
    if (localizedPath) {
      nextUrl.pathname = localizedPath;
    }
    var current = new URL(window.location.href);
    ['preview_theme_id', 'key', 'pb', '_ab', '_fd', '_sc'].forEach(function (key) {
      if (current.searchParams.has(key)) {
        nextUrl.searchParams.set(key, current.searchParams.get(key) || '');
      }
    });
    return nextUrl.toString();
  }

  function buildCartEndpointPathWithPreview(pathname) {
    var nextUrl = new URL(pathname, window.location.origin);
    var path = String(nextUrl.pathname || '/');
    var localizedPath = '';

    if (/^\/cart\.js$/i.test(path)) {
      var localizedCartPath = buildLocalizedStorefrontPath('/cart');
      if (localizedCartPath) {
        localizedPath = localizedCartPath.replace(/\/cart$/i, '/cart.js');
      }
    } else if (/^\/cart\/(?:add|update|change|clear)\.js$/i.test(path)) {
      localizedPath = buildLocalizedStorefrontPath(path);
    } else if (/^\/cart\/add$/i.test(path)) {
      localizedPath = buildLocalizedStorefrontPath('/cart/add');
    }

    if (localizedPath) {
      nextUrl.pathname = localizedPath;
    }

    var current = new URL(window.location.href);
    ['preview_theme_id', 'key', 'pb', '_ab', '_fd', '_sc'].forEach(function (key) {
      if (current.searchParams.has(key)) {
        nextUrl.searchParams.set(key, current.searchParams.get(key) || '');
      }
    });

    return nextUrl.toString();
  }

  var DIRECT_CHECKOUT_CART_BRIDGE_STORAGE_KEY = 'nb_direct_checkout_cart_bridge_v1';
  var DIRECT_CHECKOUT_CART_BRIDGE_TTL_MS = 5 * 60 * 1000;

  function clearDirectCheckoutCartBridge() {
    if (!window.sessionStorage) return;
    try {
      window.sessionStorage.removeItem(DIRECT_CHECKOUT_CART_BRIDGE_STORAGE_KEY);
    } catch (_err) {
      // noop
    }
  }

  function readDirectCheckoutCartBridge() {
    var raw = readStorageItem(window.sessionStorage, DIRECT_CHECKOUT_CART_BRIDGE_STORAGE_KEY);
    if (!raw) return null;

    var parsed = safeParseJson(raw, null);
    if (!parsed || typeof parsed !== 'object') {
      clearDirectCheckoutCartBridge();
      return null;
    }

    var createdAt = toFiniteNumber(parsed.createdAt, 0);
    if (!(createdAt > 0) || Date.now() - createdAt > DIRECT_CHECKOUT_CART_BRIDGE_TTL_MS) {
      clearDirectCheckoutCartBridge();
      return null;
    }

    return parsed;
  }

  function shouldUseDirectCheckoutCartBridge() {
    var localizedCartPath = buildLocalizedStorefrontPath('/cart');
    return !!localizedCartPath && localizedCartPath !== '/cart';
  }

  function armDirectCheckoutCartBridge(payload) {
    if (!window.sessionStorage || !shouldUseDirectCheckoutCartBridge()) return false;

    var bridgePayload = {
      createdAt: Date.now(),
      sourcePath: (window.location.pathname || '/') + (window.location.search || '')
    };

    if (payload && typeof payload === 'object') {
      var entrypoint = String(payload.entrypoint || '').trim();
      if (entrypoint) bridgePayload.entrypoint = entrypoint;
      var variantId = String(payload.variantId || '').trim();
      if (variantId) bridgePayload.variantId = variantId;
      var currency = String(payload.currency || '').trim();
      if (currency) bridgePayload.currency = currency;
      var value = toFiniteNumber(payload.value, NaN);
      if (Number.isFinite(value)) bridgePayload.value = Number(Math.max(0, value).toFixed(2));
    }

    writeStorageItem(window.sessionStorage, DIRECT_CHECKOUT_CART_BRIDGE_STORAGE_KEY, JSON.stringify(bridgePayload));
    return true;
  }

  var LOCALE_CART_TRANSFER_STORAGE_KEY = 'nb_locale_cart_transfer_v1';
  var LOCALE_CART_TRANSFER_TTL_MS = 15 * 60 * 1000;

  function clearLocaleCartTransferSnapshot() {
    if (!window.sessionStorage) return;
    try {
      window.sessionStorage.removeItem(LOCALE_CART_TRANSFER_STORAGE_KEY);
    } catch (_err) {
      // noop
    }
  }

  function normalizeLocaleCartTransferPayloadItem(item) {
    if (!item || typeof item !== 'object') return null;
    var itemId = String(item.id || '').trim();
    if (!itemId) return null;

    var quantity = Math.max(1, Math.round(toFiniteNumber(item.quantity, 1)));
    var normalized = {
      id: itemId,
      quantity: quantity
    };

    if (item.properties && typeof item.properties === 'object') {
      var properties = {};
      Object.keys(item.properties).forEach(function (key) {
        var propKey = String(key || '').trim();
        if (!propKey) return;
        var propValue = item.properties[key];
        if (propValue === null || propValue === undefined) return;
        var valueString = String(propValue).trim();
        if (!valueString) return;
        properties[propKey] = valueString;
      });
      if (Object.keys(properties).length) normalized.properties = properties;
    }

    var sellingPlan = String(item.selling_plan || '').trim();
    if (sellingPlan) normalized.selling_plan = sellingPlan;

    return normalized;
  }

  function normalizeLocaleCartSnapshotItem(item) {
    if (!item || typeof item !== 'object') return null;

    var variantId = String(item.variant_id || item.id || '').trim();
    if (!variantId) return null;

    var quantity = Math.max(1, Math.round(toFiniteNumber(item.quantity, 1)));
    var normalized = {
      id: variantId,
      quantity: quantity
    };

    if (item.properties && typeof item.properties === 'object') {
      var properties = {};
      Object.keys(item.properties).forEach(function (key) {
        var propKey = String(key || '').trim();
        if (!propKey) return;
        var propValue = item.properties[key];
        if (propValue === null || propValue === undefined) return;
        var valueString = String(propValue).trim();
        if (!valueString) return;
        properties[propKey] = valueString;
      });
      if (Object.keys(properties).length) normalized.properties = properties;
    }

    var sellingPlanId = '';
    if (item.selling_plan_allocation && item.selling_plan_allocation.selling_plan) {
      sellingPlanId = String(item.selling_plan_allocation.selling_plan.id || '').trim();
    }
    if (!sellingPlanId && item.selling_plan_allocation) {
      sellingPlanId = String(item.selling_plan_allocation.selling_plan_id || '').trim();
    }
    if (!sellingPlanId && item.selling_plan) {
      sellingPlanId = String(item.selling_plan).trim();
    }
    if (sellingPlanId) normalized.selling_plan = sellingPlanId;

    return normalized;
  }

  function readLocaleCartTransferSnapshot() {
    var raw = readStorageItem(window.sessionStorage, LOCALE_CART_TRANSFER_STORAGE_KEY);
    if (!raw) return null;

    var parsed = safeParseJson(raw, null);
    if (!parsed || typeof parsed !== 'object') {
      clearLocaleCartTransferSnapshot();
      return null;
    }

    var createdAt = toFiniteNumber(parsed.createdAt, 0);
    if (!(createdAt > 0)) {
      clearLocaleCartTransferSnapshot();
      return null;
    }

    if (Date.now() - createdAt > LOCALE_CART_TRANSFER_TTL_MS) {
      clearLocaleCartTransferSnapshot();
      return null;
    }

    var items = Array.isArray(parsed.items) ? parsed.items : [];
    if (!items.length) {
      clearLocaleCartTransferSnapshot();
      return null;
    }

    parsed.items = items
      .map(normalizeLocaleCartTransferPayloadItem)
      .filter(function (item) {
        return !!item;
      });

    if (!parsed.items.length) {
      clearLocaleCartTransferSnapshot();
      return null;
    }

    return parsed;
  }

  function snapshotCartForLocaleTransfer() {
    if (!window.fetch) return Promise.resolve(null);
    return fetch(buildCartEndpointPathWithPreview('/cart.js'), {
      method: 'GET',
      credentials: 'same-origin',
      headers: { Accept: 'application/json' }
    })
      .then(function (response) {
        if (!response || !response.ok) return null;
        return response.json();
      })
      .then(function (cart) {
        var items = cart && Array.isArray(cart.items) ? cart.items : [];
        if (!items.length) {
          clearLocaleCartTransferSnapshot();
          return null;
        }

        var normalizedItems = items
          .map(normalizeLocaleCartSnapshotItem)
          .filter(function (item) {
            return !!item;
          });

        if (!normalizedItems.length) {
          clearLocaleCartTransferSnapshot();
          return null;
        }

        var payload = {
          createdAt: Date.now(),
          sourcePath: (window.location.pathname || '/') + (window.location.search || ''),
          itemCount: Math.max(0, Math.round(toFiniteNumber(cart.item_count, normalizedItems.length))),
          currency: String(cart.currency || ''),
          items: normalizedItems
        };

        if (typeof cart.note === 'string' && cart.note.trim()) {
          payload.note = cart.note;
        }

        if (cart.attributes && typeof cart.attributes === 'object') {
          var attributes = {};
          Object.keys(cart.attributes).forEach(function (key) {
            var attrKey = String(key || '').trim();
            if (!attrKey) return;
            var attrValue = cart.attributes[key];
            if (attrValue === null || attrValue === undefined) return;
            var valueString = String(attrValue).trim();
            if (!valueString) return;
            attributes[attrKey] = valueString;
          });
          if (Object.keys(attributes).length) {
            payload.attributes = attributes;
          }
        }

        writeStorageItem(window.sessionStorage, LOCALE_CART_TRANSFER_STORAGE_KEY, JSON.stringify(payload));
        return payload;
      })
      .catch(function () {
        return null;
      });
  }

  function restoreCartAfterLocaleSwitch() {
    if (!window.fetch) return;
    var snapshot = readLocaleCartTransferSnapshot();
    if (!snapshot) return;

    fetch(buildCartEndpointPathWithPreview('/cart.js'), {
      method: 'GET',
      credentials: 'same-origin',
      headers: { Accept: 'application/json' }
    })
      .then(function (response) {
        if (!response || !response.ok) return null;
        return response.json();
      })
      .then(function (cart) {
        var currentCount = Math.max(0, Math.round(toFiniteNumber(cart && cart.item_count, 0)));
        if (currentCount > 0) {
          clearLocaleCartTransferSnapshot();
          updateCartBadge(currentCount);
          return null;
        }

        if (!snapshot.items || !snapshot.items.length) {
          clearLocaleCartTransferSnapshot();
          return null;
        }

        return fetch(buildCartEndpointPathWithPreview('/cart/add.js'), {
          method: 'POST',
          credentials: 'same-origin',
          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json'
          },
          body: JSON.stringify({ items: snapshot.items })
        })
          .then(function (addResponse) {
            if (!addResponse || !addResponse.ok) throw new Error('locale-cart-restore-failed');
            return addResponse.json();
          })
          .then(function () {
            var hasNote = typeof snapshot.note === 'string' && snapshot.note.trim();
            var hasAttributes = snapshot.attributes && typeof snapshot.attributes === 'object' && Object.keys(snapshot.attributes).length;
            if (!hasNote && !hasAttributes) return null;
            return fetch(buildCartEndpointPathWithPreview('/cart/update.js'), {
              method: 'POST',
              credentials: 'same-origin',
              headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json'
              },
              body: JSON.stringify({
                note: hasNote ? snapshot.note : '',
                attributes: hasAttributes ? snapshot.attributes : {}
              })
            }).catch(function () {
              return null;
            });
          })
          .then(function () {
            return fetch(buildCartEndpointPathWithPreview('/cart.js'), {
              method: 'GET',
              credentials: 'same-origin',
              headers: { Accept: 'application/json' }
            });
          })
          .then(function (finalResponse) {
            if (!finalResponse || !finalResponse.ok) return null;
            return finalResponse.json();
          })
          .then(function (finalCart) {
            clearLocaleCartTransferSnapshot();
            var restoredCount = Math.max(0, Math.round(toFiniteNumber(finalCart && finalCart.item_count, snapshot.itemCount || 0)));
            updateCartBadge(restoredCount);
            syncBlogOriginToCart();
            if (/\/cart(?:\/|$)/i.test(String(window.location.pathname || ''))) {
              window.location.reload();
            }
          })
          .catch(function () {
            clearLocaleCartTransferSnapshot();
          });
      })
      .catch(function () {
        clearLocaleCartTransferSnapshot();
      });
  }

  function initAtcTracking() {
    var forms = document.querySelectorAll('[data-nb-atc-form]');
    if (!forms.length) return;

    forms.forEach(function (form) {
      form.addEventListener('submit', function (event) {
        if (form.dataset.nbSubmitting === '1') {
          event.preventDefault();
          return;
        }

        var submitter = event.submitter && event.submitter.matches('[data-nb-atc-submit]') ? event.submitter : null;
        var submitButton = submitter || form.querySelector('[data-nb-atc-submit]');
        var redirectTarget = (submitter && submitter.getAttribute('data-nb-atc-redirect')) || form.getAttribute('data-nb-atc-redirect') || '';
        var requiresCompanionProduct = form.getAttribute('data-nb-requires-companion-product') === 'true';
        redirectTarget = redirectTarget.trim().toLowerCase();
        var submitMode = (form.getAttribute('data-nb-atc-mode') || 'native').trim().toLowerCase();
        var useAjax = submitMode === 'ajax' && !!window.fetch && !!window.FormData;

        form.dataset.nbSubmitting = '1';
        setAtcButtonState(submitButton, 'loading');

        var quantityInput = form.querySelector('input[name="quantity"]');
        var quantity = Number(quantityInput && quantityInput.value ? quantityInput.value : 1);
        if (!Number.isFinite(quantity) || quantity < 1) quantity = 1;
        var variantInput = form.querySelector('[name="id"]');
        var unitPrice = Number(form.getAttribute('data-product-price') || 0);
        var currency = form.getAttribute('data-product-currency') || '';
        var itemId = variantInput && variantInput.value ? String(variantInput.value) : (form.getAttribute('data-product-id') || '');
        var normalizedUnitPrice = Number(Math.max(0, unitPrice).toFixed(2));
        var addToCartPayload = {
          event: 'add_to_cart',
          context_path: window.location.pathname,
          ecommerce: {
            currency: currency,
            value: Number((normalizedUnitPrice * quantity).toFixed(2)),
            items: [
              {
                item_id: itemId,
                item_name: form.getAttribute('data-product-title') || '',
                item_brand: 'Nordbelt',
                item_category: 'Nordic Curl Tool',
                price: normalizedUnitPrice,
                quantity: quantity
              }
            ]
          },
          content_ids: [itemId],
          content_type: 'product'
        };

        if (!useAjax) {
          armReservePanelNotice();
          syncBlogOriginToCart();
          // Native Shopify submit path is the most robust for cart/checkout reliability.
          return;
        }

        event.preventDefault();
        var formData = new FormData(form);
        fetch(buildCartEndpointPathWithPreview('/cart/add.js'), {
          method: 'POST',
          headers: { Accept: 'application/json' },
          body: formData
        })
          .then(function (res) {
            if (!res.ok) throw new Error('ATC failed');
            return res.json();
          })
          .then(function (_item) {
            return syncBlogOriginToCart().then(function () {
              return _item;
            });
          })
          .then(function (_item) {
            armReservePanelNotice();
            pushEvent(addToCartPayload);
            if (redirectTarget === 'checkout' && requiresCompanionProduct) {
              window.location.assign(buildShopifyPathWithPreview('/cart'));
              return;
            }
            if (redirectTarget === 'checkout') {
              var checkoutEntrypoint = (submitter && submitter.getAttribute('data-nb-checkout-entrypoint')) || form.getAttribute('data-nb-checkout-entrypoint') || 'product_direct';
              var shouldBridgeCheckout = shouldUseDirectCheckoutCartBridge();
              var checkoutUrl = shouldBridgeCheckout
                ? buildShopifyPathWithPreview('/cart')
                : buildShopifyPathWithPreview('/checkout');
              var checkoutEventId = trackBeginCheckout({
                checkout_entrypoint: checkoutEntrypoint,
                checkout_redirect_attempt: 1,
                checkout_redirect_result: shouldBridgeCheckout ? 'bridging_to_cart' : 'redirecting',
                value: Number((normalizedUnitPrice * quantity).toFixed(2)),
                currency: currency,
                items: addToCartPayload.ecommerce.items,
                content_ids: addToCartPayload.content_ids,
                content_type: addToCartPayload.content_type
              });
              if (shouldBridgeCheckout) {
                armDirectCheckoutCartBridge({
                  entrypoint: checkoutEntrypoint,
                  variantId: itemId,
                  currency: currency,
                  value: Number((normalizedUnitPrice * quantity).toFixed(2))
                });
              }
              window.location.assign(checkoutUrl);
              if (shouldBridgeCheckout) return;
              window.setTimeout(function () {
                if (document.visibilityState !== 'visible') return;
                if (isCheckoutPath(window.location.pathname || '')) return;
                trackCheckoutRedirectFailure({
                  event_id: checkoutEventId,
                  checkout_entrypoint: checkoutEntrypoint,
                  checkout_redirect_attempt: 2,
                  checkout_redirect_result: 'not_on_checkout_after_redirect',
                  value: Number((normalizedUnitPrice * quantity).toFixed(2)),
                  currency: currency,
                  items: addToCartPayload.ecommerce.items,
                  cart_item_count: quantity
                });
                window.location.assign(checkoutUrl);
              }, 1200);
              return;
            }

            if (redirectTarget === 'cart') {
              window.location.assign(buildShopifyPathWithPreview('/cart'));
              return;
            }

            // Cart badge refresh is non-critical; avoid breaking flow on redirects/CORS edge cases.
            fetch(buildCartEndpointPathWithPreview('/cart.js'), { headers: { Accept: 'application/json' } })
              .then(function (res) {
                if (!res.ok) return null;
                return res.json();
              })
              .then(function (cart) {
                if (!cart) return;
                updateCartBadge(Number(cart && cart.item_count ? cart.item_count : 0));
              })
              .catch(function () {
                // noop
              });

            setAtcButtonState(submitButton, 'success');
          })
          .catch(function () {
            setAtcButtonState(submitButton, 'error');
            // Fallback to Shopify native form submit if AJAX add fails for any reason.
            try {
              armReservePanelNotice();
              form.submit();
            } catch (_err) {
              // noop
            }
          })
          .finally(function () {
            form.dataset.nbSubmitting = '0';
          });
      });
    });
  }

  function initBeginCheckoutTracking() {
    var nodes = document.querySelectorAll('a[data-nb-begin-checkout]:not([data-nb-checkout-trigger])');
    nodes.forEach(function (node) {
      node.addEventListener('click', function () {
        trackBeginCheckout({
          checkout_entrypoint: node.getAttribute('data-nb-checkout-entrypoint') || 'generic_link',
          checkout_redirect_attempt: 1,
          checkout_redirect_result: 'tracked_only'
        });
      });
    });
  }

  function initAdPlatformBridges() {
    if (document.documentElement.getAttribute('data-nb-ad-platform-bridges-bound') === 'true') return;
    document.documentElement.setAttribute('data-nb-ad-platform-bridges-bound', 'true');

    function isStandardEcommerceEvent(eventName) {
      return eventName === 'view_item' || eventName === 'add_to_cart' || eventName === 'begin_checkout' || eventName === 'purchase' || eventName === 'view_cart' || eventName === 'search';
    }

    function buildGoogleAdsConversionPayload(payload) {
      var ecommerce = payload && payload.ecommerce ? payload.ecommerce : {};
      var value = toFiniteNumber(ecommerce.value, NaN);
      if (!Number.isFinite(value)) {
        value = toFiniteNumber(payload && payload.value, NaN);
      }
      if (!Number.isFinite(value) && Array.isArray(ecommerce.items) && ecommerce.items.length) {
        value = ecommerce.items.reduce(function (sum, item) {
          var itemPrice = toFiniteNumber(item && item.price, 0);
          var itemQuantity = toFiniteNumber(item && item.quantity, 1);
          if (itemQuantity < 1) itemQuantity = 1;
          return sum + (itemPrice * itemQuantity);
        }, 0);
      }
      if (!Number.isFinite(value) || value < 0) value = 0;
      return {
        value: Number(value.toFixed(2)),
        currency: ecommerce.currency || getActiveShopCurrency(),
        transaction_id: payload.transaction_id || payload.event_id || ''
      };
    }

    function resolveGoogleAdsSendTo(eventName) {
      var cfg = getTrackingConfig();
      var map = cfg && cfg.googleAdsSendTo ? cfg.googleAdsSendTo : {};
      var sendTo = map && map[eventName] ? String(map[eventName]).trim() : '';
      return sendTo;
    }

    function isBlogCtaMeasurementEvent(eventName) {
      return isBlogCtaGa4MeasurementEvent(eventName);
    }

    document.addEventListener('nb:tracking', function (event) {
      var payload = event && event.detail ? event.detail : null;
      if (!payload || !payload.event) return;
      var eventName = String(payload.event || '').trim();
      if (!eventName) return;
      var trackingConfig = getTrackingConfig();
      var allowManualBridge = trackingConfig.manualAdBridgeEnabled === true;
      var allowStandardBridge = allowManualBridge || !isStandardEcommerceEvent(eventName);

      try {
        var gtag = getRuntimeBridge('gtag');
        if (typeof gtag === 'function') {
          if (allowStandardBridge && !isBlogCtaMeasurementEvent(eventName)) {
            gtag('event', eventName, payload);
          }
          var googleAdsSendTo = resolveGoogleAdsSendTo(eventName);
          if (googleAdsSendTo) {
            gtag('event', 'conversion', Object.assign({ send_to: googleAdsSendTo }, buildGoogleAdsConversionPayload(payload)));
          }
        }
      } catch (_err) {
        // noop
      }

      try {
        var fbq = getRuntimeBridge('fbq');
        if (typeof fbq === 'function' && allowStandardBridge) {
          var map = {
            view_item: { name: 'ViewContent', method: 'track' },
            add_to_cart: { name: 'AddToCart', method: 'track' },
            begin_checkout: { name: 'InitiateCheckout', method: 'track' },
            purchase: { name: 'Purchase', method: 'track' },
            checkout_redirect_failed: { name: 'CheckoutRedirectFailed', method: 'trackCustom' }
          };
          var mappedMetaEvent = map[eventName];
          if (mappedMetaEvent) {
            var ecommerce = payload.ecommerce || {};
            var itemList = ecommerce.items || [];
            var firstItem = itemList[0] || {};
            fbq(
              mappedMetaEvent.method,
              mappedMetaEvent.name,
              {
                value: ecommerce.value || firstItem.price || 0,
                currency: ecommerce.currency || getActiveShopCurrency(),
                content_type: payload.content_type || 'product',
                content_ids: payload.content_ids || (firstItem.item_id ? [firstItem.item_id] : []),
                num_items: firstItem.quantity || 1,
                checkout_entrypoint: payload.checkout_entrypoint || ''
              },
              { eventID: payload.event_id || createEventId('meta') }
            );
          }
        }
      } catch (_err2) {
        // noop
      }

      try {
        var uetq = getRuntimeBridge('uetq');
        if (uetq && typeof uetq.push === 'function' && allowStandardBridge) {
          var uetEventMap = {
            add_to_cart: 'add_to_cart',
            begin_checkout: 'begin_checkout',
            purchase: 'purchase',
            checkout_redirect_failed: 'checkout_redirect_failed'
          };
          var uetEventName = uetEventMap[eventName];
          if (uetEventName) {
            var uetEcommerce = payload.ecommerce || {};
            uetq.push('event', uetEventName, {
              event_category: 'ecommerce',
              event_label: payload.checkout_entrypoint || payload.context_path || '',
              revenue_value: Number(toFiniteNumber(uetEcommerce.value, 0).toFixed(2)),
              currency: uetEcommerce.currency || getActiveShopCurrency()
            });
          }
        }
      } catch (_err3) {
        // noop
      }

      try {
        if (trackingConfig.clarityBridgeEnabled === false) return;
        var clarity = getRuntimeBridge('clarity');
        if (typeof clarity !== 'function') return;

        clarity('event', 'nb_' + eventName);
        clarity('set', 'nb_last_event', eventName);
        if (payload.event_id) clarity('set', 'nb_last_event_id', payload.event_id);
        if (payload.page_type) clarity('set', 'nb_page_type', String(payload.page_type));
        if (payload.product_cutoff_badge_variant) {
          var cutoffVariant = String(payload.product_cutoff_badge_variant).toUpperCase();
          if (cutoffVariant === 'A' || cutoffVariant === 'B') {
            var cutoffTestName = String(payload.product_cutoff_badge_test || 'product_cutoff_badge_v1').toLowerCase().replace(/[^a-z0-9_]+/g, '_');
            clarity('set', 'product_cutoff_badge_click_variant', cutoffVariant);
            clarity('set', 'product_cutoff_badge_click_test', cutoffTestName);
            clarity('event', 'product_cutoff_badge_cta_click_' + cutoffVariant.toLowerCase());
            clarity('event', 'product_cutoff_badge_' + cutoffTestName + '_cta_click_' + cutoffVariant.toLowerCase());
          }
        }
        if (payload.ecommerce && Number.isFinite(Number(payload.ecommerce.value))) {
          clarity('set', 'nb_last_value', String(Number(payload.ecommerce.value).toFixed(2)));
        }
        if (payload.attribution && payload.attribution.utm_source) {
          clarity('set', 'nb_utm_source', String(payload.attribution.utm_source));
        }
        if (payload.attribution && payload.attribution.utm_campaign) {
          clarity('set', 'nb_utm_campaign', String(payload.attribution.utm_campaign));
        }
      } catch (_err4) {
        // noop
      }
    });
  }

  function normalizeCtaText(value) {
    return String(value || '')
      .replace(/\s+/g, ' ')
      .trim()
      .toLowerCase();
  }

  function getConversionCtaRouteTargets() {
    var body = document.body;
    if (!body) {
      return {
        buyNowUrl: '',
        productUrl: ''
      };
    }

    var buyNowUrl = (body.getAttribute('data-nb-buy-now-url') || '').trim();
    var productUrl = (body.getAttribute('data-nb-product-url') || '').trim();

    return {
      buyNowUrl: buyNowUrl ? buildShopifyPathWithPreview(buyNowUrl) : '',
      productUrl: productUrl ? buildShopifyPathWithPreview(productUrl) : ''
    };
  }

  function getCtaNodeText(node) {
    if (!node) return '';
    var tagName = node.tagName ? node.tagName.toUpperCase() : '';
    if (tagName === 'INPUT') return node.value || '';
    return node.textContent || '';
  }

  function applyConversionPreviewPaths(rootNode) {
    var scope = rootNode && rootNode.querySelectorAll ? rootNode : document;
    var links = scope.querySelectorAll('[data-nb-conv-preview-path]');
    if (!links.length) return;
    links.forEach(function (link) {
      if (!link || !link.getAttribute) return;
      var path = String(link.getAttribute('data-nb-conv-preview-path') || '').trim();
      if (!path) return;
      link.setAttribute('href', buildShopifyPathWithPreview(path));
    });
  }

  function applyConversionCtaRoutes(rootNode) {
    var targets = getConversionCtaRouteTargets();
    if (!targets.buyNowUrl && !targets.productUrl) return;
    var buyShortNeedle = normalizeCtaText(i18n('shared.buy_short', 'Koop nu'));
    var buyNowNeedle = normalizeCtaText(i18n('shared.buy_now', 'Koop nu voor [price]')).replace('[price]', '').trim();
    var viewProductNeedle = normalizeCtaText(i18n('shared.view_product', 'Bekijk product'));
    var BUY_NOW_CTA_IDS = {
      header_primary: true,
      header_primary_mobile: true,
      hero_primary: true,
      home_guide_steps_primary: true,
      home_nhc_benefits_primary: true,
      home_guide_showcase_primary: true,
      purpose_primer_primary: true,
      purpose_primer_primary_mobile: true,
      guide_primary_cta: true,
      how_it_works_cta: true,
      feature_split_primary: true,
      global_mobile_buy_now: true,
      home_mobile_sticky_to_product: true
    };
    var STATIC_BUY_NEEDLES = [
      'koop nu',
      'buy now',
      'jetzt kaufen',
      'kauf jetzt',
      'achetez',
      'acheter',
      'køb nu',
      'köp nu',
      'kjøp nå'
    ];

    function textContainsNeedle(text, needle) {
      if (!needle) return false;
      return text.indexOf(needle) !== -1;
    }

    var scope = rootNode && rootNode.querySelectorAll ? rootNode : document;
    var nodes = scope.querySelectorAll('a, button, input[type="button"], input[type="submit"]');
    nodes.forEach(function (node) {
      var text = normalizeCtaText(getCtaNodeText(node));
      if (!text) return;
      var ctaId = String((node.getAttribute && node.getAttribute('data-nb-cta')) || '').trim().toLowerCase();
      var tagName = node.tagName ? node.tagName.toUpperCase() : '';
      if (tagName === 'A') {
        var existingHref = String(node.getAttribute('href') || '').trim();
        if (existingHref.charAt(0) === '#') return;
        try {
          var parsedExistingHref = new URL(existingHref, window.location.href);
          if (
            parsedExistingHref.hash &&
            parsedExistingHref.origin === window.location.origin &&
            parsedExistingHref.pathname === window.location.pathname
          ) {
            return;
          }
        } catch (_errCtaAnchorHref) {}
      }

      var routeUrl = '';
      if (targets.buyNowUrl && ctaId && BUY_NOW_CTA_IDS[ctaId]) {
        routeUrl = targets.buyNowUrl;
      } else if (targets.productUrl && viewProductNeedle && text.indexOf(viewProductNeedle) !== -1) {
        routeUrl = targets.productUrl;
      } else if (
        targets.buyNowUrl &&
        (
          textContainsNeedle(text, buyShortNeedle) ||
          textContainsNeedle(text, buyNowNeedle) ||
          STATIC_BUY_NEEDLES.some(function (needle) { return textContainsNeedle(text, needle); })
        )
      ) {
        routeUrl = targets.buyNowUrl;
      }
      if (!routeUrl) return;

      if (tagName === 'A') {
        node.setAttribute('href', routeUrl);
        return;
      }

      if (node.dataset.nbRouteBound === 'true' && node.dataset.nbRouteTarget === routeUrl) return;
      node.dataset.nbRouteTarget = routeUrl;
      if (node.dataset.nbRouteBound === 'true') return;
      node.dataset.nbRouteBound = 'true';

      node.addEventListener('click', function (event) {
        var targetUrl = node.getAttribute('data-nb-route-target') || '';
        if (!targetUrl || node.disabled) return;
        event.preventDefault();
        window.location.assign(targetUrl);
      });
    });
  }

  function initConversionCtaRoutes() {
    applyConversionCtaRoutes(document);
    applyConversionPreviewPaths(document);
  }

  function currentPageType() {
    return document.body ? String(document.body.getAttribute('data-page-type') || '').trim().toLowerCase() : '';
  }

  function getArticleRootForNode(node) {
    if (node && node.closest) {
      var closestRoot = node.closest('[data-nb-article-conversion]');
      if (closestRoot) return closestRoot;
    }
    return document.querySelector('[data-nb-article-conversion]');
  }

  function detectArticleIntent(articleRoot) {
    if (!articleRoot || !articleRoot.getAttribute) return 'explainer';
    var cachedIntent = readArticleDataValue(articleRoot, 'data-nb-article-intent').toLowerCase();
    if (cachedIntent) return cachedIntent;

    var source = [
      articleRoot.getAttribute('data-nb-article-handle') || '',
      articleRoot.getAttribute('data-nb-article-title') || '',
      articleRoot.getAttribute('data-nb-article-tags') || ''
    ]
      .join(' ')
      .toLowerCase();

    var rehabMatchers = [
      'blessure',
      'blessures',
      'herstel',
      'behandeling',
      'prevent',
      'oorzaak',
      'oorzaken',
      'symptoom',
      'symptomen',
      'revalid',
      'injur',
      'rehab',
      'recover',
      'treat',
      'verletz',
      'behandl',
      'prävent',
      'recup',
      'rééduc',
      'riabil',
      'skada',
      'skade'
    ];
    for (var rehabIndex = 0; rehabIndex < rehabMatchers.length; rehabIndex += 1) {
      if (source.indexOf(rehabMatchers[rehabIndex]) !== -1) {
        articleRoot.setAttribute('data-nb-article-intent', 'rehab');
        return 'rehab';
      }
    }

    var performanceMatchers = [
      'kracht',
      'strength',
      'performance',
      'versterk',
      'opbouw',
      'progress',
      'topsport',
      'sporter',
      'training',
      'exercise',
      'leistung',
      'kraft',
      'prestatie',
      'prestazioni',
      'fuerza',
      'força',
      'styrke',
      'voima'
    ];
    for (var performanceIndex = 0; performanceIndex < performanceMatchers.length; performanceIndex += 1) {
      if (source.indexOf(performanceMatchers[performanceIndex]) !== -1) {
        articleRoot.setAttribute('data-nb-article-intent', 'performance');
        return 'performance';
      }
    }

    articleRoot.setAttribute('data-nb-article-intent', 'explainer');
    return 'explainer';
  }

  function getArticleLocaleRoot(articleRoot) {
    if (articleRoot && articleRoot.getAttribute) {
      var articleLocale = String(articleRoot.getAttribute('data-nb-article-locale') || '').trim();
      if (articleLocale) return localeBaseCode(articleLocale);
    }
    return localeBaseCode(document.documentElement.getAttribute('lang') || '');
  }

  function normalizeArticleSlug(value) {
    var raw = String(value || '').trim();
    if (!raw) return '';
    if (raw.indexOf('/') === -1) return raw;
    var parts = raw.split('/');
    return String(parts[parts.length - 1] || '').trim();
  }

  function readArticleDataValue(articleRoot, attributeName) {
    if (!articleRoot || !articleRoot.getAttribute || !attributeName) return '';
    var value = String(articleRoot.getAttribute(attributeName) || '').trim();
    if (/liquid syntax error/i.test(value)) {
      articleRoot.removeAttribute(attributeName);
      return '';
    }
    return value;
  }

  function sanitizeArticleDataAttributes(scope) {
    if (!scope || !scope.querySelectorAll) return;
    var roots = [];
    if (scope.matches && scope.matches('[data-nb-article-conversion]')) {
      roots.push(scope);
    }
    var foundRoots = scope.querySelectorAll('[data-nb-article-conversion]');
    for (var i = 0; i < foundRoots.length; i += 1) {
      roots.push(foundRoots[i]);
    }
    var attributes = [
      'data-nb-article-intent',
      'data-nb-article-pillar',
      'data-nb-article-page-type',
      'data-nb-article-cta-mode',
      'data-nb-article-medical',
      'data-nb-product-relevance',
      'data-nb-funnel-stage',
      'data-nb-primary-destination',
      'data-nb-hypothesis-id',
      'data-nb-query-family-id',
      'data-nb-cro-variant',
      'data-nb-cta-experiment-id',
      'data-nb-cta-experiment-variant',
      'data-nb-cta-experiment-arm',
      'data-nb-cta-assignment-id',
      'data-nb-cta-exposure-id',
      'data-nb-cta-creative-id',
      'data-nb-cta-format'
    ];
    for (var rootIndex = 0; rootIndex < roots.length; rootIndex += 1) {
      for (var attrIndex = 0; attrIndex < attributes.length; attrIndex += 1) {
        readArticleDataValue(roots[rootIndex], attributes[attrIndex]);
      }
    }
  }

  function detectArticlePillar(articleRoot) {
    if (!articleRoot || !articleRoot.getAttribute) return '';
    var cachedPillar = readArticleDataValue(articleRoot, 'data-nb-article-pillar').toLowerCase();
    if (cachedPillar) return cachedPillar;

    var source = [
      articleRoot.getAttribute('data-nb-article-slug') || '',
      articleRoot.getAttribute('data-nb-article-handle') || '',
      articleRoot.getAttribute('data-nb-article-title') || ''
    ].join(' ').toLowerCase();

    if (source.indexOf('nordic-hamstring-curl') !== -1 || source.indexOf('nordic hamstring curl') !== -1) return 'a';
    if (source.indexOf('oefening') !== -1 || source.indexOf('oefeningen') !== -1 || source.indexOf('stretches') !== -1 || source.indexOf('hamstrings-en-de-spieren') !== -1) return 'b';
    if (source.indexOf('blessure') !== -1 || source.indexOf('kramp') !== -1) return 'c';
    if (source.indexOf('pijn') !== -1 || source.indexOf('tendinopathie') !== -1 || source.indexOf('tendinitis') !== -1 || source.indexOf('bovenbeen') !== -1) return 'd';
    return '';
  }

  function detectArticlePageType(articleRoot) {
    if (!articleRoot || !articleRoot.getAttribute) return '';
    var cachedPageType = readArticleDataValue(articleRoot, 'data-nb-article-page-type').toLowerCase();
    if (cachedPageType) return cachedPageType;
    var pillar = detectArticlePillar(articleRoot);
    if (pillar === 'a' || pillar === 'c') return 'pillar';
    return '';
  }

  function detectArticleCtaMode(articleRoot) {
    if (!articleRoot || !articleRoot.getAttribute) return '';
    var cachedCtaMode = readArticleDataValue(articleRoot, 'data-nb-article-cta-mode').toLowerCase();
    if (cachedCtaMode) return cachedCtaMode;
    var intent = detectArticleIntent(articleRoot);
    return intent === 'rehab' ? 'delayed' : 'early';
  }

  function detectArticleMedical(articleRoot) {
    if (!articleRoot || !articleRoot.getAttribute) return false;
    var cachedMedical = readArticleDataValue(articleRoot, 'data-nb-article-medical').toLowerCase();
    if (cachedMedical === 'true') return true;
    if (cachedMedical === 'false') return false;
    return detectArticleIntent(articleRoot) === 'rehab';
  }

  function detectArticleProductRelevance(articleRoot) {
    if (!articleRoot || !articleRoot.getAttribute) return 'adjacent';
    var cachedRelevance = readArticleDataValue(articleRoot, 'data-nb-product-relevance').toLowerCase();
    if (/^(direct|adjacent|post_safety)$/.test(cachedRelevance)) return cachedRelevance;
    if (detectArticleMedical(articleRoot) || detectArticleIntent(articleRoot) === 'rehab') return 'post_safety';
    var source = [
      articleRoot.getAttribute('data-nb-article-slug') || '',
      articleRoot.getAttribute('data-nb-article-handle') || '',
      articleRoot.getAttribute('data-nb-article-title') || ''
    ].join(' ').toLowerCase();
    if (/apparaat|equipment|machine|zonder[- ]partner|without[- ]partner|solo|veilige[- ]setup|safe[- ]setup|deuranker|door[- ]anchor|ankle[- ]anchor/.test(source)) {
      return 'direct';
    }
    return 'adjacent';
  }

  function detectArticleFunnelStage(articleRoot) {
    if (!articleRoot || !articleRoot.getAttribute) return 'consideration';
    var cachedStage = readArticleDataValue(articleRoot, 'data-nb-funnel-stage').toLowerCase();
    if (/^(awareness|consideration|purchase)$/.test(cachedStage)) return cachedStage;
    var relevance = detectArticleProductRelevance(articleRoot);
    if (relevance === 'direct') return 'purchase';
    if (relevance === 'post_safety') return 'awareness';
    return 'consideration';
  }

  function detectArticlePrimaryDestination(articleRoot) {
    if (!articleRoot || !articleRoot.getAttribute) return 'home';
    var cachedDestination = readArticleDataValue(articleRoot, 'data-nb-primary-destination').toLowerCase();
    if (/^(product|home)$/.test(cachedDestination)) return cachedDestination;
    return detectArticleProductRelevance(articleRoot) === 'direct' ? 'product' : 'home';
  }

  function detectArticleHypothesisId(articleRoot) {
    if (!articleRoot || !articleRoot.getAttribute) return '';
    return readArticleDataValue(articleRoot, 'data-nb-hypothesis-id').toLowerCase();
  }

  function detectArticleQueryFamilyId(articleRoot) {
    if (!articleRoot || !articleRoot.getAttribute) return '';
    return readArticleDataValue(articleRoot, 'data-nb-query-family-id').toLowerCase();
  }

  function detectArticleCroVariant(articleRoot) {
    if (!articleRoot || !articleRoot.getAttribute) return 'adjacent_v1';
    var cachedVariant = readArticleDataValue(articleRoot, 'data-nb-cro-variant').toLowerCase();
    if (/^(direct_v1|adjacent_v1|post_safety_v1)$/.test(cachedVariant)) return cachedVariant;
    var relevance = detectArticleProductRelevance(articleRoot);
    if (relevance === 'direct') return 'direct_v1';
    if (relevance === 'post_safety') return 'post_safety_v1';
    return 'adjacent_v1';
  }

  function getArticleAnalyticsContext(node) {
    var articleRoot = getArticleRootForNode(node);
    if (!articleRoot) return null;
    var locale = String(articleRoot.getAttribute('data-nb-article-locale') || document.documentElement.getAttribute('lang') || '').trim();
    return {
      root: articleRoot,
      slug: normalizeArticleSlug(articleRoot.getAttribute('data-nb-article-slug') || articleRoot.getAttribute('data-nb-article-handle') || ''),
      title: String(articleRoot.getAttribute('data-nb-article-title') || '').trim(),
      locale: locale,
      locale_root: localeBaseCode(locale || ''),
      intent: detectArticleIntent(articleRoot),
      pillar: detectArticlePillar(articleRoot),
      page_type: detectArticlePageType(articleRoot),
      cta_mode: detectArticleCtaMode(articleRoot),
      medical: detectArticleMedical(articleRoot),
      product_relevance: detectArticleProductRelevance(articleRoot),
      funnel_stage: detectArticleFunnelStage(articleRoot),
      primary_destination: detectArticlePrimaryDestination(articleRoot),
      hypothesis_id: detectArticleHypothesisId(articleRoot),
      query_family_id: detectArticleQueryFamilyId(articleRoot),
      cro_variant: detectArticleCroVariant(articleRoot),
      cta_experiment_id: readArticleDataValue(articleRoot, 'data-nb-cta-experiment-id'),
      cta_experiment_signature: readArticleDataValue(articleRoot, 'data-nb-cta-experiment-signature'),
      cta_message_id: readArticleDataValue(articleRoot, 'data-nb-cta-message-id'),
      cta_experiment_scope: readArticleDataValue(articleRoot, 'data-nb-cta-experiment-scope'),
      cta_traffic_scope: readArticleDataValue(articleRoot, 'data-nb-cta-traffic-scope'),
      cta_experiment_registry_version: readArticleDataValue(articleRoot, 'data-nb-cta-experiment-registry-version'),
      cta_experiment_variant: readArticleDataValue(articleRoot, 'data-nb-cta-experiment-variant'),
      cta_experiment_arm: readArticleDataValue(articleRoot, 'data-nb-cta-experiment-arm'),
      cta_assignment_id: readArticleDataValue(articleRoot, 'data-nb-cta-assignment-id'),
      cta_assignment_device_class: readArticleDataValue(articleRoot, 'data-nb-cta-assignment-device-class'),
      cta_assigned_at: readArticleDataValue(articleRoot, 'data-nb-cta-assigned-at'),
      cta_allocation_percent: Number(readArticleDataValue(articleRoot, 'data-nb-cta-allocation-percent') || 0),
      cta_exposure_id: readArticleDataValue(articleRoot, 'data-nb-cta-exposure-id'),
      cta_creative_id: readArticleDataValue(articleRoot, 'data-nb-cta-creative-id'),
      cta_format: readArticleDataValue(articleRoot, 'data-nb-cta-format'),
      cta_experiment_enrolled: readArticleDataValue(articleRoot, 'data-nb-cta-experiment-enrolled') === 'true',
      cta_experiment_eligible: readArticleDataValue(articleRoot, 'data-nb-cta-experiment-eligible') === 'true',
      cta_qa_override: readArticleDataValue(articleRoot, 'data-nb-cta-qa-override') === 'true',
      cta_device_class: readArticleDataValue(articleRoot, 'data-nb-cta-device-class'),
      cta_eligibility_basis: readArticleDataValue(articleRoot, 'data-nb-cta-eligibility-basis'),
      cta_exclusion_reason: readArticleDataValue(articleRoot, 'data-nb-cta-exclusion-reason')
    };
  }

  function getArticleHomeTailSectionKey(node) {
    if (!node || !node.closest) return '';
    var section = node.closest('.shopify-section');
    if (!section || !section.id) return '';
    var match = section.id.match(/__([A-Za-z0-9_-]+)$/);
    return match && match[1] ? String(match[1]) : '';
  }

  function appendArticleAnalyticsContext(payload, node) {
    if (!payload || typeof payload !== 'object') return payload;
    var articleContext = getArticleAnalyticsContext(node);
    if (!articleContext) return payload;

    if (articleContext.slug) payload.article_slug = articleContext.slug;
    if (articleContext.locale) payload.article_locale = articleContext.locale;
    if (articleContext.locale_root) payload.article_locale_root = articleContext.locale_root;
    if (articleContext.intent) payload.article_intent = articleContext.intent;
    if (articleContext.pillar) payload.pillar = articleContext.pillar;
    if (articleContext.page_type) payload.article_page_type = articleContext.page_type;
    if (articleContext.cta_mode) payload.article_cta_mode = articleContext.cta_mode;
    if (articleContext.medical) payload.article_medical = true;
    if (articleContext.product_relevance) payload.product_relevance = articleContext.product_relevance;
    if (articleContext.funnel_stage) payload.funnel_stage = articleContext.funnel_stage;
    if (articleContext.primary_destination) payload.primary_destination = articleContext.primary_destination;
    if (articleContext.hypothesis_id) payload.hypothesis_id = articleContext.hypothesis_id;
    if (articleContext.query_family_id) payload.query_family_id = articleContext.query_family_id;
    if (articleContext.cro_variant) payload.cro_variant = articleContext.cro_variant;
    if (articleContext.cro_variant) payload.cro_profile = articleContext.cro_variant;
    if (articleContext.cta_experiment_id) payload.blog_cta_experiment_id = articleContext.cta_experiment_id;
    if (articleContext.cta_experiment_signature) payload.blog_cta_experiment_signature = articleContext.cta_experiment_signature;
    if (articleContext.cta_message_id) payload.blog_cta_message_id = articleContext.cta_message_id;
    if (articleContext.cta_experiment_scope) payload.blog_cta_experiment_scope = articleContext.cta_experiment_scope;
    if (articleContext.cta_traffic_scope) payload.blog_cta_traffic_scope = articleContext.cta_traffic_scope;
    if (articleContext.cta_experiment_registry_version) payload.blog_cta_experiment_registry_version = articleContext.cta_experiment_registry_version;
    if (articleContext.cta_experiment_variant) payload.blog_cta_experiment_variant = articleContext.cta_experiment_variant;
    if (articleContext.cta_experiment_arm) payload.blog_cta_experiment_arm = articleContext.cta_experiment_arm;
    if (articleContext.cta_assignment_id) payload.blog_cta_assignment_id = articleContext.cta_assignment_id;
    if (articleContext.cta_assignment_device_class) payload.blog_cta_assignment_device_class = articleContext.cta_assignment_device_class;
    if (articleContext.cta_assigned_at) payload.blog_cta_assigned_at = articleContext.cta_assigned_at;
    if (articleContext.cta_allocation_percent) payload.blog_cta_allocation_percent = articleContext.cta_allocation_percent;
    if (articleContext.cta_exposure_id) payload.blog_cta_exposure_id = articleContext.cta_exposure_id;
    if (articleContext.cta_creative_id) payload.blog_cta_creative_id = articleContext.cta_creative_id;
    if (articleContext.cta_format) payload.blog_cta_format = articleContext.cta_format;
    payload.blog_cta_experiment_enrolled = articleContext.cta_experiment_enrolled;
    payload.blog_cta_experiment_eligible = articleContext.cta_experiment_eligible;
    payload.blog_cta_qa_override = articleContext.cta_qa_override;
    payload.blog_cta_device_class = getBlogCtaDeviceClass();
    if (articleContext.cta_eligibility_basis) payload.blog_cta_eligibility_basis = articleContext.cta_eligibility_basis;
    if (articleContext.cta_exclusion_reason) payload.blog_cta_exclusion_reason = articleContext.cta_exclusion_reason;
    payload.blog_cta_measurement_contract_version = BLOG_CTA_MEASUREMENT_CONTRACT_VERSION;

    var sectionKey = getArticleHomeTailSectionKey(node);
    if (sectionKey.indexOf('home_') === 0) {
      payload.article_origin_zone = 'home_tail';
      payload.home_tail_section = sectionKey;
      if (!payload.slot_type) payload.slot_type = 'home_tail';
      if (!payload.slot_id) payload.slot_id = 'article_' + sectionKey;
    }

    return payload;
  }

  function resolveTrackedDestinationUrl(node) {
    if (!node || !node.getAttribute) return '';
    var previewPath = String(node.getAttribute('data-nb-conv-preview-path') || '').trim();
    if (previewPath) return previewPath;
    var href = String(node.getAttribute('href') || '').trim();
    if (href) return href;
    var form = node.form || (node.closest && node.closest('form'));
    if (form && form.getAttribute) {
      var returnToInput = form.querySelector('input[name="return_to"]');
      if (returnToInput && returnToInput.value) return String(returnToInput.value).trim();
      var action = String(form.getAttribute('action') || '').trim();
      if (action) return action;
    }
    return '';
  }

  function resolveBlogDestinationEventName(destination, destinationUrl) {
    var normalizedDestination = String(destination || '').trim().toLowerCase();
    var normalizedUrl = String(destinationUrl || '').trim().toLowerCase();
    if (normalizedDestination === 'product' || normalizedUrl.indexOf('/products/') !== -1) return 'blog_to_product_click';
    if (normalizedDestination === 'guide' || normalizedUrl.indexOf('/pages/how-to-guide') !== -1) return 'blog_to_guide_click';
    if (normalizedDestination === 'home') return 'blog_to_home_click';
    if (normalizedDestination === 'related_article' || normalizedDestination === 'blog' || normalizedUrl.indexOf('/blogs/blog-posts/') !== -1) return 'blog_to_related_article_click';
    if (normalizedDestination === 'quote' || normalizedUrl.indexOf('/pages/request-a-quote') !== -1 || normalizedUrl.indexOf('/pages/offerte') !== -1) return 'blog_to_quote_click';
    return '';
  }

  function getArticleClickText(node) {
    if (!node) return '';
    var text = String(node.textContent || node.getAttribute && (node.getAttribute('aria-label') || node.getAttribute('title')) || '')
      .replace(/\s+/g, ' ')
      .trim();
    return text.length > 140 ? text.slice(0, 137) + '...' : text;
  }

  function resolveArticleClickUrl(node) {
    if (!node || !node.getAttribute) return '';
    var previewPath = String(node.getAttribute('data-nb-conv-preview-path') || '').trim();
    if (previewPath) return previewPath;
    var href = String(node.getAttribute('href') || '').trim();
    if (href) return href;
    var form = node.form || (node.closest && node.closest('form'));
    if (form && form.getAttribute) {
      var returnToInput = form.querySelector('input[name="return_to"]');
      if (returnToInput && returnToInput.value) return String(returnToInput.value).trim();
      var action = String(form.getAttribute('action') || '').trim();
      if (action) return action;
    }
    return '';
  }

  function inferArticleClickDestination(node, articleRoot, explicitDestination, destinationUrl) {
    var normalizedDestination = String(explicitDestination || '').trim().toLowerCase();
    if (normalizedDestination) return normalizedDestination;

    var targetPath = normalizeArticlePathValue(destinationUrl || (node && node.getAttribute ? node.getAttribute('href') : '') || '');
    if (!targetPath) return '';

    var productPath = normalizeArticlePathValue(articleRoot && articleRoot.getAttribute ? articleRoot.getAttribute('data-nb-product-url') || '' : '');
    var guidePath = normalizeArticlePathValue(articleRoot && articleRoot.getAttribute ? articleRoot.getAttribute('data-nb-guide-url') || '' : '');
    var homePath = normalizeArticlePathValue(articleRoot && articleRoot.getAttribute ? articleRoot.getAttribute('data-nb-home-url') || '' : '');

    if (productPath && targetPath === productPath) return 'product';
    if (guidePath && targetPath === guidePath) return 'guide';
    if (homePath && targetPath === homePath) return 'home';
    if (/\/products\//i.test(targetPath)) return 'product';
    if (/\/pages\/how-to-guide/i.test(targetPath)) return 'guide';
    if (/\/cart|\/checkout/i.test(targetPath)) return 'checkout';
    if (/\/collections\//i.test(targetPath)) return 'collection';
    if (/\/blogs\/blog-posts\//i.test(targetPath)) return 'blog';
    return '';
  }

  function pushArticleClickEvent(eventName, node, articleRoot, options) {
    if (!eventName || !node) return;
    var slotCarrier = node.closest
      ? node.closest('[data-nb-slot-id], [data-nb-slot-type], [data-nb-slot-destination], [data-nb-conversion-slot], [data-nb-inline-slot]')
      : null;
    var destinationUrl = resolveArticleClickUrl(node);
    var explicitDestination = String((options && options.destination) || '').trim();
    var destination = inferArticleClickDestination(node, articleRoot, explicitDestination, destinationUrl);
    var payload = {
      event: eventName,
      context_path: window.location.pathname || '',
      destination: destination || explicitDestination || 'unknown',
      link_url: destinationUrl,
      link_text: getArticleClickText(node)
    };
    if (eventName.indexOf('blog_cta_') === 0) {
      payload.measurement_contract_version = BLOG_CTA_MEASUREMENT_CONTRACT_VERSION;
    }
    var slotId = String((options && options.slot_id) || (node.getAttribute && node.getAttribute('data-nb-slot-id')) || (slotCarrier && slotCarrier.getAttribute ? slotCarrier.getAttribute('data-nb-slot-id') : '') || '').trim();
    var slotType = String((options && options.slot_type) || (node.getAttribute && node.getAttribute('data-nb-slot-type')) || (slotCarrier && slotCarrier.getAttribute ? slotCarrier.getAttribute('data-nb-slot-type') : '') || '').trim();
    if (slotId) payload.slot_id = slotId;
    if (slotType) payload.slot_type = slotType;
    var actionRank = String((options && options.action_rank) || (node.getAttribute && node.getAttribute('data-nb-action-rank')) || '').trim();
    var surfaceSource = String((options && options.surface_source) || (node.getAttribute && node.getAttribute('data-nb-surface-source')) || '').trim();
    if (actionRank) payload.action_rank = actionRank;
    if (surfaceSource) payload.surface_source = surfaceSource;
    if (options && options.placement) payload.placement = options.placement;
    pushEvent(appendArticleAnalyticsContext(payload, articleRoot || node));
  }

  function initCtaTracking() {
    var ctas = document.querySelectorAll('[data-nb-cta]');
    if (!ctas.length) return;

    function readCssPixelVar(root, name) {
      if (!root || !name) return 0;
      var value = parseFloat(String(getComputedStyle(root).getPropertyValue(name) || '').trim());
      return Number.isFinite(value) ? value : 0;
    }

    function getVisibleFixedStackBottom() {
      var bottom = 0;
      ['.nb-announcement', '[data-nb-header]'].forEach(function (selector) {
        var node = document.querySelector(selector);
        if (!node) return;
        var rect = node.getBoundingClientRect();
        if (rect.bottom <= 0 || rect.top >= window.innerHeight) return;
        bottom = Math.max(bottom, rect.bottom);
      });
      return Math.max(0, Math.round(bottom));
    }

    function getArticleTocScrollOffset() {
      var root = document.documentElement;
      var visibleBottom = getVisibleFixedStackBottom();
      var fixedStack = readCssPixelVar(root, '--nb-fixed-stack-height');
      var liveHeader = readCssPixelVar(root, '--nb-header-live-height');
      var staticHeader = readCssPixelVar(root, '--nb-header-height');
      if (visibleBottom > 0) return visibleBottom + 7;
      if (fixedStack > 0) return fixedStack + 7;
      if (liveHeader > 0) return liveHeader + 7;
      if (staticHeader > 0) return staticHeader + 7;
      return 7;
    }

    function scrollToArticleTocTarget(target, targetId) {
      if (!target) return false;
      var offset = getArticleTocScrollOffset();
      var top = Math.max(0, Math.round(window.scrollY + target.getBoundingClientRect().top - offset));
      var prefersReducedMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      window.scrollTo({
        top: top,
        behavior: prefersReducedMotion ? 'auto' : 'smooth'
      });
      if (targetId) {
        var hash = '#' + String(targetId).replace(/^#/, '');
        if (window.location.hash !== hash) {
          if (window.history && typeof window.history.pushState === 'function') {
            window.history.pushState(null, '', hash);
          } else {
            window.location.hash = hash;
          }
        }
      }
      return true;
    }

    ctas.forEach(function (cta) {
      if (cta.dataset.nbCtaBound === 'true') return;
      cta.dataset.nbCtaBound = 'true';
      cta.addEventListener('click', function (event) {
        var slotCarrier = cta.closest('[data-nb-slot-id], [data-nb-slot-type], [data-nb-slot-destination]');
        var htmlRoot = document.documentElement;
        var payload = {
          event: 'cta_click',
          cta_id: cta.getAttribute('data-nb-cta') || '',
          context_path: window.location.pathname
        };
        var slotId = String(cta.getAttribute('data-nb-slot-id') || (slotCarrier && slotCarrier.getAttribute ? slotCarrier.getAttribute('data-nb-slot-id') : '') || '').trim();
        var slotType = String(cta.getAttribute('data-nb-slot-type') || (slotCarrier && slotCarrier.getAttribute ? slotCarrier.getAttribute('data-nb-slot-type') : '') || '').trim();
        var destination = String(cta.getAttribute('data-nb-slot-destination') || (slotCarrier && slotCarrier.getAttribute ? slotCarrier.getAttribute('data-nb-slot-destination') : '') || '').trim().toLowerCase();
        var actionRank = String(cta.getAttribute('data-nb-action-rank') || (slotCarrier && slotCarrier.getAttribute ? slotCarrier.getAttribute('data-nb-action-rank') : '') || '').trim().toLowerCase();
        var surfaceSource = String(cta.getAttribute('data-nb-surface-source') || (slotCarrier && slotCarrier.getAttribute ? slotCarrier.getAttribute('data-nb-surface-source') : '') || '').trim().toLowerCase();
        var cutoffBadgeVariant = String((htmlRoot && htmlRoot.getAttribute('data-nb-product-cutoff-badge-variant')) || '').trim().toUpperCase();
        var cutoffBadgeTest = String((htmlRoot && htmlRoot.getAttribute('data-nb-product-cutoff-badge-test')) || '').trim();
        if (slotId) payload.slot_id = slotId;
        if (slotType) payload.slot_type = slotType;
        if (destination) payload.destination = destination;
        if (actionRank) payload.action_rank = actionRank;
        if (surfaceSource) payload.surface_source = surfaceSource;
        if (cutoffBadgeVariant === 'A' || cutoffBadgeVariant === 'B') {
          payload.product_cutoff_badge_variant = cutoffBadgeVariant;
        }
        if (cutoffBadgeTest) {
          payload.product_cutoff_badge_test = cutoffBadgeTest;
        }

        appendArticleAnalyticsContext(payload, cta);

        if (cta.hasAttribute('data-nb-article-toc-link')) {
          var targetId = String(cta.getAttribute('data-nb-toc-target') || '').trim();
          var target = targetId ? document.getElementById(targetId) : null;
          if (target) {
            event.preventDefault();
            scrollToArticleTocTarget(target, targetId);
          }
          pushEvent(
            appendArticleAnalyticsContext(
              {
                event: 'blog_toc_click',
                context_path: window.location.pathname,
                slot_id: payload.slot_id || 'article_toc',
                slot_type: 'toc',
                toc_target: targetId
              },
              cta
            )
          );
        }

        var articleRootForCta = getArticleRootForNode(cta);
        var inlineExperimentCard = cta.closest ? cta.closest('.nb-article-inline-conversion') : null;
        if (
          articleRootForCta &&
          inlineExperimentCard &&
          inlineExperimentCard.getAttribute('data-nb-cta-experiment-enrolled') === 'true' &&
          inlineExperimentCard.getAttribute('data-nb-cta-qa-override') !== 'true' &&
          hasAttributionStorageConsent()
        ) {
          ensureBlogCtaInteractionExposure(inlineExperimentCard);
        }
        var storedOrigin = null;
        if (articleRootForCta && /^(product|home|guide|checkout)$/.test(destination)) {
          storedOrigin = persistBlogOrigin(articleRootForCta, {
            slot_id: slotId,
            surface_source: surfaceSource || 'theme'
          });
          if (storedOrigin && /^(product|checkout)$/.test(destination)) {
            syncBlogOriginToCart(storedOrigin);
          }
        }

        pushEvent(payload);

        if (articleRootForCta) {
          var specificEventName = '';
          var stickyCta = cta.closest('[data-nb-article-mobile-sticky]');
          var inlineProductCard = inlineExperimentCard;
          if (stickyCta) {
            specificEventName = 'blog_sticky_cta_click';
          } else if (inlineProductCard) {
            specificEventName = 'blog_product_card_click';
          }
          if (specificEventName) {
            pushArticleClickEvent(specificEventName, cta, articleRootForCta, {
              destination: destination,
              slot_id: slotId,
              slot_type: slotType,
              action_rank: actionRank,
              surface_source: surfaceSource,
              placement: stickyCta ? 'article_mobile_sticky' : 'article_product_card'
            });
          }
          if (
            inlineProductCard &&
            inlineProductCard.getAttribute('data-nb-cta-experiment-enrolled') === 'true' &&
            inlineProductCard.getAttribute('data-nb-cta-qa-override') !== 'true' &&
            hasAttributionStorageConsent() &&
            getBlogCtaDeviceClass() === 'desktop'
          ) {
            pushArticleClickEvent('blog_cta_experiment_click', cta, articleRootForCta, {
              destination: destination,
              slot_id: slotId,
              slot_type: slotType,
              action_rank: actionRank,
              surface_source: surfaceSource,
              placement: 'article_product_card'
            });
          }
        }

        var destinationUrl = resolveTrackedDestinationUrl(cta);
        var placement = payload.slot_id || payload.slot_type || payload.cta_id || '';
        if (articleRootForCta && destination && destination !== 'article_section') {
          pushEvent(
            appendArticleAnalyticsContext(
              {
                event: 'blog_cta_click',
                context_path: window.location.pathname,
                destination: destination,
                destination_url: destinationUrl,
                placement: placement,
                slot_id: slotId,
                slot_type: slotType,
                action_rank: actionRank || 'primary',
                surface_source: surfaceSource || 'theme'
              },
              cta
            )
          );
        }
        var destinationEventName = resolveBlogDestinationEventName(destination, destinationUrl);
        if (destinationEventName) {
          pushEvent(
            appendArticleAnalyticsContext(
              {
                event: destinationEventName,
                context_path: window.location.pathname,
                destination: destination || '',
                destination_url: destinationUrl,
                placement: placement,
                slot_id: slotId,
                slot_type: slotType,
                action_rank: actionRank || 'primary',
                surface_source: surfaceSource || 'theme'
              },
              cta
            )
          );
        }
      });
    });
  }

  var blogConversionObserver = null;
  var commercialSurfaceObserver = null;
  var COMMERCIAL_SURFACE_SESSION_KEY = 'nb_commercial_surface_views_v1';
  var BLOG_CONVERSION_SESSION_KEY = 'nb_blog_conversion_impressions_v1';
  var BLOG_SCROLL_DEPTH_SESSION_KEY = 'nb_blog_scroll_depth_v1';
  var BLOG_VIEW_SESSION_KEY = 'nb_blog_view_events_v1';
  var BLOG_CTA_EXPERIMENT_STORAGE_PREFIX = 'nb_blog_cta_layout_assignment_v6::';
  var BLOG_CTA_EXPERIMENT_MUTEX_KEY = 'nb_blog_cta_active_experiment_v5';
  var BLOG_CTA_EXPERIMENT_TTL_MS = 56 * 24 * 60 * 60 * 1000;
  var BLOG_CTA_ASSIGNMENT_SESSION_KEY = 'nb_blog_cta_assignment_events_v1';
  var BLOG_CTA_OPPORTUNITY_SESSION_KEY = 'nb_blog_cta_opportunity_events_v1';
  var BLOG_CTA_EXPOSURE_SESSION_KEY = 'nb_blog_cta_exposure_events_v1';
  var BLOG_HOME_TAIL_ENGAGED_SESSION_KEY = 'nb_blog_home_tail_engaged_v1';
  var BLOG_CTA_DESKTOP_MIN_WIDTH = 1024;
  var BLOG_CTA_SQUARE_MEDIA_FALLBACK_URL = 'https://www.nordbelt.nl/cdn/shop/files/D752523_c86215bc-4539-47d7-8d5b-aa2407ee05e3.webp?v=2564746804793599951&width=700';
  var BLOG_CTA_MEASUREMENT_CONTRACT_VERSION = 'cta_measurement_v2';
  var BLOG_CTA_EXPERIMENT_REGISTRY_VERSION = '2026-07-11.5';
  var blogCtaPendingAssignments = {};
  var BLOG_CTA_EXPERIMENTS = {
    direct: {
      experiment_id: 'nb_blog_cta_format_direct_desktop_v5',
      experiment_signature: 'rich_vs_compact_home_first_door_photo_eligible_blog_desktop_r5',
      message_id: 'home_first_direct_m2',
      experiment_scope: 'direct_desktop_inline_cta_layout',
      traffic_scope: 'eligible_blog_sessions',
      arms: [
        { arm: 'A', variant: 'rich_square_door_r2', creative_id: 'rich_square_door_r2', layout_variant: 'rich_square', format: 'rich', weight: 50 },
        { arm: 'B', variant: 'compact_strip_door_c2', creative_id: 'compact_strip_door_c2', layout_variant: 'compact_inline', format: 'compact', weight: 50 }
      ]
    },
    adjacent: {
      experiment_id: 'nb_blog_cta_format_adjacent_desktop_v5',
      experiment_signature: 'rich_vs_compact_home_first_door_photo_eligible_blog_desktop_r5',
      message_id: 'home_first_adjacent_m2',
      experiment_scope: 'adjacent_desktop_inline_cta_layout',
      traffic_scope: 'eligible_blog_sessions',
      arms: [
        { arm: 'A', variant: 'rich_square_door_r2', creative_id: 'rich_square_door_r2', layout_variant: 'rich_square', format: 'rich', weight: 50 },
        { arm: 'B', variant: 'compact_strip_door_c2', creative_id: 'compact_strip_door_c2', layout_variant: 'compact_inline', format: 'compact', weight: 50 }
      ]
    }
  };

  function readBlogExperimentSessionMap(key) {
    var raw = readStorageItem(window.sessionStorage, key);
    if (!raw) return {};
    var parsed = safeParseJson(raw, {});
    return parsed && typeof parsed === 'object' ? parsed : {};
  }

  function writeBlogExperimentSessionMap(key, value) {
    if (!key || !value || typeof value !== 'object') return;
    writeStorageItem(window.sessionStorage, key, JSON.stringify(value));
  }

  function getBlogCtaDeviceClass() {
    var width = window.innerWidth || document.documentElement.clientWidth || 0;
    if (width >= BLOG_CTA_DESKTOP_MIN_WIDTH) return 'desktop';
    if (width >= 701) return 'tablet';
    return 'mobile';
  }

  function getBlogCtaQaOverride() {
    try {
      var value = String(new URLSearchParams(window.location.search || '').get('nb_blog_cta_layout') || '').trim().toLowerCase();
      return value === 'rich' || value === 'compact' ? value : '';
    } catch (_err) {
      return '';
    }
  }

  function getBlogCtaExperimentSpec(articleRoot) {
    if (!articleRoot || detectArticleMedical(articleRoot)) return null;
    var relevance = detectArticleProductRelevance(articleRoot);
    return BLOG_CTA_EXPERIMENTS[relevance] || null;
  }

  function getBlogCtaExperimentId(articleRoot) {
    var spec = getBlogCtaExperimentSpec(articleRoot);
    return spec ? spec.experiment_id : '';
  }

  function getBlogCtaMessageId(articleRoot) {
    var relevance = detectArticleProductRelevance(articleRoot);
    if (relevance === 'direct') return 'home_first_direct_m2';
    if (relevance === 'post_safety') return 'home_first_post_safety_m2';
    return 'home_first_adjacent_m2';
  }

  function randomBlogCtaUnit() {
    try {
      if (window.crypto && typeof window.crypto.getRandomValues === 'function') {
        var values = new Uint32Array(1);
        window.crypto.getRandomValues(values);
        return values[0] / 4294967296;
      }
    } catch (_err) {}
    return Math.random();
  }

  function getBlogCtaArmSpec(spec, arm) {
    if (!spec || !Array.isArray(spec.arms)) return null;
    for (var index = 0; index < spec.arms.length; index += 1) {
      if (spec.arms[index] && spec.arms[index].arm === arm) return spec.arms[index];
    }
    return null;
  }

  function chooseWeightedBlogCtaArm(spec) {
    if (!spec || !Array.isArray(spec.arms) || !spec.arms.length) return null;
    var totalWeight = spec.arms.reduce(function (sum, armSpec) {
      return sum + Math.max(0, Number(armSpec && armSpec.weight || 0));
    }, 0);
    if (!(totalWeight > 0)) return null;
    var draw = randomBlogCtaUnit() * totalWeight;
    var cumulative = 0;
    for (var index = 0; index < spec.arms.length; index += 1) {
      var armSpec = spec.arms[index];
      cumulative += Math.max(0, Number(armSpec && armSpec.weight || 0));
      if (draw < cumulative) return armSpec;
    }
    return spec.arms[spec.arms.length - 1];
  }

  function readBlogCtaExperimentMutex() {
    if (!hasAttributionStorageConsent()) return null;
    var parsed = safeParseJson(readStorageItem(window.localStorage, BLOG_CTA_EXPERIMENT_MUTEX_KEY), null);
    if (!parsed || typeof parsed !== 'object') return null;
    if (!parsed.experiment_id || !parsed.experiment_signature || !parsed.message_id || !parsed.assignment_id) {
      removeStorageItem(window.localStorage, BLOG_CTA_EXPERIMENT_MUTEX_KEY);
      return null;
    }
    var assignedAt = Date.parse(parsed.assigned_at || '');
    if (!assignedAt || Date.now() - assignedAt > BLOG_CTA_EXPERIMENT_TTL_MS) {
      removeStorageItem(window.localStorage, BLOG_CTA_EXPERIMENT_MUTEX_KEY);
      return null;
    }
    return parsed;
  }

  function writeBlogCtaExperimentMutex(assignment) {
    if (!assignment || !hasAttributionStorageConsent()) return;
    writeStorageItem(window.localStorage, BLOG_CTA_EXPERIMENT_MUTEX_KEY, JSON.stringify({
      experiment_id: assignment.experiment_id,
      experiment_signature: assignment.experiment_signature,
      message_id: assignment.message_id,
      arm: assignment.arm,
      assignment_id: assignment.assignment_id,
      assigned_at: assignment.assigned_at,
      expires_at: assignment.expires_at
    }));
  }

  function readBlogCtaAssignment(spec) {
    if (!spec || !spec.experiment_id || !hasAttributionStorageConsent()) return null;
    var raw = readStorageItem(window.localStorage, BLOG_CTA_EXPERIMENT_STORAGE_PREFIX + spec.experiment_id);
    var parsed = safeParseJson(raw, null);
    if (!parsed || typeof parsed !== 'object') return null;
    var armSpec = getBlogCtaArmSpec(spec, parsed.arm);
    if (
      !armSpec ||
      parsed.experiment_id !== spec.experiment_id ||
      parsed.experiment_signature !== spec.experiment_signature ||
      parsed.message_id !== spec.message_id ||
      parsed.variant !== armSpec.variant ||
      parsed.creative_id !== armSpec.creative_id ||
      !parsed.assignment_id
    ) {
      removeStorageItem(window.localStorage, BLOG_CTA_EXPERIMENT_STORAGE_PREFIX + spec.experiment_id);
      return null;
    }
    var assignedAt = Date.parse(parsed.assigned_at || '');
    if (!assignedAt || Date.now() - assignedAt > BLOG_CTA_EXPERIMENT_TTL_MS) {
      removeStorageItem(window.localStorage, BLOG_CTA_EXPERIMENT_STORAGE_PREFIX + spec.experiment_id);
      return null;
    }
    return parsed;
  }

  function createPendingBlogCtaAssignment(spec) {
    if (!spec || !spec.experiment_id) return null;
    var existing = blogCtaPendingAssignments[spec.experiment_id];
    if (
      existing &&
      existing.experiment_signature === spec.experiment_signature &&
      existing.message_id === spec.message_id
    ) return existing;
    var armSpec = chooseWeightedBlogCtaArm(spec);
    if (!armSpec) return null;
    var pending = {
      experiment_id: spec.experiment_id,
      experiment_signature: spec.experiment_signature,
      message_id: spec.message_id,
      experiment_scope: spec.experiment_scope,
      arm: armSpec.arm,
      variant: armSpec.variant,
      creative_id: armSpec.creative_id,
      layout_variant: armSpec.layout_variant,
      format: armSpec.format,
      weight: armSpec.weight,
      assignment_id: '',
      pending_consent: true
    };
    blogCtaPendingAssignments[spec.experiment_id] = pending;
    return pending;
  }

  function createBlogCtaAssignment(spec, preferredArm) {
    if (!spec || !spec.experiment_id || !hasAttributionStorageConsent()) return null;
    var armSpec = getBlogCtaArmSpec(spec, preferredArm) || chooseWeightedBlogCtaArm(spec);
    if (!armSpec) return null;
    var now = new Date().toISOString();
    var assignment = {
      experiment_id: spec.experiment_id,
      experiment_signature: spec.experiment_signature,
      message_id: spec.message_id,
      experiment_scope: spec.experiment_scope,
      registry_version: BLOG_CTA_EXPERIMENT_REGISTRY_VERSION,
      arm: armSpec.arm,
      variant: armSpec.variant,
      creative_id: armSpec.creative_id,
      layout_variant: armSpec.layout_variant,
      format: armSpec.format,
      weight: armSpec.weight,
      assignment_id: createEventId('cta_assignment'),
      assignment_device_class: getBlogCtaDeviceClass(),
      assigned_at: now,
      expires_at: new Date(Date.now() + BLOG_CTA_EXPERIMENT_TTL_MS).toISOString()
    };
    writeStorageItem(window.localStorage, BLOG_CTA_EXPERIMENT_STORAGE_PREFIX + spec.experiment_id, JSON.stringify(assignment));
    writeBlogCtaExperimentMutex(assignment);
    delete blogCtaPendingAssignments[spec.experiment_id];
    return assignment;
  }

  function resolvedBlogCtaAssignment(spec, assignment, options) {
    var settings = options || {};
    var armSpec = assignment ? getBlogCtaArmSpec(spec, assignment.arm) : null;
    return {
      experimentId: spec ? spec.experiment_id : '',
      experimentSignature: spec ? spec.experiment_signature : '',
      messageId: spec ? spec.message_id : (settings.messageId || ''),
      experimentScope: spec ? spec.experiment_scope : '',
      trafficScope: spec ? spec.traffic_scope : '',
      registryVersion: BLOG_CTA_EXPERIMENT_REGISTRY_VERSION,
      variant: armSpec ? armSpec.variant : (settings.variant || 'rich_square_door_r2'),
      arm: armSpec ? armSpec.arm : (settings.arm || 'control'),
      assignmentId: assignment && assignment.assignment_id ? assignment.assignment_id : '',
      assignmentDeviceClass: assignment && assignment.assignment_device_class ? assignment.assignment_device_class : '',
      assignedAt: assignment && assignment.assigned_at ? assignment.assigned_at : '',
      allocationPercent: armSpec ? Number(armSpec.weight || 0) : 0,
      layoutVariant: armSpec ? armSpec.layout_variant : (settings.layoutVariant || 'rich_square'),
      format: armSpec ? armSpec.format : (settings.format || 'rich'),
      creativeId: armSpec ? armSpec.creative_id : (settings.creativeId || 'rich_square_door_r2'),
      eligible: settings.eligible === true,
      enrolled: settings.enrolled === true,
      qaOverride: settings.qaOverride === true,
      deviceClass: settings.deviceClass || getBlogCtaDeviceClass(),
      eligibilityBasis: settings.eligibilityBasis || '',
      exclusionReason: settings.exclusionReason || ''
    };
  }

  function resolveBlogCtaLayout(articleRoot) {
    var deviceClass = getBlogCtaDeviceClass();
    var relevance = detectArticleProductRelevance(articleRoot);
    var forcedVariant = getBlogCtaQaOverride();
    var spec = getBlogCtaExperimentSpec(articleRoot);
    var experimentId = spec ? spec.experiment_id : '';
    var messageId = getBlogCtaMessageId(articleRoot);
    var desktopEligible = deviceClass === 'desktop' && !!spec;
    var eligibilityBasis = detectArticleHypothesisId(articleRoot) || detectArticleQueryFamilyId(articleRoot)
      ? 'commerce_provenance'
      : 'legacy_governance';

    if (forcedVariant) {
      return {
        experimentId: experimentId || 'nb_blog_cta_format_qa_preview_v1',
        experimentSignature: 'qa_preview_not_for_analysis',
        messageId: messageId,
        experimentScope: 'qa_preview',
        registryVersion: BLOG_CTA_EXPERIMENT_REGISTRY_VERSION,
        variant: forcedVariant === 'compact' ? 'compact_strip_door_c2' : 'rich_square_door_r2',
        arm: forcedVariant === 'compact' ? 'B' : 'A',
        assignmentId: '',
        assignmentDeviceClass: '',
        allocationPercent: 0,
        layoutVariant: forcedVariant === 'compact' ? 'compact_inline' : 'rich_square',
        format: forcedVariant,
        creativeId: forcedVariant === 'compact' ? 'compact_strip_door_c2' : 'rich_square_door_r2',
        eligible: false,
        enrolled: false,
        qaOverride: true,
        deviceClass: deviceClass,
        eligibilityBasis: 'qa_override',
        exclusionReason: 'qa_override'
      };
    }

    if (deviceClass === 'desktop' && relevance === 'post_safety') {
      return {
        experimentId: '',
        experimentSignature: '',
        messageId: 'home_first_post_safety_m2',
        experimentScope: '',
        registryVersion: BLOG_CTA_EXPERIMENT_REGISTRY_VERSION,
        variant: 'compact_safety_door_c2',
        arm: 'control',
        assignmentId: '',
        assignmentDeviceClass: '',
        allocationPercent: 0,
        layoutVariant: 'compact_safety',
        format: 'compact',
        creativeId: 'compact_safety_door_c2',
        eligible: false,
        enrolled: false,
        qaOverride: false,
        deviceClass: deviceClass,
        eligibilityBasis: 'medical_safety_control',
        exclusionReason: 'medical_safety_control'
      };
    }

    if (!desktopEligible) {
      return resolvedBlogCtaAssignment(spec, null, {
        variant: 'rich_square_door_r2',
        arm: 'control',
        layoutVariant: 'rich_square',
        format: 'rich',
        creativeId: 'rich_square_door_r2',
        messageId: messageId,
        eligible: false,
        enrolled: false,
        deviceClass: deviceClass,
        eligibilityBasis: deviceClass === 'desktop' ? eligibilityBasis : 'desktop_only',
        exclusionReason: deviceClass === 'desktop' ? 'not_experiment_eligible' : 'desktop_only'
      });
    }

    var mutex = readBlogCtaExperimentMutex();
    if (
      mutex &&
      (
        mutex.experiment_id !== spec.experiment_id ||
        mutex.experiment_signature !== spec.experiment_signature ||
        mutex.message_id !== spec.message_id
      )
    ) {
      return resolvedBlogCtaAssignment(spec, null, {
        variant: 'rich_square_door_r2',
        arm: 'control_excluded',
        layoutVariant: 'rich_square',
        format: 'rich',
        creativeId: 'rich_square_door_r2',
        eligible: true,
        enrolled: false,
        deviceClass: deviceClass,
        eligibilityBasis: eligibilityBasis,
        exclusionReason: 'global_experiment_mutex'
      });
    }

    var assignment = readBlogCtaAssignment(spec);
    if (!assignment && hasAttributionStorageConsent()) {
      assignment = createBlogCtaAssignment(
        spec,
        mutex && mutex.experiment_id === spec.experiment_id && mutex.message_id === spec.message_id ? mutex.arm : ''
      );
    }
    if (!assignment) {
      var pending = createPendingBlogCtaAssignment(spec);
      return resolvedBlogCtaAssignment(spec, pending, {
        eligible: true,
        enrolled: false,
        deviceClass: deviceClass,
        eligibilityBasis: 'consent_required',
        exclusionReason: 'pending_consent'
      });
    }

    return resolvedBlogCtaAssignment(spec, assignment, {
      eligible: true,
      enrolled: true,
      deviceClass: deviceClass,
      eligibilityBasis: eligibilityBasis
    });
  }

  function setBlogCtaExperimentData(node, assignment) {
    if (!node || !node.setAttribute || !assignment) return;
    var values = {
      'data-nb-layout-variant': assignment.layoutVariant,
      'data-nb-cta-experiment-id': assignment.experimentId,
      'data-nb-cta-experiment-signature': assignment.experimentSignature,
      'data-nb-cta-message-id': assignment.messageId,
      'data-nb-cta-experiment-scope': assignment.experimentScope,
      'data-nb-cta-traffic-scope': assignment.trafficScope,
      'data-nb-cta-experiment-registry-version': assignment.registryVersion,
      'data-nb-cta-experiment-variant': assignment.variant,
      'data-nb-cta-experiment-arm': assignment.arm,
      'data-nb-cta-assignment-id': assignment.assignmentId,
      'data-nb-cta-assignment-device-class': assignment.assignmentDeviceClass,
      'data-nb-cta-assigned-at': assignment.assignedAt,
      'data-nb-cta-allocation-percent': String(assignment.allocationPercent || 0),
      'data-nb-cta-creative-id': assignment.creativeId,
      'data-nb-cta-format': assignment.format,
      'data-nb-cta-experiment-eligible': assignment.eligible ? 'true' : 'false',
      'data-nb-cta-experiment-enrolled': assignment.enrolled ? 'true' : 'false',
      'data-nb-cta-qa-override': assignment.qaOverride ? 'true' : 'false',
      'data-nb-cta-device-class': assignment.deviceClass,
      'data-nb-cta-eligibility-basis': assignment.eligibilityBasis,
      'data-nb-cta-exclusion-reason': assignment.exclusionReason
    };
    Object.keys(values).forEach(function (attribute) {
      node.setAttribute(attribute, values[attribute] || '');
    });
  }

  function applyBlogCtaLayoutExperiment(wrapper, articleRoot) {
    var assignment = resolveBlogCtaLayout(articleRoot);
    wrapper.classList.add(assignment.format === 'compact' ? 'is-layout-compact' : 'is-layout-rich');
    if (assignment.layoutVariant === 'compact_safety') wrapper.classList.add('is-layout-safety');
    setBlogCtaExperimentData(wrapper, assignment);
    setBlogCtaExperimentData(articleRoot, assignment);
    return assignment;
  }

  function enrollPendingBlogCtaAssignments(rootNode) {
    if (!hasAttributionStorageConsent()) return;
    var scope = rootNode && rootNode.querySelectorAll ? rootNode : document;
    var articleRoots = [];
    if (scope.matches && scope.matches('[data-nb-article-conversion]')) articleRoots.push(scope);
    scope.querySelectorAll('[data-nb-article-conversion]').forEach(function (articleRoot) {
      articleRoots.push(articleRoot);
    });
    articleRoots.forEach(function (articleRoot) {
      if (!articleRoot || getBlogCtaDeviceClass() !== 'desktop') return;
      if (articleRoot.getAttribute('data-nb-cta-experiment-enrolled') === 'true') return;
      if (articleRoot.getAttribute('data-nb-cta-exclusion-reason') !== 'pending_consent') return;
      var spec = getBlogCtaExperimentSpec(articleRoot);
      if (!spec) return;
      var mutex = readBlogCtaExperimentMutex();
      if (
        mutex &&
        (
          mutex.experiment_id !== spec.experiment_id ||
          mutex.experiment_signature !== spec.experiment_signature ||
          mutex.message_id !== spec.message_id
        )
      ) return;
      var pending = blogCtaPendingAssignments[spec.experiment_id] || createPendingBlogCtaAssignment(spec);
      var assignment = createBlogCtaAssignment(spec, pending && pending.arm ? pending.arm : '');
      if (!assignment) return;
      var resolved = resolvedBlogCtaAssignment(spec, assignment, {
        eligible: true,
        enrolled: true,
        deviceClass: 'desktop',
        eligibilityBasis: detectArticleHypothesisId(articleRoot) || detectArticleQueryFamilyId(articleRoot)
          ? 'commerce_provenance'
          : 'legacy_governance'
      });
      var block = articleRoot.querySelector('.nb-article-inline-conversion');
      if (block) {
        block.classList.remove('is-layout-rich', 'is-layout-compact', 'is-layout-safety');
        block.classList.add(resolved.format === 'compact' ? 'is-layout-compact' : 'is-layout-rich');
        setBlogCtaExperimentData(block, resolved);
      }
      setBlogCtaExperimentData(articleRoot, resolved);
      var sentinel = articleRoot.querySelector('[data-nb-cta-opportunity-sentinel]');
      if (!sentinel && block) {
        sentinel = createArticleCtaOpportunitySentinel(block);
        if (sentinel) insertNodeBefore(sentinel, block);
      }
      persistBlogOrigin(articleRoot, { surface_source: 'consent_accept_assignment' });
      initBlogCtaExperimentTracking(articleRoot);
    });
  }

  function trackBlogCtaExperimentAssignment(node) {
    if (!node || !hasAttributionStorageConsent()) return;
    if (node.getAttribute('data-nb-cta-experiment-enrolled') !== 'true') return;
    if (node.getAttribute('data-nb-cta-qa-override') === 'true') return;
    var experimentId = String(node.getAttribute('data-nb-cta-experiment-id') || '').trim();
    var assignmentId = String(node.getAttribute('data-nb-cta-assignment-id') || '').trim();
    if (!experimentId || !assignmentId) return;
    var articleRoot = getArticleRootForNode(node);
    var context = getArticleAnalyticsContext(articleRoot || node);
    var key = experimentId + '::' + assignmentId + '::' + (context && context.slug ? context.slug : window.location.pathname);
    var events = readBlogExperimentSessionMap(BLOG_CTA_ASSIGNMENT_SESSION_KEY);
    if (events[key]) return;
    events[key] = Date.now();
    writeBlogExperimentSessionMap(BLOG_CTA_ASSIGNMENT_SESSION_KEY, events);
    pushEvent(
      appendArticleAnalyticsContext(
        {
          event: 'blog_cta_experiment_eligible',
          context_path: window.location.pathname || '',
          eligibility_scope: 'consented_pre_assignment',
          measurement_contract_version: BLOG_CTA_MEASUREMENT_CONTRACT_VERSION
        },
        node
      )
    );
    pushEvent(
      appendArticleAnalyticsContext(
        {
          event: 'blog_cta_experiment_assignment',
          context_path: window.location.pathname || '',
          randomization_unit: 'consented_visitor',
          allocation_percent: Number(node.getAttribute('data-nb-cta-allocation-percent') || 0),
          experiment_scope: String(node.getAttribute('data-nb-cta-experiment-scope') || 'desktop_inline_cta_layout'),
          experiment_signature: String(node.getAttribute('data-nb-cta-experiment-signature') || ''),
          measurement_contract_version: BLOG_CTA_MEASUREMENT_CONTRACT_VERSION
        },
        node
      )
    );
  }

  function clearBlogCtaExperimentStorage() {
    try {
      for (var index = window.localStorage.length - 1; index >= 0; index -= 1) {
        var key = window.localStorage.key(index);
        if (key && key.indexOf('nb_blog_cta_layout_assignment_') === 0) {
          window.localStorage.removeItem(key);
        }
      }
    } catch (_err) {}
    removeStorageItem(window.localStorage, BLOG_CTA_EXPERIMENT_MUTEX_KEY);
    blogCtaPendingAssignments = {};
    removeStorageItem(window.sessionStorage, BLOG_CTA_ASSIGNMENT_SESSION_KEY);
    removeStorageItem(window.sessionStorage, BLOG_CTA_OPPORTUNITY_SESSION_KEY);
    removeStorageItem(window.sessionStorage, BLOG_CTA_EXPOSURE_SESSION_KEY);
    removeStorageItem(window.sessionStorage, BLOG_HOME_TAIL_ENGAGED_SESSION_KEY);
  }

  function clearBlogCtaExperimentCartAttributes() {
    if (!window.fetch) return;
    var attributes = {
      __nb_cta_test_id: '',
      __nb_cta_test_signature: '',
      __nb_cta_test_arm: '',
      __nb_cta_test_variant: '',
      __nb_cta_assignment_id: '',
      __nb_cta_assigned_at: '',
      __nb_cta_exposure_id: '',
      __nb_cta_creative_id: '',
      __nb_cta_profile: '',
      __nb_cta_device: '',
      __nb_cta_locale: '',
      __nb_cta_registry_version: '',
      __nb_cta_traffic_scope: '',
      __nb_cta_message_id: ''
    };
    window.fetch(buildCartEndpointPathWithPreview('/cart/update.js'), {
      method: 'POST',
      credentials: 'same-origin',
      keepalive: true,
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ attributes: attributes })
    }).catch(function () {});
  }

  document.addEventListener('nb:consent-changed', function (event) {
    var choice = event && event.detail ? String(event.detail.choice || '') : '';
    if (choice === 'accepted') {
      enrollPendingBlogCtaAssignments(document);
      return;
    }
    if (choice === 'essential') {
      clearBlogCtaExperimentStorage();
      clearBlogCtaExperimentCartAttributes();
    }
  });

  function readCommercialSurfaceViews() {
    var raw = readStorageItem(window.sessionStorage, COMMERCIAL_SURFACE_SESSION_KEY);
    if (!raw) return {};
    var parsed = safeParseJson(raw, {});
    if (!parsed || typeof parsed !== 'object') return {};
    return parsed;
  }

  function writeCommercialSurfaceViews(nextValue) {
    if (!nextValue || typeof nextValue !== 'object') return;
    writeStorageItem(window.sessionStorage, COMMERCIAL_SURFACE_SESSION_KEY, JSON.stringify(nextValue));
  }

  function getCommercialPageSurface() {
    var body = document.body;
    var pageType = body ? String(body.getAttribute('data-page-type') || '').trim().toLowerCase() : '';
    var templateName = body ? String(body.getAttribute('data-template-name') || '').trim().toLowerCase() : '';
    var path = String(window.location.pathname || '/').toLowerCase();

    if (pageType === 'index' || templateName === 'index' || path === '/' || /^\/[a-z]{2}(?:-[a-z0-9]{2,4})?\/?$/.test(path)) {
      return 'homepage';
    }

    if (pageType === 'product' || /^\/(?:[a-z]{2}(?:-[a-z0-9]{2,4})?\/)?products\/[^/?#]+\/?$/.test(path)) {
      return 'product_page';
    }

    return '';
  }

  function trackCommercialSurfaceView(surface, sourceNode) {
    var normalizedSurface = String(surface || '').trim().toLowerCase();
    if (!normalizedSurface) return '';

    var contextPath = window.location.pathname || '';
    var dedupeKey = contextPath + '::' + normalizedSurface;
    var surfaceMap = readCommercialSurfaceViews();
    if (surfaceMap[dedupeKey]) return '';
    surfaceMap[dedupeKey] = Date.now();
    writeCommercialSurfaceViews(surfaceMap);

    return pushEvent(
      appendArticleAnalyticsContext(
        {
          event: 'commercial_surface_view',
          commercial_surface: normalizedSurface,
          context_path: contextPath,
          page_type: document.body ? (document.body.getAttribute('data-page-type') || '') : ''
        },
        sourceNode || document.body
      )
    );
  }

  function ensureCommercialSurfaceObserver() {
    if (!('IntersectionObserver' in window)) return null;
    if (commercialSurfaceObserver) return commercialSurfaceObserver;

    commercialSurfaceObserver = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting || entry.intersectionRatio < 0.45) return;
          var node = entry.target;
          if (!node || !node.getAttribute) return;
          var surface = String(node.getAttribute('data-nb-commercial-surface') || '').trim();
          if (surface) trackCommercialSurfaceView(surface, node);
          node.setAttribute('data-nb-commercial-surface-tracked', 'true');
          commercialSurfaceObserver.unobserve(node);
        });
      },
      { threshold: [0, 0.45, 0.72] }
    );

    return commercialSurfaceObserver;
  }

  function observeCommercialSurfaceNode(node, surface) {
    if (!node || !node.getAttribute || !surface) return;
    if (node.getAttribute('data-nb-commercial-surface-bound') === 'true') return;

    node.setAttribute('data-nb-commercial-surface-bound', 'true');
    node.setAttribute('data-nb-commercial-surface', surface);

    var observer = ensureCommercialSurfaceObserver();
    if (observer) {
      observer.observe(node);
    } else {
      trackCommercialSurfaceView(surface, node);
      node.setAttribute('data-nb-commercial-surface-tracked', 'true');
    }
  }

  function initCommercialSurfaceViewTracking(rootNode) {
    var pageSurface = getCommercialPageSurface();
    if (pageSurface) {
      trackCommercialSurfaceView(pageSurface, document.body);
    }

    var scope = rootNode && rootNode.querySelectorAll ? rootNode : document;
    var selector = [
      'body[data-page-type="article"] .shopify-section[id*="__home_hero"]',
      'body[data-page-type="article"] .shopify-section[id*="__home_backbone"]',
      'body[data-page-type="article"] .shopify-section[id*="__home_homepage"]',
      'body[data-page-type="article"] .nb-home2-hero',
      'body[data-page-type="article"] .nb-home-ab-homepage2-panel'
    ].join(', ');

    if (scope && scope.nodeType === 1 && scope.matches && scope.matches(selector)) {
      observeCommercialSurfaceNode(scope, 'blog_homepage_tail');
    }

    var tailNodes = scope.querySelectorAll ? scope.querySelectorAll(selector) : [];
    tailNodes.forEach(function (node) {
      observeCommercialSurfaceNode(node, 'blog_homepage_tail');
    });
    initBlogHomepageTailEngagedTracking(scope);
  }

  var blogHomepageTailEngagementStates = typeof WeakMap === 'function' ? new WeakMap() : null;

  function findBlogHomepageTailNodes(scope) {
    var root = scope && scope.querySelector ? scope : document;
    var selector = [
      'body[data-page-type="article"] .nb-main-content > .shopify-section[id*="__home_hero"]',
      'body[data-page-type="article"] main > .shopify-section[id*="__home_hero"]',
      'body[data-page-type="article"] .nb-main-content > .shopify-section[id*="__home_"]',
      'body[data-page-type="article"] main > .shopify-section[id*="__home_"]'
    ].join(', ');
    var nodes = Array.prototype.slice.call(root.querySelectorAll(selector));
    if (!nodes.length && root !== document) nodes = Array.prototype.slice.call(document.querySelectorAll(selector));
    return nodes.filter(function (node, index) { return nodes.indexOf(node) === index; });
  }

  function getViewportCoverageRatio(node) {
    if (!node || !node.getBoundingClientRect) return 0;
    var rect = node.getBoundingClientRect();
    var viewportWidth = window.innerWidth || document.documentElement.clientWidth || 0;
    var viewportHeight = window.innerHeight || document.documentElement.clientHeight || 0;
    if (viewportWidth <= 0 || viewportHeight <= 0 || rect.width <= 0 || rect.height <= 0) return 0;
    var visibleWidth = Math.max(0, Math.min(rect.right, viewportWidth) - Math.max(rect.left, 0));
    var visibleHeight = Math.max(0, Math.min(rect.bottom, viewportHeight) - Math.max(rect.top, 0));
    return Math.max(0, Math.min(1, (visibleWidth * visibleHeight) / (viewportWidth * viewportHeight)));
  }

  function hasArticleReachedTrackedDepth(articleRoot, depth) {
    if (!articleRoot) return false;
    var key = (window.location.pathname || '') + '::' + String(articleRoot.getAttribute('data-nb-article-handle') || '') + '::' + String(depth);
    return !!readBlogScrollDepthImpressions()[key];
  }

  function trackBlogHomepageTailEngagedView(node, state) {
    if (!node || !state || !hasAttributionStorageConsent()) return;
    var articleRoot = getArticleRootForNode(node) || document.querySelector('[data-nb-article-conversion]');
    if (!articleRoot || !hasArticleReachedTrackedDepth(articleRoot, 90)) return;
    var context = getArticleAnalyticsContext(articleRoot);
    var key = (window.location.pathname || '') + '::' + (context && context.slug ? context.slug : '') + '::home_tail_engaged';
    var events = readBlogExperimentSessionMap(BLOG_HOME_TAIL_ENGAGED_SESSION_KEY);
    if (events[key]) return;
    events[key] = Date.now();
    writeBlogExperimentSessionMap(BLOG_HOME_TAIL_ENGAGED_SESSION_KEY, events);
    state.completed = true;
    pushEvent(
      appendArticleAnalyticsContext(
        {
          event: 'blog_home_tail_engaged_view',
          conversion_class: 'earned_attention',
          is_micro_conversion: true,
          commercial_surface: 'blog_homepage_tail',
          context_path: window.location.pathname || '',
          read_depth_required: 90,
          visibility_threshold_pct: 50,
          cumulative_dwell_threshold_ms: 8000,
          continuous_dwell_threshold_ms: 3000,
          active_visible_ms: Math.round(state.cumulativeVisibleMs),
          longest_continuous_visible_ms: Math.round(state.longestContinuousMs),
          max_viewport_coverage: Math.round(state.maxCoverage * 1000) / 1000,
          home_tail_section: getArticleHomeTailSectionKey(node) || 'home_hero'
        },
        articleRoot
      )
    );
  }

  function initBlogHomepageTailEngagedTracking(rootNode) {
    if (!document.body || document.body.getAttribute('data-page-type') !== 'article') return;
    var tailNodes = findBlogHomepageTailNodes(rootNode);
    var node = tailNodes[0];
    if (!node || node.getAttribute('data-nb-home-tail-engagement-bound') === 'true') return;
    node.setAttribute('data-nb-home-tail-engagement-bound', 'true');
    tailNodes.forEach(function (tailNode) {
      tailNode.setAttribute('data-nb-home-tail-engagement-member', 'true');
    });
    var state = {
      cumulativeVisibleMs: 0,
      continuousVisibleMs: 0,
      longestContinuousMs: 0,
      maxCoverage: 0,
      lastTickAt: 0,
      intervalId: 0,
      completed: false
    };
    if (blogHomepageTailEngagementStates) blogHomepageTailEngagementStates.set(node, state);

    function stopTicker() {
      if (state.intervalId) window.clearInterval(state.intervalId);
      state.intervalId = 0;
      state.lastTickAt = 0;
      state.continuousVisibleMs = 0;
    }

    function tick() {
      if (state.completed) {
        stopTicker();
        return;
      }
      var now = Date.now();
      var delta = state.lastTickAt ? Math.min(500, Math.max(0, now - state.lastTickAt)) : 0;
      state.lastTickAt = now;
      var articleRoot = getArticleRootForNode(node) || document.querySelector('[data-nb-article-conversion]');
      var coverage = 0;
      var activeTailNode = node;
      var activeTailCoverage = 0;
      tailNodes.forEach(function (tailNode) {
        var tailCoverage = getViewportCoverageRatio(tailNode);
        coverage = Math.min(1, coverage + tailCoverage);
        if (tailCoverage > activeTailCoverage) {
          activeTailCoverage = tailCoverage;
          activeTailNode = tailNode;
        }
      });
      state.maxCoverage = Math.max(state.maxCoverage, coverage);
      var active = document.visibilityState === 'visible' && (!document.hasFocus || document.hasFocus());
      var qualifies = active && hasAttributionStorageConsent() && coverage >= 0.5 && hasArticleReachedTrackedDepth(articleRoot, 90);
      if (!qualifies) {
        state.continuousVisibleMs = 0;
        return;
      }
      state.cumulativeVisibleMs += delta;
      state.continuousVisibleMs += delta;
      state.longestContinuousMs = Math.max(state.longestContinuousMs, state.continuousVisibleMs);
      if (state.cumulativeVisibleMs >= 8000 && state.longestContinuousMs >= 3000) {
        trackBlogHomepageTailEngagedView(activeTailNode, state);
      }
    }

    function startTicker() {
      if (state.completed || state.intervalId) return;
      state.lastTickAt = Date.now();
      state.intervalId = window.setInterval(tick, 250);
    }

    if ('IntersectionObserver' in window) {
      var visibleTailNodes = [];
      var observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          var existingIndex = visibleTailNodes.indexOf(entry.target);
          if (entry.isIntersecting && existingIndex === -1) visibleTailNodes.push(entry.target);
          if (!entry.isIntersecting && existingIndex !== -1) visibleTailNodes.splice(existingIndex, 1);
        });
        if (visibleTailNodes.length) startTicker();
        else stopTicker();
      }, { threshold: [0, 0.01, 0.25, 0.5, 0.75] });
      tailNodes.forEach(function (tailNode) { observer.observe(tailNode); });
      window.addEventListener('pagehide', function () {
        stopTicker();
        observer.disconnect();
      }, { once: true });
    } else {
      startTicker();
    }
  }

  function getElementVisibleRatio(node) {
    if (!node || !node.getBoundingClientRect) return 0;
    var rect = node.getBoundingClientRect();
    var viewportWidth = window.innerWidth || document.documentElement.clientWidth || 0;
    var viewportHeight = window.innerHeight || document.documentElement.clientHeight || 0;
    if (viewportWidth <= 0 || viewportHeight <= 0 || rect.width <= 0 || rect.height <= 0) return 0;
    var visibleWidth = Math.max(0, Math.min(rect.right, viewportWidth) - Math.max(rect.left, 0));
    var visibleHeight = Math.max(0, Math.min(rect.bottom, viewportHeight) - Math.max(rect.top, 0));
    return Math.max(0, Math.min(1, (visibleWidth * visibleHeight) / (rect.width * rect.height)));
  }

  function createArticleCtaOpportunitySentinel(block) {
    if (!block || block.getAttribute('data-nb-cta-experiment-enrolled') !== 'true') return null;
    var sentinel = document.createElement('span');
    sentinel.className = 'nb-article-cta-opportunity-sentinel';
    sentinel.setAttribute('aria-hidden', 'true');
    sentinel.setAttribute('data-nb-cta-opportunity-sentinel', '');
    sentinel.setAttribute('data-nb-slot-id', block.getAttribute('data-nb-slot-id') || 'article_inline_cta');
    sentinel.setAttribute('data-nb-slot-type', block.getAttribute('data-nb-slot-type') || 'rescue');
    sentinel.setAttribute('data-nb-slot-destination', block.getAttribute('data-nb-slot-destination') || 'unknown');
    sentinel.setAttribute('data-nb-cta-experiment-enrolled', 'true');
    sentinel.setAttribute('data-nb-cta-qa-override', block.getAttribute('data-nb-cta-qa-override') || 'false');
    return sentinel;
  }

  function trackBlogCtaExperimentQualifiedEvent(node, eventName, storageKey, options) {
    if (!node || !eventName || !storageKey || !hasAttributionStorageConsent()) return;
    var settings = options || {};
    var articleRoot = getArticleRootForNode(node);
    if (!articleRoot || articleRoot.getAttribute('data-nb-cta-experiment-enrolled') !== 'true') return;
    if (articleRoot.getAttribute('data-nb-cta-qa-override') === 'true') return;
    var context = getArticleAnalyticsContext(articleRoot);
    if (!context || !context.cta_experiment_id || !context.cta_assignment_id) return;
    var actualDeviceClass = getBlogCtaDeviceClass();
    if (actualDeviceClass !== 'desktop') {
      var mismatchEvents = readBlogExperimentSessionMap(storageKey);
      var mismatchKey = context.cta_experiment_id + '::' + context.cta_assignment_id + '::delivery_mismatch::' + actualDeviceClass;
      if (!mismatchEvents[mismatchKey]) {
        mismatchEvents[mismatchKey] = Date.now();
        writeBlogExperimentSessionMap(storageKey, mismatchEvents);
        pushEvent(
          appendArticleAnalyticsContext(
            {
              event: 'blog_cta_experiment_delivery_mismatch',
              context_path: window.location.pathname || '',
              assignment_device_class: context.cta_assignment_device_class || '',
              actual_device_class: actualDeviceClass,
              excluded_from_analysis: true,
              measurement_contract_version: BLOG_CTA_MEASUREMENT_CONTRACT_VERSION
            },
            articleRoot
          )
        );
      }
      return;
    }
    var slotId = String(node.getAttribute('data-nb-slot-id') || '').trim();
    var key = [
      window.location.pathname || '',
      context.cta_experiment_id,
      context.cta_assignment_id,
      context.cta_experiment_variant,
      slotId,
      eventName
    ].join('::');
    var events = readBlogExperimentSessionMap(storageKey);
    if (events[key]) return;

    var exposureId = '';
    if (eventName === 'blog_cta_experiment_exposure') {
      exposureId = createEventId('cta_exposure');
      articleRoot.setAttribute('data-nb-cta-exposure-id', exposureId);
      var block = node.matches && node.matches('.nb-article-inline-conversion')
        ? node
        : articleRoot.querySelector('.nb-article-inline-conversion[data-nb-cta-experiment-enrolled="true"]');
      if (block) block.setAttribute('data-nb-cta-exposure-id', exposureId);
      persistBlogOrigin(articleRoot, {
        slot_id: slotId,
        surface_source: 'cta_exposure',
        exposure_id: exposureId
      });
    }

    events[key] = Date.now();
    writeBlogExperimentSessionMap(storageKey, events);
    pushEvent(
      appendArticleAnalyticsContext(
        {
          event: eventName,
          context_path: window.location.pathname || '',
          slot_id: slotId,
          slot_type: String(node.getAttribute('data-nb-slot-type') || 'rescue'),
          destination: String(node.getAttribute('data-nb-slot-destination') || 'unknown'),
          minimum_visible_percent: typeof settings.minimumVisiblePercent === 'number'
            ? settings.minimumVisiblePercent
            : (eventName === 'blog_cta_experiment_exposure' ? 50 : 1),
          minimum_visible_ms: typeof settings.minimumVisibleMs === 'number' ? settings.minimumVisibleMs : 1000,
          opportunity_scope: eventName === 'blog_cta_opportunity' ? 'assigned_consented_opportunity' : '',
          opportunity_basis: eventName === 'blog_cta_opportunity' ? 'shared_insertion_sentinel' : 'actual_creative',
          exposure_basis: eventName === 'blog_cta_experiment_exposure' ? (settings.exposureBasis || 'qualified_visibility') : '',
          actual_device_class: actualDeviceClass,
          measurement_contract_version: BLOG_CTA_MEASUREMENT_CONTRACT_VERSION,
          exposure_id: exposureId
        },
        articleRoot
      )
    );
  }

  function ensureBlogCtaInteractionExposure(block) {
    if (!block) return;
    trackBlogCtaExperimentQualifiedEvent(
      block,
      'blog_cta_experiment_exposure',
      BLOG_CTA_EXPOSURE_SESSION_KEY,
      {
        minimumVisiblePercent: Math.round(getElementVisibleRatio(block) * 100),
        minimumVisibleMs: 0,
        exposureBasis: 'interaction_implied'
      }
    );
  }

  function bindBlogCtaQualifiedVisibility(node, options) {
    if (!node || !options || node.getAttribute(options.boundAttribute) === 'true') return;
    node.setAttribute(options.boundAttribute, 'true');
    var timerId = 0;
    var observer = null;
    var completed = false;

    function clearTimer() {
      if (timerId) window.clearTimeout(timerId);
      timerId = 0;
    }

    function qualifiesNow() {
      if (completed || !hasAttributionStorageConsent()) return false;
      if (document.visibilityState !== 'visible') return false;
      if (document.hasFocus && !document.hasFocus()) return false;
      return getElementVisibleRatio(node) >= options.minimumRatio;
    }

    function finish() {
      clearTimer();
      if (!qualifiesNow()) return;
      completed = true;
      trackBlogCtaExperimentQualifiedEvent(node, options.eventName, options.storageKey);
      if (observer) observer.disconnect();
      document.removeEventListener('visibilitychange', handleVisibilityChange);
      window.removeEventListener('blur', clearTimer);
      window.removeEventListener('focus', schedule);
    }

    function schedule() {
      if (!qualifiesNow() || timerId) return;
      timerId = window.setTimeout(finish, options.minimumVisibleMs);
    }

    function handleVisibilityChange() {
      if (document.visibilityState !== 'visible') clearTimer();
      else schedule();
    }

    if ('IntersectionObserver' in window) {
      observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.target !== node) return;
          if (entry.isIntersecting && getElementVisibleRatio(node) >= options.minimumRatio) schedule();
          else clearTimer();
        });
      }, { threshold: [0, 0.01, 0.5, 1] });
      observer.observe(node);
    } else {
      schedule();
    }

    document.addEventListener('visibilitychange', handleVisibilityChange);
    window.addEventListener('blur', clearTimer);
    window.addEventListener('focus', schedule);
  }

  function initBlogCtaExperimentTracking(rootNode) {
    var scope = rootNode && rootNode.querySelectorAll ? rootNode : document;
    var blocks = [];
    if (scope.matches && scope.matches('.nb-article-inline-conversion[data-nb-cta-experiment-enrolled="true"]')) blocks.push(scope);
    scope.querySelectorAll('.nb-article-inline-conversion[data-nb-cta-experiment-enrolled="true"]').forEach(function (node) {
      blocks.push(node);
    });
    blocks.forEach(function (block) {
      trackBlogCtaExperimentAssignment(block);
      bindBlogCtaQualifiedVisibility(block, {
        boundAttribute: 'data-nb-cta-exposure-bound',
        eventName: 'blog_cta_experiment_exposure',
        storageKey: BLOG_CTA_EXPOSURE_SESSION_KEY,
        minimumRatio: 0.5,
        minimumVisibleMs: 1000
      });
    });

    var sentinels = [];
    if (scope.matches && scope.matches('[data-nb-cta-opportunity-sentinel]')) sentinels.push(scope);
    scope.querySelectorAll('[data-nb-cta-opportunity-sentinel]').forEach(function (node) {
      sentinels.push(node);
    });
    sentinels.forEach(function (sentinel) {
      bindBlogCtaQualifiedVisibility(sentinel, {
        boundAttribute: 'data-nb-cta-opportunity-bound',
        eventName: 'blog_cta_opportunity',
        storageKey: BLOG_CTA_OPPORTUNITY_SESSION_KEY,
        minimumRatio: 0.01,
        minimumVisibleMs: 1000
      });
    });
  }

  function readBlogConversionImpressions() {
    var raw = readStorageItem(window.sessionStorage, BLOG_CONVERSION_SESSION_KEY);
    if (!raw) return {};
    var parsed = safeParseJson(raw, {});
    if (!parsed || typeof parsed !== 'object') return {};
    return parsed;
  }

  function writeBlogConversionImpressions(nextValue) {
    if (!nextValue || typeof nextValue !== 'object') return;
    writeStorageItem(window.sessionStorage, BLOG_CONVERSION_SESSION_KEY, JSON.stringify(nextValue));
  }

  function readBlogScrollDepthImpressions() {
    var raw = readStorageItem(window.sessionStorage, BLOG_SCROLL_DEPTH_SESSION_KEY);
    if (!raw) return {};
    var parsed = safeParseJson(raw, {});
    if (!parsed || typeof parsed !== 'object') return {};
    return parsed;
  }

  function writeBlogScrollDepthImpressions(nextValue) {
    if (!nextValue || typeof nextValue !== 'object') return;
    writeStorageItem(window.sessionStorage, BLOG_SCROLL_DEPTH_SESSION_KEY, JSON.stringify(nextValue));
  }

  function readBlogViewEvents() {
    var raw = readStorageItem(window.sessionStorage, BLOG_VIEW_SESSION_KEY);
    if (!raw) return {};
    var parsed = safeParseJson(raw, {});
    if (!parsed || typeof parsed !== 'object') return {};
    return parsed;
  }

  function writeBlogViewEvents(nextValue) {
    if (!nextValue || typeof nextValue !== 'object') return;
    writeStorageItem(window.sessionStorage, BLOG_VIEW_SESSION_KEY, JSON.stringify(nextValue));
  }

  function trackBlogConversionImpression(slotNode) {
    if (!slotNode || !slotNode.getAttribute) return;
    var slotId = String(slotNode.getAttribute('data-nb-slot-id') || '').trim();
    var slotType = String(slotNode.getAttribute('data-nb-slot-type') || '').trim().toLowerCase();
    var destination = String(slotNode.getAttribute('data-nb-slot-destination') || '').trim().toLowerCase();
    var actionRank = String(slotNode.getAttribute('data-nb-action-rank') || '').trim().toLowerCase();
    var surfaceSource = String(slotNode.getAttribute('data-nb-surface-source') || '').trim().toLowerCase();
    if (!slotId) return;

    var contextPath = window.location.pathname || '';
    var dedupeKey = contextPath + '::' + slotId;
    var impressionMap = readBlogConversionImpressions();
    if (impressionMap[dedupeKey]) return;
    impressionMap[dedupeKey] = Date.now();
    writeBlogConversionImpressions(impressionMap);

    pushEvent(
      appendArticleAnalyticsContext(
        {
          event: 'blog_conversion_impression',
          slot_id: slotId,
          slot_type: slotType,
          destination: destination || 'unknown',
          action_rank: actionRank || 'primary',
          surface_source: surfaceSource || 'theme',
          page_type: document.body ? (document.body.getAttribute('data-page-type') || '') : '',
          context_path: contextPath
        },
        slotNode
      )
    );

    if (destination === 'home' && slotId.indexOf('article_mobile_') !== 0) {
      trackCommercialSurfaceView('blog_home_slot', slotNode);
    }
  }

  function initBlogConversionTracking(rootNode) {
    var scope = rootNode && rootNode.querySelectorAll ? rootNode : document;
    var slotNodes = [];
    if (scope && scope.nodeType === 1 && scope.matches && scope.matches('[data-nb-conversion-slot]')) {
      slotNodes.push(scope);
    }
    var foundNodes = scope.querySelectorAll('[data-nb-conversion-slot]');
    foundNodes.forEach(function (node) {
      slotNodes.push(node);
    });
    if (!slotNodes.length) return;

    if ('IntersectionObserver' in window && !blogConversionObserver) {
      blogConversionObserver = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (!entry.isIntersecting || entry.intersectionRatio < 0.45) return;
            trackBlogConversionImpression(entry.target);
            blogConversionObserver.unobserve(entry.target);
          });
        },
        { threshold: [0, 0.45, 0.72] }
      );
    }

    slotNodes.forEach(function (slotNode) {
      if (!slotNode || !slotNode.getAttribute) return;
      if (slotNode.dataset.nbConversionTracked === 'true') return;
      slotNode.dataset.nbConversionTracked = 'true';
      if (blogConversionObserver) {
        blogConversionObserver.observe(slotNode);
      } else {
        trackBlogConversionImpression(slotNode);
      }
    });
  }

  function createInlineConversionLink(options) {
    if (!options || !options.href || !options.label) return null;
    var link = document.createElement('a');
    link.className = options.secondary ? 'nb-button nb-button--secondary' : 'nb-button';
    link.setAttribute('href', options.href);
    link.setAttribute('data-nb-conv-preview-path', options.href);
    link.setAttribute('data-nb-cta', options.ctaId);
    link.setAttribute('data-nb-slot-id', options.slotId);
    link.setAttribute('data-nb-slot-type', options.slotType);
    link.setAttribute('data-nb-slot-destination', options.destination);
    link.setAttribute('data-nb-action-rank', options.secondary ? 'secondary' : 'primary');
    link.setAttribute('data-nb-surface-source', options.surfaceSource || 'theme');
    link.textContent = options.label;
    return link;
  }

  function createInlineConversionCheckoutForm(options, articleRoot) {
    if (!options || !articleRoot) return null;
    var variantId = String(articleRoot.getAttribute('data-nb-product-variant-id') || '').trim();
    var productTitle = String(articleRoot.getAttribute('data-nb-product-title') || '').trim();
    var productPrice = String(articleRoot.getAttribute('data-nb-product-price') || '').trim();
    var productCurrency = String(articleRoot.getAttribute('data-nb-product-currency') || '').trim();
    if (!variantId) return null;

    var form = document.createElement('form');
    form.method = 'post';
    form.action = buildShopifyPathWithPreview('/cart/add');
    form.enctype = 'multipart/form-data';
    form.className = 'nb-article-inline-conversion__checkout';
    form.setAttribute('data-nb-atc-form', '');
    form.setAttribute('data-nb-atc-mode', 'ajax');
    form.setAttribute('data-nb-atc-redirect', 'checkout');
    form.setAttribute('data-product-id', variantId);
    form.setAttribute('data-product-title', productTitle);
    form.setAttribute('data-product-price', productPrice);
    form.setAttribute('data-product-currency', productCurrency);

    var returnTo = document.createElement('input');
    returnTo.type = 'hidden';
    returnTo.name = 'return_to';
    returnTo.value = buildShopifyPathWithPreview('/cart');
    form.appendChild(returnTo);

    var variantInput = document.createElement('input');
    variantInput.type = 'hidden';
    variantInput.name = 'id';
    variantInput.value = variantId;
    form.appendChild(variantInput);

    var quantityInput = document.createElement('input');
    quantityInput.type = 'hidden';
    quantityInput.name = 'quantity';
    quantityInput.value = '1';
    form.appendChild(quantityInput);

    var button = document.createElement('button');
    button.type = 'submit';
    button.className = 'nb-button';
    button.setAttribute('data-nb-atc-submit', '');
    button.setAttribute('data-nb-checkout-entrypoint', options.checkoutEntrypoint || 'article_buy');
    button.setAttribute('data-nb-cta', options.ctaId);
    button.setAttribute('data-nb-slot-id', options.slotId);
    button.setAttribute('data-nb-slot-type', options.slotType);
    button.setAttribute('data-nb-slot-destination', options.destination || 'checkout');
    button.setAttribute('data-nb-action-rank', 'primary');
    button.setAttribute('data-nb-surface-source', 'theme');
    button.textContent = options.label;
    form.appendChild(button);

    return form;
  }

  function createInlineConversionMedia(config) {
    if (!config || !config.src) return null;
    var media = document.createElement('figure');
    media.className = 'nb-article-inline-conversion__media';

    var picture = document.createElement('picture');
    picture.className = 'nb-article-inline-conversion__picture';

    if (config.desktopSrc) {
      var desktopSource = document.createElement('source');
      desktopSource.setAttribute('media', '(min-width: 1024px)');
      desktopSource.setAttribute('srcset', config.desktopSrcSet || config.desktopSrc);
      desktopSource.setAttribute('sizes', config.desktopSizes || '292px');
      picture.appendChild(desktopSource);
    }

    var image = document.createElement('img');
    image.setAttribute('src', config.src);
    if (config.srcSet) image.setAttribute('srcset', config.srcSet);
    if (config.sizes) image.setAttribute('sizes', config.sizes);
    image.setAttribute('alt', config.alt || i18n('article_inline.inline_1.media_alt', 'Nordbelt product'));
    image.setAttribute('loading', 'lazy');
    image.setAttribute('decoding', 'async');
    image.setAttribute('fetchpriority', 'low');
    image.setAttribute('width', '700');
    image.setAttribute('height', '700');
    picture.appendChild(image);
    media.appendChild(picture);

    if (config.badge) {
      var badge = document.createElement('span');
      badge.className = 'nb-article-inline-conversion__media-badge';
      badge.textContent = config.badge;
      media.appendChild(badge);
    }

    return media;
  }

  function createInlineConversionBlock(config, articleRoot) {
    var wrapper = document.createElement('section');
    wrapper.className = 'nb-card nb-article-inline-conversion nb-reveal is-visible is-' + config.slotName;
    wrapper.setAttribute('data-nb-inline-slot', config.slotName);
    wrapper.setAttribute('data-nb-generated', 'conversion');
    wrapper.setAttribute('data-nb-conversion-slot', '');
    wrapper.setAttribute('data-nb-slot-id', config.slotId);
    wrapper.setAttribute('data-nb-slot-type', config.slotType);
    wrapper.setAttribute('data-nb-slot-destination', config.primaryDestination || '');
    wrapper.setAttribute('data-nb-action-rank', 'primary');
    wrapper.setAttribute('data-nb-surface-source', 'theme');
    wrapper.setAttribute('data-nb-cro-variant', config.croVariant || '');
    var layoutAssignment = applyBlogCtaLayoutExperiment(wrapper, articleRoot);

    var mediaConfig = Object.assign({}, config.media || {});
    mediaConfig.desktopSizes = layoutAssignment.layoutVariant === 'compact_safety'
      ? '116px'
      : layoutAssignment.format === 'compact' ? '124px' : '292px';
    var media = createInlineConversionMedia(mediaConfig);
    if (media) {
      wrapper.classList.add('has-media');
      wrapper.appendChild(media);
    }

    var body = document.createElement('div');
    body.className = 'nb-article-inline-conversion__body';

    if (config.kicker) {
      var kicker = document.createElement('p');
      kicker.className = 'nb-article-inline-conversion__kicker';
      kicker.textContent = config.kicker;
      body.appendChild(kicker);
    }

    if (config.title) {
      var title = document.createElement('h3');
      title.textContent = config.title;
      body.appendChild(title);
    }

    if (config.copy) {
      var copy = document.createElement('p');
      copy.className = 'nb-article-inline-conversion__copy';
      copy.textContent = config.copy;
      body.appendChild(copy);
    }

    if (config.chips && config.chips.length) {
      var chips = document.createElement('div');
      chips.className = 'nb-article-inline-conversion__chips';
      config.chips.forEach(function (chipText) {
        if (!chipText) return;
        var chip = document.createElement('span');
        chip.textContent = chipText;
        chips.appendChild(chip);
      });
      if (chips.children.length) {
        body.appendChild(chips);
      }
    }

    if (config.note) {
      var note = document.createElement('p');
      note.className = 'nb-article-inline-conversion__note';
      note.textContent = config.note;
      body.appendChild(note);
    }

    var actions = document.createElement('div');
    actions.className = 'nb-article-inline-conversion__actions';

    var primaryAction = null;
    if (config.primaryAction && config.primaryAction.kind === 'checkout_form') {
      primaryAction = createInlineConversionCheckoutForm({
        label: config.primaryAction.label,
        ctaId: config.primaryAction.ctaId,
        slotId: config.slotId,
        slotType: config.slotType,
        destination: config.primaryAction.destination,
        checkoutEntrypoint: config.primaryAction.checkoutEntrypoint
      }, articleRoot);
    } else if (config.primaryAction) {
      primaryAction = createInlineConversionLink({
        href: config.primaryAction.href,
        label: config.primaryAction.label,
        ctaId: config.primaryAction.ctaId,
        slotId: config.slotId,
        slotType: config.slotType,
        destination: config.primaryAction.destination,
        surfaceSource: 'theme',
        secondary: false
      });
    }

    var secondaryLink = config.secondaryAction
      ? createInlineConversionLink({
          href: config.secondaryAction.href,
          label: config.secondaryAction.label,
          ctaId: config.secondaryAction.ctaId,
          slotId: config.slotId,
          slotType: config.slotType,
          destination: config.secondaryAction.destination,
          surfaceSource: 'theme',
          secondary: true
        })
      : null;

    if (primaryAction) actions.appendChild(primaryAction);
    if (secondaryLink) actions.appendChild(secondaryLink);

    wrapper.appendChild(body);
    if (actions.children.length) {
      wrapper.appendChild(actions);
    }
    return wrapper;
  }

  function insertNodeAfter(node, referenceNode) {
    if (!node || !referenceNode || !referenceNode.parentNode) return;
    if (referenceNode.nextSibling) {
      referenceNode.parentNode.insertBefore(node, referenceNode.nextSibling);
      return;
    }
    referenceNode.parentNode.appendChild(node);
  }

  function insertNodeBefore(node, referenceNode) {
    if (!node || !referenceNode || !referenceNode.parentNode) return;
    referenceNode.parentNode.insertBefore(node, referenceNode);
  }

  function isArticleHeadingNode(node) {
    return !!(node && node.tagName && /^H[2-4]$/.test(String(node.tagName || '').toUpperCase()));
  }

  function getArticleNodeTextLength(node) {
    return String(node && node.textContent ? node.textContent : '').replace(/\s+/g, ' ').trim().length;
  }

  var ARTICLE_EDITORIAL_NOISE_RE = /(?:\b(?:zachte|soft|proof|buy)\s+cta\b|\b(?:tool|product|setup)[-\s]?bridge\b|\blogische(?:\s+interne)?\s+doorstroom\b|\blogische bridge\b|\bhelpfulness\b|\bkoopmodus\b|\bowner-pagina\b|\bquery\b|\bzakelijk beter\b|\bvoor deze intent\b|\bproduct pusht\b|\bvolgorde belangrijk\b|product of tool hier pas laat)/i;
  var ARTICLE_EDITORIAL_LIST_LEAD_RE = /(?:doorstroom|owner-pagina|cta|bridge|volgorde belangrijk|voor deze intent)/i;

  function getArticleBlockText(node) {
    return String(node && node.textContent ? node.textContent : '').replace(/\s+/g, ' ').trim();
  }

  function isArticleEditorialNoiseNode(node) {
    if (!node || !node.tagName || node.hasAttribute('data-nb-generated')) return false;
    var tagName = String(node.tagName || '').toUpperCase();
    if (!/^(P|H2|H3|H4|UL|OL|DIV|BLOCKQUOTE)$/.test(tagName)) return false;
    return ARTICLE_EDITORIAL_NOISE_RE.test(getArticleBlockText(node));
  }

  function cleanupArticleEditorialNoise(rootNode) {
    var scope = rootNode && rootNode.querySelectorAll ? rootNode : document;
    var articleRoots = [];
    if (scope && scope.nodeType === 1 && scope.matches && scope.matches('[data-nb-article-conversion]')) {
      articleRoots.push(scope);
    }
    var foundRoots = scope.querySelectorAll('[data-nb-article-conversion]');
    foundRoots.forEach(function (root) {
      articleRoots.push(root);
    });
    if (!articleRoots.length) return;

    articleRoots.forEach(function (articleRoot) {
      if (!articleRoot || articleRoot.dataset.nbEditorialNoiseCleaned === 'true') return;
      var rte = articleRoot.querySelector('[data-nb-article-rte]');
      if (!rte) return;

      var children = Array.prototype.slice.call(rte.children);
      var nodesToRemove = new Set();

      children.forEach(function (node, index) {
        if (!isArticleEditorialNoiseNode(node)) return;
        nodesToRemove.add(node);

        if (ARTICLE_EDITORIAL_LIST_LEAD_RE.test(getArticleBlockText(node))) {
          var nextNode = children[index + 1];
          if (nextNode && /^(UL|OL)$/i.test(String(nextNode.tagName || '').toUpperCase())) {
            nodesToRemove.add(nextNode);
          }
        }
      });

      nodesToRemove.forEach(function (node) {
        if (node && node.parentNode === rte) {
          node.parentNode.removeChild(node);
        }
      });

      Array.prototype.slice.call(rte.children).forEach(function (node) {
        if (!isArticleHeadingNode(node)) return;
        var sibling = node.nextElementSibling;
        var hasContent = false;
        while (sibling) {
          if (isArticleHeadingNode(sibling)) break;
          if (!sibling.hasAttribute('data-nb-generated') && (getArticleNodeTextLength(sibling) > 0 || !!(sibling.querySelector && sibling.querySelector('img,video,iframe,table,ul,ol')))) {
            hasContent = true;
            break;
          }
          sibling = sibling.nextElementSibling;
        }
        if (!hasContent && node.parentNode === rte) {
          node.parentNode.removeChild(node);
        }
      });

      articleRoot.dataset.nbEditorialNoiseCleaned = 'true';
    });
  }

  function getArticleFlowNodes(rte) {
    return Array.prototype.slice.call(rte.children).filter(function (node) {
      if (!node || !node.tagName) return false;
      if (node.hasAttribute('data-nb-generated')) return false;
      var tagName = String(node.tagName || '').toUpperCase();
      if (tagName === 'SCRIPT' || tagName === 'STYLE') return false;
      if (node.classList && node.classList.contains('nb-article-inline-conversion')) return false;
      return getArticleNodeTextLength(node) > 0 || !!node.querySelector('img,video,iframe,table,ul,ol');
    });
  }

  function getArticleNodeWeight(node) {
    var weight = getArticleNodeTextLength(node);
    if (node && node.querySelector && node.querySelector('img,video,iframe')) {
      weight += 140;
    }
    return weight;
  }

  function findLastSectionAnchor(nodes) {
    if (!nodes || !nodes.length) return null;
    for (var index = nodes.length - 1; index >= 0; index -= 1) {
      var node = nodes[index];
      if (!node || isArticleHeadingNode(node)) continue;
      var tagName = String(node.tagName || '').toUpperCase();
      var isRichNode = /^(P|UL|OL|DIV|BLOCKQUOTE|FIGURE|TABLE|IMG)$/.test(tagName);
      if (getArticleNodeWeight(node) >= 24 || isRichNode) return node;
    }
    return nodes[nodes.length - 1] || null;
  }

  function buildArticleSections(flowNodes) {
    var headings = flowNodes.filter(isArticleHeadingNode);
    if (!headings.length) {
      var pseudoNodes = flowNodes.filter(function (node) {
        return getArticleNodeWeight(node) >= 30;
      });
      if (!pseudoNodes.length) return [];
      var chunkSize = pseudoNodes.length >= 9 ? 3 : 2;
      var fallbackSections = [];
      for (var chunkIndex = 0; chunkIndex < pseudoNodes.length; chunkIndex += chunkSize) {
        var chunkNodes = pseudoNodes.slice(chunkIndex, chunkIndex + chunkSize);
        fallbackSections.push({
          heading: null,
          nodes: chunkNodes,
          anchor: findLastSectionAnchor(chunkNodes),
          weight: chunkNodes.reduce(function (sum, node) {
            return sum + getArticleNodeWeight(node);
          }, 0)
        });
      }
      return fallbackSections.filter(function (section) {
        return !!section.anchor;
      });
    }

    var rawSections = [];
    headings.forEach(function (headingNode, headingIndex) {
      var startIndex = flowNodes.indexOf(headingNode);
      var endIndex = headingIndex + 1 < headings.length ? flowNodes.indexOf(headings[headingIndex + 1]) : flowNodes.length;
      if (startIndex === -1) return;
      if (endIndex === -1) endIndex = flowNodes.length;
      var nodes = flowNodes.slice(startIndex, endIndex);
      var contentNodes = nodes.slice(1);
      rawSections.push({
        heading: headingNode,
        nodes: nodes,
        anchor: findLastSectionAnchor(contentNodes.length ? contentNodes : nodes),
        weight: contentNodes.reduce(function (sum, node) {
          return sum + getArticleNodeWeight(node);
        }, 0)
      });
    });

    var sections = [];
    for (var sectionIndex = 0; sectionIndex < rawSections.length; sectionIndex += 1) {
      var currentSection = rawSections[sectionIndex];
      if (!currentSection) continue;

      while ((currentSection.anchor === currentSection.heading || !currentSection.anchor) && sectionIndex + 1 < rawSections.length) {
        sectionIndex += 1;
        var nextSection = rawSections[sectionIndex];
        if (!nextSection) break;
        currentSection = {
          heading: currentSection.heading || nextSection.heading,
          nodes: currentSection.nodes.concat(nextSection.nodes),
          anchor: nextSection.anchor,
          weight: currentSection.weight + nextSection.weight
        };
      }

      if (!currentSection.anchor || currentSection.anchor === currentSection.heading) continue;
      sections.push(currentSection);
    }

    return sections.filter(function (section) {
      return !!section.anchor;
    });
  }

  function findArticleIntroAnchor(flowNodes) {
    var firstHeadingIndex = -1;
    for (var index = 0; index < flowNodes.length; index += 1) {
      if (isArticleHeadingNode(flowNodes[index])) {
        firstHeadingIndex = index;
        break;
      }
    }
    var introNodes = firstHeadingIndex === -1 ? flowNodes.slice(0, Math.min(flowNodes.length, 3)) : flowNodes.slice(0, firstHeadingIndex);
    var candidates = introNodes.filter(function (node) {
      return getArticleNodeWeight(node) >= 40 || !!(node && node.querySelector && node.querySelector('img,video'));
    });
    return candidates.length ? candidates[candidates.length - 1] : null;
  }

  function slugifyArticleHeading(text, fallbackIndex) {
    var base = String(text || '')
      .toLowerCase()
      .replace(/&/g, ' and ')
      .replace(/[^a-z0-9\u00C0-\u024F]+/g, '-')
      .replace(/^-+|-+$/g, '')
      .slice(0, 64);
    if (!base) base = 'section-' + String(fallbackIndex || 1);
    return base;
  }

  function ensureArticleHeadingIds(headings) {
    var seen = {};
    headings.forEach(function (heading, index) {
      if (!heading) return;
      var candidate = String(heading.id || '').trim();
      if (!candidate) {
        candidate = 'article-' + slugifyArticleHeading(heading.textContent || '', index + 1);
      }
      while (seen[candidate] || document.getElementById(candidate)) {
        candidate += '-' + String(index + 1);
      }
      seen[candidate] = true;
      heading.id = candidate;
      heading.setAttribute('data-nb-article-anchor', '');
    });
  }

  function escapeRegExp(value) {
    return String(value || '').replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
  }

  function normalizeArticleTocLabel(text) {
    return String(text || '').replace(/\s+/g, ' ').trim();
  }

  var ARTICLE_TOC_QUESTION_STARTERS = {
    how: true, hoe: true, why: true, waarom: true, what: true, wat: true, when: true, wanneer: true,
    where: true, waar: true, which: true, welke: true, welcher: true, welche: true, was: true,
    wann: true, warumde: true, comment: true, quand: true, pourquoi: true, que: true, como: true,
    quando: true, porque: true, mitä: true, miten: true, milloin: true
  };

  function stripArticleTocPunctuation(text) {
    return normalizeArticleTocLabel(text).replace(/[.!?;:,]+$/g, '');
  }

  function shortenArticleTocLabel(text) {
    var original = stripArticleTocPunctuation(text);
    if (!original) return '';

    var shortened = original;
    var firstWord = String(original.split(/\s+/)[0] || '').toLowerCase();
    var isQuestionHeading = !!ARTICLE_TOC_QUESTION_STARTERS[firstWord];

    if (shortened.length > 34 && shortened.indexOf(':') !== -1) {
      var leftOfColon = normalizeArticleTocLabel(shortened.split(':')[0]);
      if (leftOfColon.length >= 10 && leftOfColon.length <= 34) {
        shortened = leftOfColon;
      }
    }

    if (!isQuestionHeading && shortened.length > 34) {
      var splitCandidate = shortened.split(/\s+(?:voor|van|over|bij|met|om|tegen|rond|rondom|for|with|about|über|mit|für|sur|pour|med|til|con|per|para|sobre|su|sul|del|della|di)\s+/i)[0];
      splitCandidate = normalizeArticleTocLabel(splitCandidate);
      if (splitCandidate.length >= 10 && splitCandidate.length <= 34 && splitCandidate.length <= shortened.length - 6) {
        shortened = splitCandidate;
      }
    }

    if (!isQuestionHeading && shortened.length > 34) {
      var listCandidate = shortened.split(/\s+(?:en|and|und|et|och|og|y|e|ja|sekä|ning)\s+/i)[0];
      listCandidate = normalizeArticleTocLabel(listCandidate);
      if (
        listCandidate.length >= 10
        && listCandidate.length <= 30
        && listCandidate.length <= shortened.length - 8
        && !/\b(?:voor|van|over|bij|met|om|tegen|rond|rondom|for|with|about|über|mit|für|sur|pour|med|til|con|per|para|sobre|su|sul|del|della|di)\b/i.test(listCandidate)
      ) {
        shortened = listCandidate;
      }
    }

    if (shortened.length > (isQuestionHeading ? 42 : 36)) {
      var trimmed = shortened.slice(0, isQuestionHeading ? 39 : 33);
      var lastSpace = trimmed.lastIndexOf(' ');
      if (lastSpace > 18) {
        trimmed = trimmed.slice(0, lastSpace);
      }
      shortened = normalizeArticleTocLabel(trimmed) + '…';
    }

    return normalizeArticleTocLabel(shortened) || original;
  }

  function toPreviewPath(url) {
    if (!url) return '';
    try {
      var parsed = new URL(url, window.location.origin);
      return parsed.pathname || '';
    } catch (_err) {
      return String(url || '').trim();
    }
  }

  function buildArticleTocFallbackLabel(section, sectionIndex) {
    if (!section) return '';
    var candidateNodes = (section.nodes || []).filter(function (node) {
      return !!node && node !== section.heading;
    });
    for (var index = 0; index < candidateNodes.length; index += 1) {
      var node = candidateNodes[index];
      var text = getArticleBlockText(node);
      if (!text) continue;
      var nodeTag = String(node.tagName || '').toUpperCase();
      if (nodeTag === 'UL' || nodeTag === 'OL') {
        var firstItem = node.querySelector('li');
        text = getArticleBlockText(firstItem) || text;
      }
      if (text.length > 64) {
        var sentenceCandidate = text.split(/(?<=[.!?])\s+/)[0];
        if (sentenceCandidate && sentenceCandidate.length >= 12) {
          text = sentenceCandidate;
        }
      }
      if (text.length > 72) {
        var words = text.split(/\s+/).slice(0, 8);
        text = words.join(' ');
      }
      text = shortenArticleTocLabel(text);
      if (text.length >= 3) return text;
    }
    return i18n('article_funnel.toc_fallback_label', 'Belangrijk onderdeel') + ' ' + String(sectionIndex + 1);
  }

  function ensureArticleTocTargetId(node, fallbackLabel, fallbackIndex) {
    if (!node) return '';
    var candidate = String(node.id || '').trim();
    if (!candidate) {
      candidate = 'article-' + slugifyArticleHeading(fallbackLabel || node.textContent || '', fallbackIndex + 1);
    }
    var suffix = fallbackIndex + 1;
    while (candidate && document.getElementById(candidate) && document.getElementById(candidate) !== node) {
      candidate = candidate.replace(/-\d+$/, '') + '-' + String(suffix);
      suffix += 1;
    }
    node.id = candidate;
    node.setAttribute('data-nb-article-anchor', '');
    return candidate;
  }

  function pickArticleTocSections(sections, maxItems) {
    if (!sections || !sections.length) return [];
    if (sections.length <= maxItems) return sections.slice();

    var indices = [];
    for (var index = 0; index < maxItems; index += 1) {
      indices.push(Math.round(((sections.length - 1) * index) / (maxItems - 1)));
    }

    var seen = {};
    var picked = [];
    indices.forEach(function (sectionIndex) {
      if (seen[sectionIndex]) return;
      seen[sectionIndex] = true;
      picked.push(sections[sectionIndex]);
    });

    for (var fillIndex = 0; picked.length < maxItems && fillIndex < sections.length; fillIndex += 1) {
      if (seen[fillIndex]) continue;
      seen[fillIndex] = true;
      picked.push(sections[fillIndex]);
    }

    return picked.sort(function (a, b) {
      return sections.indexOf(a) - sections.indexOf(b);
    });
  }

  function buildArticleTocEntries(sections) {
    if (!sections || !sections.length) return [];
    var selectedSections = pickArticleTocSections(sections, 6);
    return selectedSections.map(function (section, index) {
      var heading = section.heading;
      var label = heading && getArticleBlockText(heading).length >= 3
        ? shortenArticleTocLabel(heading.textContent || '')
        : buildArticleTocFallbackLabel(section, index);
      var targetNode = heading || section.anchor || (section.nodes && section.nodes[0]) || null;
      var targetId = ensureArticleTocTargetId(targetNode, label, index);
      return {
        heading: heading,
        label: label,
        targetId: targetId,
        title: normalizeArticleTocLabel((heading && heading.textContent) || label || ''),
        isSublevel: !!heading && String(heading.tagName || '').toUpperCase() === 'H3'
      };
    }).filter(function (entry) {
      return !!entry && !!entry.label && !!entry.targetId;
    });
  }

  function createArticleToc(articleRoot, flowNodes, sections) {
    if (!articleRoot) return null;
    var tocEntries = buildArticleTocEntries(sections);
    if (!tocEntries.length) return null;
    var hasPrimaryH2 = tocEntries.some(function (entry) {
      return !!entry.heading && String(entry.heading.tagName || '').toUpperCase() === 'H2';
    });
    var articleIntent = detectArticleIntent(articleRoot);
    var toc = document.createElement('nav');
    toc.className = 'nb-card nb-article-toc nb-reveal is-visible';
    toc.classList.add('is-' + articleIntent);
    toc.setAttribute('data-nb-generated', 'toc');
    toc.setAttribute('data-nb-toc-intent', articleIntent);
    toc.setAttribute('aria-label', i18n('article_funnel.toc_title', 'In dit artikel'));

    var header = document.createElement('div');
    header.className = 'nb-article-toc__header';

    var eyebrow = document.createElement('p');
    eyebrow.className = 'nb-article-toc__eyebrow';
    eyebrow.textContent = i18n('article_funnel.toc_eyebrow', 'Leeswijzer');
    header.appendChild(eyebrow);

    var title = document.createElement('p');
    title.className = 'nb-article-toc__title';
    title.textContent = i18n('article_funnel.toc_title', 'In dit artikel');
    header.appendChild(title);

    var hint = document.createElement('p');
    hint.className = 'nb-article-toc__hint';
    hint.textContent = i18n('article_funnel.toc_hint', 'Scan eerst de kernpunten en kies daarna je volgende stap.');
    header.appendChild(hint);

    toc.appendChild(header);

    var list = document.createElement('ol');
    list.className = 'nb-article-toc__list';

    tocEntries.forEach(function (entry, headingIndex) {
      var item = document.createElement('li');
      item.className = 'nb-article-toc__item';
      if (hasPrimaryH2 && entry.isSublevel) {
        item.classList.add('is-sublevel');
      }
      var link = document.createElement('a');
      link.setAttribute('href', '#' + entry.targetId);
      link.setAttribute('data-nb-article-toc-link', '');
      link.setAttribute('data-nb-cta', 'article_toc_jump');
      link.setAttribute('data-nb-slot-id', 'article_toc');
      link.setAttribute('data-nb-slot-type', 'toc');
      link.setAttribute('data-nb-slot-destination', 'article_section');
      link.setAttribute('data-nb-toc-target', entry.targetId);
      var indexBadge = document.createElement('span');
      indexBadge.className = 'nb-article-toc__index';
      indexBadge.textContent = String(headingIndex + 1).padStart(2, '0');
      link.appendChild(indexBadge);

      var label = document.createElement('span');
      label.className = 'nb-article-toc__label';
      var labelText = entry.label;
      label.textContent = labelText;
      if (labelText.length > 40) {
        item.classList.add('is-long');
      }
      link.setAttribute('title', entry.title || labelText);
      link.appendChild(label);
      item.appendChild(link);
      list.appendChild(item);
    });

    toc.appendChild(list);

    return toc;
  }

  function createArticleDestinationConfig(destination, slotType, slotId, ctaId, urls, labelOverride) {
    var href = '';
    var label = '';
    if (destination === 'guide' && urls.guide) {
      href = urls.guide;
      label = i18n('shared.view_guide', 'Bekijk complete handleiding');
    } else if (destination === 'home' && urls.home) {
      href = urls.home;
      label = i18n('shared.go_home', 'Ga naar homepage');
    } else {
      href = urls.product;
      label = i18n('shared.view_nordbelt', 'Bekijk Nordbelt');
      destination = 'product';
    }
    if (labelOverride) label = labelOverride;
    if (!href || !label) return null;
    return {
      href: href,
      label: label,
      ctaId: ctaId,
      slotId: slotId,
      slotType: slotType,
      destination: destination
    };
  }

  function resolveArticleSlotConfigs(articleRoot) {
    var productUrl = String(articleRoot.getAttribute('data-nb-product-url') || '').trim();
    var productImage = String(articleRoot.getAttribute('data-nb-product-image') || '').trim();
    var inlineMediaImage = String(articleRoot.getAttribute('data-nb-inline-media') || '').trim();
    var ctaMediaSmall = String(articleRoot.getAttribute('data-nb-cta-media-480') || '').trim();
    var ctaMediaLarge = String(articleRoot.getAttribute('data-nb-cta-media-809') || '').trim();
    var homeUrl = String(articleRoot.getAttribute('data-nb-home-url') || '').trim();
    var guideUrl = String(articleRoot.getAttribute('data-nb-guide-url') || '').trim();
    var mediaBadge = i18n('article_inline.inline_1.media_badge', 'Nordbelt setup');
    var primaryDestination = detectArticlePrimaryDestination(articleRoot);
    var squareMediaSmall = ctaMediaSmall || ctaMediaLarge || BLOG_CTA_SQUARE_MEDIA_FALLBACK_URL;
    var squareMediaLarge = ctaMediaLarge || ctaMediaSmall || BLOG_CTA_SQUARE_MEDIA_FALLBACK_URL;
    var squareMediaSrcSet = ctaMediaSmall && ctaMediaLarge
      ? ctaMediaSmall + ' 480w, ' + ctaMediaLarge + ' 809w'
      : squareMediaLarge;
    var squareMediaSizes = '(min-width: 561px) 520px, calc(100vw - 3rem)';

    var urls = {
      product: productUrl,
      home: homeUrl,
      guide: guideUrl
    };
    var softPrimaryDestination = 'product';
    var softSecondaryDestination = guideUrl ? 'guide' : 'home';
    var proofPrimaryDestination = primaryDestination === 'product' ? 'product' : 'home';
    var proofSecondaryDestination = proofPrimaryDestination === 'product' ? (guideUrl ? 'guide' : 'home') : 'product';
    var buyPrimaryDestination = primaryDestination === 'product' ? 'product' : 'home';
    var buySecondaryDestination = buyPrimaryDestination === 'product' ? (guideUrl ? 'guide' : 'home') : 'product';
    var softTitle = i18n('article_cro.direct.title', 'Do Nordic hamstring curls at home — without a partner');
    var softCopy = i18n('article_cro.direct.copy', 'With Nordbelt, you can do Nordic hamstring curls at home without a training partner or bulky machine. Secure your ankles to a sturdy door, training bench or other suitable anchor. Check the attachment and build your range and repetitions gradually.');
    var proofTitle = i18n('article_cro.adjacent.title', 'Want to add Nordic hamstring curls at home?');
    var proofCopy = i18n('article_cro.adjacent.copy', 'Nordbelt makes it practical to add controlled Nordic curls at home alongside the exercises in this article — without a training partner or bulky machine. Secure your ankles to a sturdy door, training bench or other suitable anchor. Progress only when you can perform the earlier exercise steps with control.');
    var postSafetyTitle = i18n('article_cro.post_safety.title', 'Nordic curls at home — when strength training fits your stage');
    var postSafetyCopy = i18n('article_cro.post_safety.copy', 'Nordbelt is a training tool that secures your ankles at home for controlled Nordic variations; it is not a treatment. Use it only when the exercise suits your situation and stage, check the anchor and build up gradually. If pain, injury or rehabilitation is involved, seek qualified guidance when needed.');

    return {
      soft: {
        slotName: 'direct',
        slotId: 'article_direct_rescue',
        slotType: 'rescue',
        croVariant: 'direct_v1',
        primaryDestination: softPrimaryDestination,
        kicker: i18n('article_cro.direct.kicker', 'Nordic curls, right at home'),
        title: softTitle,
        copy: softCopy,
        chips: [
          i18n('article_cro.direct.chip_1', 'Nordics at home'),
          i18n('article_cro.direct.chip_2', 'No training partner'),
          i18n('article_cro.direct.chip_3', 'No bulky machine')
        ],
        media: {
              src: squareMediaSmall,
              srcSet: squareMediaSrcSet,
              sizes: squareMediaSizes,
              desktopSrc: squareMediaLarge,
              desktopSrcSet: squareMediaSrcSet,
              alt: i18n('article_inline.inline_1.media_alt', 'Nordbelt product'),
              badge: i18n('article_cro.direct.kicker', mediaBadge)
            },
        primaryAction: createArticleDestinationConfig(
          softPrimaryDestination,
          'rescue',
          'article_direct_rescue',
          'article_direct_primary',
          urls,
          i18n('article_cro.direct.primary_product', 'View Nordbelt for home training')
        ),
        secondaryAction: createArticleDestinationConfig(
          softSecondaryDestination,
          'rescue',
          'article_direct_rescue',
          'article_direct_secondary',
          urls,
          i18n('article_cro.direct.secondary_guide', 'How to set up Nordbelt')
        )
      },
      proof: {
        slotName: 'adjacent',
        slotId: 'article_adjacent_rescue',
        slotType: 'rescue',
        croVariant: 'adjacent_v1',
        primaryDestination: proofPrimaryDestination,
        kicker: i18n('article_cro.adjacent.kicker', 'Your next step at home'),
        title: proofTitle,
        copy: proofCopy,
        chips: [
          i18n('article_cro.adjacent.chip_1', 'Nordics at home'),
          i18n('article_cro.adjacent.chip_2', 'No training partner'),
          i18n('article_cro.adjacent.chip_3', 'Compact to store')
        ],
        media: {
              src: squareMediaSmall,
              srcSet: squareMediaSrcSet,
              sizes: squareMediaSizes,
              desktopSrc: squareMediaLarge,
              desktopSrcSet: squareMediaSrcSet,
              alt: i18n('article_inline.inline_2.media_alt', 'Nordbelt close-up'),
              badge: i18n('article_cro.adjacent.kicker', 'Your next step at home')
            },
        primaryAction: createArticleDestinationConfig(
          proofPrimaryDestination,
          'rescue',
          'article_adjacent_rescue',
          'article_adjacent_primary',
          urls,
          proofPrimaryDestination === 'product'
            ? i18n('article_cro.adjacent.primary_product', 'View Nordbelt for home training')
            : i18n('article_cro.adjacent.primary_home', 'See how Nordbelt works at home')
        ),
        secondaryAction: createArticleDestinationConfig(
          proofSecondaryDestination,
          'rescue',
          'article_adjacent_rescue',
          'article_adjacent_secondary',
          urls,
          proofSecondaryDestination === 'product'
            ? i18n('article_cro.adjacent.secondary_product', 'View the product')
            : i18n('article_cro.adjacent.secondary_guide', 'See how the setup works')
        )
      },
      buy: {
        slotName: 'post-safety',
        slotId: 'article_post_safety_rescue',
        slotType: 'rescue',
        croVariant: 'post_safety_v1',
        primaryDestination: buyPrimaryDestination,
        kicker: i18n('article_cro.post_safety.kicker', 'For a later stage of your progression'),
        title: postSafetyTitle,
        copy: postSafetyCopy,
        chips: [
          i18n('article_cro.post_safety.chip_1', 'Training tool'),
          i18n('article_cro.post_safety.chip_2', 'For Nordics at home'),
          i18n('article_cro.post_safety.chip_3', 'Build up gradually')
        ],
        media: {
              src: squareMediaSmall,
              srcSet: squareMediaSrcSet,
              sizes: squareMediaSizes,
              desktopSrc: squareMediaLarge,
              desktopSrcSet: squareMediaSrcSet,
              alt: i18n('article_inline.inline_1.media_alt', 'Nordbelt product'),
              badge: i18n('article_cro.post_safety.kicker', 'For a later stage of your progression')
            },
        note: null,
        primaryAction: createArticleDestinationConfig(
          buyPrimaryDestination,
          'rescue',
          'article_post_safety_rescue',
          'article_post_safety_primary',
          urls,
          buyPrimaryDestination === 'product'
            ? i18n('article_cro.post_safety.primary_product', 'View Nordbelt for home training')
            : i18n('article_cro.post_safety.primary_home', 'See how Nordbelt works at home')
        ),
        secondaryAction: createArticleDestinationConfig(
          buySecondaryDestination,
          'rescue',
          'article_post_safety_rescue',
          'article_post_safety_secondary',
          urls,
          buySecondaryDestination === 'product'
            ? i18n('article_cro.post_safety.secondary_product', 'View Nordbelt')
            : i18n('article_cro.post_safety.secondary_guide', 'How to set up Nordbelt')
        )
      }
    };
  }

  function getSectionInsertPlan(sections, productRelevance) {
    if (!sections.length) return { slotName: '', rescueIndex: -1 };
    var totalWeight = sections.reduce(function (sum, section) {
      return sum + Math.max(section.weight, 1);
    }, 0);
    var targetFraction = productRelevance === 'post_safety' ? 0.84 : productRelevance === 'direct' ? 0.78 : 0.72;
    var rescueIndex = sections.length - 1;
    var cumulativeWeight = 0;
    for (var candidateIndex = 0; candidateIndex < sections.length; candidateIndex += 1) {
      cumulativeWeight += Math.max(sections[candidateIndex].weight, 1);
      if (cumulativeWeight / totalWeight >= targetFraction) {
        rescueIndex = candidateIndex;
        break;
      }
    }
    return {
      slotName: productRelevance === 'direct' ? 'soft' : productRelevance === 'post_safety' ? 'buy' : 'proof',
      rescueIndex: Math.max(0, Math.min(sections.length - 1, rescueIndex))
    };
  }

  function initArticleTableOfContents(rootNode) {
    var scope = rootNode && rootNode.querySelectorAll ? rootNode : document;
    var articleRoots = [];
    if (scope && scope.nodeType === 1 && scope.matches && scope.matches('[data-nb-article-conversion]')) {
      articleRoots.push(scope);
    }
    var foundRoots = scope.querySelectorAll('[data-nb-article-conversion]');
    foundRoots.forEach(function (root) {
      articleRoots.push(root);
    });
    if (!articleRoots.length) return;

    articleRoots.forEach(function (articleRoot) {
      if (!articleRoot || articleRoot.dataset.nbTocInjected === 'true') return;
      var rte = articleRoot.querySelector('[data-nb-article-rte]');
      if (!rte) return;
      var flowNodes = getArticleFlowNodes(rte);
      if (!flowNodes.length) return;
      var sections = buildArticleSections(flowNodes);
      var toc = createArticleToc(articleRoot, flowNodes, sections);
      if (!toc) {
        articleRoot.dataset.nbTocInjected = 'true';
        return;
      }

      var introAnchor = findArticleIntroAnchor(flowNodes);
      var firstHeading = sections.length && sections[0].heading ? sections[0].heading : null;
      if (introAnchor) {
        insertNodeAfter(toc, introAnchor);
      } else if (firstHeading) {
        insertNodeBefore(toc, firstHeading);
      } else if (rte.firstChild) {
        rte.insertBefore(toc, rte.firstChild);
      } else {
        rte.appendChild(toc);
      }

      articleRoot.dataset.nbTocInjected = 'true';
    });
  }

  function initArticleEditorialMedia(rootNode) {
    var scope = rootNode && rootNode.querySelectorAll ? rootNode : document;
    var articleRoots = [];
    if (scope && scope.nodeType === 1 && scope.matches && scope.matches('[data-nb-article-conversion]')) {
      articleRoots.push(scope);
    }
    var foundRoots = scope.querySelectorAll('[data-nb-article-conversion]');
    foundRoots.forEach(function (root) {
      articleRoots.push(root);
    });
    if (!articleRoots.length) return;

    articleRoots.forEach(function (articleRoot) {
      var rte = articleRoot.querySelector('[data-nb-article-rte]');
      if (!rte) return;
      var images = rte.querySelectorAll('img');
      images.forEach(function (image) {
        if (!image || image.dataset.nbArticleMediaBound === 'true') return;
        if (image.closest('.nb-article-inline-conversion')) return;
        image.dataset.nbArticleMediaBound = 'true';

        var shell = image.closest('figure');
        if (!shell || !rte.contains(shell)) {
          shell = image.parentElement;
          if (shell && shell.tagName === 'A') {
            shell = shell.parentElement;
          }
        }
        if (!shell || !rte.contains(shell)) return;
        var shellTag = String(shell.tagName || '').toUpperCase();
        if (shellTag !== 'P' && shellTag !== 'DIV' && shellTag !== 'FIGURE') return;
        if (shell.querySelectorAll('img').length !== 1) return;

        var shellText = String(shell.textContent || '').replace(/\s+/g, ' ').trim();
        var imageAlt = String(image.getAttribute('alt') || '').replace(/\s+/g, ' ').trim();
        if (shellText && imageAlt && shellText !== imageAlt && shellText.length > imageAlt.length + 18) return;

        shell.classList.add('nb-article-media-shell');

        function syncImageShellRatio() {
          var naturalWidth = Number(image.naturalWidth || image.getAttribute('width') || 0);
          var naturalHeight = Number(image.naturalHeight || image.getAttribute('height') || 0);
          if (!naturalWidth || !naturalHeight) return;
          shell.classList.remove('is-nb-portrait-media', 'is-nb-square-media', 'is-nb-landscape-media');
          var ratio = naturalWidth / naturalHeight;
          if (ratio <= 0.92) {
            shell.classList.add('is-nb-portrait-media');
          } else if (ratio <= 1.18) {
            shell.classList.add('is-nb-square-media');
          } else {
            shell.classList.add('is-nb-landscape-media');
          }
        }

        if (image.complete) {
          syncImageShellRatio();
        } else {
          image.addEventListener('load', syncImageShellRatio, { once: true });
        }
      });
    });
  }

  function isArticleLeadCandidateNode(node) {
    if (!node || !node.tagName || node.hasAttribute('data-nb-generated')) return false;
    var tagName = String(node.tagName || '').toUpperCase();
    if (tagName !== 'P' && tagName !== 'DIV' && tagName !== 'BLOCKQUOTE') return false;
    if (node.querySelector && node.querySelector('img,video,iframe,table,ul,ol')) return false;
    return getArticleNodeTextLength(node) >= 90;
  }

  function normalizeArticleComparableText(value) {
    return String(value || '')
      .toLowerCase()
      .replace(/[\u2018\u2019\u201c\u201d"'`]+/g, '')
      .replace(/[.,:;!?()\[\]{}\-–—/]+/g, ' ')
      .replace(/\s+/g, ' ')
      .trim();
  }

  function extractNbContextImageId(value) {
    var match = String(value || '').match(/nb-blog-context-\d{8}-(\d{3})-/i);
    return match ? 'nb-img-' + match[1] : '';
  }

  function syncArticleHeroImageFromMeta(articleRoot) {
    if (!articleRoot || articleRoot.dataset.nbHeroMetaSynced === 'true') return;
    var heroImage = articleRoot.querySelector('.nb-article__media img');
    if (!heroImage) return;

    var metaImage = document.querySelector('meta[property="og:image"][content*="nb-blog-context-"], meta[name="twitter:image"][content*="nb-blog-context-"]');
    var metaSrc = metaImage ? String(metaImage.getAttribute('content') || '').trim() : '';
    var metaImageId = extractNbContextImageId(metaSrc);
    if (!metaSrc || !metaImageId) return;

    var currentSrc = heroImage.currentSrc || heroImage.getAttribute('src') || '';
    var currentImageId = extractNbContextImageId(currentSrc);
    if (currentImageId === metaImageId) {
      articleRoot.dataset.nbHeroMetaSynced = 'true';
      return;
    }

    heroImage.setAttribute('src', metaSrc);
    heroImage.removeAttribute('srcset');
    heroImage.removeAttribute('sizes');
    var metaAlt = document.querySelector('meta[name="twitter:image:alt"]');
    var nextAlt = metaAlt ? String(metaAlt.getAttribute('content') || '').trim() : '';
    if (nextAlt) heroImage.setAttribute('alt', nextAlt);
    articleRoot.dataset.nbHeroMetaSynced = 'true';
  }

  function initArticleHeroEnhancements(rootNode) {
    var scope = rootNode && rootNode.querySelectorAll ? rootNode : document;
    var articleRoots = [];
    if (scope && scope.nodeType === 1 && scope.matches && scope.matches('[data-nb-article-conversion]')) {
      articleRoots.push(scope);
    }
    var foundRoots = scope.querySelectorAll('[data-nb-article-conversion]');
    foundRoots.forEach(function (root) {
      articleRoots.push(root);
    });
    if (!articleRoots.length) return;

    articleRoots.forEach(function (articleRoot) {
      syncArticleHeroImageFromMeta(articleRoot);
      if (!articleRoot || articleRoot.dataset.nbHeroEnhanced === 'true') return;
      var articleContent = articleRoot.querySelector('.nb-article__content');
      var rte = articleRoot.querySelector('[data-nb-article-rte]');
      var articleHero = articleRoot.querySelector('[data-nb-article-hero]');
      var articleHeroCopy = articleHero ? articleHero.querySelector('.nb-article-hero__copy') : null;
      var articleHeroTrust = articleHero ? articleHero.querySelector('.nb-article-hero__trust') : null;
      var articleDeck = articleRoot.querySelector('.nb-article__deck');
      if (!articleContent || !rte || !articleHero || !articleHeroCopy) return;

      Array.prototype.slice.call(rte.querySelectorAll('.is-nb-article-lead, .is-nb-article-lead-support, .is-nb-first-section-heading')).forEach(function (node) {
        node.classList.remove('is-nb-article-lead', 'is-nb-article-lead-support', 'is-nb-first-section-heading');
      });

      var flowNodes = getArticleFlowNodes(rte);
      if (!flowNodes.length) return;

      var firstHeadingIndex = -1;
      for (var index = 0; index < flowNodes.length; index += 1) {
        if (isArticleHeadingNode(flowNodes[index])) {
          firstHeadingIndex = index;
          break;
        }
      }

      var introNodes = firstHeadingIndex === -1 ? flowNodes.slice(0, Math.min(flowNodes.length, 4)) : flowNodes.slice(0, firstHeadingIndex);
      var leadCandidates = introNodes.filter(isArticleLeadCandidateNode);
      var firstLeadCandidate = leadCandidates[0] || null;
      var deckText = articleDeck ? normalizeArticleComparableText(articleDeck.textContent) : '';
      var leadText = firstLeadCandidate ? normalizeArticleComparableText(firstLeadCandidate.textContent) : '';
      var isDeckDuplicateLead = !!(
        articleDeck
        && firstLeadCandidate
        && deckText
        && leadText
        && (
          deckText === leadText
          || deckText.indexOf(leadText) !== -1
          || leadText.indexOf(deckText) !== -1
        )
      );

      articleContent.classList.toggle('has-nb-article-intro', introNodes.length > 0);
      articleContent.classList.toggle('has-nb-article-deck', !!articleDeck);
      articleContent.classList.toggle('has-nb-deck-duplicate', isDeckDuplicateLead);

      if (leadCandidates.length) {
        if (articleDeck) {
          if (isDeckDuplicateLead) {
            firstLeadCandidate.classList.add('is-nb-article-deck-duplicate');
            if (leadCandidates[1]) {
              leadCandidates[1].classList.add('is-nb-article-lead-support');
            }
          } else {
            firstLeadCandidate.classList.add('is-nb-article-lead-support');
          }
        } else {
          var heroSummary = document.createElement('div');
          heroSummary.className = 'nb-article-hero__summary';
          heroSummary.setAttribute('data-nb-generated', 'hero-summary');
          firstLeadCandidate.classList.add('nb-article-hero__summary-copy');
          heroSummary.appendChild(firstLeadCandidate);
          if (articleHeroTrust) {
            articleHeroCopy.insertBefore(heroSummary, articleHeroTrust);
          } else {
            articleHeroCopy.appendChild(heroSummary);
          }
          articleContent.classList.add('has-nb-hero-summary');
          if (leadCandidates[1]) {
            leadCandidates[1].classList.add('is-nb-article-lead-support');
          }
        }
      }

      if (firstHeadingIndex > -1 && flowNodes[firstHeadingIndex]) {
        flowNodes[firstHeadingIndex].classList.add('is-nb-first-section-heading');
      }

      articleRoot.dataset.nbHeroEnhanced = 'true';
    });
  }

  var ARTICLE_CALLOUT_LEAD_RE = /^\s*([^:<]{2,32})\s*:\s+/;
  var ARTICLE_CALLOUT_TIP_RE = /^(?:tip|tips|tipp|tipps|conseil|conseils|vinkki|vinkit|suggerimento|suggerimenti|consejo|consejos|dica|dicas)$/i;
  var ARTICLE_CALLOUT_NEXT_STEP_RE = /^(?:wil je|want to|ready to|do you want|möchten sie|bereit|voulez-vous|prêt à|vill du|redo att|vil du|klar til|haluatko|quer|vuoi|quieres|kas tahad)\b/i;

  function normalizeArticlePathValue(value) {
    if (!value) return '';
    try {
      return String(new URL(value, window.location.origin).pathname || '').replace(/\/+$/, '') || '/';
    } catch (_err) {
      return String(value || '').trim().replace(/\/+$/, '') || '/';
    }
  }

  function isArticleCommerceLink(link, articleRoot) {
    if (!link || !link.getAttribute || !articleRoot) return false;
    var href = String(link.getAttribute('href') || '').trim();
    if (!href) return false;

    var targetPath = normalizeArticlePathValue(href);
    var productPath = normalizeArticlePathValue(articleRoot.getAttribute('data-nb-product-url') || '');
    var guidePath = normalizeArticlePathValue(articleRoot.getAttribute('data-nb-guide-url') || '');
    var homePath = normalizeArticlePathValue(articleRoot.getAttribute('data-nb-home-url') || '');

    if (targetPath && (targetPath === productPath || targetPath === guidePath || targetPath === homePath)) return true;
    return /\/products\/|\/pages\/how-to-guide|\/collections\//i.test(targetPath);
  }

  function isArticleTrackedCommerceDestination(destination) {
    return /^(product|guide|home|checkout|collection|quote)$/i.test(String(destination || '').trim());
  }

  function initArticleInlineProductLinkTracking(rootNode) {
    var scope = rootNode && rootNode.querySelectorAll ? rootNode : document;
    var articleRoots = [];
    if (scope && scope.nodeType === 1 && scope.matches && scope.matches('[data-nb-article-conversion]')) {
      articleRoots.push(scope);
    }
    var foundRoots = scope.querySelectorAll('[data-nb-article-conversion]');
    foundRoots.forEach(function (root) {
      articleRoots.push(root);
    });
    if (!articleRoots.length) return;

    articleRoots.forEach(function (articleRoot) {
      if (!articleRoot) return;
      var rte = articleRoot.querySelector('[data-nb-article-rte]');
      if (!rte) return;
      var links = rte.querySelectorAll('a[href]');
      links.forEach(function (link, linkIndex) {
        if (!link || link.dataset.nbArticleCommerceClickBound === 'true') return;
        if (link.closest('[data-nb-cta], .nb-article-inline-conversion, [data-nb-article-mobile-sticky]')) return;
        if (!isArticleCommerceLink(link, articleRoot)) return;
        var isFaqLink = !!link.closest('[data-nb-article-faq]');
        var destinationUrl = resolveArticleClickUrl(link);
        var destination = inferArticleClickDestination(link, articleRoot, '', destinationUrl);
        if (!isArticleTrackedCommerceDestination(destination)) return;
        var primaryDestination = detectArticlePrimaryDestination(articleRoot);
        var slotId = isFaqLink ? 'article_faq_bridge' : 'article_authored_bridge_' + String(linkIndex + 1);
        var actionRank = destination === primaryDestination ? 'primary' : 'secondary';
        link.setAttribute('data-nb-cta', isFaqLink ? 'article_faq_bridge' : 'article_authored_bridge');
        link.setAttribute('data-nb-slot-id', slotId);
        link.setAttribute('data-nb-slot-type', isFaqLink ? 'faq' : 'authored_bridge');
        link.setAttribute('data-nb-slot-destination', destination);
        link.setAttribute('data-nb-action-rank', actionRank);
        link.setAttribute('data-nb-surface-source', 'authored');
        var impressionNode = link.closest('p, li, blockquote') || link;
        if (!impressionNode.hasAttribute('data-nb-conversion-slot')) {
          impressionNode.setAttribute('data-nb-conversion-slot', '');
          impressionNode.setAttribute('data-nb-slot-id', slotId);
          impressionNode.setAttribute('data-nb-slot-type', isFaqLink ? 'faq' : 'authored_bridge');
          impressionNode.setAttribute('data-nb-slot-destination', destination);
          impressionNode.setAttribute('data-nb-action-rank', actionRank);
          impressionNode.setAttribute('data-nb-surface-source', 'authored');
        }
        link.dataset.nbArticleCommerceClickBound = 'true';
        link.addEventListener('click', function () {
          pushArticleClickEvent(isFaqLink ? 'faq_cta_click' : 'inline_product_link_click', link, articleRoot, {
            destination: destination,
            slot_id: slotId,
            slot_type: isFaqLink ? 'faq' : 'authored_bridge',
            action_rank: actionRank,
            surface_source: 'authored',
            placement: isFaqLink ? 'article_faq' : 'article_body'
          });
        });
      });
      initCtaTracking();
      initBlogConversionTracking(articleRoot);
    });
  }

  function wrapArticleCalloutLead(node, leadMatch) {
    if (!node || !leadMatch || node.dataset.nbCalloutWrapped === 'true') return;
    var html = String(node.innerHTML || '');
    var match = html.match(ARTICLE_CALLOUT_LEAD_RE);
    if (!match) return;

    var lead = String(leadMatch[1] || '').trim();
    var restHtml = html.slice(match[0].length);
    if (!lead || !restHtml) return;

    var leadNode = document.createElement('span');
    leadNode.className = 'nb-article-callout__lead';
    leadNode.textContent = lead;

    var bodyNode = document.createElement('span');
    bodyNode.className = 'nb-article-callout__body';
    bodyNode.innerHTML = restHtml;

    node.innerHTML = '';
    node.appendChild(leadNode);
    node.appendChild(bodyNode);
    node.dataset.nbCalloutWrapped = 'true';
  }

  function initArticleEditorialCallouts(rootNode) {
    var scope = rootNode && rootNode.querySelectorAll ? rootNode : document;
    var articleRoots = [];
    if (scope && scope.nodeType === 1 && scope.matches && scope.matches('[data-nb-article-conversion]')) {
      articleRoots.push(scope);
    }
    var foundRoots = scope.querySelectorAll('[data-nb-article-conversion]');
    foundRoots.forEach(function (root) {
      articleRoots.push(root);
    });
    if (!articleRoots.length) return;

    articleRoots.forEach(function (articleRoot) {
      if (!articleRoot || articleRoot.dataset.nbEditorialCalloutsEnhanced === 'true') return;
      var rte = articleRoot.querySelector('[data-nb-article-rte]');
      if (!rte) return;

      var blocks = Array.prototype.slice.call(rte.children).filter(function (node) {
        if (!node || !node.tagName || node.hasAttribute('data-nb-generated')) return false;
        var tagName = String(node.tagName || '').toUpperCase();
        if (tagName !== 'P' && tagName !== 'BLOCKQUOTE') return false;
        if (node.querySelector && node.querySelector('img,video,iframe,table,ul,ol,figure')) return false;
        return getArticleNodeTextLength(node) >= 34;
      });

      blocks.forEach(function (node, index) {
        var text = getArticleBlockText(node);
        if (!text) return;
        var links = Array.prototype.slice.call(node.querySelectorAll('a[href]'));
        var hasCommerceLink = links.some(function (link) {
          return isArticleCommerceLink(link, articleRoot);
        });
        if (hasCommerceLink) return;
        var leadMatch = text.match(ARTICLE_CALLOUT_LEAD_RE);
        var leadLabel = leadMatch ? String(leadMatch[1] || '').trim() : '';
        var isTipCallout = !!leadLabel && ARTICLE_CALLOUT_TIP_RE.test(leadLabel);
        var isNextStepCallout = ARTICLE_CALLOUT_NEXT_STEP_RE.test(text) && index >= blocks.length - 3;
        if (!isTipCallout && !isNextStepCallout) return;

        node.classList.add('nb-article-callout');
        if (isTipCallout) {
          node.classList.add('is-tip');
          wrapArticleCalloutLead(node, leadMatch);
        }
        if (isNextStepCallout) {
          node.classList.add('is-next-step');
        }
      });

      articleRoot.dataset.nbEditorialCalloutsEnhanced = 'true';
    });
  }

  function initArticleInlineConversionBlocks(rootNode) {
    var scope = rootNode && rootNode.querySelectorAll ? rootNode : document;
    var articleRoots = [];
    if (scope && scope.nodeType === 1 && scope.matches && scope.matches('[data-nb-article-conversion]')) {
      articleRoots.push(scope);
    }
    var foundRoots = scope.querySelectorAll('[data-nb-article-conversion]');
    foundRoots.forEach(function (root) {
      articleRoots.push(root);
    });
    if (!articleRoots.length) return;

    articleRoots.forEach(function (articleRoot) {
      if (!articleRoot || articleRoot.dataset.nbInlineBlocksInjected === 'true') return;
      if (String(articleRoot.getAttribute('data-nb-inline-enabled')) !== 'true') return;
      var rte = articleRoot.querySelector('[data-nb-article-rte]');
      if (!rte) return;

      var flowNodes = getArticleFlowNodes(rte);
      if (!flowNodes.length) return;

      var sections = buildArticleSections(flowNodes);
      if (!sections.length) {
        articleRoot.dataset.nbInlineBlocksInjected = 'true';
        applyConversionPreviewPaths(articleRoot);
        initCtaTracking();
        initBlogConversionTracking(articleRoot);
        initAtcTracking();
        return;
      }

      var slotConfigs = resolveArticleSlotConfigs(articleRoot);
      var productRelevance = detectArticleProductRelevance(articleRoot);
      var insertPlan = getSectionInsertPlan(sections, productRelevance);
      var insertedSlots = {};

      function placeSlot(slotName, sectionIndex) {
        if (sectionIndex < 0 || !sections[sectionIndex] || !sections[sectionIndex].anchor || insertedSlots[slotName]) return;
        var block = createInlineConversionBlock(slotConfigs[slotName], articleRoot);
        insertNodeAfter(block, sections[sectionIndex].anchor);
        var opportunitySentinel = createArticleCtaOpportunitySentinel(block);
        if (opportunitySentinel) insertNodeBefore(opportunitySentinel, block);
        initBlogCtaExperimentTracking(articleRoot);
        insertedSlots[slotName] = true;
      }

      placeSlot(insertPlan.slotName, insertPlan.rescueIndex);

      articleRoot.dataset.nbInlineBlocksInjected = 'true';
      applyConversionPreviewPaths(articleRoot);
      initCtaTracking();
      initBlogConversionTracking(articleRoot);
      initAtcTracking();
    });
  }

  function initArticleScrollDepthTracking(rootNode) {
    var scope = rootNode && rootNode.querySelectorAll ? rootNode : document;
    var articleRoots = [];
    if (scope && scope.nodeType === 1 && scope.matches && scope.matches('[data-nb-article-conversion]')) {
      articleRoots.push(scope);
    }
    var foundRoots = scope.querySelectorAll('[data-nb-article-conversion]');
    foundRoots.forEach(function (root) {
      articleRoots.push(root);
    });
    if (!articleRoots.length) return;

    articleRoots.forEach(function (articleRoot) {
      if (!articleRoot || articleRoot.dataset.nbScrollDepthBound === 'true') return;
      articleRoot.dataset.nbScrollDepthBound = 'true';

      var articleContent = articleRoot.querySelector('.nb-article__content') || articleRoot;
      var endSentinel = articleRoot.querySelector('[data-nb-article-end-sentinel]') || articleContent;
      var emittedDepths = readBlogScrollDepthImpressions();
      var thresholds = [25, 50, 75, 90];
      var rafId = 0;

      function syncDepth() {
        rafId = 0;
        var scrollTop = window.scrollY || window.pageYOffset || 0;
        var viewportBottom = scrollTop + (window.innerHeight || document.documentElement.clientHeight || 0);
        var articleTop = scrollTop + articleContent.getBoundingClientRect().top;
        var articleEnd = scrollTop + endSentinel.getBoundingClientRect().top;
        var travel = Math.max(1, articleEnd - articleTop);
        var progress = Math.max(0, Math.min(1, (viewportBottom - articleTop) / travel));

        thresholds.forEach(function (threshold) {
          var key = (window.location.pathname || '') + '::' + String(articleRoot.getAttribute('data-nb-article-handle') || '') + '::' + String(threshold);
          if (progress < threshold / 100 || emittedDepths[key]) return;
          emittedDepths[key] = Date.now();
          writeBlogScrollDepthImpressions(emittedDepths);
          pushEvent(
            appendArticleAnalyticsContext(
              {
                event: 'blog_scroll_depth',
                depth_percent: threshold,
                context_path: window.location.pathname,
                slot_type: 'scroll_depth'
              },
              articleRoot
            )
          );

          if (threshold === 75) {
            pushEvent(
              appendArticleAnalyticsContext(
                {
                  event: 'blog_scroll_75',
                  depth_percent: threshold,
                  context_path: window.location.pathname,
                  placement: 'article_body'
                },
                articleRoot
              )
            );
          }
        });
      }

      function scheduleDepthSync() {
        if (rafId) return;
        rafId = requestAnimationFrame(syncDepth);
      }

      scheduleDepthSync();
      window.addEventListener('scroll', scheduleDepthSync, { passive: true });
      window.addEventListener('resize', scheduleDepthSync, { passive: true });
      window.addEventListener('load', scheduleDepthSync, { once: true });
    });
  }

  function initArticleViewTracking(rootNode) {
    var scope = rootNode && rootNode.querySelectorAll ? rootNode : document;
    var articleRoots = [];
    if (scope && scope.nodeType === 1 && scope.matches && scope.matches('[data-nb-article-conversion]')) {
      articleRoots.push(scope);
    }
    var foundRoots = scope.querySelectorAll('[data-nb-article-conversion]');
    foundRoots.forEach(function (root) {
      articleRoots.push(root);
    });
    if (!articleRoots.length) return;

    articleRoots.forEach(function (articleRoot) {
      if (!articleRoot || articleRoot.dataset.nbViewTracked === 'true') return;
      var articleContext = getArticleAnalyticsContext(articleRoot);
      if (!articleContext || !articleContext.slug) return;
      persistBlogOrigin(articleRoot, {
        surface_source: 'article_view'
      });

      var viewMap = readBlogViewEvents();
      var dedupeKey = (window.location.pathname || '') + '::' + articleContext.slug;
      if (viewMap[dedupeKey]) {
        articleRoot.dataset.nbViewTracked = 'true';
        return;
      }

      viewMap[dedupeKey] = Date.now();
      writeBlogViewEvents(viewMap);
      articleRoot.dataset.nbViewTracked = 'true';

      pushEvent(
        appendArticleAnalyticsContext(
          {
            event: 'blog_view',
            context_path: window.location.pathname,
            placement: 'article_body'
          },
          articleRoot
        )
      );
    });
  }

  function initArticleMobileStickyCta(rootNode) {
    var scope = rootNode && rootNode.querySelectorAll ? rootNode : document;
    var stickyBars = [];
    if (scope && scope.nodeType === 1 && scope.matches && scope.matches('[data-nb-article-mobile-sticky]')) {
      stickyBars.push(scope);
    }
    var foundBars = scope.querySelectorAll('[data-nb-article-mobile-sticky]');
    foundBars.forEach(function (bar) {
      stickyBars.push(bar);
    });
    if (!stickyBars.length) return;

    stickyBars.forEach(function (stickyBar) {
      if (!stickyBar || stickyBar.dataset.nbStickyBound === 'true') return;
      stickyBar.dataset.nbStickyBound = 'true';

      var articleRoot = stickyBar.closest('[data-nb-article-conversion]');
      if (!articleRoot) return;
      if (String(articleRoot.getAttribute('data-nb-mobile-sticky-enabled')) !== 'true') return;
      var productRelevance = detectArticleProductRelevance(articleRoot);
      var articleContent = articleRoot.querySelector('.nb-article__content') || articleRoot;
      var endSentinel = articleRoot.querySelector('[data-nb-article-end-sentinel]');
      var mobileMq = window.matchMedia('(max-width: 840px)');
      var hideBecauseEndVisible = false;
      var showThreshold = 0;
      var isIdle = false;
      var idleTimer = null;
      var idleDelayMs = 2000;
      var previewBottomInsetPx = 0;

      var productUrl = String(articleRoot.getAttribute('data-nb-product-url') || '').trim();
      var homeUrl = String(articleRoot.getAttribute('data-nb-home-url') || '').trim();
      var productPath = '';
      var homePath = '';
      var competingCtaCandidates = null;

      function normalizePath(path) {
        if (!path) return '/';
        var normalized = path.replace(/\/+$/, '');
        return normalized || '/';
      }

      function toPath(url) {
        if (!url) return '';
        try {
          return normalizePath(new URL(url, window.location.origin).pathname || '/');
        } catch (_err) {
          return '';
        }
      }

      productPath = toPath(productUrl);
      homePath = toPath(homeUrl);

      function getCompetingCtaCandidates() {
        if (competingCtaCandidates) return competingCtaCandidates;
        competingCtaCandidates = Array.prototype.slice.call(articleRoot.querySelectorAll('a, button')).filter(function (node) {
          return !!(node && !stickyBar.contains(node));
        });
        return competingCtaCandidates;
      }

      function isNodeVisibleInViewport(node) {
        if (!node || !node.getBoundingClientRect) return false;
        var style = window.getComputedStyle(node);
        if (!style || style.display === 'none' || style.visibility === 'hidden' || Number(style.opacity || '1') < 0.05) return false;
        var rect = node.getBoundingClientRect();
        if (rect.width <= 0 || rect.height <= 0) return false;
        var viewportWidth = window.innerWidth || document.documentElement.clientWidth || 0;
        var viewportHeight = window.innerHeight || document.documentElement.clientHeight || 0;
        var visibleX = Math.min(rect.right, viewportWidth) - Math.max(rect.left, 0);
        var visibleY = Math.min(rect.bottom, viewportHeight) - Math.max(rect.top, 0);
        return visibleX > Math.min(28, rect.width * 0.35) && visibleY > Math.min(22, rect.height * 0.35);
      }

      function hasInViewCompetingCta() {
        var candidates = getCompetingCtaCandidates();
        if (!candidates.length) return false;
        var goHomeNeedle = String(i18n('shared.go_home', 'Ga naar homepage') || '').trim().toLowerCase();
        var viewNordbeltNeedle = String(i18n('shared.view_nordbelt', 'Bekijk Nordbelt') || '').trim().toLowerCase();
        for (var index = 0; index < candidates.length; index += 1) {
          var node = candidates[index];
          if (!node || stickyBar.contains(node)) continue;
          if (!isNodeVisibleInViewport(node)) continue;

          var text = String(node.textContent || '').trim().toLowerCase();
          var hrefPath = node.tagName === 'A' ? toPath(node.getAttribute('href') || '') : '';
          var hasLabelMatch =
            (goHomeNeedle && text.indexOf(goHomeNeedle) !== -1) ||
            (viewNordbeltNeedle && text.indexOf(viewNordbeltNeedle) !== -1);
          var hasHrefMatch =
            node.classList.contains('nb-button') &&
            (hrefPath === productPath || hrefPath === homePath);

          if (hasLabelMatch || hasHrefMatch) return true;
        }
        return false;
      }

      function parseCssPixels(rawValue) {
        if (typeof rawValue !== 'string') return 0;
        var parsed = Number.parseFloat(rawValue.replace('px', '').trim());
        if (!Number.isFinite(parsed) || parsed <= 0) return 0;
        return parsed;
      }

      function detectPreviewBottomInset() {
        var previewFrame = document.getElementById('PBarNextFrame');
        if (!previewFrame) return 0;

        // Try known CSS vars first (if Shopify exposes them).
        var roots = [document.documentElement, document.body].filter(Boolean);
        var cssVarNames = [
          '--shopify-preview-bar-height',
          '--preview-bar-height',
          '--shopify-admin-bar-height'
        ];
        for (var rootIndex = 0; rootIndex < roots.length; rootIndex += 1) {
          var styles = window.getComputedStyle(roots[rootIndex]);
          for (var varIndex = 0; varIndex < cssVarNames.length; varIndex += 1) {
            var cssValue = parseCssPixels(styles.getPropertyValue(cssVarNames[varIndex]));
            if (cssValue > 0 && cssValue < 220) return cssValue;
          }
        }

        var frameRect = previewFrame.getBoundingClientRect();
        var viewportHeight = window.innerHeight || document.documentElement.clientHeight || 0;
        // Shopify preview frame commonly spans the full viewport and draws a bottom toolbar inside.
        if (viewportHeight > 0 && frameRect.height >= viewportHeight - 4) {
          return 64;
        }
        return 0;
      }

      function applyPreviewBottomInset() {
        var inset = detectPreviewBottomInset();
        if (inset === previewBottomInsetPx) return;
        previewBottomInsetPx = inset;
        stickyBar.style.setProperty('--nb-preview-bottom-offset', inset > 0 ? inset + 'px' : '0px');
      }

      function hideSticky(fast) {
        if (fast) {
          stickyBar.classList.add('is-fast-hide');
        } else {
          stickyBar.classList.remove('is-fast-hide');
        }
        stickyBar.classList.remove('is-visible');
        stickyBar.setAttribute('aria-hidden', 'true');
        document.body.classList.remove('has-article-mobile-sticky');
      }

      function showSticky() {
        stickyBar.classList.remove('is-fast-hide');
        stickyBar.classList.add('is-visible');
        stickyBar.setAttribute('aria-hidden', 'false');
        document.body.classList.add('has-article-mobile-sticky');
        if (stickyBar.dataset.nbVisibleTrackingStarted !== 'true') {
          stickyBar.dataset.nbVisibleTrackingStarted = 'true';
          initBlogConversionTracking(stickyBar);
        }
      }

      function computeThreshold() {
        var rect = articleContent.getBoundingClientRect();
        var scrollTop = window.scrollY || window.pageYOffset || 0;
        var thresholdFraction = productRelevance === 'post_safety' ? 0.8 : productRelevance === 'direct' ? 0.55 : 0.65;
        showThreshold = Math.max(0, scrollTop + rect.top + Math.max(240, rect.height * thresholdFraction));
      }

      function syncStickyState(options) {
        applyPreviewBottomInset();
        var scrollTop = window.scrollY || window.pageYOffset || 0;
        var hasReachedThreshold = scrollTop >= showThreshold;
        var hasDuplicateInView = hasInViewCompetingCta();
        var shouldShow = mobileMq.matches && hasReachedThreshold && !hideBecauseEndVisible && !hasDuplicateInView && isIdle;
        if (shouldShow) {
          showSticky();
          return;
        }
        hideSticky(Boolean(options && options.fastHide));
      }

      function scheduleIdleCheck() {
        isIdle = false;
        window.clearTimeout(idleTimer);
        idleTimer = window.setTimeout(function () {
          isIdle = true;
          syncStickyState({ fastHide: false });
        }, idleDelayMs);
      }

      stickyBar.hidden = false;
      stickyBar.setAttribute('aria-hidden', 'true');
      computeThreshold();
      applyPreviewBottomInset();
      hideSticky(false);
      scheduleIdleCheck();

      if ('IntersectionObserver' in window && endSentinel) {
        var endObserver = new IntersectionObserver(
          function (entries) {
            entries.forEach(function (entry) {
              hideBecauseEndVisible = entry.isIntersecting;
              syncStickyState({ fastHide: hideBecauseEndVisible });
            });
          },
          { threshold: [0, 0.08, 0.2] }
        );
        endObserver.observe(endSentinel);
      }

      window.addEventListener('scroll', function () {
        hideSticky(true);
        scheduleIdleCheck();
      }, { passive: true });
      window.addEventListener('resize', function () {
        computeThreshold();
        applyPreviewBottomInset();
        hideSticky(true);
        scheduleIdleCheck();
      }, { passive: true });

      if (mobileMq.addEventListener) {
        mobileMq.addEventListener('change', function () {
          computeThreshold();
          applyPreviewBottomInset();
          hideSticky(true);
          scheduleIdleCheck();
        });
      } else if (mobileMq.addListener) {
        mobileMq.addListener(function () {
          computeThreshold();
          applyPreviewBottomInset();
          hideSticky(true);
          scheduleIdleCheck();
        });
      }

      applyConversionPreviewPaths(stickyBar);
      initCtaTracking();
    });
  }

  function initImageLoadingHints(rootNode) {
    var scope = rootNode && rootNode.querySelectorAll ? rootNode : document;
    var lazyImages = scope.querySelectorAll('img[loading="lazy"]');
    if (!lazyImages.length) return;

    lazyImages.forEach(function (image) {
      if (!image.getAttribute('decoding')) {
        image.setAttribute('decoding', 'async');
      }
      if (!image.getAttribute('fetchpriority')) {
        image.setAttribute('fetchpriority', 'low');
      }
    });
  }

  function initReveal() {
    var revealNodes = document.querySelectorAll('.nb-reveal');
    if (!('IntersectionObserver' in window) || !revealNodes.length) {
      revealNodes.forEach(function (node) {
        node.classList.add('is-visible');
      });
      return;
    }

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.14 }
    );

    revealNodes.forEach(function (node) {
      observer.observe(node);
    });
  }

  var headerLocalizationOptionsCache = null;

  function getHeaderLocalizationOptions() {
    if (headerLocalizationOptionsCache) return headerLocalizationOptionsCache;
    headerLocalizationOptionsCache = { languages: [], countries: [] };
    var node = document.getElementById('NbLocalizationOptionsJson');
    if (!node) return headerLocalizationOptionsCache;
    var parsed = safeParseJson(node.textContent || '{}', {});
    if (!parsed || typeof parsed !== 'object') return headerLocalizationOptionsCache;
    if (Array.isArray(parsed.languages)) headerLocalizationOptionsCache.languages = parsed.languages;
    if (Array.isArray(parsed.countries)) headerLocalizationOptionsCache.countries = parsed.countries;
    return headerLocalizationOptionsCache;
  }

  function hydrateHeaderLocalizationSelect(select) {
    if (!select || select.dataset.nbLocalizationHydrated === 'true') return;
    var kind = select.getAttribute('data-nb-localization-kind') || '';
    var options = getHeaderLocalizationOptions();
    var entries = kind === 'country' ? options.countries : options.languages;
    if (!Array.isArray(entries) || !entries.length) return;

    var currentValue = select.value || select.getAttribute('data-initial-value') || '';
    var fragment = document.createDocumentFragment();
    entries.forEach(function (entry) {
      if (!entry || entry.value === undefined || entry.value === null) return;
      var option = document.createElement('option');
      option.value = String(entry.value);
      option.textContent = String(entry.label || entry.value);
      if (String(entry.value) === String(currentValue)) option.selected = true;
      fragment.appendChild(option);
    });
    if (!fragment.childNodes.length) return;

    select.textContent = '';
    select.appendChild(fragment);
    if (currentValue) select.value = currentValue;
    select.dataset.nbLocalizationHydrated = 'true';
  }

  function hydrateHeaderLocalizationSelects(scope) {
    var root = scope && scope.querySelectorAll ? scope : document;
    var selects = root.querySelectorAll('[data-localization-select]');
    selects.forEach(hydrateHeaderLocalizationSelect);
  }

  function initMobileNav() {
    var toggles = document.querySelectorAll('[data-mobile-nav-toggle]');
    var panel = document.querySelector('[data-mobile-nav]');
    if (!toggles.length || !panel) return;
    var header = panel.closest('[data-nb-header]');
    var defaultMode = panel.getAttribute('data-mobile-nav-default-mode') || 'pages';
    var desktopMq = window.matchMedia('(min-width: 841px)');
    var desktopPanelGlass = null;

    function ensureDesktopPanelGlass() {
      if (desktopPanelGlass && desktopPanelGlass.isConnected) return desktopPanelGlass;
      desktopPanelGlass = document.querySelector('.nb-header__panel-glass-layer');
      if (desktopPanelGlass) return desktopPanelGlass;
      if (!document.body) return null;
      desktopPanelGlass = document.createElement('div');
      desktopPanelGlass.className = 'nb-header__panel-glass-layer';
      desktopPanelGlass.setAttribute('aria-hidden', 'true');
      document.body.appendChild(desktopPanelGlass);
      return desktopPanelGlass;
    }

    function hideDesktopPanelGlass() {
      if (!desktopPanelGlass) return;
      desktopPanelGlass.classList.remove('is-visible');
    }

    function updateDesktopPanelGlass(isOpen) {
      var shouldShow = Boolean(isOpen && desktopMq.matches && header && panel.classList.contains('is-open'));
      if (!shouldShow) {
        hideDesktopPanelGlass();
        return;
      }
      var glass = ensureDesktopPanelGlass();
      if (!glass) return;
      var rect = panel.getBoundingClientRect();
      if (!rect.width || !rect.height) {
        hideDesktopPanelGlass();
        return;
      }
      glass.style.left = rect.left + 'px';
      glass.style.top = rect.top + 'px';
      glass.style.width = rect.width + 'px';
      glass.style.height = rect.height + 'px';
      glass.classList.add('is-visible');
    }

    function queueDesktopPanelGlassUpdate(isOpen) {
      window.requestAnimationFrame(function () {
        updateDesktopPanelGlass(isOpen);
      });
    }

    function setMode(mode) {
      var normalizedMode = mode || defaultMode;
      panel.dataset.mode = normalizedMode;
      panel.classList.toggle('is-mode-pages', normalizedMode === 'pages');
      panel.classList.toggle('is-mode-locale', normalizedMode === 'locale');
      panel.classList.toggle('is-mode-default', normalizedMode !== 'pages' && normalizedMode !== 'locale');
    }

    function setOpenState(isOpen, mode) {
      if (mode) setMode(mode);
      else if (!panel.dataset.mode) setMode(defaultMode);
      if (isOpen) {
        hydrateHeaderLocalizationSelects(panel);
      }
      panel.hidden = !isOpen;
      panel.setAttribute('aria-hidden', isOpen ? 'false' : 'true');
      if ('inert' in panel) {
        panel.inert = !isOpen;
      } else if (isOpen) {
        panel.removeAttribute('inert');
      } else {
        panel.setAttribute('inert', '');
      }
      panel.classList.toggle('is-open', isOpen);
      if (header) {
        header.classList.toggle('is-nav-panel-open', isOpen);
      }
      toggles.forEach(function (toggle) {
        toggle.setAttribute('aria-expanded', String(isOpen));
        var toggleMode = toggle.getAttribute('data-mobile-nav-mode') || defaultMode;
        toggle.classList.toggle('is-active', isOpen && toggleMode === (panel.dataset.mode || defaultMode));
      });
      queueDesktopPanelGlassUpdate(isOpen);
    }

    toggles.forEach(function (toggle) {
      toggle.addEventListener('click', function () {
        var requestedMode = toggle.getAttribute('data-mobile-nav-mode') || defaultMode;
        var isOpen = panel.classList.contains('is-open');
        var currentMode = panel.dataset.mode || defaultMode;
        if (isOpen && currentMode === requestedMode) {
          setOpenState(false, requestedMode);
          return;
        }
        setOpenState(true, requestedMode);
      });
    });

    panel.addEventListener('click', function (event) {
      var target = event.target;
      if (!target || !target.closest) return;
      if (!target.closest('a')) return;
      setOpenState(false);
    });

    document.addEventListener('click', function (event) {
      if (!panel.classList.contains('is-open')) return;
      var clickedToggle = event.target && event.target.closest('[data-mobile-nav-toggle]');
      if (clickedToggle) return;
      if (panel.contains(event.target)) return;
      setOpenState(false);
    });

    document.addEventListener('keydown', function (event) {
      if (event.key !== 'Escape') return;
      if (!panel.classList.contains('is-open')) return;
      setOpenState(false);
    });

    window.addEventListener('resize', function () {
      if (!panel.classList.contains('is-open')) return;
      queueDesktopPanelGlassUpdate(true);
    }, { passive: true });

    window.addEventListener('scroll', function () {
      if (!panel.classList.contains('is-open')) return;
      queueDesktopPanelGlassUpdate(true);
    }, { passive: true });

    function handleDesktopMqChange() {
      queueDesktopPanelGlassUpdate(panel.classList.contains('is-open'));
    }

    if (desktopMq.addEventListener) {
      desktopMq.addEventListener('change', handleDesktopMqChange);
    } else if (desktopMq.addListener) {
      desktopMq.addListener(handleDesktopMqChange);
    }
  }

  function initHeaderCompactState() {
    var header = document.querySelector('[data-nb-header]');
    if (!header) return;

    var threshold = 36;
    var lastCompact = null;
    var lastScrolled = null;
    var ticking = false;

    function applyState() {
      var scrollY = window.scrollY || window.pageYOffset || 0;
      var compact = scrollY > threshold;
      var scrolled = scrollY > 2;
      if (compact === lastCompact && scrolled === lastScrolled) return;
      header.classList.toggle('is-scrolled', scrolled);
      header.classList.toggle('is-compact', compact);
      lastCompact = compact;
      lastScrolled = scrolled;
    }

    function queueState() {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(function () {
        applyState();
        ticking = false;
      });
    }

    applyState();
    window.addEventListener('scroll', queueState, { passive: true });
    window.addEventListener('resize', queueState, { passive: true });
  }

  function initAnnouncementAutoHide() {
    var root = document.documentElement;
    var announcement = document.querySelector('.nb-announcement');
    if (!root || !announcement) return;
    var mobileMq = window.matchMedia('(max-width: 840px)');

    var lastOffset = null;
    var lastProgress = null;
    var ticking = false;
    var announcementHeight = 0;

    function refreshAnnouncementHeight() {
      announcementHeight = Math.max(1, Math.round(announcement.getBoundingClientRect().height));
    }

    function applyState() {
      if (mobileMq.matches) {
        root.style.setProperty('--nb-announcement-offset', '0px');
        root.style.setProperty('--nb-announcement-collapse', '1');
        announcement.classList.add('is-hidden');
        return;
      }
      var scrollY = window.scrollY || window.pageYOffset || 0;
      var height = announcementHeight || 1;
      var progress = Math.max(0, Math.min(1, scrollY / height));
      var offset = -Math.round(height * progress);
      if (offset === lastOffset && progress === lastProgress) return;

      root.style.setProperty('--nb-announcement-offset', offset + 'px');
      root.style.setProperty('--nb-announcement-collapse', progress.toFixed(4));
      announcement.classList.toggle('is-hidden', progress >= 0.995);

      lastOffset = offset;
      lastProgress = progress;
    }

    function queueState() {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(function () {
        applyState();
        ticking = false;
      });
    }

    function handleReflowStateChange() {
      refreshAnnouncementHeight();
      queueState();
    }

    refreshAnnouncementHeight();
    applyState();
    window.addEventListener('scroll', queueState, { passive: true });
    window.addEventListener('resize', handleReflowStateChange, { passive: true });
    if (mobileMq.addEventListener) mobileMq.addEventListener('change', handleReflowStateChange);
    else if (mobileMq.addListener) mobileMq.addListener(handleReflowStateChange);
    if ('ResizeObserver' in window) {
      var sizeObserver = new ResizeObserver(handleReflowStateChange);
      sizeObserver.observe(announcement);
    }
  }

  function initHeaderLocalization() {
    var selects = document.querySelectorAll('[data-localization-select]');
    if (!selects.length) return;
    var MANUAL_LOCALE_STORAGE_KEY = 'nb_locale_manual_v3';

    function enforceSecureLocalizationAction(form) {
      if (!form || !form.setAttribute) return '/localization';
      // Force same-origin localization endpoint to avoid mixed-content form submits.
      form.setAttribute('action', '/localization');
      return '/localization';
    }

    function resolveManualLocalizationIntent(form, changedSelect, syncedLocaleCode) {
      if (!form) return null;

      var countrySelect = form.querySelector('select[name="country_code"]');
      var localeSelect = form.querySelector('select[name="locale_code"], select[name="locale_code_ui"], select[data-nb-original-name="locale_code"]');

      var countryCode = '';
      if (changedSelect && changedSelect.name === 'country_code' && changedSelect.value) {
        countryCode = String(changedSelect.value).trim().toUpperCase();
      } else if (countrySelect && countrySelect.value) {
        countryCode = String(countrySelect.value).trim().toUpperCase();
      }

      var localeCode = normalizeLocaleCode(syncedLocaleCode || '');
      if (!localeCode && changedSelect && changedSelect.name === 'locale_code' && changedSelect.value) {
        localeCode = normalizeLocaleCode(changedSelect.value);
      }
      if (!localeCode && localeSelect && localeSelect.value) {
        localeCode = normalizeLocaleCode(localeSelect.value);
      }

      var localeBase = localeBaseCode(localeCode);
      if (!localeBase && countryCode) {
        localeBase = resolveCountryPrimaryLocale(countryCode);
      }
      if (!localeBase) localeBase = 'en';

      return {
        countryCode: countryCode,
        localeCode: localeCode,
        localeBase: localeBase
      };
    }

    function buildManualReturnPath(currentUrl, intent) {
      var config = window.NordbeltLocaleConfig || {};
      var locales = sanitizeAvailableLocales(config.availableLocales || []);
      var rawPath = currentUrl.pathname || '/';
      var canonicalPath = stripLocalePrefixFromPath(rawPath, locales);
      var marketPath = parseMarketLocaleFromPath(rawPath);
      if (marketPath) {
        var strippedMarketPath = stripFirstPathSegment(rawPath) || '/';
        if (!canonicalPath || canonicalPath === rawPath || canonicalPath === marketPath.rootUrl) {
          canonicalPath = strippedMarketPath;
        } else if (canonicalPath.indexOf(marketPath.rootUrl + '/') === 0) {
          canonicalPath = canonicalPath.slice(marketPath.rootUrl.length) || '/';
        }
      }
      if (!canonicalPath) canonicalPath = '/';
      if (canonicalPath.charAt(0) !== '/') canonicalPath = '/' + canonicalPath;
      canonicalPath = canonicalPath.replace(/\/{2,}/g, '/');

      var targetRoot = '/';
      if (intent.localeBase === 'nl' || intent.countryCode === 'NL') {
        targetRoot = intent.localeBase === 'en' ? '/en' : '/';
      } else if (intent.localeBase && intent.localeBase !== 'en') {
        targetRoot = preferredMarketRootForLocaleBase(intent.localeBase) || ('/' + intent.localeBase);
      }

      return buildLocalizedPath(canonicalPath, targetRoot);
    }

    function ensurePreviewReturnTo(form, stripCampaignParams, changedSelect, syncedLocaleCode) {
      if (!form) return;
      var current = new URL(window.location.href);
      if (stripCampaignParams) {
        current.searchParams.delete('country');
        current.searchParams.delete('shpxid');
        current.searchParams.delete('locale');
        current.searchParams.delete('market');
      }
      var returnPath = current.pathname;
      if (stripCampaignParams) {
        var intent = resolveManualLocalizationIntent(form, changedSelect, syncedLocaleCode);
        if (intent) {
          returnPath = buildManualReturnPath(current, intent);
        }
      }

      var returnTo = returnPath + current.search;
      var field = form.querySelector('input[name="return_to"]');
      if (!field) {
        field = document.createElement('input');
        field.type = 'hidden';
        field.name = 'return_to';
        form.appendChild(field);
      }
      field.value = returnTo;
    }

    function submitLocalizationWithPreviewLock(form) {
      if (!form || !window.fetch || !window.FormData) return false;
      var current = new URL(window.location.href);
      if (!current.searchParams.has('preview_theme_id')) return false;

      var action = enforceSecureLocalizationAction(form);
      var formData = new FormData(form);
      formData.set('return_to', buildShopifyPathWithPreview(window.location.pathname));

      fetch(action, {
        method: 'POST',
        body: formData,
        credentials: 'same-origin'
      })
        .catch(function () {
          // noop
        })
        .finally(function () {
          window.location.assign(buildShopifyPathWithPreview(window.location.pathname));
        });

      return true;
    }

    function submitLocalizationForm(form, changedSelect) {
      if (!form) return;
      var isManualLocalizationChange = !!(
        changedSelect &&
        (changedSelect.name === 'locale_code' || changedSelect.name === 'country_code')
      );
      var syncedLocaleCode = syncLocalizationLocaleToCountryPrimary(form, changedSelect);
      if (isManualLocalizationChange) {
        clearCampaignMarketLock();
        var localeSelect = form.querySelector('select[name="locale_code"], select[name="locale_code_ui"], select[data-nb-original-name="locale_code"]');
        var manualLocaleCode = '';
        if (syncedLocaleCode) {
          manualLocaleCode = normalizeLocaleCode(syncedLocaleCode);
        } else if (localeSelect && localeSelect.value) {
          manualLocaleCode = normalizeLocaleCode(localeSelect.value);
        } else if (changedSelect && changedSelect.name === 'locale_code' && changedSelect.value) {
          manualLocaleCode = normalizeLocaleCode(changedSelect.value);
        }
        if (manualLocaleCode) {
          writeStorageItem(window.localStorage, MANUAL_LOCALE_STORAGE_KEY, manualLocaleCode);
          writeStorageItem(window.sessionStorage, MANUAL_LOCALE_STORAGE_KEY, manualLocaleCode);
        }
      }
      var manualIntent = isManualLocalizationChange
        ? resolveManualLocalizationIntent(form, changedSelect, syncedLocaleCode)
        : null;

      if (manualIntent) {
        var manualCurrentUrl = new URL(window.location.href);
        manualCurrentUrl.searchParams.delete('country');
        manualCurrentUrl.searchParams.delete('shpxid');
        manualCurrentUrl.searchParams.delete('locale');
        manualCurrentUrl.searchParams.delete('market');

        var manualConfig = window.NordbeltLocaleConfig || {};
        var manualHostName = sanitizeHostName(manualCurrentUrl.hostname || '');
        var manualIsNlHost = isNordbeltNlHost(manualHostName);

        if (!manualIsNlHost && (manualIntent.localeBase === 'nl' || manualIntent.countryCode === 'NL')) {
          var nlTargetHost = resolvePreferredNlHost(manualConfig, manualCurrentUrl.hostname || '');
          var nlTargetPath = buildManualReturnPath(manualCurrentUrl, manualIntent) || '/';
          var nlTargetUrl = buildHostSwapUrl(nlTargetHost, manualCurrentUrl, nlTargetPath);
          if (nlTargetUrl) {
            window.location.assign(nlTargetUrl);
            return;
          }
        }

        if (!manualIsNlHost && changedSelect && changedSelect.name === 'locale_code' && manualIntent.localeBase && manualIntent.localeBase !== 'en') {
          var preferredLocalePath = buildManualReturnPath(manualCurrentUrl, manualIntent) || '/';
          if (preferredLocalePath) {
            window.location.assign(preferredLocalePath);
            return;
          }
        }

        if (manualIsNlHost && manualIntent.localeBase && manualIntent.localeBase !== 'nl') {
          var manualLocales = sanitizeAvailableLocales(manualConfig.availableLocales || []);
          var canonicalPath = stripLocalePrefixFromPath(manualCurrentUrl.pathname, manualLocales) || '/';
          var comTargetPath = manualIntent.localeBase === 'en'
            ? canonicalPath
            : (buildManualReturnPath(manualCurrentUrl, manualIntent) || '/');
          var preferredComHost = sanitizeHostName(manualConfig.preferredComHost || 'www.nordbelt.com');
          var comTargetUrl = buildHostSwapUrl(preferredComHost, manualCurrentUrl, comTargetPath);
          if (comTargetUrl) {
            try {
              var comTargetResolvedUrl = new URL(comTargetUrl);
              if (manualIntent.countryCode) {
                comTargetResolvedUrl.searchParams.set('country', String(manualIntent.countryCode).trim().toUpperCase());
              }
              window.location.assign(comTargetResolvedUrl.toString());
            } catch (_errComTargetUrl) {
              window.location.assign(comTargetUrl);
            }
            return;
          }
        }
      }

      enforceSecureLocalizationAction(form);
      ensurePreviewReturnTo(form, isManualLocalizationChange, changedSelect, syncedLocaleCode);
      if (submitLocalizationWithPreviewLock(form)) return;
      form.submit();
    }

    selects.forEach(function (select) {
      select.dataset.initialValue = select.value || '';
      select.addEventListener('focus', function () {
        hydrateHeaderLocalizationSelect(select);
      });
      select.addEventListener('pointerdown', function () {
        hydrateHeaderLocalizationSelect(select);
      }, { passive: true });
      select.addEventListener('change', function () {
        if (!select.form) return;
        hydrateHeaderLocalizationSelects(select.form);
        if (select.name === 'locale_code' && select.value) {
          var manualLocaleCode = normalizeLocaleCode(select.value);
          if (manualLocaleCode) {
            writeStorageItem(window.localStorage, MANUAL_LOCALE_STORAGE_KEY, manualLocaleCode);
            writeStorageItem(window.sessionStorage, MANUAL_LOCALE_STORAGE_KEY, manualLocaleCode);
          }
        }
        if (select.name === 'country_code') clearCampaignMarketLock();

        if (select.form.dataset.nbLocaleSubmitting === '1') return;
        select.form.dataset.nbLocaleSubmitting = '1';

        var submitTriggered = false;
        var submitNow = function () {
          if (submitTriggered) return;
          submitTriggered = true;
          submitLocalizationForm(select.form, select);
        };

        var timeoutId = window.setTimeout(submitNow, 2200);
        snapshotCartForLocaleTransfer()
          .catch(function () {
            // noop
          })
          .finally(function () {
            window.clearTimeout(timeoutId);
            submitNow();
          });
      });
    });
  }

  function isLocalePreservableStorePath(pathname) {
    var path = String(pathname || '/');
    if (!path) path = '/';
    if (path.charAt(0) !== '/') path = '/' + path;
    if (path === '/') return true;
    return /^\/(products|pages|blogs|collections|search|cart)(\/|$)/i.test(path);
  }

  function buildLocalizedStorefrontPath(pathname) {
    var path = String(pathname || '/');
    if (!path) path = '/';
    if (path.charAt(0) !== '/') path = '/' + path;
    if (!isLocalePreservableStorePath(path)) return '';
    if (isCheckoutPath(path)) return '';
    if (path === '/localization' || path.indexOf('/localization/') === 0) return '';

    var config = window.NordbeltLocaleConfig || {};
    var currentRootUrl = normalizeLocaleRootUrl(config.currentRootUrl || '/');
    if (isNordbeltNlHost(window.location && window.location.hostname ? window.location.hostname : '') && localeBaseCode(config.currentLocale || '') === 'nl') {
      currentRootUrl = '/';
    }
    if (currentRootUrl === '/') return '';

    var locales = sanitizeAvailableLocales(config.availableLocales || []);
    if (!locales.length) {
      var fallbackCode = normalizeLocaleCode(config.currentLocale || document.documentElement.getAttribute('lang') || '');
      if (fallbackCode) {
        locales = [{
          code: fallbackCode,
          base: localeBaseCode(fallbackCode),
          rootUrl: currentRootUrl
        }];
      }
    }

    if (hasExplicitLocalePath(path, locales)) return '';

    var localizedPath = buildLocalizedPath(path, currentRootUrl);
    return localizedPath && localizedPath !== path ? localizedPath : '';
  }

  function localizeInternalAnchors(rootNode) {
    var scope = rootNode && rootNode.querySelectorAll ? rootNode : document;
    var links = scope.querySelectorAll('a[href]');
    if (!links.length) return;

    links.forEach(function (link) {
      if (!link || !link.getAttribute || !link.setAttribute) return;
      var rawHref = String(link.getAttribute('href') || '').trim();
      if (!rawHref || rawHref.charAt(0) === '#') return;

      var lowerHref = rawHref.toLowerCase();
      if (
        lowerHref.indexOf('mailto:') === 0 ||
        lowerHref.indexOf('tel:') === 0 ||
        lowerHref.indexOf('sms:') === 0 ||
        lowerHref.indexOf('javascript:') === 0 ||
        lowerHref.indexOf('data:') === 0
      ) {
        return;
      }

      var parsed;
      try {
        parsed = new URL(rawHref, window.location.origin);
      } catch (_err) {
        return;
      }

      if (parsed.origin !== window.location.origin) return;

      var localizedPath = buildLocalizedStorefrontPath(parsed.pathname || '/');
      if (!localizedPath) return;

      var localizedHref = localizedPath + (parsed.search || '') + (parsed.hash || '');
      link.setAttribute('href', localizedHref);
    });
  }

  function normalizeLocaleRootUrl(rootUrl) {
    var normalized = String(rootUrl || '/').trim();
    if (!normalized) normalized = '/';
    if (normalized.charAt(0) !== '/') normalized = '/' + normalized;
    if (normalized.length > 1 && normalized.charAt(normalized.length - 1) === '/') {
      normalized = normalized.slice(0, -1);
    }
    return normalized || '/';
  }

  function normalizeLocaleCode(code) {
    return String(code || '').trim().toLowerCase().replace(/_/g, '-');
  }

  function localeBaseCode(code) {
    var normalized = normalizeLocaleCode(code);
    return normalized ? normalized.split('-')[0] : '';
  }

  function resolveCountryPrimaryLocale(countryCode) {
    var code = String(countryCode || '').trim().toUpperCase();
    if (!code) return '';
    var COUNTRY_PRIMARY_LOCALE = {
      NL: 'nl',
      BE: 'nl',
      AW: 'nl',
      CW: 'nl',
      SX: 'nl',
      BQ: 'nl',
      SR: 'nl',
      DE: 'de',
      AT: 'de',
      LI: 'de',
      LU: 'de',
      CH: 'de',
      FR: 'fr',
      MC: 'fr',
      RE: 'fr',
      GP: 'fr',
      MQ: 'fr',
      GF: 'fr',
      PF: 'fr',
      NC: 'fr',
      BL: 'fr',
      MF: 'fr',
      PM: 'fr',
      WF: 'fr',
      YT: 'fr',
      SE: 'sv',
      DK: 'da',
      NO: 'nb',
      FI: 'fi',
      EE: 'et',
      ES: 'es',
      IT: 'it',
      PT: 'pt',
      IE: 'en',
      GB: 'en',
      US: 'en',
      CA: 'en',
      AU: 'en',
      NZ: 'en',
      MT: 'en',
      CY: 'en'
    };
    return COUNTRY_PRIMARY_LOCALE[code] || 'en';
  }

  function sanitizeAvailableLocales(locales) {
    var list = [];
    var seen = {};
    (locales || []).forEach(function (entry) {
      if (!entry || typeof entry !== 'object') return;
      var code = normalizeLocaleCode(entry.code || entry.iso_code || entry.locale || '');
      if (!code || seen[code]) return;
      seen[code] = true;
      list.push({
        code: code,
        base: localeBaseCode(code),
        rootUrl: normalizeLocaleRootUrl(entry.rootUrl || entry.root_url || '/')
      });
    });
    return list;
  }

  function getBrowserLocaleCandidates() {
    var candidates = [];
    var seen = {};
    var languages = [];

    if (Array.isArray(navigator.languages) && navigator.languages.length) {
      languages = languages.concat(navigator.languages);
    }
    if (navigator.language) languages.push(navigator.language);

    function pushCandidate(value) {
      var normalized = normalizeLocaleCode(value);
      if (!normalized || seen[normalized]) return;
      seen[normalized] = true;
      candidates.push(normalized);
    }

    languages.forEach(function (language) {
      var normalized = normalizeLocaleCode(language);
      if (!normalized) return;
      pushCandidate(normalized);
      pushCandidate(localeBaseCode(normalized));
    });

    return candidates;
  }

  function resolveBrowserRegionCountryHint(preferredBase) {
    var preferred = localeBaseCode(preferredBase);
    var languages = [];
    if (Array.isArray(navigator.languages) && navigator.languages.length) {
      languages = languages.concat(navigator.languages);
    }
    if (navigator.language) languages.push(navigator.language);

    for (var i = 0; i < languages.length; i += 1) {
      var normalized = normalizeLocaleCode(languages[i]);
      if (!normalized) continue;
      var parts = normalized.split('-');
      if (parts.length < 2 || !parts[1] || parts[1].length !== 2) continue;

      var base = localeBaseCode(normalized);
      if (base === 'no') base = 'nb';
      if (preferred && preferred !== base) continue;

      return String(parts[1]).toUpperCase();
    }

    return '';
  }

  function isLikelyCrawlerUserAgent() {
    var ua = String((window.navigator && window.navigator.userAgent) || '').toLowerCase();
    if (!ua) return false;
    return /bot|crawl|spider|slurp|bingpreview|google-structured-data-testing-tool|lighthouse|pagespeed|headlesschrome|facebookexternalhit|whatsapp|telegrambot|linkedinbot|twitterbot/.test(ua);
  }

  function findLocaleByCandidate(locales, candidate) {
    var normalizedCandidate = normalizeLocaleCode(candidate);
    if (!normalizedCandidate) return null;
    for (var i = 0; i < locales.length; i += 1) {
      if (locales[i].code === normalizedCandidate) return locales[i];
    }
    var baseCandidate = localeBaseCode(normalizedCandidate);
    if (!baseCandidate) return null;
    for (var j = 0; j < locales.length; j += 1) {
      if (locales[j].base === baseCandidate) return locales[j];
    }
    return null;
  }

  function stripLocalePrefixFromPath(pathname, locales) {
    var path = String(pathname || '/');
    if (!path) path = '/';
    if (path.charAt(0) !== '/') path = '/' + path;
    var prefixes = locales
      .map(function (locale) { return locale.rootUrl; })
      .filter(function (rootUrl) { return rootUrl && rootUrl !== '/'; })
      .sort(function (a, b) { return b.length - a.length; });

    for (var i = 0; i < prefixes.length; i += 1) {
      var prefix = prefixes[i];
      if (path === prefix) return '/';
      if (path.indexOf(prefix + '/') === 0) {
        var stripped = path.slice(prefix.length);
        return stripped || '/';
      }
    }

    return path;
  }

  function buildLocalizedPath(pathname, targetRootUrl) {
    var cleanPath = String(pathname || '/');
    if (!cleanPath || cleanPath.charAt(0) !== '/') cleanPath = '/' + cleanPath;
    var root = normalizeLocaleRootUrl(targetRootUrl || '/');
    if (root === '/') return cleanPath;
    return cleanPath === '/' ? root : root + cleanPath;
  }

  function isNordbeltNlHost(hostName) {
    var normalized = String(hostName || '').trim().toLowerCase();
    return /(^|\.)nordbelt\.nl$/.test(normalized);
  }

  function sanitizeHostName(hostValue) {
    var normalized = String(hostValue || '').trim().toLowerCase();
    normalized = normalized.replace(/^https?:\/\//, '');
    normalized = normalized.split('/')[0];
    normalized = normalized.replace(/:\d+$/, '');
    return normalized;
  }

  function resolvePreferredNlHost(config, currentHostName) {
    var configuredHost = sanitizeHostName(config && config.preferredNlHost ? config.preferredNlHost : '');
    if (configuredHost) return configuredHost;
    var currentHost = sanitizeHostName(currentHostName);
    if (isNordbeltNlHost(currentHost)) return currentHost;
    return 'www.nordbelt.nl';
  }

  function buildHostSwapUrl(targetHost, currentUrl, targetPathname) {
    if (!targetHost || !currentUrl) return '';
    var path = String(targetPathname || '/');
    if (!path || path.charAt(0) !== '/') path = '/' + path;
    return (
      'https://' +
      sanitizeHostName(targetHost) +
      path +
      (currentUrl.search || '') +
      (currentUrl.hash || '')
    );
  }

  function resolvePrimaryLocaleOption(selectEl, desiredBaseLocale) {
    if (!selectEl || !selectEl.options || !desiredBaseLocale) return '';
    var desiredBase = localeBaseCode(desiredBaseLocale);
    if (!desiredBase) return '';

    for (var i = 0; i < selectEl.options.length; i += 1) {
      var exactCode = normalizeLocaleCode(selectEl.options[i].value || '');
      if (exactCode === desiredBase) return selectEl.options[i].value;
    }

    for (var j = 0; j < selectEl.options.length; j += 1) {
      var optionBase = localeBaseCode(selectEl.options[j].value || '');
      if (optionBase === desiredBase) return selectEl.options[j].value;
    }

    var FALLBACK_SUPPORTED_BASES = {
      nl: true,
      en: true,
      de: true,
      fr: true,
      sv: true,
      da: true,
      nb: true,
      fi: true,
      es: true,
      it: true,
      et: true,
      pt: true
    };
    if (FALLBACK_SUPPORTED_BASES[desiredBase]) return desiredBase;
    if (selectEl.options.length) return String(selectEl.options[0].value || '');
    return '';
  }

  function syncLocalizationLocaleToCountryPrimary(form, changedSelect) {
    if (!form || !changedSelect) return '';
    if (String(changedSelect.name || '').trim() !== 'country_code') return '';

    var countryCode = String(changedSelect.value || '').trim().toUpperCase();
    if (!countryCode) return '';

    var primaryLocaleBase = resolveCountryPrimaryLocale(countryCode);
    if (!primaryLocaleBase) return '';

    var localeSelect = form.querySelector('select[name="locale_code"], select[name="locale_code_ui"], select[data-nb-original-name="locale_code"]');
    if (!localeSelect) return '';

    var originalLocaleFieldName = String(
      localeSelect.getAttribute('data-nb-original-name') || localeSelect.getAttribute('name') || 'locale_code'
    );
    if (!localeSelect.getAttribute('data-nb-original-name')) {
      localeSelect.setAttribute('data-nb-original-name', originalLocaleFieldName);
    }
    localeSelect.setAttribute('name', originalLocaleFieldName);
    var forcedLocaleField = form.querySelector('input[data-nb-forced-locale="1"]');
    if (forcedLocaleField && forcedLocaleField.parentNode) {
      forcedLocaleField.parentNode.removeChild(forcedLocaleField);
    }

    var targetLocaleValue = resolvePrimaryLocaleOption(localeSelect, primaryLocaleBase);
    if (!targetLocaleValue) return '';
    localeSelect.value = targetLocaleValue;
    if (String(localeSelect.value || '') !== String(targetLocaleValue)) {
      localeSelect.setAttribute('name', originalLocaleFieldName + '_ui');
      forcedLocaleField = document.createElement('input');
      forcedLocaleField.type = 'hidden';
      forcedLocaleField.name = originalLocaleFieldName;
      forcedLocaleField.value = targetLocaleValue;
      forcedLocaleField.setAttribute('data-nb-forced-locale', '1');
      form.appendChild(forcedLocaleField);
    }

    return targetLocaleValue;
  }

  function resolveAutoLocaleTarget(config, locales, countryHint) {
    var countryCode = String(countryHint || config.countryCode || '').trim().toUpperCase();
    var countryPrimaryLocale = resolveCountryPrimaryLocale(countryCode);
    var hasDedicatedCountryLocale = !!countryPrimaryLocale && countryPrimaryLocale !== 'en';
    var hostName = String(window.location && window.location.hostname ? window.location.hostname : '').toLowerCase();
    var isNlHost = isNordbeltNlHost(hostName);
    var priority = [];
    var seen = {};
    var HARD_NL_COUNTRIES = {
      NL: true
    };
    var FRENCH_DEFAULT_COUNTRIES = {
      FR: true,
      MC: true,
      RE: true,
      GP: true,
      MQ: true,
      GF: true,
      PF: true,
      NC: true,
      BL: true,
      MF: true,
      PM: true,
      WF: true,
      YT: true
    };
    var GERMAN_DEFAULT_COUNTRIES = {
      DE: true,
      AT: true,
      LI: true
    };
    var NORDIC_DEFAULT_LOCALES = {
      SE: 'sv',
      DK: 'da',
      NO: 'nb',
      FI: 'fi'
    };

    function pushPriority(candidate) {
      var normalized = normalizeLocaleCode(candidate);
      if (!normalized || seen[normalized]) return;
      seen[normalized] = true;
      priority.push(normalized);
    }

    // Hard rule: Dutch visitors should land on Dutch by default.
    if (HARD_NL_COUNTRIES[countryCode]) pushPriority('nl');

    // Countries with their own storefront language should prefer that language
    // over the browser language when entering from the market root.
    if (hasDedicatedCountryLocale) {
      if (countryPrimaryLocale) pushPriority(countryPrimaryLocale);
      if (NORDIC_DEFAULT_LOCALES[countryCode]) pushPriority(NORDIC_DEFAULT_LOCALES[countryCode]);
      if (FRENCH_DEFAULT_COUNTRIES[countryCode]) pushPriority('fr');
      if (GERMAN_DEFAULT_COUNTRIES[countryCode]) pushPriority('de');
    }

    getBrowserLocaleCandidates().forEach(pushPriority);

    if (!hasDedicatedCountryLocale) {
      if (countryPrimaryLocale) pushPriority(countryPrimaryLocale);
      if (NORDIC_DEFAULT_LOCALES[countryCode]) pushPriority(NORDIC_DEFAULT_LOCALES[countryCode]);
      if (FRENCH_DEFAULT_COUNTRIES[countryCode]) pushPriority('fr');
      if (GERMAN_DEFAULT_COUNTRIES[countryCode]) pushPriority('de');
    }
    if (isNlHost) pushPriority('nl');
    else pushPriority('en');
    ['nl', 'en', 'de', 'fr', 'sv', 'da', 'nb', 'fi', 'es', 'it', 'et', 'pt'].forEach(pushPriority);

    for (var i = 0; i < priority.length; i += 1) {
      var match = findLocaleByCandidate(locales, priority[i]);
      if (match) return match;
    }

    return null;
  }

  function resolvePreferredLocaleBase(countryHint) {
    var countryCode = String(countryHint || '').trim().toUpperCase();
    var SUPPORTED_BASES = {
      nl: true,
      en: true,
      de: true,
      fr: true,
      sv: true,
      da: true,
      nb: true,
      fi: true,
      es: true,
      it: true,
      et: true,
      pt: true
    };

    if (countryCode === 'NL') return 'nl';

    var countryPrimary = resolveCountryPrimaryLocale(countryCode);
    if (countryPrimary === 'no') countryPrimary = 'nb';
    if (countryPrimary && countryPrimary !== 'en' && SUPPORTED_BASES[countryPrimary]) {
      return countryPrimary;
    }

    var browserCandidates = getBrowserLocaleCandidates();
    for (var i = 0; i < browserCandidates.length; i += 1) {
      var browserBase = localeBaseCode(browserCandidates[i]);
      if (browserBase === 'no') browserBase = 'nb';
      if (SUPPORTED_BASES[browserBase]) return browserBase;
    }

    if (SUPPORTED_BASES[countryPrimary]) return countryPrimary;

    if (countryCode === 'SE') return 'sv';
    if (countryCode === 'DK') return 'da';
    if (countryCode === 'NO') return 'nb';
    if (countryCode === 'FI') return 'fi';
    if (countryCode === 'ES') return 'es';
    if (countryCode === 'IT') return 'it';
    if (countryCode === 'EE') return 'et';
    if (countryCode === 'PT') return 'pt';
    if (countryCode === 'AT' || countryCode === 'DE' || countryCode === 'LI') return 'de';
    if (countryCode === 'FR' || countryCode === 'MC') return 'fr';

    return 'en';
  }

  function resolvePreferredCountryLocaleRoute(countryHint, locales) {
    var countryCode = normalizeCountryCode(countryHint);
    if (!countryCode || !document || !document.querySelectorAll) return null;

    var routes = [];
    var seenBases = {};
    var links = document.querySelectorAll('link[rel="alternate"][hreflang][href]');

    for (var linkIndex = 0; linkIndex < links.length; linkIndex += 1) {
      var link = links[linkIndex];
      var hreflang = normalizeLocaleCode(link.getAttribute('hreflang') || '');
      if (!hreflang || hreflang === 'x-default') continue;

      var parts = hreflang.split('-');
      var base = localeBaseCode(hreflang);
      if (base === 'no') base = 'nb';
      if (!base || seenBases[base]) continue;

      var href = String(link.getAttribute('href') || '').trim();
      var url;
      try {
        url = new URL(href, window.location.origin);
      } catch (_errCountryLocaleHref) {
        continue;
      }

      var routeCountry = parts.length > 1 ? String(parts[parts.length - 1] || '').toUpperCase() : '';
      var isNlGenericRoute =
        countryCode === 'NL' &&
        (hreflang === 'nl' || hreflang === 'en') &&
        isNordbeltNlHost(url.hostname || '');
      if (!isNlGenericRoute && routeCountry !== countryCode) continue;

      var localeMatch = findLocaleByCandidate(locales || [], base);
      seenBases[base] = true;
      routes.push({
        base: base,
        localeCode: localeMatch && localeMatch.code ? localeMatch.code : base,
        href: url.toString(),
        hostName: sanitizeHostName(url.hostname || ''),
        pathname: url.pathname || '/'
      });
    }

    if (!routes.length) return null;

    var priority = [];
    var seenPriority = {};
    function pushPriority(value) {
      var base = localeBaseCode(value);
      if (base === 'no') base = 'nb';
      if (!base || seenPriority[base]) return;
      seenPriority[base] = true;
      priority.push(base);
    }

    getBrowserLocaleCandidates().forEach(pushPriority);
    pushPriority(resolveCountryPrimaryLocale(countryCode));
    pushPriority('en');

    for (var i = 0; i < priority.length; i += 1) {
      for (var j = 0; j < routes.length; j += 1) {
        if (routes[j].base === priority[i]) return routes[j];
      }
    }

    return routes[0];
  }

  function shouldSkipAutoLocale(pathname, searchParams, manualLocaleSet) {
    if (manualLocaleSet) return true;
    if (isCheckoutPath(pathname)) return true;
    if (searchParams && searchParams.has('locale')) return true;
    if (searchParams && searchParams.has('preview_theme_id')) return true;
    var path = String(pathname || '').toLowerCase();
    if (path.indexOf('/account') === 0) return true;
    if (path.indexOf('/challenge') === 0) return true;
    if (path.indexOf('/apps') === 0) return true;
    return false;
  }

  function findExplicitLocalePathMatch(pathname, locales) {
    var path = String(pathname || '/');
    if (!path) path = '/';
    if (path.charAt(0) !== '/') path = '/' + path;

    var matches = [];
    for (var i = 0; i < locales.length; i += 1) {
      var locale = locales[i] || {};
      var root = normalizeLocaleRootUrl(locale.rootUrl || '/');
      if (!root || root === '/') continue;
      if (path === root || path.indexOf(root + '/') === 0) {
        matches.push({
          code: normalizeLocaleCode(locale.code || ''),
          base: localeBaseCode(locale.code || ''),
          rootUrl: root
        });
      }
    }

    if (!matches.length) return null;
    matches.sort(function (a, b) { return b.rootUrl.length - a.rootUrl.length; });
    return matches[0];
  }

  function isDutchLocalePrefixPath(pathname) {
    var path = String(pathname || '/');
    if (!path) path = '/';
    if (path.charAt(0) !== '/') path = '/' + path;
    var firstSegment = String(path.split('/')[1] || '').trim().toLowerCase();
    if (!firstSegment) return false;
    return firstSegment === 'nl' || firstSegment.indexOf('nl-') === 0;
  }

  function stripFirstPathSegment(pathname) {
    var path = String(pathname || '/');
    if (!path) path = '/';
    if (path.charAt(0) !== '/') path = '/' + path;
    var segments = path.split('/');
    if (segments.length <= 2) return '/';
    var remainder = '/' + segments.slice(2).join('/');
    return remainder === '//' ? '/' : remainder.replace(/\/{2,}/g, '/');
  }

  function hasExplicitLocalePath(pathname, locales) {
    return !!findExplicitLocalePathMatch(pathname, locales);
  }

  var GEO_COUNTRY_HINT_STORAGE_KEY = 'nb_geo_country_hint_v1';
  var GEO_COUNTRY_HINT_TTL_MS = 24 * 60 * 60 * 1000;

  function normalizeCountryCode(value) {
    var code = String(value || '').trim().toUpperCase();
    return /^[A-Z]{2}$/.test(code) ? code : '';
  }

  function readGeoCountryHint() {
    var raw =
      readStorageItem(window.sessionStorage, GEO_COUNTRY_HINT_STORAGE_KEY) ||
      readStorageItem(window.localStorage, GEO_COUNTRY_HINT_STORAGE_KEY);
    if (!raw) return '';
    var parsed = safeParseJson(raw, null);
    if (!parsed || typeof parsed !== 'object') return '';
    var code = normalizeCountryCode(parsed.code);
    var ts = Number(parsed.ts || 0);
    if (!code || !ts) return '';
    if (Date.now() - ts > GEO_COUNTRY_HINT_TTL_MS) return '';
    return code;
  }

  function writeGeoCountryHint(code) {
    var normalized = normalizeCountryCode(code);
    if (!normalized) return;
    var payload = JSON.stringify({ code: normalized, ts: Date.now() });
    writeStorageItem(window.sessionStorage, GEO_COUNTRY_HINT_STORAGE_KEY, payload);
    writeStorageItem(window.localStorage, GEO_COUNTRY_HINT_STORAGE_KEY, payload);
  }

  function extractGeoCountryFromSuggestions(payload) {
    if (!payload || typeof payload !== 'object') return '';
    var detected = payload.detected_values;
    if (!detected || typeof detected !== 'object') return '';
    var countryObj = detected.country;
    var handle = '';
    if (countryObj && typeof countryObj === 'object') {
      handle = countryObj.handle || countryObj.code || countryObj.iso_code || '';
    } else if (typeof countryObj === 'string') {
      handle = countryObj;
    }
    return normalizeCountryCode(handle);
  }

  function requestGeoCountryHint() {
    if (typeof Promise === 'undefined') return null;
    if (!window.fetch) return Promise.resolve('');

    var controller = typeof AbortController !== 'undefined' ? new AbortController() : null;
    var timeoutId = 0;
    if (controller && window.setTimeout) {
      timeoutId = window.setTimeout(function () {
        try {
          controller.abort();
        } catch (_errAbortGeoCountryHint) {
          // noop
        }
      }, 900);
    }

    var geoFetch = fetch('/browsing_context_suggestions.json', {
      credentials: 'same-origin',
      cache: 'no-store',
      headers: { Accept: 'application/json' },
      signal: controller ? controller.signal : undefined
    })
      .then(function (response) {
        if (!response || !response.ok) return null;
        return response.json().catch(function () {
          return null;
        });
      })
      .then(function (payload) {
        if (timeoutId && window.clearTimeout) window.clearTimeout(timeoutId);
        var country = extractGeoCountryFromSuggestions(payload);
        if (country) writeGeoCountryHint(country);
        return country || '';
      })
      .catch(function () {
        if (timeoutId && window.clearTimeout) window.clearTimeout(timeoutId);
        return '';
      });

    if (!controller && window.setTimeout) {
      return Promise.race([
        geoFetch,
        new Promise(function (resolve) {
          window.setTimeout(function () {
            resolve('');
          }, 900);
        })
      ]);
    }

    return geoFetch;
  }

  function readManualLocalePreference(manualLocaleStorageKey) {
    var manualLocale = normalizeLocaleCode(
      readStorageItem(window.localStorage, manualLocaleStorageKey) ||
      readStorageItem(window.sessionStorage, manualLocaleStorageKey)
    );
    if (!manualLocale) return '';
    var manualBase = localeBaseCode(manualLocale);
    var SUPPORTED_MANUAL_BASES = {
      nl: true,
      en: true,
      de: true,
      fr: true,
      sv: true,
      da: true,
      nb: true,
      fi: true,
      es: true,
      it: true,
      et: true,
      pt: true
    };
    if (SUPPORTED_MANUAL_BASES[manualBase]) return manualLocale;
    try {
      window.localStorage.removeItem(manualLocaleStorageKey);
      window.sessionStorage.removeItem(manualLocaleStorageKey);
    } catch (_errClearInvalidManualLocale) {
      // noop
    }
    return '';
  }

  function resolveUserCountryHint(config) {
    var explicitCountryFromQuery = '';
    try {
      var params = new URLSearchParams(window.location.search || '');
      explicitCountryFromQuery = String(params.get('country') || '').trim().toUpperCase();
    } catch (_errCountryQuery) {
      explicitCountryFromQuery = '';
    }
    if (/^[A-Z]{2}$/.test(explicitCountryFromQuery)) return explicitCountryFromQuery;

    var explicitFromPath = parseMarketLocaleFromPath(window.location.pathname || '/');
    if (explicitFromPath && /^[A-Z]{2}$/.test(explicitFromPath.country || '')) {
      return String(explicitFromPath.country || '').toUpperCase();
    }

    var cachedGeoCountry = readGeoCountryHint();
    if (cachedGeoCountry) return cachedGeoCountry;

    var TZ_COUNTRY_MAP = {
      'Europe/Andorra': 'AD',
      'Europe/Amsterdam': 'NL',
      'Europe/Brussels': 'BE',
      'Europe/Sofia': 'BG',
      'Europe/Nicosia': 'CY',
      'Europe/Luxembourg': 'LU',
      'Europe/Dublin': 'IE',
      'Europe/Paris': 'FR',
      'Europe/Vienna': 'AT',
      'Europe/Berlin': 'DE',
      'Europe/Zurich': 'CH',
      'Europe/Copenhagen': 'DK',
      'Europe/Stockholm': 'SE',
      'Europe/Oslo': 'NO',
      'Europe/Helsinki': 'FI',
      'Europe/Tallinn': 'EE',
      'Europe/Athens': 'GR',
      'Europe/Budapest': 'HU',
      'Europe/Rome': 'IT',
      'Europe/Zagreb': 'HR',
      'Europe/Riga': 'LV',
      'Europe/Vilnius': 'LT',
      'Europe/Malta': 'MT',
      'Europe/Monaco': 'MC',
      'Europe/Vaduz': 'LI',
      'Europe/Warsaw': 'PL',
      'Europe/Lisbon': 'PT',
      'Europe/Bucharest': 'RO',
      'Europe/Ljubljana': 'SI',
      'Europe/Bratislava': 'SK',
      'Europe/Madrid': 'ES',
      'Europe/Prague': 'CZ',
      'Europe/London': 'GB'
    };
    var tz = '';
    try {
      tz = String(Intl.DateTimeFormat().resolvedOptions().timeZone || '');
    } catch (_errTz) {
      tz = '';
    }
    if (TZ_COUNTRY_MAP[tz]) return TZ_COUNTRY_MAP[tz];

    var locales = [];
    if (Array.isArray(navigator.languages) && navigator.languages.length) {
      locales = locales.concat(navigator.languages);
    }
    if (navigator.language) locales.push(navigator.language);

    for (var i = 0; i < locales.length; i += 1) {
      var normalized = normalizeLocaleCode(locales[i]);
      if (!normalized) continue;
      var parts = normalized.split('-');
      if (parts.length > 1 && parts[1] && parts[1].length === 2) {
        return parts[1].toUpperCase();
      }
    }

    // Shopify can expose the storefront's current/default market here instead of
    // the visitor's actual country. Use it only after browser-owned signals.
    var shopifyCountry = '';
    try {
      shopifyCountry = String((window.Shopify && window.Shopify.country) || '').trim().toUpperCase();
    } catch (_errShopifyCountry) {
      shopifyCountry = '';
    }
    if (/^[A-Z]{2}$/.test(shopifyCountry)) return shopifyCountry;

    var configCountry = String((config && config.countryCode) || '').trim().toUpperCase();
    if (/^[A-Z]{2}$/.test(configCountry)) return configCountry;

    return '';
  }

  function isAutoLocaleEntryPath(pathname, locales) {
    var path = String(pathname || '/');
    if (!path) path = '/';
    if (path.charAt(0) !== '/') path = '/' + path;
    if (path.length > 1 && path.charAt(path.length - 1) === '/') path = path.slice(0, -1);
    if (path === '/') return true;

    var explicit = findExplicitLocalePathMatch(path, locales);
    if (!explicit) return false;
    return path === explicit.rootUrl;
  }

  function parseMarketLocaleFromPath(pathname) {
    var path = String(pathname || '/');
    if (!path) path = '/';
    if (path.charAt(0) !== '/') path = '/' + path;
    var segment = String(path.split('/')[1] || '').trim().toLowerCase();
    if (!segment) return null;
    var match = segment.match(/^([a-z]{2})-([a-z]{2,3})$/i);
    if (!match) return null;
    var suffix = String(match[2] || '').toLowerCase();
    var countryCode = '';
    if (suffix.length === 2) countryCode = suffix.toUpperCase();
    if (suffix === 'est') countryCode = 'EE';
    if (!countryCode) return null;
    return {
      language: String(match[1] || '').toLowerCase(),
      country: countryCode,
      rootUrl: '/' + segment
    };
  }

  function countryCodeForLocaleBase(baseLocale) {
    var base = localeBaseCode(baseLocale);
    var map = {
      nl: 'NL',
      en: 'US',
      de: 'DE',
      fr: 'FR',
      sv: 'SE',
      da: 'DK',
      nb: 'NO',
      fi: 'FI',
      es: 'ES',
      it: 'IT',
      et: 'EE',
      pt: 'PT'
    };
    return map[base] || '';
  }

  function preferredMarketRootForLocaleBase(baseLocale) {
    var base = localeBaseCode(baseLocale);
    var map = {
      fr: '/fr-fr',
      de: '/de-de',
      sv: '/sv-se',
      da: '/da-dk',
      nb: '/nb-no',
      fi: '/fi-fi',
      pt: '/pt-pt',
      it: '/it-it',
      es: '/es-es',
      et: '/et-est'
    };
    return map[base] || '';
  }

  function localeTagFromBaseAndCountry(baseLocale, countryCode, separator) {
    var base = localeBaseCode(baseLocale) || 'en';
    var country = String(countryCode || '').trim().toUpperCase() || countryCodeForLocaleBase(base) || 'US';
    return base + String(separator || '-') + country;
  }

  function detectDutchContentFromDocument(pageType) {
    var type = String(pageType || '').toLowerCase();
    if (type !== 'article' && type !== 'blog') return false;

    var samples = [];
    var titleNode = document.querySelector('h1');
    if (titleNode && titleNode.textContent) samples.push(titleNode.textContent);
    if (document.title) samples.push(document.title);
    var leadNode = document.querySelector('.nb-article-hero__summary-copy, .nb-article__deck, .nb-article__rte p');
    if (leadNode && leadNode.textContent) samples.push(leadNode.textContent);

    var sample = samples.join(' ').toLowerCase().replace(/\s+/g, ' ').trim();
    if (!sample) return false;

    var signals = [
      /\bblessure\b/,
      /\bpijn\b/,
      /\boefeningen\b/,
      /\boorzaken\b/,
      /\bherstel\b/,
      /\bwanneer\b/,
      /\bbovenbeen\b/,
      /\bachterkant\b/,
      /\bzonder\b/,
      /\bthuis\b/
    ];

    var score = 0;
    signals.forEach(function (pattern) {
      if (pattern.test(sample)) score += 1;
    });

    return score >= 2;
  }

  function resolveEffectiveLocaleInfo(currentUrl, hostName, pageType, firstSegment, marketPath) {
    if (isNordbeltNlHost(hostName)) {
      return {
        base: firstSegment === 'en' ? 'en' : 'nl',
        country: 'NL'
      };
    }

    if (marketPath) {
      return {
        base: marketPath.language || 'en',
        country: marketPath.country || countryCodeForLocaleBase(marketPath.language || 'en') || 'US'
      };
    }

    var preferredCountry = countryCodeForLocaleBase(firstSegment);
    if (preferredCountry && firstSegment !== 'en') {
      return {
        base: firstSegment,
        country: preferredCountry
      };
    }

    if (detectDutchContentFromDocument(pageType)) {
      return {
        base: 'nl',
        country: 'NL'
      };
    }

    var currentLocale = normalizeLocaleCode(
      (window.NordbeltLocaleConfig && window.NordbeltLocaleConfig.currentLocale)
      || document.documentElement.getAttribute('lang')
      || 'en'
    );
    var fallbackBase = localeBaseCode(currentLocale) || 'en';
    return {
      base: fallbackBase,
      country: countryCodeForLocaleBase(fallbackBase) || 'US'
    };
  }

  function extractLocaleIntentFromReferrer(locales) {
    var referrer = String(document.referrer || '').trim();
    if (!referrer) return null;

    var refUrl;
    try {
      refUrl = new URL(referrer);
    } catch (_errRefUrl) {
      return null;
    }

    var refHost = sanitizeHostName(refUrl.hostname || '');
    if (!refHost || (refHost.indexOf('nordbelt.com') === -1 && refHost.indexOf('nordbelt.nl') === -1)) return null;

    var refPath = String(refUrl.pathname || '/');
    if (!refPath) refPath = '/';
    if (refPath.charAt(0) !== '/') refPath = '/' + refPath;

    var market = parseMarketLocaleFromPath(refPath);
    if (market) {
      return {
        base: market.language,
        rootUrl: market.rootUrl,
        pathWithoutPrefix: stripFirstPathSegment(refPath) || '/',
        country: market.country
      };
    }

    var explicit = findExplicitLocalePathMatch(refPath, locales || []);
    if (!explicit || !explicit.rootUrl || explicit.rootUrl === '/') return null;

    var pathWithoutPrefix = '/';
    if (refPath !== explicit.rootUrl) {
      pathWithoutPrefix = refPath.slice(explicit.rootUrl.length);
      if (!pathWithoutPrefix) pathWithoutPrefix = '/';
      if (pathWithoutPrefix.charAt(0) !== '/') pathWithoutPrefix = '/' + pathWithoutPrefix;
    }

    var countryParam = String(refUrl.searchParams.get('country') || '').trim().toUpperCase();
    var countryCode = /^[A-Z]{2}$/.test(countryParam) ? countryParam : countryCodeForLocaleBase(explicit.base);

    return {
      base: explicit.base,
      rootUrl: explicit.rootUrl,
      pathWithoutPrefix: pathWithoutPrefix,
      country: countryCode
    };
  }

  function ensureMetaTag(selector, attributes) {
    if (!document || !document.head) return null;
    var node = document.head.querySelector(selector);
    if (!node) {
      node = document.createElement('meta');
      document.head.appendChild(node);
    }
    Object.keys(attributes || {}).forEach(function (key) {
      var value = attributes[key];
      if (value == null) return;
      node.setAttribute(key, String(value));
    });
    return node;
  }

  function ensureCanonicalTag(href) {
    if (!document || !document.head || !href) return null;
    var node = document.head.querySelector('link[rel=\"canonical\"]');
    if (!node) {
      node = document.createElement('link');
      node.setAttribute('rel', 'canonical');
      document.head.appendChild(node);
    }
    node.setAttribute('href', String(href));
    return node;
  }

  function ensureDescriptionTags(content) {
    var value = String(content || '').trim();
    if (!value) return;
    ensureMetaTag('meta[name=\"description\"]', { name: 'description', content: value });
    ensureMetaTag('meta[property=\"og:description\"]', { property: 'og:description', content: value });
    ensureMetaTag('meta[name=\"twitter:description\"]', { name: 'twitter:description', content: value });
  }

  function resolveRuntimeBlogDescription(pathname) {
    var path = String(pathname || '/');
    if (!path) path = '/';
    if (path.charAt(0) !== '/') path = '/' + path;
    var match = path.match(/^\/(?:[a-z]{2}(?:-[a-z]{2})?\/)?blogs\/([^\/?#]+)/i);
    if (!match || !match[1]) return '';

    var handle = String(match[1] || '').trim().toLowerCase();
    var key = 'seo.blog.description';
    if (handle === 'nieuws') key = 'seo.blog.description_nieuws';
    else if (handle === 'hamstring') key = 'seo.blog.description_hamstring';
    else if (handle === 'blog-posts') key = 'seo.blog.description_blog_posts';

    return i18n(key, '');
  }

  function buildCanonicalPathFromMarketVariant(pathname) {
    var parsed = parseMarketLocaleFromPath(pathname);
    if (!parsed) return String(pathname || '/');
    var remainder = stripFirstPathSegment(pathname) || '/';
    if (parsed.language === 'en') return remainder;
    if (remainder === '/') return '/' + parsed.language;
    return '/' + parsed.language + remainder;
  }

  function hasNoindexQuerySignals(queryString) {
    var query = String(queryString || '').toLowerCase();
    if (!query) return false;

    var needles = [
      'sort_by=',
      'filter.',
      'preview_theme_id=',
      'utm_',
      'gclid=',
      'fbclid=',
      'msclkid=',
      'twclid=',
      'ttclid=',
      'wbraid=',
      'gbraid=',
      'yclid=',
      'epik=',
      '_kx=',
      'mkt_tok=',
      'rb_clickid=',
      'section_id=',
      'view=',
      'constraint=',
      'page=',
      'srsltid=',
      '_pos=',
      '_psq=',
      '_ss=',
      '_v=',
      'pr_prod_strat=',
      'pr_rec_id=',
      'pr_rec_pid=',
      'pr_ref_pid=',
      'pr_seq=',
      'okereviewspagenum=',
      'currency=',
      'country=',
      'locale=',
      'market='
    ];

    for (var i = 0; i < needles.length; i += 1) {
      if (query.indexOf(needles[i]) !== -1) return true;
    }
    return false;
  }

  function initRuntimeSeoGuards() {
    var currentUrl;
    try {
      currentUrl = new URL(window.location.href);
    } catch (_errUrl) {
      return;
    }

    var hostName = sanitizeHostName(currentUrl.hostname || '');
    var isNlHost = isNordbeltNlHost(hostName);
    var path = String(currentUrl.pathname || '/');
    if (!path) path = '/';
    if (path.charAt(0) !== '/') path = '/' + path;
    var pathLower = path.toLowerCase();
    var firstSegment = String(path.split('/')[1] || '').trim().toLowerCase();
    var isDutchPrefixPath = firstSegment === 'nl';
    var marketPath = parseMarketLocaleFromPath(path);
    var NON_NL_COM_PREFIXES = {
      en: true,
      fr: true,
      de: true,
      sv: true,
      nb: true,
      da: true,
      fi: true,
      es: true,
      it: true,
      et: true,
      pt: true
    };

    var canonicalHost = isNlHost ? 'www.nordbelt.nl' : 'www.nordbelt.com';
    var canonicalPath = path;
    var preferredLanguageOnlyRoot = preferredMarketRootForLocaleBase(firstSegment);

    if (marketPath) {
      canonicalHost = marketPath.language === 'nl' && marketPath.country === 'NL' ? 'www.nordbelt.nl' : 'www.nordbelt.com';
      canonicalPath = path;
    } else if (isDutchPrefixPath) {
      canonicalHost = 'www.nordbelt.nl';
      canonicalPath = stripFirstPathSegment(path) || '/';
    } else if (!isNlHost && preferredLanguageOnlyRoot) {
      var strippedLanguagePath = stripFirstPathSegment(path) || '/';
      canonicalHost = 'www.nordbelt.com';
      canonicalPath = strippedLanguagePath === '/' ? preferredLanguageOnlyRoot : preferredLanguageOnlyRoot + strippedLanguagePath;
    } else if (isNlHost && NON_NL_COM_PREFIXES[firstSegment]) {
      canonicalHost = 'www.nordbelt.com';
      canonicalPath = firstSegment === 'en' ? (stripFirstPathSegment(path) || '/') : path;
    }

    if (!canonicalPath) canonicalPath = '/';
    if (canonicalPath.charAt(0) !== '/') canonicalPath = '/' + canonicalPath;
    canonicalPath = canonicalPath.replace(/\/{2,}/g, '/');
    var canonicalUrl = 'https://' + canonicalHost + canonicalPath;

    var pageType = String((document.body && document.body.getAttribute('data-page-type')) || '').toLowerCase();
    var noindex = false;

    if (pageType === 'search' || pageType === 'cart' || pageType === '404') noindex = true;
    if (pathLower.indexOf('/account') === 0 || pathLower.indexOf('/policies/') !== -1) noindex = true;
    if (pathLower.indexOf('/tagged/') !== -1) noindex = true;
    if (pathLower.indexOf('/collections/vendors') !== -1 || pathLower.indexOf('/collections/types') !== -1) noindex = true;
    if (isDutchPrefixPath) noindex = true;
    if (hostName && canonicalHost && hostName !== canonicalHost) noindex = true;
    if (hasNoindexQuerySignals(currentUrl.search || '')) noindex = true;

    var robotsValue = noindex
      ? 'noindex,follow'
      : 'index,follow,max-image-preview:large,max-snippet:-1,max-video-preview:-1';

    if (pageType === 'blog') {
      ensureDescriptionTags(resolveRuntimeBlogDescription(path));
    }

    var effectiveLocale = resolveEffectiveLocaleInfo(currentUrl, hostName, pageType, firstSegment, marketPath);
    if (document.documentElement && effectiveLocale) {
      document.documentElement.setAttribute('lang', localeTagFromBaseAndCountry(effectiveLocale.base, effectiveLocale.country, '-'));
    }

    ensureCanonicalTag(canonicalUrl);
    ensureMetaTag('meta[name=\"robots\"]', { name: 'robots', content: robotsValue });
    ensureMetaTag('meta[name=\"googlebot\"]', { name: 'googlebot', content: robotsValue });
    ensureMetaTag('meta[name=\"bingbot\"]', { name: 'bingbot', content: robotsValue });
    ensureMetaTag('meta[property=\"og:url\"]', { property: 'og:url', content: canonicalUrl });
    ensureMetaTag('meta[property=\"og:locale\"]', { property: 'og:locale', content: localeTagFromBaseAndCountry(effectiveLocale.base, effectiveLocale.country, '_') });
    ensureMetaTag('meta[name=\"nb-runtime-seo-build\"]', { name: 'nb-runtime-seo-build', content: '2026-03-18-r51' });
  }

  var CAMPAIGN_MARKET_LOCK_STORAGE_KEY = 'nb_campaign_market_lock_v2';

  function clearCampaignMarketLock() {
    if (!window.sessionStorage) return;
    try {
      window.sessionStorage.removeItem(CAMPAIGN_MARKET_LOCK_STORAGE_KEY);
    } catch (_err) {
      // noop
    }
  }

  function readCampaignMarketLock() {
    var raw = readStorageItem(window.sessionStorage, CAMPAIGN_MARKET_LOCK_STORAGE_KEY);
    if (!raw) return null;
    var parsed = safeParseJson(raw, null);
    if (!parsed || typeof parsed !== 'object') return null;
    var rootUrl = normalizeLocaleRootUrl(parsed.rootUrl || '');
    var country = String(parsed.country || '').trim().toUpperCase();
    if (!rootUrl || rootUrl === '/' || !/^[A-Z]{2}$/.test(country)) return null;
    return {
      rootUrl: rootUrl,
      country: country
    };
  }

  function persistCampaignMarketLock(lockContext) {
    if (!lockContext || typeof lockContext !== 'object') return;
    var rootUrl = normalizeLocaleRootUrl(lockContext.rootUrl || '');
    var country = String(lockContext.country || '').trim().toUpperCase();
    if (!rootUrl || rootUrl === '/' || !/^[A-Z]{2}$/.test(country)) return;
    writeStorageItem(
      window.sessionStorage,
      CAMPAIGN_MARKET_LOCK_STORAGE_KEY,
      JSON.stringify({ rootUrl: rootUrl, country: country, ts: Date.now() })
    );
  }

  function shouldSkipCampaignLockEnforcement(pathname, searchParams) {
    if (isCheckoutPath(pathname)) return true;
    if (searchParams && searchParams.has('preview_theme_id')) return true;
    var path = String(pathname || '').toLowerCase();
    if (path.indexOf('/account') === 0) return true;
    if (path.indexOf('/challenge') === 0) return true;
    if (path.indexOf('/apps') === 0) return true;
    return false;
  }

  function enforcePersistedCampaignLock(persistedLock, currentUrl, config, locales) {
    if (!persistedLock || !persistedLock.rootUrl || !currentUrl || !config) return false;
    if (shouldSkipCampaignLockEnforcement(currentUrl.pathname, currentUrl.searchParams)) return false;

    var preferredComHost = sanitizeHostName(config.preferredComHost || 'www.nordbelt.com');
    if (!preferredComHost) return false;

    var canonicalPath = stripLocalePrefixFromPath(currentUrl.pathname, locales || []);
    var targetPath = buildLocalizedPath(canonicalPath || '/', persistedLock.rootUrl);
    var targetUrlValue = buildHostSwapUrl(preferredComHost, currentUrl, targetPath || persistedLock.rootUrl);
    if (!targetUrlValue) return false;

    try {
      var targetUrl = new URL(targetUrlValue);
      targetUrl.searchParams.delete('shpxid');
      if (!targetUrl.searchParams.has('country') && /^[A-Z]{2}$/.test(persistedLock.country || '')) {
        targetUrl.searchParams.set('country', persistedLock.country);
      }
      if (targetUrl.toString() === currentUrl.toString()) return false;
      window.location.replace(targetUrl.toString());
      return true;
    } catch (_errTargetCampaignLock) {
      return false;
    }
  }

  function extractCampaignMarketContext(pathname, searchParams, locales) {
    if (!searchParams || typeof searchParams.get !== 'function') return null;

    var countryParam = String(searchParams.get('country') || '').trim().toUpperCase();
    if (!/^[A-Z]{2}$/.test(countryParam)) return null;

    var explicit = findExplicitLocalePathMatch(pathname, locales || []);
    var marketPath = parseMarketLocaleFromPath(pathname);
    if (!marketPath && explicit && explicit.rootUrl && explicit.rootUrl !== '/') {
      marketPath = parseMarketLocaleFromPath(explicit.rootUrl);
    }
    if (marketPath && marketPath.country === countryParam) {
      return { rootUrl: marketPath.rootUrl, country: countryParam };
    }

    // Fallback lock for explicit locale roots after server normalization (e.g. /de-at -> /de).
    if (explicit && explicit.rootUrl && explicit.rootUrl !== '/') {
      var expectedCountry = countryCodeForLocaleBase(explicit.base);
      if (expectedCountry && expectedCountry === countryParam) {
        return { rootUrl: explicit.rootUrl, country: countryParam };
      }
      if (hasCampaignAttributionSignals(searchParams)) {
        return { rootUrl: explicit.rootUrl, country: countryParam };
      }
    }

    return null;
  }

  function hasCampaignAttributionSignals(searchParams) {
    if (!searchParams || typeof searchParams.has !== 'function') return false;
    var KNOWN_KEYS = [
      'gclid',
      'fbclid',
      'msclkid',
      'twclid',
      'ttclid',
      'wbraid',
      'gbraid',
      'yclid',
      'epik',
      'mkt_tok',
      'rb_clickid'
    ];
    for (var i = 0; i < KNOWN_KEYS.length; i += 1) {
      if (searchParams.has(KNOWN_KEYS[i])) return true;
    }
    if (typeof searchParams.forEach === 'function') {
      var hasUtm = false;
      searchParams.forEach(function (_value, key) {
        if (hasUtm) return;
        if (String(key || '').toLowerCase().indexOf('utm_') === 0) hasUtm = true;
      });
      if (hasUtm) return true;
    }
    return false;
  }

  function isCampaignMarketLocked(pathname, searchParams, locales) {
    return !!extractCampaignMarketContext(pathname, searchParams, locales);
  }

  function shouldStripLooseCountryQuery(pathname, searchParams, locales) {
    if (!searchParams || typeof searchParams.has !== 'function') return false;
    if (!searchParams.has('country')) return false;
    if (shouldSkipCampaignLockEnforcement(pathname, searchParams)) return false;

    var countryCode = String(searchParams.get('country') || '').trim().toUpperCase();
    if (!/^[A-Z]{2}$/.test(countryCode)) return true;

    if (parseMarketLocaleFromPath(pathname)) return false;

    var explicit = findExplicitLocalePathMatch(pathname, locales || []);
    if (explicit && explicit.rootUrl && explicit.rootUrl !== '/') return false;

    return true;
  }

  function enforceManualLocalePreference(manualLocale, currentUrl, config, locales, isNlHost) {
    if (!manualLocale || !currentUrl || !config) return false;
    if (shouldSkipCampaignLockEnforcement(currentUrl.pathname, currentUrl.searchParams)) return false;
    if (!isAutoLocaleEntryPath(currentUrl.pathname, locales || [])) return false;
    if (currentUrl.searchParams && currentUrl.searchParams.has('country')) return false;

    var targetLocale = findLocaleByCandidate(locales || [], manualLocale);
    if (!targetLocale) return false;

    var targetBase = localeBaseCode(targetLocale.code || targetLocale.base || '');
    if (!targetBase) return false;

    var canonicalPath = stripLocalePrefixFromPath(currentUrl.pathname, locales || []) || '/';
    var targetRootUrl = normalizeLocaleRootUrl(targetLocale.rootUrl || '/');
    if (isNlHost && targetBase === 'nl') targetRootUrl = '/';
    var targetPath = buildLocalizedPath(canonicalPath, targetRootUrl);
    if (!targetPath) return false;

    if (targetBase === 'nl' && !isNlHost) {
      var preferredNlHost = resolvePreferredNlHost(config, currentUrl.hostname || '');
      var nlUrl = buildHostSwapUrl(preferredNlHost, currentUrl, canonicalPath || '/');
      if (nlUrl && nlUrl !== currentUrl.toString()) {
        window.location.replace(nlUrl);
        return true;
      }
      return false;
    }

    if (targetPath !== currentUrl.pathname) {
      currentUrl.pathname = targetPath;
      currentUrl.searchParams.delete('locale');
      window.location.replace(currentUrl.toString());
      return true;
    }

    return false;
  }

  function applyAutoLocaleSelection(targetLocaleCode, countryCode, currentUrl) {
    if (!targetLocaleCode || !document || !document.body) return false;
    var form = document.createElement('form');
    form.method = 'post';
    form.action = '/localization';
    form.style.display = 'none';
    form.setAttribute('accept-charset', 'UTF-8');
    form.enctype = 'multipart/form-data';

    function appendField(name, value) {
      var input = document.createElement('input');
      input.type = 'hidden';
      input.name = name;
      input.value = value;
      form.appendChild(input);
    }

    appendField('form_type', 'localization');
    appendField('utf8', '✓');
    appendField('_method', 'put');
    appendField('locale_code', targetLocaleCode);
    if (countryCode) appendField('country_code', String(countryCode).trim().toUpperCase());
    appendField(
      'return_to',
      (currentUrl.pathname || '/') + (currentUrl.search || '') + (currentUrl.hash || '')
    );

    document.body.appendChild(form);
    form.submit();
    return true;
  }

  function initAutoLocaleRouting() {
    var AUTO_LOCALE_SESSION_KEY = 'nb_locale_auto_checked_v12';
    var MANUAL_LOCALE_STORAGE_KEY = 'nb_locale_manual_v3';
    var REFERRER_LOCALE_RECOVERY_KEY = 'nb_locale_referrer_recovery_v1';
    var config = window.NordbeltLocaleConfig;
    if (!config || typeof config !== 'object') return;

    var currentUrl;
    try {
      currentUrl = new URL(window.location.href);
    } catch (_err) {
      writeStorageItem(window.sessionStorage, AUTO_LOCALE_SESSION_KEY, '1');
      return;
    }

    var hostName = sanitizeHostName(currentUrl.hostname || config.hostName || window.location.hostname || '');
    var isNlHost = isNordbeltNlHost(hostName);
    var locales = sanitizeAvailableLocales(config.availableLocales || []);
    if (!locales.length) {
      writeStorageItem(window.sessionStorage, AUTO_LOCALE_SESSION_KEY, '1');
      return;
    }
    if (isCampaignMarketLocked(currentUrl.pathname, currentUrl.searchParams, locales)) {
      // Campaign lock is page-scoped (ads landing). Do not freeze auto-locale for the rest of the session.
      try {
        window.sessionStorage.removeItem(AUTO_LOCALE_SESSION_KEY);
      } catch (_errAutoLocaleKey) {
        // noop
      }
      return;
    }

    var hasDutchPrefixPath = isDutchLocalePrefixPath(currentUrl.pathname);
    if (isNlHost && hasDutchPrefixPath) {
      var nlCleanPath = stripFirstPathSegment(currentUrl.pathname) || '/';
      var nlCleanUrl = buildHostSwapUrl(resolvePreferredNlHost(config, hostName), currentUrl, nlCleanPath);
      if (nlCleanUrl && nlCleanUrl !== currentUrl.toString()) {
        writeStorageItem(window.sessionStorage, AUTO_LOCALE_SESSION_KEY, '1');
        window.location.replace(nlCleanUrl);
        return;
      }
    }
    if (!isNlHost && hasDutchPrefixPath) {
      var nlHost = resolvePreferredNlHost(config, hostName);
      var nlHostPath = stripFirstPathSegment(currentUrl.pathname) || '/';
      var nlHostUrl = buildHostSwapUrl(nlHost, currentUrl, nlHostPath);
      if (nlHostUrl && nlHostUrl !== currentUrl.toString()) {
        writeStorageItem(window.sessionStorage, AUTO_LOCALE_SESSION_KEY, '1');
        window.location.replace(nlHostUrl);
        return;
      }
    }

    // Recovery for unexpected server redirects from explicit .com locale paths to .nl.
    if (isNlHost && currentUrl.searchParams.has('shpxid') && !isLikelyCrawlerUserAgent()) {
      var localeRecoveryState = readStorageItem(window.sessionStorage, REFERRER_LOCALE_RECOVERY_KEY);
      if (localeRecoveryState !== '1') {
        var referrerIntent = extractLocaleIntentFromReferrer(locales);
        if (referrerIntent && referrerIntent.base && referrerIntent.base !== 'nl') {
          var recoveryComHost = sanitizeHostName(config.preferredComHost || 'www.nordbelt.com');
          var recoveryRoot = normalizeLocaleRootUrl(referrerIntent.rootUrl || ('/' + referrerIntent.base));
          var recoveryPath = buildLocalizedPath(referrerIntent.pathWithoutPrefix || '/', recoveryRoot);
          var recoveryTarget = buildHostSwapUrl(recoveryComHost, currentUrl, recoveryPath || '/');
          if (recoveryTarget) {
            try {
              var recoveryUrl = new URL(recoveryTarget);
              recoveryUrl.searchParams.delete('shpxid');
              if (referrerIntent.country && !recoveryUrl.searchParams.has('country')) {
                recoveryUrl.searchParams.set('country', referrerIntent.country);
              }
              if (recoveryUrl.toString() !== currentUrl.toString()) {
                writeStorageItem(window.sessionStorage, REFERRER_LOCALE_RECOVERY_KEY, '1');
                writeStorageItem(window.sessionStorage, AUTO_LOCALE_SESSION_KEY, '1');
                window.location.replace(recoveryUrl.toString());
                return;
              }
            } catch (_errRecoveryUrl) {
              // noop
            }
          }
        }
      }
      var cleanedNlUrl = new URL(currentUrl.toString());
      cleanedNlUrl.searchParams.delete('shpxid');
      if (cleanedNlUrl.toString() !== currentUrl.toString()) {
        writeStorageItem(window.sessionStorage, AUTO_LOCALE_SESSION_KEY, '1');
        window.location.replace(cleanedNlUrl.toString());
        return;
      }
    }
    if (!isNlHost && currentUrl.searchParams.has('shpxid') && !isLikelyCrawlerUserAgent()) {
      var cleanedComUrl = new URL(currentUrl.toString());
      cleanedComUrl.searchParams.delete('shpxid');
      if (cleanedComUrl.toString() !== currentUrl.toString()) {
        window.location.replace(cleanedComUrl.toString());
        return;
      }
    }

    var explicitLocalePath = findExplicitLocalePathMatch(currentUrl.pathname, locales);
    if (explicitLocalePath && explicitLocalePath.rootUrl && explicitLocalePath.rootUrl !== '/') {
      // Respect explicit locale/market URLs (manual selections, deep links, campaign landings).
      // Auto-locale should only steer entry/root traffic, not rewrite explicit user intent.
      return;
    }

    if (shouldStripLooseCountryQuery(currentUrl.pathname, currentUrl.searchParams, locales)) {
      var countryCleanUrl = new URL(currentUrl.toString());
      countryCleanUrl.searchParams.delete('country');
      if (countryCleanUrl.toString() !== currentUrl.toString()) {
        window.location.replace(countryCleanUrl.toString());
        return;
      }
    }

    var manualLocale = readManualLocalePreference(MANUAL_LOCALE_STORAGE_KEY);
    if (enforceManualLocalePreference(manualLocale, currentUrl, config, locales, isNlHost)) {
      return;
    }

    if (readStorageItem(window.sessionStorage, AUTO_LOCALE_SESSION_KEY) === '1') return;
    if (isLikelyCrawlerUserAgent()) {
      writeStorageItem(window.sessionStorage, AUTO_LOCALE_SESSION_KEY, '1');
      return;
    }

    var isEntryRootLike =
      isAutoLocaleEntryPath(currentUrl.pathname, locales) &&
      !currentUrl.searchParams.has('country') &&
      !parseMarketLocaleFromPath(currentUrl.pathname);
    var shouldAttemptGeoHint =
      !manualLocale &&
      !currentUrl.searchParams.has('country') &&
      !parseMarketLocaleFromPath(currentUrl.pathname) &&
      isAutoLocaleEntryPath(currentUrl.pathname, locales);

    function continueAutoLocaleRouting(detectedGeoCountry) {
      if (readManualLocalePreference(MANUAL_LOCALE_STORAGE_KEY) && !manualLocale) return;

      if (shouldSkipAutoLocale(currentUrl.pathname, currentUrl.searchParams, !!manualLocale)) {
        writeStorageItem(window.sessionStorage, AUTO_LOCALE_SESSION_KEY, '1');
        return;
      }

      if (!isAutoLocaleEntryPath(currentUrl.pathname, locales)) {
        writeStorageItem(window.sessionStorage, AUTO_LOCALE_SESSION_KEY, '1');
        return;
      }

      var canonicalPath = stripLocalePrefixFromPath(currentUrl.pathname, locales);
      var countryHint = normalizeCountryCode(detectedGeoCountry) || resolveUserCountryHint(config);
      var preferredRoute = isEntryRootLike ? resolvePreferredCountryLocaleRoute(countryHint, locales) : null;

      if (preferredRoute) {
        var preferredCountry = normalizeCountryCode(countryHint);
        var activeCountry = normalizeCountryCode(config.countryCode);
        var activeLocaleCode = normalizeLocaleCode(
          config.currentLocale || document.documentElement.getAttribute('lang') || ''
        );
        var activeLocaleBase = localeBaseCode(activeLocaleCode);
        if (activeLocaleBase === 'no') activeLocaleBase = 'nb';

        var routeUrl = null;
        try {
          routeUrl = new URL(preferredRoute.href, currentUrl);
        } catch (_errPreferredRouteUrl) {
          routeUrl = null;
        }

        if (routeUrl) {
          routeUrl.search = currentUrl.search;
          routeUrl.hash = currentUrl.hash;
          routeUrl.searchParams.delete('locale');
          routeUrl.searchParams.delete('market');
          routeUrl.searchParams.delete('shpxid');

          var routeHost = sanitizeHostName(routeUrl.hostname || '');
          if (preferredCountry === 'NL') {
            routeUrl.searchParams.delete('country');
            if (routeUrl.toString() !== currentUrl.toString()) {
              writeStorageItem(window.sessionStorage, AUTO_LOCALE_SESSION_KEY, '1');
              window.location.replace(routeUrl.toString());
              return;
            }
          } else if (routeHost && routeHost !== hostName) {
            routeUrl.searchParams.set('country', preferredCountry);
            writeStorageItem(window.sessionStorage, AUTO_LOCALE_SESSION_KEY, '1');
            window.location.replace(routeUrl.toString());
            return;
          }

          var needsPreferredMarket =
            activeCountry !== preferredCountry ||
            activeLocaleBase !== preferredRoute.base ||
            currentUrl.pathname !== routeUrl.pathname;
          if (needsPreferredMarket) {
            routeUrl.searchParams.delete('country');
            writeStorageItem(window.sessionStorage, AUTO_LOCALE_SESSION_KEY, '1');
            applyAutoLocaleSelection(preferredRoute.localeCode, preferredCountry, routeUrl);
            return;
          }

          writeStorageItem(window.sessionStorage, AUTO_LOCALE_SESSION_KEY, '1');
          return;
        }
      }

      var targetLocale = resolveAutoLocaleTarget(config, locales, countryHint);
      if (!targetLocale) {
        writeStorageItem(window.sessionStorage, AUTO_LOCALE_SESSION_KEY, '1');
        return;
      }

      var currentLocale = normalizeLocaleCode(
        config.currentLocale || document.documentElement.getAttribute('lang') || ''
      );
      var currentLocaleBase = localeBaseCode(currentLocale);
      var currentRootUrl = normalizeLocaleRootUrl(config.currentRootUrl || '/');
      var targetRootUrl = normalizeLocaleRootUrl(targetLocale.rootUrl || '/');
      if (isNlHost && targetLocale.base === 'nl') {
        // Keep Dutch on nordbelt.nl at the root URL, never under /nl*.
        targetRootUrl = '/';
      }
      var localizedPath = buildLocalizedPath(canonicalPath, targetRootUrl);
      if (!localizedPath) {
        writeStorageItem(window.sessionStorage, AUTO_LOCALE_SESSION_KEY, '1');
        return;
      }

      if (targetLocale.base === 'nl' && !isNlHost) {
        var preferredNlHost = resolvePreferredNlHost(config, hostName);
        var nlPath = canonicalPath || '/';
        var crossDomainNlUrl = buildHostSwapUrl(preferredNlHost, currentUrl, nlPath);
        if (crossDomainNlUrl && crossDomainNlUrl !== currentUrl.toString()) {
          writeStorageItem(window.sessionStorage, AUTO_LOCALE_SESSION_KEY, '1');
          window.location.replace(crossDomainNlUrl);
          return;
        }
      }

      if (isNlHost && targetLocale.base !== 'nl') {
        var preferredComHost = sanitizeHostName(config.preferredComHost || 'www.nordbelt.com');
        var comPath = targetLocale.base === 'en' ? (canonicalPath || '/') : localizedPath;
        var comUrl = buildHostSwapUrl(preferredComHost, currentUrl, comPath);
        if (comUrl && comUrl !== currentUrl.toString()) {
          writeStorageItem(window.sessionStorage, AUTO_LOCALE_SESSION_KEY, '1');
          window.location.replace(comUrl);
          return;
        }
      }

      var sameLocale = targetLocale.code === currentLocale || targetLocale.base === currentLocaleBase;
      var sameCountry =
        !countryHint || normalizeCountryCode(config.countryCode) === normalizeCountryCode(countryHint);
      if (
        sameLocale &&
        sameCountry &&
        targetRootUrl === currentRootUrl &&
        localizedPath === currentUrl.pathname
      ) {
        writeStorageItem(window.sessionStorage, AUTO_LOCALE_SESSION_KEY, '1');
        return;
      }

      var fallbackRouteUrl = new URL(currentUrl.toString());
      fallbackRouteUrl.pathname = localizedPath;
      fallbackRouteUrl.searchParams.delete('locale');
      fallbackRouteUrl.searchParams.delete('market');
      fallbackRouteUrl.searchParams.delete('shpxid');
      writeStorageItem(window.sessionStorage, AUTO_LOCALE_SESSION_KEY, '1');
      applyAutoLocaleSelection(targetLocale.code, countryHint || config.countryCode, fallbackRouteUrl);
    }

    var cachedGeoCountry = readGeoCountryHint();
    if (shouldAttemptGeoHint && !cachedGeoCountry) {
      var geoRequest = requestGeoCountryHint();
      if (geoRequest && typeof geoRequest.then === 'function') {
        geoRequest.then(function (geoCountry) {
          if (window.location.href !== currentUrl.toString()) return;
          if (readManualLocalePreference(MANUAL_LOCALE_STORAGE_KEY)) return;
          continueAutoLocaleRouting(geoCountry);
        });
        return;
      }
    }

    continueAutoLocaleRouting(cachedGeoCountry);
  }

  function initFixedStackOffsets() {
    var root = document.documentElement;
    var header = document.querySelector('[data-nb-header]');
    var announcement = document.querySelector('.nb-announcement');
    if (!root || !header) return;

    var ticking = false;

    function applyOffsets() {
      var announcementHeight = announcement ? Math.round(announcement.getBoundingClientRect().height) : 0;
      var headerHeight = Math.round(header.getBoundingClientRect().height);
      var stackHeight = announcementHeight + headerHeight;
      root.style.setProperty('--nb-announcement-height', announcementHeight + 'px');
      root.style.setProperty('--nb-header-live-height', headerHeight + 'px');
      root.style.setProperty('--nb-fixed-stack-height', stackHeight + 'px');
    }

    function queueOffsets() {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(function () {
        applyOffsets();
        ticking = false;
      });
    }

    applyOffsets();
    window.addEventListener('resize', queueOffsets, { passive: true });

    var observer = new MutationObserver(queueOffsets);
    observer.observe(header, { attributes: true, attributeFilter: ['class', 'style'] });
    if (announcement) observer.observe(announcement, { attributes: true, childList: true, subtree: true });
    if ('ResizeObserver' in window) {
      var sizeObserver = new ResizeObserver(queueOffsets);
      sizeObserver.observe(header);
      if (announcement) sizeObserver.observe(announcement);
    }
  }

  function isArticleFaqHeading(text) {
    var normalized = String(text || '')
      .toLowerCase()
      .replace(/\s+/g, ' ')
      .trim();
    if (!normalized) return false;
    return [
      'faq',
      'veelgestelde vragen',
      'frequently asked questions',
      'questions fréquentes',
      'häufige fragen',
      'häufig gestellte fragen',
      'domande frequenti',
      'preguntas frecuentes',
      'vanliga frågor',
      'ofta ställda frågor',
      'vanlige spørsmål',
      'vanlege spørsmål',
      'usein kysytyt kysymykset',
      'korduma kippuvad küsimused'
    ].indexOf(normalized) !== -1;
  }

  function hasMeaningfulFaqNode(node) {
    if (!node) return false;
    if (node.matches && node.matches('figure, img, picture, ul, ol, table, blockquote, .nb-article-media-shell')) {
      return true;
    }
    return String(node.textContent || '')
      .replace(/\s+/g, ' ')
      .trim().length > 0;
  }

  function hasMeaningfulFaqIntroNode(node) {
    if (!node) return false;
    if (node.matches && node.matches('[data-nb-inline-article-image], figure, img, picture, .nb-article-media-shell')) {
      return false;
    }
    return String(node.textContent || '')
      .replace(/\s+/g, ' ')
      .trim().length > 0;
  }

  function shouldPruneFaqLeadNode(node) {
    if (!node) return false;
    if (node.matches && node.matches('[data-nb-inline-article-image], figure, img, picture, .nb-article-media-shell')) {
      return true;
    }
    return !String(node.textContent || '')
      .replace(/\s+/g, ' ')
      .trim().length;
  }

  function createArticleFaqToggleIcon() {
    var iconWrap = document.createElement('span');
    iconWrap.className = 'nb-article-faq__toggle';
    iconWrap.innerHTML =
      '<svg viewBox="0 0 20 20" aria-hidden="true" focusable="false"><path d="M10 4.5v11M4.5 10h11" fill="none" stroke="currentColor" stroke-linecap="round" stroke-width="1.7"></path></svg>';
    return iconWrap;
  }

  function getArticleFaqHandle(articleRoot) {
    return String(
      articleRoot && articleRoot.getAttribute
        ? articleRoot.getAttribute('data-nb-article-slug') ||
            articleRoot.getAttribute('data-nb-article-handle') ||
            'faq'
        : 'faq'
    )
      .toLowerCase()
      .replace(/[^a-z0-9]+/g, '-')
      .replace(/^-+|-+$/g, '') || 'faq';
  }

  function injectArticleFaqJsonLd(articleRoot, faqWrapper, faqHandle) {
    if (!articleRoot || !faqWrapper || !document.head) return;
    if (document.querySelector('script[type="application/ld+json"][data-nb-article-faq-schema]')) return;

    var items = [];
    var cards = faqWrapper.querySelectorAll('[data-faq-item]');
    cards.forEach(function (card) {
      var questionNode = card.querySelector('.nb-article-faq__question, [data-faq-trigger]');
      var answerNode = card.querySelector('.nb-faq-content, .nb-article-faq__content');
      var questionText = String(questionNode && questionNode.textContent ? questionNode.textContent : '')
        .replace(/\s+/g, ' ')
        .trim();
      var answerText = String(answerNode && answerNode.textContent ? answerNode.textContent : '')
        .replace(/\s+/g, ' ')
        .trim();
      if (!questionText || !answerText) return;
      items.push({
        '@type': 'Question',
        name: questionText,
        acceptedAnswer: {
          '@type': 'Answer',
          text: answerText.length > 1500 ? answerText.slice(0, 1497) + '...' : answerText
        }
      });
    });
    if (!items.length) return;

    var pageUrl = window.location.origin + String(window.location.pathname || '').replace(/\/+$/, '');
    var schema = {
      '@context': 'https://schema.org',
      '@type': 'FAQPage',
      '@id': pageUrl + '#faq-' + (faqHandle || getArticleFaqHandle(articleRoot)),
      url: pageUrl,
      mainEntity: items
    };
    var script = document.createElement('script');
    script.type = 'application/ld+json';
    script.setAttribute('data-nb-article-faq-schema', '');
    script.textContent = JSON.stringify(schema);
    document.head.appendChild(script);
  }

  function injectArticleLooseFaqJsonLd(articleRoot, rte, faqHandle) {
    if (!articleRoot || !rte || !document.head) return;
    if (document.querySelector('script[type="application/ld+json"][data-nb-article-faq-schema]')) return;
    var headings = rte.querySelectorAll('h2, h3, h4');
    var items = [];

    headings.forEach(function (heading) {
      var questionText = String(heading && heading.textContent ? heading.textContent : '')
        .replace(/\s+/g, ' ')
        .trim();
      if (!questionText || !/[?？]\s*$/.test(questionText)) return;
      var headingLevel = Number(String(heading.tagName || '').replace('H', '')) || 2;
      var answerParts = [];
      var cursor = heading.nextElementSibling;

      while (cursor) {
        var tagName = String(cursor.tagName || '').toUpperCase();
        var nextHeadingLevel = /^H[1-6]$/.test(tagName) ? Number(tagName.replace('H', '')) : 0;
        if (nextHeadingLevel && nextHeadingLevel <= headingLevel) break;
        if (cursor.matches && cursor.matches('[data-nb-generated], .nb-article-inline-conversion, .nb-article-toc')) {
          cursor = cursor.nextElementSibling;
          continue;
        }
        var answerChunk = String(cursor.textContent || '').replace(/\s+/g, ' ').trim();
        if (answerChunk) answerParts.push(answerChunk);
        cursor = cursor.nextElementSibling;
      }

      var answerText = answerParts.join(' ').trim();
      if (answerText.length < 32) return;
      items.push({
        '@type': 'Question',
        name: questionText,
        acceptedAnswer: {
          '@type': 'Answer',
          text: answerText.length > 1500 ? answerText.slice(0, 1497) + '...' : answerText
        }
      });
    });

    if (items.length < 2) return;
    var pageUrl = window.location.origin + String(window.location.pathname || '').replace(/\/+$/, '');
    var schema = {
      '@context': 'https://schema.org',
      '@type': 'FAQPage',
      '@id': pageUrl + '#faq-' + (faqHandle || getArticleFaqHandle(articleRoot)),
      url: pageUrl,
      mainEntity: items
    };
    var script = document.createElement('script');
    script.type = 'application/ld+json';
    script.setAttribute('data-nb-article-faq-schema', '');
    script.textContent = JSON.stringify(schema);
    document.head.appendChild(script);
  }

  function getStructuredFaqText(node) {
    return String(node && node.textContent ? node.textContent : '')
      .replace(/\s+/g, ' ')
      .trim();
  }

  function injectHomepageFaqJsonLd(rootNode) {
    if (!document.head) return;
    if (document.querySelector('script[type="application/ld+json"][data-nb-homepage-faq-schema]')) return;

    var scope = rootNode && rootNode.querySelectorAll ? rootNode : document;
    var faqRoot =
      scope.nodeType === 1 && scope.matches && scope.matches('#nb-homepage-2-faq')
        ? scope
        : scope.querySelector('#nb-homepage-2-faq');
    if (!faqRoot) return;

    var items = [];
    faqRoot.querySelectorAll('details').forEach(function (item) {
      var questionNode = item.querySelector('summary');
      var answerNode = item.querySelector('summary + div');
      var questionText = getStructuredFaqText(questionNode);
      var answerText = getStructuredFaqText(answerNode);
      if (!questionText || !answerText) return;
      items.push({
        '@type': 'Question',
        name: questionText,
        acceptedAnswer: {
          '@type': 'Answer',
          text: answerText.length > 1500 ? answerText.slice(0, 1497) + '...' : answerText
        }
      });
    });

    if (items.length < 2) return;
    var pagePath = String(window.location.pathname || '/').replace(/\/+$/, '');
    var pageUrl = window.location.origin + (pagePath || '');
    var schema = {
      '@context': 'https://schema.org',
      '@type': 'FAQPage',
      '@id': pageUrl + '#homepage-faq',
      url: pageUrl,
      mainEntity: items
    };
    var script = document.createElement('script');
    script.type = 'application/ld+json';
    script.setAttribute('data-nb-homepage-faq-schema', '');
    script.textContent = JSON.stringify(schema);
    document.head.appendChild(script);
  }

  function initArticleFaqEnhancements(rootNode) {
    var scope = rootNode && rootNode.querySelectorAll ? rootNode : document;
    var articleRoots = [];
    if (scope && scope.nodeType === 1 && scope.matches && scope.matches('[data-nb-article-conversion]')) {
      articleRoots.push(scope);
    }
    var foundRoots = scope.querySelectorAll('[data-nb-article-conversion]');
    foundRoots.forEach(function (root) {
      articleRoots.push(root);
    });
    if (!articleRoots.length) return;

    articleRoots.forEach(function (articleRoot) {
      if (!articleRoot || articleRoot.dataset.nbArticleFaqEnhanced === 'true') return;
      var rte = articleRoot.querySelector('[data-nb-article-rte]');
      if (!rte) {
        articleRoot.dataset.nbArticleFaqEnhanced = 'true';
        return;
      }
      var existingFaq = rte.querySelector('[data-nb-article-faq]');
      if (existingFaq) {
        injectArticleFaqJsonLd(articleRoot, existingFaq, getArticleFaqHandle(articleRoot));
        articleRoot.dataset.nbArticleFaqEnhanced = 'true';
        return;
      }

      var faqHeading = null;
      var faqHeadingLevel = 0;
      var headings = rte.querySelectorAll('h2, h3');
      for (var i = 0; i < headings.length; i += 1) {
        var heading = headings[i];
        if (!isArticleFaqHeading(heading.textContent)) continue;
        faqHeading = heading;
        faqHeadingLevel = Number(String(heading.tagName || '').replace('H', '')) || 2;
        break;
      }

      if (!faqHeading) {
        injectArticleLooseFaqJsonLd(articleRoot, rte, getArticleFaqHandle(articleRoot));
        articleRoot.dataset.nbArticleFaqEnhanced = 'true';
        return;
      }

      var leadNodes = [];
      var items = [];
      var currentItem = null;
      var cursor = faqHeading.nextElementSibling;

      while (cursor) {
        var next = cursor.nextElementSibling;
        var tagName = String(cursor.tagName || '').toUpperCase();
        var headingLevel = /^H[1-6]$/.test(tagName) ? Number(tagName.replace('H', '')) : 0;

        if (headingLevel && headingLevel <= faqHeadingLevel) break;

        if (headingLevel && headingLevel > faqHeadingLevel && headingLevel <= Math.min(6, faqHeadingLevel + 2)) {
          currentItem = {
            questionNode: cursor,
            answerNodes: []
          };
          items.push(currentItem);
        } else if (currentItem) {
          currentItem.answerNodes.push(cursor);
        } else {
          leadNodes.push(cursor);
        }

        cursor = next;
      }

      items = items.filter(function (item) {
        var questionText = String(item.questionNode && item.questionNode.textContent ? item.questionNode.textContent : '')
          .replace(/\s+/g, ' ')
          .trim();
        if (!questionText) return false;
        return item.answerNodes.some(hasMeaningfulFaqNode);
      });

      if (!items.length) {
        articleRoot.dataset.nbArticleFaqEnhanced = 'true';
        return;
      }

      var faqHandle = getArticleFaqHandle(articleRoot);

      var wrapper = document.createElement('section');
      wrapper.className = 'nb-article-faq';
      wrapper.setAttribute('data-nb-article-faq', '');

      var head = document.createElement('div');
      head.className = 'nb-article-faq__head';

      rte.insertBefore(wrapper, faqHeading);
      wrapper.appendChild(head);

      faqHeading.classList.add('nb-article-faq__title');
      head.appendChild(faqHeading);

      var introNodes = leadNodes.filter(hasMeaningfulFaqIntroNode);
      if (introNodes.length) {
        var intro = document.createElement('div');
        intro.className = 'nb-article-faq__intro';
        introNodes.forEach(function (node) {
          intro.appendChild(node);
        });
        head.appendChild(intro);
      }

      leadNodes.forEach(function (node) {
        if (introNodes.indexOf(node) !== -1) return;
        if (shouldPruneFaqLeadNode(node) && node.parentNode) {
          node.parentNode.removeChild(node);
        }
      });

      var list = document.createElement('div');
      list.className = 'nb-article-faq__items nb-faq';
      wrapper.appendChild(list);

      items.forEach(function (item, index) {
        var questionText = String(item.questionNode.textContent || '').replace(/\s+/g, ' ').trim();
        var card = document.createElement('article');
        card.className = 'nb-faq-item nb-article-faq__item';
        card.setAttribute('data-faq-item', '');
        if (index === 0) card.classList.add('is-open');

        var trigger = document.createElement('button');
        trigger.className = 'nb-faq-trigger nb-article-faq__trigger';
        trigger.type = 'button';
        trigger.setAttribute('data-faq-trigger', '');
        trigger.setAttribute('aria-expanded', index === 0 ? 'true' : 'false');

        var panelId = 'nb-article-faq-panel-' + faqHandle + '-' + String(index + 1);
        trigger.setAttribute('aria-controls', panelId);

        var label = document.createElement('span');
        label.className = 'nb-article-faq__question';
        label.textContent = questionText;
        trigger.appendChild(label);
        trigger.appendChild(createArticleFaqToggleIcon());

        var content = document.createElement('div');
        content.className = 'nb-faq-content nb-article-faq__content';
        content.id = panelId;
        item.answerNodes.forEach(function (node) {
          content.appendChild(node);
        });

        card.appendChild(trigger);
        card.appendChild(content);
        list.appendChild(card);

        if (item.questionNode && item.questionNode.parentNode) {
          item.questionNode.parentNode.removeChild(item.questionNode);
        }
      });

      injectArticleFaqJsonLd(articleRoot, wrapper, faqHandle);
      articleRoot.dataset.nbArticleFaqEnhanced = 'true';
    });
  }

  function initFaq() {
    function decodeFaqEntities(value) {
      var probe = document.createElement('textarea');
      var output = value || '';

      for (var i = 0; i < 3; i += 1) {
        probe.innerHTML = output;
        var decoded = probe.value || '';
        if (!decoded || decoded === output) break;
        output = decoded;
      }

      return output
        .replace(/_NBTOK18__/g, '</p><p>')
        .replace(/NBTOK18__/g, '</p><p>')
        .replace(/_NBTOK20__/g, '</p><p>')
        .replace(/NBTOK20__/g, '</p><p>')
        .replace(/__NBTOK21\.__NBTOK21/g, '')
        .replace(/__NBTOK21/g, '')
        .replace(/__NTOK0__/g, 'Nordbelt™');
    }

    document.querySelectorAll('.nb-faq-content').forEach(function (node) {
      var raw = node.innerHTML || '';
      if (!raw) return;
      var normalized = decodeFaqEntities(raw);
      if (!normalized || normalized === raw) return;
      node.innerHTML = normalized;
    });

    document.querySelectorAll('[data-faq-item]').forEach(function (item) {
      if (item.dataset.nbFaqBound === 'true') return;
      item.dataset.nbFaqBound = 'true';
      var trigger = item.querySelector('[data-faq-trigger]');
      if (!trigger) return;

      trigger.addEventListener('click', function () {
        var open = item.classList.toggle('is-open');
        trigger.setAttribute('aria-expanded', String(open));
      });
    });
  }

  function initGallery() {
    var mainMedia = document.querySelector('[data-main-media]');
    if (!mainMedia) return;
    var productSection = mainMedia.closest('.nb-product');
    var galleryPin = productSection ? productSection.querySelector('.nb-product__gallery-pin') : null;
    var galleryMain = productSection ? productSection.querySelector('.nb-gallery-main') : null;
    var thumbsRail = productSection ? productSection.querySelector('.nb-gallery-thumbs') : null;
    var mobileHeroSlot = productSection ? productSection.querySelector('.nb-product__mobile-hero') : null;
    var mobileThumbsSlot = productSection ? productSection.querySelector('[data-mobile-thumbs-slot]') : null;
    var mobileHeroImage = productSection ? productSection.querySelector('.nb-product__mobile-hero-image') : null;
    var mobileTrigger = productSection ? productSection.querySelector('[data-mobile-main-media-trigger]') : null;
    var thumbs = Array.prototype.slice.call(thumbsRail ? thumbsRail.querySelectorAll('[data-gallery-thumb]') : []);
    var items = [];
    var currentIndex = 0;
    var lightbox = null;
    var lightboxImg = null;
    var lightboxCaption = null;
    var lightboxTouchStartX = null;
    var lightboxTouchStartY = null;
    var mobileLayoutMq = window.matchMedia('(max-width: 840px)');

    function collectItems() {
      if (!thumbs.length) {
        items = [{ src: mainMedia.getAttribute('src') || '', alt: mainMedia.getAttribute('alt') || '' }];
        return;
      }

      items = thumbs
        .map(function (thumb) {
          return {
            src: thumb.getAttribute('data-media-url') || '',
            alt: thumb.getAttribute('data-media-alt') || ''
          };
        })
        .filter(function (item) {
          return Boolean(item.src);
        });
    }

    function preloadGalleryImages(limit) {
      var max = Math.max(0, Number(limit) || 0);
      if (!max) return;
      items.slice(1, max + 1).forEach(function (item) {
        if (!item.src) return;
        var image = new Image();
        image.decoding = 'async';
        image.src = item.src;
      });
    }

    function scheduleGalleryPreload() {
      var connection = navigator.connection || navigator.mozConnection || navigator.webkitConnection;
      if (connection && (connection.saveData || /2g/i.test(connection.effectiveType || ''))) return;
      var kickoff = function () {
        preloadGalleryImages(2);
      };
      if ('requestIdleCallback' in window) {
        window.requestIdleCallback(kickoff, { timeout: 1600 });
      } else {
        window.setTimeout(kickoff, 900);
      }
    }

    function syncThumbState(index) {
      thumbs.forEach(function (thumb, thumbIndex) {
        var isActive = thumbIndex === index;
        thumb.classList.toggle('is-active', isActive);
        thumb.setAttribute('aria-pressed', isActive ? 'true' : 'false');
      });
    }

    function renderMain(index) {
      if (!items.length || !items[index]) return;
      currentIndex = index;
      mainMedia.setAttribute('src', items[index].src);
      mainMedia.setAttribute('alt', items[index].alt || '');
      if (mobileHeroImage) {
        mobileHeroImage.setAttribute('src', items[index].src);
        mobileHeroImage.setAttribute('alt', items[index].alt || '');
      }
      syncThumbState(index);
    }

    function syncMobileThumbPlacement() {
      if (!thumbsRail || !galleryPin || !galleryMain || !mobileHeroSlot) return;
      var mobileHeroVisible = window.getComputedStyle(mobileHeroSlot).display !== 'none';
      if (mobileLayoutMq.matches && mobileHeroVisible) {
        var mobileTarget = mobileThumbsSlot || mobileHeroSlot;
        if (!mobileTarget.contains(thumbsRail)) {
          mobileTarget.appendChild(thumbsRail);
        }
      } else if (!galleryPin.contains(thumbsRail)) {
        galleryMain.insertAdjacentElement('afterend', thumbsRail);
      }
    }

    function ensureLightbox() {
      if (lightbox) return;

      var lightboxLabel = i18n('gallery.lightbox_label', 'Productafbeelding groot bekijken');
      var backLabel = i18n('gallery.back', 'Terug');
      var prevLabel = i18n('gallery.prev', 'Vorige afbeelding');
      var nextLabel = i18n('gallery.next', 'Volgende afbeelding');

      lightbox = document.createElement('dialog');
      lightbox.className = 'nb-gallery-lightbox';
      lightbox.setAttribute('aria-label', lightboxLabel);
      lightbox.innerHTML =
        '<button type="button" class="nb-gallery-lightbox__back" data-gallery-lightbox-close aria-label="' + backLabel + '">' + backLabel + '</button>' +
        '<button type="button" class="nb-gallery-lightbox__nav nb-gallery-lightbox__nav--prev" data-gallery-lightbox-prev aria-label="' + prevLabel + '">&#8249;</button>' +
        '<figure class="nb-gallery-lightbox__figure">' +
        '  <img class="nb-gallery-lightbox__image" alt="">' +
        '  <figcaption class="nb-gallery-lightbox__caption"></figcaption>' +
        '</figure>' +
        '<button type="button" class="nb-gallery-lightbox__nav nb-gallery-lightbox__nav--next" data-gallery-lightbox-next aria-label="' + nextLabel + '">&#8250;</button>';

      document.body.appendChild(lightbox);
      lightboxImg = lightbox.querySelector('.nb-gallery-lightbox__image');
      lightboxCaption = lightbox.querySelector('.nb-gallery-lightbox__caption');

      var close = lightbox.querySelector('[data-gallery-lightbox-close]');
      var prev = lightbox.querySelector('[data-gallery-lightbox-prev]');
      var next = lightbox.querySelector('[data-gallery-lightbox-next]');

      close.addEventListener('click', function () {
        closeLightbox();
      });

      lightbox.addEventListener('click', function (event) {
        if (event.target === lightbox) closeLightbox();
      });

      prev.addEventListener('click', function (event) {
        event.stopPropagation();
        showLightboxItem(currentIndex - 1);
      });

      next.addEventListener('click', function (event) {
        event.stopPropagation();
        showLightboxItem(currentIndex + 1);
      });

      lightbox.addEventListener('touchstart', function (event) {
        if (!event.touches || !event.touches.length) return;
        lightboxTouchStartX = event.touches[0].clientX;
        lightboxTouchStartY = event.touches[0].clientY;
      }, { passive: true });

      lightbox.addEventListener('touchend', function (event) {
        if (lightboxTouchStartX === null || lightboxTouchStartY === null) return;
        if (!event.changedTouches || !event.changedTouches.length) return;

        var endX = event.changedTouches[0].clientX;
        var endY = event.changedTouches[0].clientY;
        var deltaX = endX - lightboxTouchStartX;
        var deltaY = endY - lightboxTouchStartY;
        var absX = Math.abs(deltaX);
        var absY = Math.abs(deltaY);

        lightboxTouchStartX = null;
        lightboxTouchStartY = null;

        if (absX < 36 || absX <= absY) return;
        if (deltaX < 0) showLightboxItem(currentIndex + 1);
        if (deltaX > 0) showLightboxItem(currentIndex - 1);
      }, { passive: true });
    }

    function showLightboxItem(index) {
      if (!items.length) return;
      if (index < 0) index = items.length - 1;
      if (index >= items.length) index = 0;
      currentIndex = index;
      var item = items[index];
      if (!item) return;
      lightboxImg.setAttribute('src', item.src);
      lightboxImg.setAttribute('alt', item.alt || '');
      lightboxCaption.textContent = item.alt || '';
      syncThumbState(index);
    }

    function openLightbox(index) {
      ensureLightbox();
      showLightboxItem(index);
      if (lightbox.open) return;
      if (typeof lightbox.showModal === 'function') {
        lightbox.showModal();
      } else {
        lightbox.setAttribute('open', 'open');
      }
    }

    function closeLightbox() {
      if (!lightbox || !lightbox.open) return;
      if (typeof lightbox.close === 'function') {
        lightbox.close();
      } else {
        lightbox.removeAttribute('open');
      }
    }

    collectItems();
    scheduleGalleryPreload();

    if (!items.length) return;

    mainMedia.style.cursor = 'zoom-in';
    mainMedia.addEventListener('click', function () {
      openLightbox(currentIndex);
    });

    if (mobileTrigger) {
      mobileTrigger.style.cursor = 'zoom-in';
      mobileTrigger.addEventListener('click', function (event) {
        if (event.target && event.target.closest && event.target.closest('[data-gallery-thumb]')) return;
        openLightbox(currentIndex);
      });
    }

    thumbs.forEach(function (thumb, index) {
      thumb.addEventListener('click', function () {
        renderMain(index);
        openLightbox(index);
      });

      thumb.addEventListener('keydown', function (event) {
        if (event.key !== 'Enter' && event.key !== ' ') return;
        event.preventDefault();
        renderMain(index);
        openLightbox(index);
      });
    });

    document.addEventListener('keydown', function (event) {
      if (!lightbox || !lightbox.open) return;
      if (event.key === 'Escape') {
        closeLightbox();
      } else if (event.key === 'ArrowLeft') {
        showLightboxItem(currentIndex - 1);
      } else if (event.key === 'ArrowRight') {
        showLightboxItem(currentIndex + 1);
      }
    });

    syncMobileThumbPlacement();
    window.requestAnimationFrame(syncMobileThumbPlacement);
    setTimeout(syncMobileThumbPlacement, 140);
    window.addEventListener('resize', syncMobileThumbPlacement, { passive: true });
    if (mobileLayoutMq.addEventListener) mobileLayoutMq.addEventListener('change', syncMobileThumbPlacement);
    else if (mobileLayoutMq.addListener) mobileLayoutMq.addListener(syncMobileThumbPlacement);

    renderMain(currentIndex);
  }

  function initMobileStickyCta() {
    var sticky = document.querySelector('[data-mobile-sticky-cta]');
    if (!sticky) return;
    document.body.classList.add('has-mobile-sticky-cta');
  }

  function initScrollTo() {
    var triggers = document.querySelectorAll('[data-scroll-to]');
    if (!triggers.length) return;

    triggers.forEach(function (trigger) {
      trigger.addEventListener('click', function () {
        var selector = trigger.getAttribute('data-scroll-target');
        if (!selector) return;
        var target = document.querySelector(selector);
        if (!target) return;
        target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });
    });
  }

  function initGlobalMobileBuyCta() {
    var body = document.body;
    if (body && body.getAttribute('data-b2b-layout') === 'true') return;
    var cta = document.querySelector('[data-mobile-float-buy]');
    if (!cta) return;
    var buyShortNeedle = normalizeCtaText(i18n('shared.buy_short', 'Koop nu'));

    var media = window.matchMedia('(max-width: 840px)');
    var pathname = (window.location.pathname || '').replace(/\/+$/, '');
    var isHomePage = pathname === '';
    var requiresHomeUnlock = isHomePage;
    var firstMainBuyCta = null;
    var homeUnlocked = !requiresHomeUnlock;
    var lastY = window.scrollY || 0;
    var travel = 0;
    var hidden = false;
    var lastToggleAt = 0;
    var ticking = false;
    var idleTimer = null;
    var competingSelectors = [
      '[data-mobile-sticky-cta]',
      '.nb-mobile-quick-cta'
    ];

    function getFirstMainBuyCta() {
      var candidates = document.querySelectorAll('#MainContent a, #MainContent button');
      for (var i = 0; i < candidates.length; i += 1) {
        var node = candidates[i];
        if (!node || node === cta || cta.contains(node)) continue;
        var text = (node.textContent || '').trim().toLowerCase();
        if (buyShortNeedle && text.indexOf(buyShortNeedle) !== -1) return node;
      }
      return null;
    }

    function hasReachedFirstHomeBuyCta() {
      if (!firstMainBuyCta || !firstMainBuyCta.getBoundingClientRect) return true;
      var rect = firstMainBuyCta.getBoundingClientRect();
      return rect.top <= window.innerHeight;
    }

    function isElementInViewport(element) {
      if (!element || !element.getBoundingClientRect) return false;
      var rect = element.getBoundingClientRect();
      if (rect.width <= 0 || rect.height <= 0) return false;
      var styles = window.getComputedStyle(element);
      if (styles.display === 'none' || styles.visibility === 'hidden' || Number(styles.opacity) === 0) return false;
      return rect.bottom > 0 && rect.top < window.innerHeight;
    }

    function hasCompetingCtaInViewport() {
      for (var i = 0; i < competingSelectors.length; i += 1) {
        var nodes = document.querySelectorAll(competingSelectors[i]);
        for (var j = 0; j < nodes.length; j += 1) {
          if (isElementInViewport(nodes[j])) return true;
        }
      }

      var ctaCandidates = document.querySelectorAll('a, button');
      for (var k = 0; k < ctaCandidates.length; k += 1) {
        var node = ctaCandidates[k];
        if (node === cta || cta.contains(node)) continue;
        var text = (node.textContent || '').trim().toLowerCase();
        if (!text) continue;
        if (!buyShortNeedle || text.indexOf(buyShortNeedle) === -1) continue;
        if (isElementInViewport(node)) return true;
      }
      return false;
    }

    function setHidden(nextHidden, force) {
      if (nextHidden === hidden && !force) return;
      var now = Date.now();
      if (!force && now - lastToggleAt < 120) return;
      hidden = nextHidden;
      lastToggleAt = now;
      cta.classList.toggle('is-hidden', hidden);
    }

    function updateVisibility() {
      ticking = false;
      if (!media.matches) {
        setHidden(false, true);
        return;
      }

      if (requiresHomeUnlock && !homeUnlocked) {
        homeUnlocked = hasReachedFirstHomeBuyCta();
        if (!homeUnlocked) {
          setHidden(true, true);
          return;
        }
      }

      var currentY = window.scrollY || 0;
      var delta = currentY - lastY;
      var absDelta = Math.abs(delta);
      var scrollingDown = delta > 0;
      var nearTop = currentY < 90;
      var competingVisible = hasCompetingCtaInViewport();

      if (absDelta > 1) {
        if ((travel > 0 && !scrollingDown) || (travel < 0 && scrollingDown)) {
          travel = 0;
        }
        travel += delta;
      }

      if (competingVisible) {
        setHidden(true, false);
      } else if (nearTop || travel < -18) {
        setHidden(false, false);
      } else if (travel > 24 && currentY > 120) {
        setHidden(true, false);
      }

      lastY = currentY;
    }

    function scheduleIdleReveal() {
      if (idleTimer) window.clearTimeout(idleTimer);
      idleTimer = window.setTimeout(function () {
        if (!media.matches) return;
        if (requiresHomeUnlock && !homeUnlocked) return;
        if (hasCompetingCtaInViewport()) return;
        travel = Math.min(travel, 0);
        setHidden(false, false);
      }, 500);
    }

    function onScroll() {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(updateVisibility);
      scheduleIdleReveal();
    }

    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll);
    firstMainBuyCta = getFirstMainBuyCta();
    if (requiresHomeUnlock && firstMainBuyCta == null) {
      homeUnlocked = true;
    }
    updateVisibility();
    scheduleIdleReveal();
  }

  function initProductDescriptionToggle() {
    var wrappers = document.querySelectorAll('[data-product-description]');
    if (!wrappers.length) return;
    var desktopMq = window.matchMedia('(min-width: 841px)');

    wrappers.forEach(function (wrap) {
      var content = wrap.querySelector('[data-product-description-content]');
      var toggle = wrap.querySelector('[data-product-description-toggle]');
      if (!content || !toggle) return;
      var section = wrap.closest('.nb-product');
      var panel = section ? section.querySelector('.nb-product__panel') : null;
      var galleryPin = section ? section.querySelector('.nb-product__gallery-pin') : null;
      var collapsedMaxHeight = 0;
      var desktopExpandedByUser = false;
      var syncRaf = 0;

      function setToggleLabel(isExpanded) {
        toggle.setAttribute('aria-expanded', String(isExpanded));
        toggle.textContent = isExpanded
          ? toggle.getAttribute('data-label-close') || 'Minder tonen'
          : toggle.getAttribute('data-label-open') || 'Lees meer';
      }

      function clearDesktopClamp() {
        collapsedMaxHeight = 0;
        desktopExpandedByUser = false;
        wrap.classList.remove('is-desktop-collapsible');
        content.style.maxHeight = '';
      }

      function applyDesktopClamp() {
        if (!desktopMq.matches || !panel || !galleryPin) {
          clearDesktopClamp();
          setToggleLabel(wrap.classList.contains('is-expanded'));
          updateToggleVisibility();
          return;
        }

        var wasExpanded = desktopExpandedByUser;
        wrap.classList.add('is-expanded');
        wrap.classList.remove('is-desktop-collapsible');
        content.style.maxHeight = '';

        var galleryHeight = Math.ceil(galleryPin.getBoundingClientRect().height);
        var panelHeight = Math.ceil(panel.getBoundingClientRect().height);
        var overflow = panelHeight - galleryHeight;
        var contentFullHeight = Math.ceil(content.scrollHeight);
        var shouldClamp = overflow > 6 && contentFullHeight > 0;

        if (!shouldClamp) {
          clearDesktopClamp();
          wrap.classList.remove('is-expanded');
          setToggleLabel(false);
          updateToggleVisibility();
          return;
        }

        collapsedMaxHeight = Math.max(0, contentFullHeight - overflow - 2);
        if (collapsedMaxHeight >= contentFullHeight - 6) {
          clearDesktopClamp();
          wrap.classList.remove('is-expanded');
          setToggleLabel(false);
          updateToggleVisibility();
          return;
        }

        wrap.classList.add('is-desktop-collapsible');
        content.style.maxHeight = collapsedMaxHeight + 'px';

        if (wasExpanded) {
          wrap.classList.add('is-expanded');
        } else {
          wrap.classList.remove('is-expanded');
        }

        setToggleLabel(wrap.classList.contains('is-expanded'));
        updateToggleVisibility();
      }

      function scheduleDesktopClampSync() {
        if (syncRaf) return;
        syncRaf = window.requestAnimationFrame(function () {
          syncRaf = 0;
          applyDesktopClamp();
        });
      }

      function updateToggleVisibility() {
        var overflows = content.scrollHeight > content.clientHeight + 6;
        if (desktopMq.matches && wrap.classList.contains('is-desktop-collapsible')) {
          overflows = true;
        }
        toggle.hidden = !overflows && !wrap.classList.contains('is-expanded');
      }

      toggle.addEventListener('click', function () {
        var isExpanded = wrap.classList.toggle('is-expanded');
        if (desktopMq.matches && wrap.classList.contains('is-desktop-collapsible')) {
          desktopExpandedByUser = isExpanded;
        }
        setToggleLabel(isExpanded);
        window.requestAnimationFrame(updateToggleVisibility);
      });

      window.requestAnimationFrame(function () {
        scheduleDesktopClampSync();
        updateToggleVisibility();
      });
      window.setTimeout(scheduleDesktopClampSync, 180);
      window.setTimeout(scheduleDesktopClampSync, 520);

      window.addEventListener('resize', scheduleDesktopClampSync);
      if (desktopMq.addEventListener) desktopMq.addEventListener('change', scheduleDesktopClampSync);
      else if (desktopMq.addListener) desktopMq.addListener(scheduleDesktopClampSync);

      if ('ResizeObserver' in window) {
        var resizeObserver = new ResizeObserver(scheduleDesktopClampSync);
        resizeObserver.observe(content);
        if (panel) resizeObserver.observe(panel);
        if (galleryPin) resizeObserver.observe(galleryPin);
      }
    });
  }

  function initMobileProductDetailsToggle() {
    var productSections = document.querySelectorAll('.nb-product');
    if (!productSections.length) return;

    var mobileMq = window.matchMedia('(max-width: 980px)');

    productSections.forEach(function (section) {
      var detailsGroups = section.querySelectorAll('[data-mobile-product-details]');
      var toggles = section.querySelectorAll('[data-mobile-product-details-toggle]');
      if (!detailsGroups.length || !toggles.length) return;

      function setCollapsed(collapsed) {
        detailsGroups.forEach(function (group, index) {
          if (!group) return;
          if (mobileMq.matches && collapsed && index > 0) {
            group.classList.add('is-collapsed');
          } else {
            group.classList.remove('is-collapsed');
          }
        });

        toggles.forEach(function (toggle) {
          if (!toggle) return;
          if (!mobileMq.matches) {
            toggle.hidden = true;
            toggle.setAttribute('aria-expanded', 'true');
            toggle.textContent = toggle.getAttribute('data-label-close') || 'Minder tonen';
            return;
          }
          toggle.hidden = false;
          toggle.setAttribute('aria-expanded', collapsed ? 'false' : 'true');
          toggle.textContent = collapsed
            ? (toggle.getAttribute('data-label-open') || 'Meer lezen')
            : (toggle.getAttribute('data-label-close') || 'Minder tonen');
        });
      }

      toggles.forEach(function (toggle) {
        toggle.addEventListener('click', function () {
          var expanded = toggle.getAttribute('aria-expanded') === 'true';
          setCollapsed(expanded);
        });
      });

      setCollapsed(true);
      if (mobileMq.addEventListener) mobileMq.addEventListener('change', function () { setCollapsed(true); });
      else if (mobileMq.addListener) mobileMq.addListener(function () { setCollapsed(true); });
    });
  }

  function initFounderStoryMedia() {
    var sections = document.querySelectorAll('.nb-founder-story');
    if (!sections.length) return;

    var desktopMq = window.matchMedia('(min-width: 1061px)');

    sections.forEach(function (section) {
      var copy = section.querySelector('.nb-founder-story__copy');
      var media = section.querySelector('.nb-founder-story__media');
      var videoShell = section.querySelector('.nb-founder-story__video-shell');
      var mediaNode = section.querySelector('[data-founder-video], .nb-founder-story__video');
      var video = mediaNode && mediaNode.tagName && mediaNode.tagName.toLowerCase() === 'video' ? mediaNode : null;
      if (!copy || !media) return;

      var shouldPlay = false;
      var pausingProgrammatically = false;

      function syncDesktopHeights() {
        if (!desktopMq.matches) {
          media.style.height = '';
          if (videoShell) videoShell.style.height = '';
          return;
        }
        var copyHeight = Math.ceil(copy.getBoundingClientRect().height);
        if (copyHeight > 0) {
          media.style.height = copyHeight + 'px';
          if (videoShell) videoShell.style.height = '100%';
        }
      }

      function enforceVideoPolicy() {
        if (!video) return;
        video.muted = true;
        video.defaultMuted = true;
        video.autoplay = true;
        video.loop = true;
        video.playsInline = true;
        video.controls = false;
        video.setAttribute('muted', '');
        video.setAttribute('autoplay', '');
        video.setAttribute('loop', '');
        video.setAttribute('playsinline', '');
        video.setAttribute('webkit-playsinline', 'true');
        video.setAttribute('tabindex', '-1');
        video.setAttribute('aria-hidden', 'true');
        video.setAttribute('disablepictureinpicture', '');
        video.removeAttribute('controls');
        video.style.pointerEvents = 'none';
      }

      function hydrateFounderVideoSource() {
        if (!video || video.dataset.nbSourceHydrated === 'true') return;
        var source = video.querySelector('source[data-src]');
        if (!source) {
          video.dataset.nbSourceHydrated = 'true';
          return;
        }
        var src = source.getAttribute('data-src') || '';
        if (!src) return;
        if (!source.getAttribute('src')) {
          source.setAttribute('src', src);
          if (typeof video.load === 'function') video.load();
        }
        video.dataset.nbSourceHydrated = 'true';
      }

      function playVideo() {
        if (!video) return;
        hydrateFounderVideoSource();
        enforceVideoPolicy();
        var p = video.play();
        if (p && typeof p.catch === 'function') p.catch(function () {});
      }

      function pauseVideo() {
        if (!video) return;
        pausingProgrammatically = true;
        video.pause();
        window.setTimeout(function () {
          pausingProgrammatically = false;
        }, 0);
      }

      if (video) {
        if ('IntersectionObserver' in window) {
          var observer = new IntersectionObserver(
            function (entries) {
              entries.forEach(function (entry) {
                shouldPlay = entry.isIntersecting && entry.intersectionRatio >= 0.45;
                if (shouldPlay) playVideo();
                else pauseVideo();
              });
            },
            { threshold: [0, 0.25, 0.45, 0.7] }
          );
          observer.observe(section);
        } else {
          shouldPlay = true;
          playVideo();
        }

        video.addEventListener('pause', function () {
          if (pausingProgrammatically) return;
          if (shouldPlay) playVideo();
        });

        video.addEventListener('loadedmetadata', function () {
          enforceVideoPolicy();
          syncDesktopHeights();
        });

        document.addEventListener('visibilitychange', function () {
          if (document.hidden) {
            pauseVideo();
            return;
          }
          if (shouldPlay) playVideo();
        });

        enforceVideoPolicy();
        if (!('IntersectionObserver' in window)) {
          shouldPlay = true;
          playVideo();
        }
      }

      if (window.ResizeObserver) {
        var ro = new ResizeObserver(function () {
          syncDesktopHeights();
        });
        ro.observe(copy);
      }

      syncDesktopHeights();
      window.addEventListener('resize', syncDesktopHeights, { passive: true });
      if (desktopMq.addEventListener) desktopMq.addEventListener('change', syncDesktopHeights);
      else if (desktopMq.addListener) desktopMq.addListener(syncDesktopHeights);
    });
  }

  var mobileVideoViewportController = null;

  function createMobileVideoViewportController() {
    var observedVideos = [];
    var mobileMq = window.matchMedia('(max-width: 1120px), (pointer: coarse)');
    var observer = null;
    var syncRaf = 0;
    var manualSyncBound = false;
    var activationBound = false;
    var iosAutoPlayBoost = /iP(hone|ad|od)/.test(navigator.userAgent || '') ||
      (/Mac/.test(navigator.platform || '') && navigator.maxTouchPoints > 1);

    function isMobileMode() {
      return !!mobileMq.matches;
    }

    function getState(video) {
      if (!video.__nbMobileViewportState) {
        video.__nbMobileViewportState = {
          visible: false,
          retryTimer: 0,
          retryCount: 0
        };
      }
      return video.__nbMobileViewportState;
    }

    function shouldKeepAudio(video) {
      return !!(video && video.dataset && video.dataset.nbUserUnmuted === 'true');
    }

    function isFirstWithin(container, node, selector) {
      if (!container || !node) return false;
      var first = container.querySelector(selector);
      return first === node;
    }

    function isContextAutoplayAllowed(video) {
      if (!video || !video.isConnected) return false;

      var guideStep = video.closest('.nb-guide-pro__step, .nb-home-guide-steps__card, .nb-purpose-primer__step-card');
      if (guideStep) {
        if (guideStep.classList.contains('is-active')) return true;
        var guideRail = guideStep.parentElement;
        return isFirstWithin(guideRail, guideStep, '.nb-guide-pro__step, .nb-home-guide-steps__card, .nb-purpose-primer__step-card');
      }

      var videoCard = video.closest('.nb-video-card');
      if (videoCard) {
        if (videoCard.classList.contains('is-active')) return true;
        var videoGrid = videoCard.parentElement;
        var activeVideoCard = videoGrid ? videoGrid.querySelector('.nb-video-card.is-active') : null;
        if (activeVideoCard) return activeVideoCard === videoCard;
        return isFirstWithin(videoGrid, videoCard, '.nb-video-card');
      }

      return true;
    }

    function applyAutoplayPolicy(video) {
      if (!video) return;
      video.playsInline = true;
      video.autoplay = true;
      video.defaultMuted = true;
      video.setAttribute('playsinline', '');
      video.setAttribute('webkit-playsinline', 'true');
      video.setAttribute('autoplay', '');
      if (video.preload === 'none') video.preload = 'metadata';
      if (!shouldKeepAudio(video)) {
        video.muted = true;
        video.setAttribute('muted', '');
      }
    }

    function hydrateVideoSource(video) {
      if (!video || video.dataset.nbSourceHydrated === 'true') return;
      var source = video.querySelector('source[data-src]');
      if (!source) {
        video.dataset.nbSourceHydrated = 'true';
        return;
      }
      var src = source.getAttribute('data-src') || '';
      if (!src) return;
      if (!source.getAttribute('src')) {
        source.setAttribute('src', src);
        if (typeof video.load === 'function') video.load();
      }
      video.dataset.nbSourceHydrated = 'true';
    }

    function clearRetry(video) {
      var state = getState(video);
      if (!state.retryTimer) return;
      window.clearTimeout(state.retryTimer);
      state.retryTimer = 0;
    }

    function canAttemptPlay(video) {
      if (!video) return false;
      var state = getState(video);
      return state.visible && isMobileMode() && !document.hidden;
    }

    function scheduleRetry(video) {
      var state = getState(video);
      clearRetry(video);
      if (!canAttemptPlay(video)) return;
      var maxRetries = iosAutoPlayBoost ? 36 : 16;
      if (state.retryCount >= maxRetries) return;
      state.retryCount += 1;
      var baseDelay = iosAutoPlayBoost ? 70 : 100;
      var delayStep = iosAutoPlayBoost ? 90 : 120;
      var delayCap = iosAutoPlayBoost ? 1800 : 1500;
      var delay = Math.min(delayCap, baseDelay + state.retryCount * delayStep);
      state.retryTimer = window.setTimeout(function () {
        state.retryTimer = 0;
        if (!canAttemptPlay(video)) return;
        playVideo(video);
      }, delay);
    }

    function playVideo(video) {
      if (!canAttemptPlay(video)) return;
      applyAutoplayPolicy(video);
      hydrateVideoSource(video);
      var state = getState(video);
      var readyState = Number(video.readyState || 0);
      if (readyState < 2) {
        video.addEventListener('loadeddata', function onLoaded() {
          if (canAttemptPlay(video)) playVideo(video);
        }, { once: true });
        video.addEventListener('canplay', function onCanPlay() {
          if (canAttemptPlay(video)) playVideo(video);
        }, { once: true });
      }
      var playPromise = null;
      try {
        playPromise = video.play();
      } catch (_err) {
        scheduleRetry(video);
        return;
      }
      if (playPromise && typeof playPromise.catch === 'function') {
        playPromise
          .then(function () {
            clearRetry(video);
            state.retryCount = 0;
          })
          .catch(function () {
            scheduleRetry(video);
          });
      } else {
        clearRetry(video);
        state.retryCount = 0;
      }
    }

    function pauseVideo(video) {
      if (!video) return;
      clearRetry(video);
      if (!video.paused) video.pause();
    }

    function setVideoVisibility(video, ratio, intersecting) {
      if (!video) return;
      var state = getState(video);
      if (!isMobileMode()) {
        return;
      }
      var startThreshold = iosAutoPlayBoost ? 0.24 : 0.55;
      var keepThreshold = iosAutoPlayBoost ? 0.08 : 0.18;
      var nextVisible = state.visible
        ? (intersecting && ratio >= keepThreshold)
        : (intersecting && ratio >= startThreshold);
      if (nextVisible === state.visible) {
        if (nextVisible && video.paused) playVideo(video);
        return;
      }
      state.visible = nextVisible;
      if (nextVisible) playVideo(video);
      else pauseVideo(video);
    }

    function getViewportRatio(node) {
      if (!node || !node.getBoundingClientRect) return 0;
      var rect = node.getBoundingClientRect();
      var viewportWidth = window.innerWidth || document.documentElement.clientWidth || 0;
      var viewportHeight = window.innerHeight || document.documentElement.clientHeight || 0;
      var visibleWidth = Math.max(0, Math.min(rect.right, viewportWidth) - Math.max(rect.left, 0));
      var visibleHeight = Math.max(0, Math.min(rect.bottom, viewportHeight) - Math.max(rect.top, 0));
      var visibleArea = visibleWidth * visibleHeight;
      var totalArea = Math.max(1, rect.width * rect.height);
      return visibleArea / totalArea;
    }

    function syncAllVideos() {
      syncRaf = 0;
      observedVideos = observedVideos.filter(function (video) {
        if (!video) return false;
        if (!video.isConnected) {
          if (observer) observer.unobserve(video);
          return false;
        }
        return true;
      });
      observedVideos.forEach(function (video) {
        var ratio = getViewportRatio(video);
        setVideoVisibility(video, ratio, ratio > 0.01);
      });
    }

    function requestSync() {
      if (syncRaf) return;
      syncRaf = window.requestAnimationFrame(syncAllVideos);
    }

    function bindManualSync() {
      if (manualSyncBound) return;
      manualSyncBound = true;
      window.addEventListener('scroll', requestSync, { passive: true });
      window.addEventListener('resize', requestSync, { passive: true });
      window.addEventListener('orientationchange', requestSync, { passive: true });
      window.addEventListener('pageshow', requestSync);
    }

    function bindActivationFallback() {
      if (activationBound) return;
      activationBound = true;
      var forceSync = function () {
        requestSync();
      };
      document.addEventListener('touchstart', forceSync, { once: true, passive: true });
      document.addEventListener('click', forceSync, { once: true, passive: true });
    }

    if ('IntersectionObserver' in window) {
      observer = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            setVideoVisibility(entry.target, entry.intersectionRatio || 0, !!entry.isIntersecting);
          });
        },
        { threshold: [0, 0.08, 0.18, 0.35, 0.55, 0.75] }
      );
    } else {
      bindManualSync();
    }

    document.addEventListener('visibilitychange', function () {
      if (!isMobileMode()) return;
      if (document.hidden) {
        observedVideos.forEach(function (video) {
          var state = getState(video);
          state.visible = false;
          pauseVideo(video);
        });
        return;
      }
      requestSync();
    });

    if (mobileMq.addEventListener) {
      mobileMq.addEventListener('change', requestSync);
    } else if (mobileMq.addListener) {
      mobileMq.addListener(requestSync);
    }

    return {
      register: function (videos) {
        if (!videos || !videos.length) return;
        videos.forEach(function (video) {
          if (!video || video.__nbMobileViewportManaged) return;
          if (video.hasAttribute('data-nb-mobile-video-ignore')) return;
          if (
            video.hasAttribute('data-nb-home-guide-video') ||
            video.hasAttribute('data-nb-primer-video') ||
            video.hasAttribute('data-nb-guide-video') ||
            video.hasAttribute('data-nb-proof-video') ||
            video.hasAttribute('data-founder-video') ||
            video.hasAttribute('data-nb-guide-showcase-home-video')
          ) {
            return;
          }
          video.__nbMobileViewportManaged = true;
          observedVideos.push(video);
          if (observer) observer.observe(video);
        });
        bindActivationFallback();
        if (!observer) bindManualSync();
      },
      sync: requestSync
    };
  }

  function initMobileVideoViewportAutoplay(rootNode) {
    var scope = rootNode && rootNode.querySelectorAll ? rootNode : document;
    var videos = Array.prototype.slice.call(scope.querySelectorAll('video'));
    if (!videos.length) return;
    if (!mobileVideoViewportController) {
      mobileVideoViewportController = createMobileVideoViewportController();
    }
    mobileVideoViewportController.register(videos);
    mobileVideoViewportController.sync();
  }

  function initHomeGuideStepsRuntimePatch(rootNode) {
    var ENGINE_VERSION = '2026-04-24-guide-autoplay-force-v3';
    var compactMq = window.matchMedia('(max-width: 1120px)');
    var scope = rootNode && rootNode.querySelectorAll ? rootNode : document;
    var sections = Array.prototype.slice.call(
      scope.querySelectorAll('[id^="nb-home-guide-steps-"].nb-guide-pro--home-steps')
    );
    if (
      rootNode &&
      rootNode.matches &&
      rootNode.matches('[id^="nb-home-guide-steps-"].nb-guide-pro--home-steps')
    ) {
      sections.unshift(rootNode);
    }
    if (!sections.length) return;

    sections.forEach(function (initialRoot) {
      var sectionRoot = initialRoot;
      if (!sectionRoot) return;
      if (sectionRoot.getAttribute('data-nb-guide-variant') === 'practices') return;
      if (sectionRoot.getAttribute('data-nb-runtime-steps-patched') === 'true') return;

      // Detach all legacy inline listeners by replacing the section subtree once.
      if (sectionRoot.getAttribute('data-nb-runtime-steps-cloned') !== 'true') {
        if (!sectionRoot.parentNode) return;
        var replacement = sectionRoot.cloneNode(true);
        sectionRoot.parentNode.replaceChild(replacement, sectionRoot);
        sectionRoot = replacement;
        sectionRoot.setAttribute('data-nb-runtime-steps-cloned', 'true');
      }

      var stepsWrap = sectionRoot.querySelector('[data-nb-home-guide-steps-wrap]');
      var stepsRail = sectionRoot.querySelector('[data-nb-home-guide-steps]');
      var stepsIndicator = sectionRoot.querySelector('[data-nb-home-guide-steps-indicator]');
      if (!stepsWrap || !stepsRail) return;

      var cards = Array.prototype.slice.call(stepsRail.querySelectorAll('.nb-guide-pro__step'));
      if (!cards.length) return;

      var videoCards = cards.filter(function (card) {
        return !!card.querySelector('[data-nb-home-guide-video]');
      });
      var videos = videoCards.map(function (card) {
        return card.querySelector('[data-nb-home-guide-video]');
      });
      if (!videos.length) return;

      sectionRoot.setAttribute('data-nb-runtime-steps-patched', 'true');
      sectionRoot.setAttribute('data-nb-steps-engine', ENGINE_VERSION);

      var activeIndex = 0;
      var sectionVisible = false;
      var progressRaf = 0;
      var scrollSyncRaf = 0;
      var refreshRaf = 0;
      var gestureKickTs = 0;
      var autoplayKickTimer = 0;

      function clamp01(value) {
        return Math.max(0, Math.min(1, Number(value || 0)));
      }

      function setVideoReadyState(video, isReady) {
        if (!video) return;
        var mediaShell = video.closest ? video.closest('.nb-guide-pro__step-media') : null;
        if (!mediaShell) return;
        mediaShell.classList.toggle('is-video-ready', !!isReady);
      }

      function setVideoPlayingState(video, isPlaying) {
        if (!video) return;
        var mediaShell = video.closest ? video.closest('.nb-guide-pro__step-media') : null;
        if (!mediaShell) return;
        mediaShell.classList.toggle('is-video-playing', !!isPlaying);
      }

      function setCardProgress(card, ratio) {
        if (!card) return;
        card.style.setProperty('--nb-guide-progress', String(clamp01(ratio)));
      }

      function resolvePlaybackRate(video, fallbackIndex) {
        if (!video) return 1;
        var attrValue = Number.parseFloat(video.getAttribute('data-nb-step-playback-rate') || '');
        if (Number.isFinite(attrValue) && attrValue > 0) return attrValue;

        var card = video.closest ? video.closest('.nb-guide-pro__step') : null;
        var stepIndex = Number.parseInt(card ? card.getAttribute('data-nb-step-index') : '', 10);
        if (!Number.isFinite(stepIndex) || stepIndex < 1) stepIndex = Number(fallbackIndex || 0) + 1;
        return stepIndex === 3 ? 1.5 : 1;
      }

      function applyPlaybackRate(video, fallbackIndex) {
        if (!video) return 1;
        var targetRate = resolvePlaybackRate(video, fallbackIndex);
        try {
          if (Math.abs(Number(video.defaultPlaybackRate || 1) - targetRate) > 0.001) {
            video.defaultPlaybackRate = targetRate;
          }
        } catch (_errDefaultRate) {}
        try {
          if (Math.abs(Number(video.playbackRate || 1) - targetRate) > 0.001) {
            video.playbackRate = targetRate;
          }
        } catch (_errRate) {}
        return targetRate;
      }

      function setVideoPreload(video, mode) {
        if (!video) return;
        var nextMode = mode === 'auto' ? 'auto' : mode === 'metadata' ? 'metadata' : 'none';
        if (video.preload !== nextMode) video.preload = nextMode;
        if (video.getAttribute('preload') !== nextMode) {
          video.setAttribute('preload', nextMode);
        }
      }

      function setVideoAutoplayIntent(video, shouldAutoplay) {
        if (!video) return;
        if (shouldAutoplay) {
          video.autoplay = true;
          video.setAttribute('autoplay', '');
          return;
        }
        video.autoplay = false;
        video.removeAttribute('autoplay');
      }

      function ensureVideo(video, fallbackIndex, shouldAutoplay) {
        if (!video) return;
        setVideoAutoplayIntent(video, shouldAutoplay === true);
        video.loop = false;
        video.playsInline = true;
        video.defaultMuted = true;
        video.muted = true;
        video.controls = false;
        video.removeAttribute('loop');
        video.setAttribute('playsinline', '');
        video.setAttribute('webkit-playsinline', 'true');
        video.setAttribute('muted', '');
        video.removeAttribute('controls');
        video.setAttribute('disablepictureinpicture', '');
        var preloadMode = Number(fallbackIndex) === Number(activeIndex) ? 'metadata' : 'none';
        setVideoPreload(video, preloadMode);
        applyPlaybackRate(video, fallbackIndex);
      }

      function hydrateVideo(video, forceReload, fallbackIndex, options) {
        if (!video) return;
        var settings = options || {};
        ensureVideo(video, fallbackIndex, settings.autoplay === true);
        var source = video.querySelector('source');
        var targetSrc = '';
        if (source) {
          targetSrc =
            source.getAttribute('src') ||
            source.getAttribute('data-src') ||
            video.getAttribute('data-nb-step-video-url') ||
            '';
        } else {
          targetSrc = video.getAttribute('src') || video.getAttribute('data-nb-step-video-url') || '';
        }
        if (!targetSrc) return;

        var changed = false;
        if (source) {
          if (source.getAttribute('src') !== targetSrc) {
            source.setAttribute('src', targetSrc);
            changed = true;
          }
        } else if (video.getAttribute('src') !== targetSrc) {
          video.setAttribute('src', targetSrc);
          changed = true;
        }

        if (forceReload === true || changed || video.dataset.nbSourceHydrated !== 'true') {
          setVideoReadyState(video, false);
          setVideoPlayingState(video, false);
          try {
            if (typeof video.load === 'function') video.load();
          } catch (_errLoad) {}
        }
        video.dataset.nbSourceHydrated = 'true';
        if (video.readyState >= 2) setVideoReadyState(video, true);
      }

      function playVideo(video, restart, fallbackIndex) {
        if (!video) return;
        setVideoPreload(video, 'auto');
        hydrateVideo(video, false, fallbackIndex, { autoplay: true });
        if (restart === true) {
          try {
            video.currentTime = 0;
          } catch (_errCurrentTime) {}
        }

        var tryPlay = function () {
          if (!sectionVisible || document.hidden) return;
          if (videos[activeIndex] !== video) return;
          applyPlaybackRate(video, fallbackIndex);
          var playPromise = video.play();
          if (playPromise && typeof playPromise.catch === 'function') {
            if (typeof playPromise.then === 'function') {
              playPromise.then(function () {
                if (videos[activeIndex] === video && !video.paused && !video.ended) {
                  setVideoPlayingState(video, true);
                }
              }).catch(function () {
                setVideoPlayingState(video, false);
                var retryCount = Number.parseInt(video.dataset.nbGuidePlayRetries || '0', 10);
                if (!Number.isFinite(retryCount)) retryCount = 0;
                if (retryCount < 6 && videos[activeIndex] === video && sectionVisible && !document.hidden) {
                  video.dataset.nbGuidePlayRetries = String(retryCount + 1);
                  window.setTimeout(function () {
                    if (videos[activeIndex] === video && sectionVisible && !document.hidden && video.paused) {
                      playVideo(video, false, fallbackIndex);
                    }
                  }, 180 + retryCount * 160);
                }
              });
            } else {
              playPromise.catch(function () {
                setVideoPlayingState(video, false);
              });
            }
          } else if (!video.paused && !video.ended) {
            setVideoPlayingState(video, true);
          }
        };

        if (video.readyState >= 2) {
          setVideoReadyState(video, true);
          applyPlaybackRate(video, fallbackIndex);
          tryPlay();
          return;
        }

        var onReady = function () {
          if (!sectionVisible || document.hidden) return;
          if (videos[activeIndex] !== video) return;
          setVideoReadyState(video, true);
          tryPlay();
        };
        video.addEventListener('loadeddata', onReady, { once: true });
        video.addEventListener('canplay', onReady, { once: true });
      }

      function scheduleAutoplayKick(attempt) {
        if (autoplayKickTimer) window.clearTimeout(autoplayKickTimer);
        var nextAttempt = Number(attempt || 0);
        if (nextAttempt > 10) return;
        autoplayKickTimer = window.setTimeout(function () {
          autoplayKickTimer = 0;
          if (!sectionVisible || document.hidden) return;
          var currentVideo = videos[activeIndex] || videos[0];
          if (!currentVideo) return;
          currentVideo.muted = true;
          currentVideo.defaultMuted = true;
          currentVideo.playsInline = true;
          currentVideo.setAttribute('muted', '');
          currentVideo.setAttribute('playsinline', '');
          currentVideo.setAttribute('webkit-playsinline', 'true');
          playVideo(currentVideo, false, activeIndex);
          window.setTimeout(function () {
            if (sectionVisible && !document.hidden && videos[activeIndex] === currentVideo && currentVideo.paused) {
              scheduleAutoplayKick(nextAttempt + 1);
            }
          }, 120);
        }, nextAttempt === 0 ? 0 : Math.min(900, 120 + nextAttempt * 110));
      }

      function pauseVideo(video) {
        if (!video) return;
        try {
          video.pause();
        } catch (_errPause) {}
        setVideoPlayingState(video, false);
      }

      function stopProgressLoop() {
        if (!progressRaf) return;
        cancelAnimationFrame(progressRaf);
        progressRaf = 0;
      }

      function startProgressLoop() {
        stopProgressLoop();
        var tick = function () {
          if (!sectionVisible || document.hidden) {
            stopProgressLoop();
            return;
          }
          var currentVideo = videos[activeIndex];
          var currentCard = videoCards[activeIndex];
          if (currentVideo && currentCard) {
            var duration = Number(currentVideo.duration || 0);
            var ratio = duration > 0 ? Number(currentVideo.currentTime || 0) / duration : 0;
            setCardProgress(currentCard, ratio);
          }
          progressRaf = requestAnimationFrame(tick);
        };
        progressRaf = requestAnimationFrame(tick);
      }

      function markActiveCard(cardToActivate) {
        cards.forEach(function (card) {
          var isActive = card === cardToActivate;
          card.classList.toggle('is-active', isActive);
          if (!isActive) setCardProgress(card, 0);
        });
      }

      function centerCard(card) {
        if (!compactMq.matches || !card || !stepsRail) return;
        try {
          var left = card.offsetLeft - Math.max(0, (stepsRail.clientWidth - card.clientWidth) / 2);
          stepsRail.scrollTo({ left: left, behavior: 'smooth' });
        } catch (_errScroll) {}
      }

      function getCenteredVideoIndex() {
        if (!stepsRail || !videoCards.length) return -1;
        var railCenter = stepsRail.getBoundingClientRect().left + stepsRail.clientWidth / 2;
        var bestIndex = 0;
        var bestDistance = Infinity;
        videoCards.forEach(function (card, index) {
          var rect = card.getBoundingClientRect();
          var cardCenter = rect.left + rect.width / 2;
          var distance = Math.abs(cardCenter - railCenter);
          if (distance < bestDistance) {
            bestDistance = distance;
            bestIndex = index;
          }
        });
        return bestIndex;
      }

      function isNodeVisibleInViewport(node) {
        if (!node) return false;
        var rect = node.getBoundingClientRect();
        if (rect.width <= 0 || rect.height <= 0) return false;
        var vw = window.innerWidth || document.documentElement.clientWidth || 0;
        var vh = window.innerHeight || document.documentElement.clientHeight || 0;
        var visibleWidth = Math.max(0, Math.min(rect.right, vw) - Math.max(rect.left, 0));
        var visibleHeight = Math.max(0, Math.min(rect.bottom, vh) - Math.max(rect.top, 0));
        var visibleRatio = (visibleWidth * visibleHeight) / Math.max(1, rect.width * rect.height);
        return visibleRatio > 0.08;
      }

      function ensureRailDots() {
        if (!stepsIndicator) return;
        if (stepsIndicator.children.length === videoCards.length) return;
        stepsIndicator.innerHTML = '';
        for (var i = 0; i < videoCards.length; i += 1) {
          var dot = document.createElement('span');
          dot.className = 'nb-guide-pro__rail-dot';
          stepsIndicator.appendChild(dot);
        }
      }

      function updateRailState() {
        var maxLeft = Math.max(0, stepsRail.scrollWidth - stepsRail.clientWidth);
        var isScrollable = compactMq.matches && maxLeft > 8;
        stepsWrap.classList.toggle('is-scrollable', isScrollable);
        stepsWrap.classList.toggle('is-at-start', !isScrollable || stepsRail.scrollLeft <= 8);
        stepsWrap.classList.toggle('is-at-end', !isScrollable || stepsRail.scrollLeft >= maxLeft - 8);

        ensureRailDots();
        if (!stepsIndicator) return;
        stepsIndicator.style.display = isScrollable ? '' : 'none';
        if (!isScrollable) return;

        var dotIndex = compactMq.matches ? getCenteredVideoIndex() : activeIndex;
        if (dotIndex < 0) dotIndex = activeIndex;
        Array.prototype.forEach.call(stepsIndicator.children, function (dot, index) {
          dot.classList.toggle('is-active', index === dotIndex);
        });
      }

      function syncPlayback(options) {
        var settings = options || {};
        if (!sectionVisible || document.hidden) {
          videos.forEach(function (video) {
            setVideoPreload(video, 'none');
            pauseVideo(video);
          });
          stopProgressLoop();
          updateRailState();
          return;
        }

        var activeCard = videoCards[activeIndex];
        var activeVideo = videos[activeIndex];
        if (!activeCard || !activeVideo) {
          updateRailState();
          return;
        }

        markActiveCard(activeCard);

        videos.forEach(function (video, index) {
          if (index === activeIndex) {
            setVideoPreload(video, 'metadata');
            setVideoAutoplayIntent(video, true);
            playVideo(video, settings.restart === true, index);
          } else {
            setVideoPreload(video, 'none');
            setVideoAutoplayIntent(video, false);
            pauseVideo(video);
            if (settings.resetOthers === true) {
              try {
                video.currentTime = 0;
              } catch (_errReset) {}
            }
            setCardProgress(videoCards[index], 0);
          }
        });

        var nextIndex = (activeIndex + 1) % videos.length;
        var nextVideo = videos[nextIndex];
        if (nextVideo && nextIndex !== activeIndex) {
          setVideoPreload(nextVideo, 'metadata');
          setVideoAutoplayIntent(nextVideo, false);
          hydrateVideo(nextVideo, false, nextIndex, { autoplay: false });
          pauseVideo(nextVideo);
        }

        startProgressLoop();
        updateRailState();
        scheduleAutoplayKick(0);
      }

      function goTo(index, options) {
        var settings = options || {};
        activeIndex = (index + videos.length) % videos.length;
        syncPlayback({ restart: settings.restart === true, resetOthers: true });
        if (settings.center === true) centerCard(videoCards[activeIndex]);
      }

      function syncFromScroll() {
        scrollSyncRaf = 0;
        if (!compactMq.matches || !sectionVisible || document.hidden) return;
        var centered = getCenteredVideoIndex();
        if (centered < 0 || centered === activeIndex) return;
        activeIndex = centered;
        syncPlayback({ restart: true, resetOthers: true });
      }

      function refreshViewportState() {
        if (refreshRaf) cancelAnimationFrame(refreshRaf);
        refreshRaf = requestAnimationFrame(function () {
          refreshRaf = 0;
          sectionVisible = isNodeVisibleInViewport(stepsRail);
          syncPlayback();
        });
      }

      function kickPlaybackFromGesture() {
        var now = Date.now();
        if (now - gestureKickTs < 140) return;
        gestureKickTs = now;
        if (!sectionVisible || document.hidden) return;
        var current = videos[activeIndex] || videos[0];
        if (!current || !current.paused) return;
        playVideo(current, false, activeIndex);
      }

      videos.forEach(function (video, index) {
        ensureVideo(video, index);
        var shouldPrime = index === activeIndex || index === ((activeIndex + 1) % videos.length);
        if (shouldPrime) hydrateVideo(video, false, index);

        video.addEventListener('loadedmetadata', function () {
          applyPlaybackRate(video, index);
          if (index !== activeIndex) return;
          setCardProgress(videoCards[index], 0);
        });

        video.addEventListener('loadeddata', function () {
          setVideoReadyState(video, true);
          if (index === activeIndex && sectionVisible && !document.hidden && video.paused) {
            playVideo(video, false, index);
          }
        });

        video.addEventListener('canplay', function () {
          setVideoReadyState(video, true);
          if (index === activeIndex && sectionVisible && !document.hidden && video.paused) {
            playVideo(video, false, index);
          }
        });

        video.addEventListener('playing', function () {
          setVideoReadyState(video, true);
          setVideoPlayingState(video, true);
          video.dataset.nbGuidePlayRetries = '0';
        });

        video.addEventListener('pause', function () {
          setVideoPlayingState(video, false);
        });

        video.addEventListener('timeupdate', function () {
          if (index !== activeIndex) return;
          var duration = Number(video.duration || 0);
          var ratio = duration > 0 ? Number(video.currentTime || 0) / duration : 0;
          setCardProgress(videoCards[index], ratio);
        });

        video.addEventListener('ended', function () {
          setVideoPlayingState(video, false);
          if (index !== activeIndex) return;
          setCardProgress(videoCards[index], 1);
          goTo(activeIndex + 1, { restart: true, center: compactMq.matches });
        });

        video.addEventListener('waiting', function () {
          setVideoPlayingState(video, false);
          if (index !== activeIndex || !sectionVisible || document.hidden) return;
          playVideo(video, false, index);
        });

        video.addEventListener('stalled', function () {
          setVideoPlayingState(video, false);
          if (index !== activeIndex || !sectionVisible || document.hidden) return;
          playVideo(video, false, index);
        });

        video.addEventListener('error', function () {
          setVideoReadyState(video, false);
          setVideoPlayingState(video, false);
          if (video.dataset.nbRetryAttempted === 'true') return;
          video.dataset.nbRetryAttempted = 'true';
          hydrateVideo(video, true, index);
          if (index === activeIndex) playVideo(video, true, index);
        });
      });

      videoCards.forEach(function (card, index) {
        card.addEventListener('click', function () {
          goTo(index, { restart: true, center: compactMq.matches });
        });
      });

      if ('IntersectionObserver' in window) {
        var observer = new IntersectionObserver(
          function (entries) {
            var entry = entries[0];
            sectionVisible = !!(entry && entry.isIntersecting && entry.intersectionRatio > 0.08);
            syncPlayback();
            if (sectionVisible) scheduleAutoplayKick(0);
          },
          { threshold: [0, 0.08, 0.2, 0.45], rootMargin: '160px 0px -10% 0px' }
        );
        observer.observe(stepsRail);
      } else {
        sectionVisible = isNodeVisibleInViewport(stepsRail);
      }

      document.addEventListener('visibilitychange', function () {
        if (!document.hidden) {
          sectionVisible = isNodeVisibleInViewport(stepsRail);
        }
        syncPlayback();
      });

      var onCompactChange = function () {
        if (compactMq.matches) {
          var centered = getCenteredVideoIndex();
          if (centered >= 0) activeIndex = centered;
        }
        syncPlayback();
      };
      if (compactMq.addEventListener) compactMq.addEventListener('change', onCompactChange);
      else if (compactMq.addListener) compactMq.addListener(onCompactChange);

      window.addEventListener('pageshow', function () {
        sectionVisible = isNodeVisibleInViewport(stepsRail);
        syncPlayback();
        if (sectionVisible) scheduleAutoplayKick(0);
      });

      stepsRail.addEventListener(
        'scroll',
        function () {
          updateRailState();
          if (scrollSyncRaf) cancelAnimationFrame(scrollSyncRaf);
          scrollSyncRaf = requestAnimationFrame(syncFromScroll);
        },
        { passive: true }
      );

      document.addEventListener('touchstart', kickPlaybackFromGesture, { passive: true });
      document.addEventListener('touchmove', kickPlaybackFromGesture, { passive: true });
      document.addEventListener('click', kickPlaybackFromGesture, { passive: true });
      window.addEventListener('resize', refreshViewportState, { passive: true });
      window.addEventListener('orientationchange', refreshViewportState, { passive: true });
      window.addEventListener('scroll', refreshViewportState, { passive: true });

      sectionVisible = isNodeVisibleInViewport(stepsRail);
      syncPlayback({ restart: true, resetOthers: true });
      if (sectionVisible) scheduleAutoplayKick(0);
      window.setTimeout(refreshViewportState, 120);
      window.setTimeout(refreshViewportState, 520);
      window.setTimeout(updateRailState, 220);
    });
  }

  var heroTitleThreeLineFitRaf = 0;
  var heroTitleThreeLineFitTimeout = 0;
  var heroTitleThreeLineFitBootstrapped = false;

  function getElementLineHeightPx(node) {
    if (!node) return 0;
    var computed = window.getComputedStyle(node);
    var lineHeight = toFiniteNumber(computed.lineHeight, 0);
    if (lineHeight > 0) return lineHeight;
    var fontSize = toFiniteNumber(computed.fontSize, 16);
    return fontSize * 1.12;
  }

  function measureElementLineCount(node) {
    if (!node) return 1;
    var lineHeight = getElementLineHeightPx(node);
    var lineTopTolerance = Math.max(2, lineHeight * 0.32);
    if (document.createRange) {
      try {
        var range = document.createRange();
        range.selectNodeContents(node);
        var rects = range.getClientRects();
        if (rects && rects.length) {
          var uniqueTops = [];
          for (var i = 0; i < rects.length; i += 1) {
            var rect = rects[i];
            if (!rect || rect.height < 0.5 || rect.width < 0.5) continue;
            var normalizedTop = Math.round(rect.top * 2) / 2;
            var known = false;
            for (var j = 0; j < uniqueTops.length; j += 1) {
              if (Math.abs(uniqueTops[j] - normalizedTop) <= lineTopTolerance) {
                known = true;
                break;
              }
            }
            if (!known) uniqueTops.push(normalizedTop);
          }
          if (uniqueTops.length) return uniqueTops.length;
        }
      } catch (_err) {}
    }
    if (lineHeight <= 0) return 1;
    return Math.max(1, node.scrollHeight / lineHeight);
  }

  function fitHeroTitleToMaxLines(title, maxLines) {
    if (!title || !maxLines || maxLines < 1) return;
    var width = Math.ceil(title.getBoundingClientRect().width || 0);
    if (width < 8) return;

    title.style.removeProperty('font-size');
    var baseFontSize = toFiniteNumber(window.getComputedStyle(title).fontSize, 0);
    if (baseFontSize <= 0) return;

    var lineCount = measureElementLineCount(title);
    if (lineCount <= maxLines + 0.02) {
      if (lineCount >= maxLines - 0.02) return;

      var maxGrowScale = toFiniteNumber(title.getAttribute('data-nb-fit-max-scale'), 1.18);
      if (maxGrowScale <= 1) return;

      var growLow = baseFontSize;
      var growHigh = baseFontSize * Math.min(maxGrowScale, 1.34);
      var growBest = baseFontSize;

      for (var g = 0; g < 18; g += 1) {
        var growMid = (growLow + growHigh) / 2;
        title.style.setProperty('font-size', growMid.toFixed(3) + 'px', 'important');
        lineCount = measureElementLineCount(title);
        if (lineCount <= maxLines + 0.02) {
          growBest = growMid;
          growLow = growMid + 0.05;
        } else {
          growHigh = growMid - 0.05;
        }
        if (growLow > growHigh) break;
      }

      title.style.setProperty('font-size', growBest.toFixed(3) + 'px', 'important');
      return;
    }

    var minFontSize = Math.max(8.5, Math.min(baseFontSize - 0.1, baseFontSize * 0.52));
    var low = minFontSize;
    var high = baseFontSize;
    var best = minFontSize;

    for (var i = 0; i < 20; i += 1) {
      var mid = (low + high) / 2;
      title.style.setProperty('font-size', mid.toFixed(3) + 'px', 'important');
      lineCount = measureElementLineCount(title);
      if (lineCount <= maxLines + 0.02) {
        best = mid;
        low = mid + 0.05;
      } else {
        high = mid - 0.05;
      }
      if (low > high) break;
    }

    title.style.setProperty('font-size', best.toFixed(3) + 'px', 'important');
    var guard = 0;
    while (measureElementLineCount(title) > maxLines + 0.02 && best > 8.5 && guard < 28) {
      best = Math.max(8.5, best - 0.35);
      title.style.setProperty('font-size', best.toFixed(3) + 'px', 'important');
      guard += 1;
    }
  }

  function applyHeroTitleMaxLines(scope) {
    var root = scope && scope.querySelectorAll ? scope : document;
    var titles = root.querySelectorAll('[data-nb-hero-title]');
    if (!titles.length && root !== document) return;
    if (!titles.length) return;

    titles.forEach(function (title) {
      var fitDisabledRoot = title.closest('[data-nb-hero-disable-title-fit="true"]');
      if (fitDisabledRoot) {
        title.style.removeProperty('font-size');
        return;
      }
      var maxLines = Math.round(toFiniteNumber(title.getAttribute('data-nb-max-lines'), 3));
      if (maxLines < 1) maxLines = 3;
      fitHeroTitleToMaxLines(title, maxLines);
    });
  }

  function scheduleHeroTitleMaxLines(scope) {
    var scopedRoot = scope && scope.querySelectorAll ? scope : null;
    if (scopedRoot) {
      window.requestAnimationFrame(function () {
        applyHeroTitleMaxLines(scopedRoot);
      });
    }

    if (heroTitleThreeLineFitRaf) cancelAnimationFrame(heroTitleThreeLineFitRaf);
    heroTitleThreeLineFitRaf = requestAnimationFrame(function () {
      heroTitleThreeLineFitRaf = 0;
      applyHeroTitleMaxLines(document);
    });

    if (heroTitleThreeLineFitTimeout) clearTimeout(heroTitleThreeLineFitTimeout);
    heroTitleThreeLineFitTimeout = window.setTimeout(function () {
      heroTitleThreeLineFitTimeout = 0;
      applyHeroTitleMaxLines(document);
    }, 180);
  }

  function initHeroTitleMaxLines(scope) {
    if (scope && scope.querySelectorAll) {
      scheduleHeroTitleMaxLines(scope);
    }

    if (heroTitleThreeLineFitBootstrapped) return;
    heroTitleThreeLineFitBootstrapped = true;

    var scheduleAll = function () {
      scheduleHeroTitleMaxLines(document);
    };

    window.addEventListener('resize', scheduleAll, { passive: true });
    window.addEventListener('orientationchange', scheduleAll, { passive: true });
    window.addEventListener('pageshow', scheduleAll);
    document.addEventListener('visibilitychange', function () {
      if (!document.hidden) scheduleAll();
    });

    if (document.fonts && typeof document.fonts.addEventListener === 'function') {
      document.fonts.addEventListener('loadingdone', scheduleAll);
    } else if (document.fonts && document.fonts.ready && typeof document.fonts.ready.then === 'function') {
      document.fonts.ready.then(scheduleAll).catch(function () {});
    }

    if ('MutationObserver' in window) {
      var heroRoot = document.querySelector('[data-nb-hero]');
      if (heroRoot) {
        var mutationObserver = new MutationObserver(function (mutations) {
          var shouldRefit = false;
          for (var i = 0; i < mutations.length; i += 1) {
            var mutation = mutations[i];
            if (!mutation) continue;
            if (mutation.type === 'characterData') {
              var parentNode = mutation.target && mutation.target.parentElement;
              if (parentNode && parentNode.closest && parentNode.closest('[data-nb-hero-title]')) {
                shouldRefit = true;
                break;
              }
            } else if (mutation.target && mutation.target.closest && mutation.target.closest('[data-nb-hero-title]')) {
              shouldRefit = true;
              break;
            }
          }
          if (shouldRefit) scheduleAll();
        });
        mutationObserver.observe(heroRoot, { childList: true, subtree: true, characterData: true });
      }
    }

    scheduleHeroTitleMaxLines(document);
  }

  function initHeroAbRuntimeFix() {
    var root = document.querySelector('[data-nb-hero]');
    if (!root) return;
    if (root.getAttribute('data-nb-hero-runtime-ab-patched') === 'true') return;

    var desktopImage = root.querySelector('[data-nb-hero-media-desktop]');
    var mobileImage = root.querySelector('[data-nb-hero-media-mobile]');
    if (!desktopImage || !mobileImage) return;

    var variantASrc = desktopImage.getAttribute('data-variant-a-src') || '';
    var variantBSrc = desktopImage.getAttribute('data-variant-b-src') || '';
    if (!variantASrc || !variantBSrc) return;

    var currentTestName = String(root.getAttribute('data-nb-hero-test-name') || '').trim();
    var stickyRaw = root.getAttribute('data-nb-hero-sticky-assignment');
    var needsFix = currentTestName !== 'hero_image_v2' || stickyRaw === null || stickyRaw === '';
    if (!needsFix) return;

    var testSignature = String(root.getAttribute('data-nb-hero-test-signature') || '');
    function hashSignature(value) {
      var hash = 5381;
      var str = String(value || '');
      for (var i = 0; i < str.length; i += 1) {
        hash = ((hash << 5) + hash) + str.charCodeAt(i);
      }
      return (hash >>> 0).toString(36);
    }

    function writeCookie(name, value, days) {
      var maxAge = Math.max(1, Math.floor((Number(days) || 365) * 24 * 60 * 60));
      document.cookie = name + '=' + encodeURIComponent(value) + '; path=/; max-age=' + maxAge + '; SameSite=Lax';
    }

    function readCookie(name) {
      var escaped = String(name || '').replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
      var match = document.cookie.match(new RegExp('(?:^|; )' + escaped + '=([^;]*)'));
      return match ? decodeURIComponent(match[1]) : '';
    }

    var signatureHash = testSignature ? hashSignature(testSignature) : '';
    var v2TestKey = signatureHash ? ('hero_image_v2__' + signatureHash) : 'hero_image_v2';
    var v2StorageKey = 'nb_hero_ab_' + v2TestKey;

    function readV2Variant() {
      var local = '';
      try {
        local = window.localStorage ? window.localStorage.getItem(v2StorageKey) : '';
      } catch (_err) {
        local = '';
      }
      if (local === 'A' || local === 'B') return local;
      var fromCookie = readCookie(v2StorageKey);
      if (fromCookie === 'A' || fromCookie === 'B') return fromCookie;
      return '';
    }

    function persistV2Variant(variant) {
      try {
        if (window.localStorage) window.localStorage.setItem(v2StorageKey, variant);
      } catch (_err) {}
      writeCookie(v2StorageKey, variant, 365);
    }

    var splitA = toFiniteNumber(root.getAttribute('data-nb-hero-split-a'), 50);
    splitA = Math.max(0, Math.min(100, splitA));
    var variant = readV2Variant();
    if (variant !== 'A' && variant !== 'B') {
      variant = String(root.getAttribute('data-nb-hero-variant') || '').toUpperCase();
    }
    if (variant !== 'A' && variant !== 'B') {
      variant = String(desktopImage.getAttribute('data-active-variant') || '').toUpperCase();
    }
    if (variant !== 'A' && variant !== 'B') {
      var currentDesktopSrc = desktopImage.getAttribute('src') || '';
      if (currentDesktopSrc === variantBSrc) variant = 'B';
      else if (currentDesktopSrc === variantASrc) variant = 'A';
    }
    if (variant !== 'A' && variant !== 'B') {
      variant = Math.random() * 100 < splitA ? 'A' : 'B';
    }

    var nextDesktopSrc = variant === 'B' ? variantBSrc : variantASrc;
    var nextMobileSrc = variant === 'B'
      ? (mobileImage.getAttribute('data-variant-b-src') || '')
      : (mobileImage.getAttribute('data-variant-a-src') || '');
    if (nextDesktopSrc) desktopImage.setAttribute('src', nextDesktopSrc);
    if (nextMobileSrc) mobileImage.setAttribute('src', nextMobileSrc);

    root.setAttribute('data-nb-hero-test-name', 'hero_image_v2');
    root.setAttribute('data-nb-hero-sticky-assignment', 'true');
    root.setAttribute('data-nb-hero-variant', variant);
    desktopImage.setAttribute('data-active-variant', variant);
    mobileImage.setAttribute('data-active-variant', variant);
    root.setAttribute('data-nb-hero-runtime-ab-patched', 'true');
    persistV2Variant(variant);

    var abApi = window.NordbeltAB && typeof window.NordbeltAB.recordExposure === 'function' ? window.NordbeltAB : null;
    if (abApi) {
      abApi.recordExposure({
        namespace: 'hero_image',
        testName: 'hero_image_v2',
        testSignature: testSignature,
        variant: variant,
        sectionId: root.id || '',
        source: 'v2-hero-runtime-fix'
      });
    }
  }

  function initCookieMiniBanner() {
    var banner = document.querySelector('[data-nb-cookie-banner]');
    if (!banner) return;
    var STORAGE_KEY = 'nb_cookie_consent_v1';
    var FORCE_MIGRATION_KEY = 'nb_force_consent_migrated_v1';

    function isPreviewThemeSession() {
      var role = '';
      try {
        role = String((window.Shopify && window.Shopify.theme && window.Shopify.theme.role) || '').toLowerCase();
      } catch (_err) {
        role = '';
      }

      var hasPreviewParam = false;
      try {
        hasPreviewParam = new URLSearchParams(window.location.search).has('preview_theme_id');
      } catch (_err2) {
        hasPreviewParam = false;
      }

      var hasPreviewBar =
        !!document.querySelector('#OnlineStorePreviewBarNextData') ||
        !!document.querySelector('[id*="OnlineStorePreviewBar"]') ||
        !!document.querySelector('[data-shopify-preview-bar]');

      return role === 'unpublished' || hasPreviewParam || hasPreviewBar;
    }

    if (HIDE_COOKIE_BANNER_IN_PREVIEW && isPreviewThemeSession()) {
      document.documentElement.classList.add('nb-preview-theme');
      if (document.body) document.body.classList.add('nb-preview-theme');
      banner.hidden = true;
      banner.classList.remove('is-visible');
      document.body.classList.remove('nb-cookie-mini-active');
      return;
    }
    var acceptButton = banner.querySelector('[data-nb-cookie-accept]');
    var essentialButton = banner.querySelector('[data-nb-cookie-essential]');
    if (!acceptButton || !essentialButton) return;

    var hideTimer = null;
    var scrollDismissArmed = false;
    var scrollStartY = 0;
    var scrollListener = null;
    var SCROLL_DISMISS_DELTA = 10;

    function readSavedChoice() {
      var raw = readStorageItem(window.localStorage, STORAGE_KEY) || readStorageItem(window.sessionStorage, STORAGE_KEY);
      if (!raw) return '';
      if (raw === 'accepted' || raw === 'essential') return raw;
      var parsed = safeParseJson(raw, null);
      if (!parsed || typeof parsed !== 'object') return '';
      var choice = String(parsed.choice || '').toLowerCase();
      return (choice === 'accepted' || choice === 'essential') ? choice : '';
    }

    function writeSavedChoice(choice) {
      if (choice !== 'accepted' && choice !== 'essential') return;
      var payload = JSON.stringify({
        choice: choice,
        updated_at: new Date().toISOString()
      });
      writeStorageItem(window.localStorage, STORAGE_KEY, payload);
      writeStorageItem(window.sessionStorage, STORAGE_KEY, payload);
    }

    function clearScrollDismissListener() {
      scrollDismissArmed = false;
      if (!scrollListener) return;
      window.removeEventListener('scroll', scrollListener);
      scrollListener = null;
    }

    function armScrollDismissListener() {
      clearScrollDismissListener();
      scrollStartY = toFiniteNumber(window.scrollY, toFiniteNumber(window.pageYOffset, 0));
      scrollDismissArmed = true;
      scrollListener = function () {
        if (!scrollDismissArmed) return;
        var currentY = toFiniteNumber(window.scrollY, toFiniteNumber(window.pageYOffset, 0));
        if (Math.abs(currentY - scrollStartY) < SCROLL_DISMISS_DELTA) return;
        clearScrollDismissListener();
        // Passive scroll should never write consent on behalf of the visitor.
        hideBanner();
      };
      window.addEventListener('scroll', scrollListener, { passive: true });
    }

    function withPrivacyApi(callback) {
      if (typeof callback !== 'function') return;
      var privacyApi = window.Shopify && window.Shopify.customerPrivacy;
      if (privacyApi) {
        callback(privacyApi);
        return;
      }
      var loadFeatures = window.Shopify && window.Shopify.loadFeatures;
      if (typeof loadFeatures !== 'function') return;
      try {
        loadFeatures([
          {
            name: 'consent-tracking-api',
            version: '0.1'
          }
        ], function (error) {
          if (error) return;
          var loadedPrivacyApi = window.Shopify && window.Shopify.customerPrivacy;
          if (!loadedPrivacyApi) return;
          callback(loadedPrivacyApi);
        });
      } catch (_err) {
        // noop
      }
    }

    function applyShopifyConsent(choice) {
      var allowTracking = choice === 'accepted';
      var payload = {
        analytics: allowTracking,
        marketing: allowTracking,
        preferences: allowTracking,
        sale_of_data: allowTracking
      };
      withPrivacyApi(function (privacyApi) {
        if (!privacyApi || typeof privacyApi.setTrackingConsent !== 'function') return;
        try {
          privacyApi.setTrackingConsent(payload, function () {});
        } catch (_err) {
          try {
            privacyApi.setTrackingConsent(allowTracking, function () {});
          } catch (_innerErr) {
            // noop
          }
        }
      });
    }

    function applyGoogleConsent(choice) {
      var consentState = choice === 'accepted' ? 'granted' : 'denied';
      var gtag = typeof window.gtag === 'function' ? window.gtag : null;
      if (!gtag) return;
      try {
        gtag('consent', 'update', {
          ad_storage: consentState,
          analytics_storage: consentState,
          functionality_storage: consentState,
          personalization_storage: consentState,
          ad_user_data: consentState,
          ad_personalization: consentState,
          security_storage: 'granted'
        });
      } catch (_err) {
        // noop
      }
    }

    function readShopifyConsentChoice() {
      var privacyApi = window.Shopify && window.Shopify.customerPrivacy;
      if (!privacyApi || typeof privacyApi.currentVisitorConsent !== 'function') return '';
      try {
        var consent = privacyApi.currentVisitorConsent();
        if (!consent || typeof consent !== 'object') return '';
        var keys = ['analytics', 'marketing', 'preferences', 'sale_of_data'];
        var hasExplicit = keys.some(function (key) {
          return typeof consent[key] === 'boolean';
        });
        if (!hasExplicit) return '';
        var hasAccepted = !!(consent.analytics || consent.marketing || consent.preferences || consent.sale_of_data);
        return hasAccepted ? 'accepted' : 'essential';
      } catch (_err) {
        return '';
      }
    }

    function isBannerForceHidden() {
      try {
        return window.getComputedStyle(banner).display === 'none';
      } catch (_err) {
        return false;
      }
    }

    function showBanner() {
      if (hideTimer) {
        window.clearTimeout(hideTimer);
        hideTimer = null;
      }
      banner.hidden = false;
      document.body.classList.add('nb-cookie-mini-active');
      window.requestAnimationFrame(function () {
        banner.classList.add('is-visible');
      });
      armScrollDismissListener();
    }

    function hideBanner() {
      clearScrollDismissListener();
      if (hideTimer) {
        window.clearTimeout(hideTimer);
        hideTimer = null;
      }
      banner.classList.remove('is-visible');
      document.body.classList.remove('nb-cookie-mini-active');
      hideTimer = window.setTimeout(function () {
        banner.hidden = true;
      }, 240);
    }

    function setChoice(choice) {
      writeSavedChoice(choice);
      applyShopifyConsent(choice);
      applyGoogleConsent(choice);
      if (choice === 'essential') {
        attributionCache = null;
        removeStorageItem(window.localStorage, ATTRIBUTION_STORAGE_KEY);
        removeStorageItem(window.sessionStorage, ATTRIBUTION_STORAGE_KEY);
        clearBlogOriginStorage();
      } else {
        var articleRoot = document.querySelector('[data-nb-article-conversion]');
        if (articleRoot) persistBlogOrigin(articleRoot, { surface_source: 'consent_accept' });
      }
      removeStorageItem(window.localStorage, FORCE_MIGRATION_KEY);
      document.dispatchEvent(new CustomEvent('nb:consent-changed', { detail: { choice: choice } }));
      hideBanner();
    }

    acceptButton.addEventListener('click', function () {
      setChoice('accepted');
    });

    essentialButton.addEventListener('click', function () {
      setChoice('essential');
    });

    var savedChoice = readSavedChoice();
    if (savedChoice) {
      applyShopifyConsent(savedChoice);
      hideBanner();
      return;
    }

    var forceMigrationPending = !!readStorageItem(window.localStorage, FORCE_MIGRATION_KEY);
    var shopifyChoice = forceMigrationPending ? '' : readShopifyConsentChoice();
    if (shopifyChoice) {
      writeSavedChoice(shopifyChoice);
      hideBanner();
      return;
    }

    if (isBannerForceHidden()) {
      hideBanner();
      return;
    }

    showBanner();
  }

  function initGlobalReserveTimer() {
    var body = document.body;
    if (body && body.getAttribute('data-b2b-layout') === 'true') return;
    var header = document.querySelector('[data-nb-header]');
    if (!header) return;

    var timerLink = header.querySelector('[data-nb-reserve-header]');
    var timeNode = header.querySelector('[data-nb-reserve-header-time]');
    var ringNode = header.querySelector('[data-nb-reserve-header-ring]');
    var modal = document.querySelector('[data-nb-reserve-expiry-modal]');
    var modalDialog = modal ? modal.querySelector('.nb-reserve-modal__dialog') : null;
    var modalDismissButtons = modal ? Array.prototype.slice.call(modal.querySelectorAll('[data-nb-reserve-dismiss]')) : [];
    var reservePanel = document.querySelector('[data-nb-reserve-panel]');
    var reservePanelIsHomepage = !!(reservePanel && reservePanel.hasAttribute('data-nb-reserve-panel-homepage'));
    var reservePanelStatus = reservePanel ? reservePanel.querySelector('.nb-cart-form__status') : null;
    var reservePanelHint = reservePanel ? reservePanel.querySelector('.nb-cart-reserve__hint') : null;
    var reservePanelResetButton = reservePanel ? reservePanel.querySelector('[data-nb-reserve-reset]') : null;
    var resetButtons = Array.prototype.slice.call(document.querySelectorAll('[data-nb-reserve-reset]'));
    var previewPathLinks = Array.prototype.slice.call(document.querySelectorAll('[data-nb-reserve-preview-path]'));
    var modalCheckoutLink = modal ? modal.querySelector('[data-nb-reserve-checkout]') : null;
    var modalCartLink = modal ? modal.querySelector('[data-nb-reserve-go-cart]') : null;
    var modalHydrated = !!(modal && modalDialog);

    var STORAGE_KEY = 'nb_reserve_timer_v3';
    var LAST_CART_COUNT_KEY = 'nb_reserve_last_cart_count_v1';
    var DEFAULT_SECONDS = 600;
    var DEFAULT_DELAY_MS = 3000;
    var CART_THRESHOLD_FOR_TIMER = 1;
    var timerId = null;
    var panelHideTimer = null;
    var panelHideFinalizeTimer = null;
    var PANEL_HIDE_DELAY_MS = 5000;
    var PANEL_COLLAPSE_MS = 420;
    var titleFlashId = null;
    var modalOpen = false;
    var baseTitle = document.title || 'Nordbelt';
    var notifiedCycleId = '';
    var cartCount = Math.max(0, Math.round(toFiniteNumber(header.getAttribute('data-cart-count'), 0)));
    var state = readState();

    function readState() {
      try {
        var raw = window.localStorage.getItem(STORAGE_KEY);
        if (!raw) return null;
        var parsed = JSON.parse(raw);
        if (!parsed || typeof parsed !== 'object') return null;
        if (!Number.isFinite(parsed.endAt) || !Number.isFinite(parsed.duration) || !Number.isFinite(parsed.delayUntil)) return null;
        parsed.duration = Math.max(60, Math.round(parsed.duration));
        parsed.endAt = Math.round(parsed.endAt);
        parsed.delayUntil = Math.round(parsed.delayUntil);
        parsed.expired = parsed.expired === true;
        parsed.cycleId = parsed.cycleId ? String(parsed.cycleId) : createEventId('reserve');
        return parsed;
      } catch (_err) {
        return null;
      }
    }

    function persistState(nextState) {
      state = nextState;
      try {
        if (!nextState) {
          window.localStorage.removeItem(STORAGE_KEY);
        } else {
          window.localStorage.setItem(STORAGE_KEY, JSON.stringify(nextState));
        }
      } catch (_err) {
        // noop
      }
      return state;
    }

    function clearState() {
      persistState(null);
    }

    function readLastCartCount() {
      try {
        var raw = window.localStorage.getItem(LAST_CART_COUNT_KEY);
        if (raw == null) return null;
        var parsed = parseInt(raw, 10);
        return Number.isFinite(parsed) ? Math.max(0, parsed) : null;
      } catch (_err) {
        return null;
      }
    }

    function writeLastCartCount(count) {
      try {
        window.localStorage.setItem(LAST_CART_COUNT_KEY, String(Math.max(0, Math.round(toFiniteNumber(count, 0)))));
      } catch (_err) {
        // noop
      }
    }

    function applyPreviewPaths() {
      previewPathLinks.forEach(function (link) {
        if (!link || !link.getAttribute) return;
        var path = link.getAttribute('data-nb-reserve-preview-path') || '';
        if (!path) return;
        link.setAttribute('href', buildShopifyPathWithPreview(path));
      });
    }

    function createReserveModalElement(tagName, className, text) {
      var element = document.createElement(tagName);
      if (className) element.className = className;
      if (text !== undefined && text !== null) element.textContent = String(text);
      return element;
    }

    var reserveModalCopyCache = null;

    function getReserveModalCopy() {
      if (reserveModalCopyCache) return reserveModalCopyCache;
      reserveModalCopyCache = {};
      var node = document.getElementById('NbReserveModalCopyJson');
      if (!node) return reserveModalCopyCache;
      var parsed = safeParseJson(node.textContent || '{}', {});
      if (parsed && typeof parsed === 'object') reserveModalCopyCache = parsed;
      return reserveModalCopyCache;
    }

    function reserveModalCopy(key, i18nPath, fallback) {
      var copy = getReserveModalCopy();
      var value = copy && copy[key];
      if (typeof value === 'string' && value) return value;
      return i18n(i18nPath, fallback);
    }

    function ensureReserveModalContent() {
      if (!modal || modalHydrated) return;
      modalHydrated = true;
      modal.textContent = '';

      var closeLabel = reserveModalCopy('close', 'shared.close', 'Sluiten');
      var backdrop = createReserveModalElement('button', 'nb-reserve-modal__backdrop');
      backdrop.type = 'button';
      backdrop.setAttribute('data-nb-reserve-dismiss', '');
      backdrop.setAttribute('aria-label', closeLabel);

      var dialog = createReserveModalElement('section', 'nb-reserve-modal__dialog');
      dialog.setAttribute('role', 'dialog');
      dialog.setAttribute('aria-modal', 'true');
      dialog.setAttribute('aria-labelledby', 'nbReserveModalTitle');

      var closeButton = createReserveModalElement('button', 'nb-reserve-modal__close');
      closeButton.type = 'button';
      closeButton.setAttribute('data-nb-reserve-dismiss', '');
      closeButton.setAttribute('aria-label', closeLabel);
      var closeIcon = createReserveModalElement('span', '', '\u00d7');
      closeIcon.setAttribute('aria-hidden', 'true');
      closeButton.appendChild(closeIcon);

      var kicker = createReserveModalElement('p', 'nb-reserve-modal__kicker', reserveModalCopy('kicker', 'reserve.expired_kicker', 'Reservering verlopen'));
      var title = createReserveModalElement('h3', '', reserveModalCopy('title', 'reserve.expired_modal_title', 'Wil je je bestelling nu afronden?'));
      title.id = 'nbReserveModalTitle';
      var copy = createReserveModalElement('p', '', reserveModalCopy('copy', 'reserve.expired_modal_copy', 'Je product ligt nog in de winkelwagen. Kies hieronder hoe je verder wilt.'));
      var actions = createReserveModalElement('div', 'nb-reserve-modal__actions');

      var checkoutLink = createReserveModalElement('a', 'nb-button', reserveModalCopy('checkout', 'reserve.checkout_now', 'Ga nu naar afrekenen'));
      checkoutLink.href = buildShopifyPathWithPreview('/checkout');
      checkoutLink.setAttribute('data-nb-reserve-checkout', '');
      checkoutLink.setAttribute('data-nb-reserve-preview-path', '/checkout');

      var cartPath = modal.getAttribute('data-nb-reserve-cart-path') || '/cart';
      var cartLink = createReserveModalElement('a', 'nb-button nb-button--secondary', reserveModalCopy('cart', 'reserve.to_cart', 'Naar winkelwagen'));
      cartLink.href = buildShopifyPathWithPreview(cartPath);
      cartLink.setAttribute('data-nb-reserve-go-cart', '');
      cartLink.setAttribute('data-nb-reserve-preview-path', cartPath);

      var resetButton = createReserveModalElement('button', 'nb-button nb-button--secondary', reserveModalCopy('reset', 'reserve.reset', 'Opnieuw 10 min reserveren'));
      resetButton.type = 'button';
      resetButton.setAttribute('data-nb-reserve-reset', '');

      actions.appendChild(checkoutLink);
      actions.appendChild(cartLink);
      actions.appendChild(resetButton);
      dialog.appendChild(closeButton);
      dialog.appendChild(kicker);
      dialog.appendChild(title);
      dialog.appendChild(copy);
      dialog.appendChild(actions);
      modal.appendChild(backdrop);
      modal.appendChild(dialog);

      modalDialog = dialog;
      modalDismissButtons = Array.prototype.slice.call(modal.querySelectorAll('[data-nb-reserve-dismiss]'));
      previewPathLinks = Array.prototype.slice.call(document.querySelectorAll('[data-nb-reserve-preview-path]'));
      modalCheckoutLink = checkoutLink;
      modalCartLink = cartLink;
      applyPreviewPaths();
    }

    function formatTime(seconds) {
      var safe = Math.max(0, Math.round(seconds));
      var mins = Math.floor(safe / 60);
      var secs = safe % 60;
      return String(mins).padStart(2, '0') + ':' + String(secs).padStart(2, '0');
    }

    function setRingProgress(progress) {
      if (!ringNode) return;
      var clamped = Math.max(0, Math.min(100, toFiniteNumber(progress, 0)));
      ringNode.style.setProperty('--nb-reserve-progress', clamped.toFixed(2));
    }

    function clearPanelHideTimers() {
      if (panelHideTimer) {
        window.clearTimeout(panelHideTimer);
        panelHideTimer = null;
      }
      if (panelHideFinalizeTimer) {
        window.clearTimeout(panelHideFinalizeTimer);
        panelHideFinalizeTimer = null;
      }
    }

    function collapseReservePanelAnimated() {
      if (!reservePanel || reservePanel.hidden || reservePanel.classList.contains('is-collapsing')) return;
      if (state && state.expired) return;
      clearPanelHideTimers();
      reservePanel.classList.add('is-collapsing');
      panelHideFinalizeTimer = window.setTimeout(function () {
        reservePanel.hidden = true;
        reservePanel.classList.remove('is-collapsing');
        reservePanel.classList.add('is-collapsed');
      }, PANEL_COLLAPSE_MS);
    }

    function showReservePanelTemporarily() {
      if (!reservePanel) return;
      if (state && state.expired) {
        reservePanel.hidden = true;
        reservePanel.classList.remove('is-collapsing', 'is-expired');
        reservePanel.classList.add('is-collapsed');
        return;
      }
      clearPanelHideTimers();
      reservePanel.hidden = false;
      reservePanel.classList.remove('is-collapsing', 'is-collapsed');
      // Force layout so collapse animation starts reliably.
      reservePanel.offsetHeight;
      panelHideTimer = window.setTimeout(function () {
        collapseReservePanelAnimated();
      }, PANEL_HIDE_DELAY_MS);
    }

    function maybeShowReservePanelForFreshAdd() {
      if (!reservePanel) return;
      if (cartCount < CART_THRESHOLD_FOR_TIMER) return;
      if (!state || state.expired) return;
      if (!consumeReservePanelNotice()) return;
      showReservePanelTemporarily();
    }

    function maybeShowHomepageReservePanel() {
      if (!reservePanelIsHomepage) return;
      if (cartCount < CART_THRESHOLD_FOR_TIMER) return;
      if (!state || state.expired) return;
      showReservePanelTemporarily();
    }

    function setModalOpen(nextOpen) {
      if (!modal) return;
      if (nextOpen === modalOpen) return;
      if (nextOpen) ensureReserveModalContent();
      modalOpen = nextOpen;
      modal.hidden = !nextOpen;
      modal.setAttribute('aria-hidden', nextOpen ? 'false' : 'true');
      if ('inert' in modal) {
        modal.inert = !nextOpen;
      } else if (nextOpen) {
        modal.removeAttribute('inert');
      } else {
        modal.setAttribute('inert', '');
      }
      document.body.classList.toggle('nb-reserve-modal-open', nextOpen);
      if (nextOpen) {
        window.requestAnimationFrame(function () {
          modal.classList.add('is-open');
        });
      } else {
        modal.classList.remove('is-open');
      }
    }

    function dismissExpiredModal() {
      clearState();
      stopTicking();
      clearPanelHideTimers();
      stopTitleFlash();
      if (reservePanel) {
        reservePanel.hidden = true;
        reservePanel.classList.remove('is-collapsing', 'is-expired');
        reservePanel.classList.add('is-collapsed');
      }
      setModalOpen(false);
      render();
    }

    function stopTitleFlash() {
      if (titleFlashId) {
        window.clearInterval(titleFlashId);
        titleFlashId = null;
      }
      document.title = baseTitle;
    }

    function maybeStartTitleFlash() {
      if (document.visibilityState !== 'hidden') return;
      if (titleFlashId) return;
      titleFlashId = window.setInterval(function () {
        document.title = document.title === baseTitle
          ? i18n('reserve.expired_title', '⏱️ Reservering verlopen - Nordbelt')
          : baseTitle;
      }, 1200);
    }

    function requestNotificationPermissionOnIntent() {
      if (SUPPRESS_BROWSER_POPUPS) return;
      if (!('Notification' in window)) return;
      if (Notification.permission !== 'default') return;

      var asked = false;
      function askPermission() {
        if (asked) return;
        asked = true;
        try {
          Notification.requestPermission();
        } catch (_err) {
          // noop
        }
      }

      document.addEventListener('pointerdown', askPermission, { once: true, passive: true });
      document.addEventListener('keydown', askPermission, { once: true });
    }

    function maybeSendExpiryNotification() {
      if (!state || !state.expired) return;
      if (notifiedCycleId === state.cycleId) return;
      notifiedCycleId = state.cycleId;

      if (document.visibilityState === 'hidden') {
        maybeStartTitleFlash();
      }

      if (SUPPRESS_BROWSER_POPUPS) return;

      if (!('Notification' in window)) return;
      if (Notification.permission !== 'granted') return;

      if (document.visibilityState === 'hidden') {
        try {
          var notificationIcon = '';
          try {
            notificationIcon = (window.NordbeltThemeAssets && window.NordbeltThemeAssets.notificationIcon) || '';
          } catch (_iconErr) {
            notificationIcon = '';
          }
          if (notificationIcon && notificationIcon.indexOf('//') === 0) {
            notificationIcon = window.location.protocol + notificationIcon;
          }
          var notificationOptions = {
            body: i18n('reserve.notification_body', 'Je product staat nog in je winkelwagen. Rond direct af of reserveer opnieuw 10 minuten.')
          };
          if (notificationIcon) {
            notificationOptions.icon = notificationIcon;
          }
          var notice = new Notification(i18n('reserve.notification_title', 'Je Nordbelt reservering is verlopen'), notificationOptions);
          notice.onclick = function () {
            try {
              window.focus();
            } catch (_err) {
              // noop
            }
            setModalOpen(true);
          };
        } catch (_err) {
          // noop
        }
      }
    }

    function syncReservePanel(isExpired) {
      if (!reservePanel) return;
      reservePanel.classList.toggle('is-expired', isExpired);
      if (reservePanelResetButton) reservePanelResetButton.hidden = true;
      if (reservePanelStatus) {
        reservePanelStatus.textContent = i18n('reserve.panel_active', 'Reservering actief');
      }
      if (reservePanelHint) {
        reservePanelHint.textContent = i18n('reserve.panel_hint', 'Timer loopt in de header naast je winkelwagen.');
      }
    }

    function getSecondsLeft(now) {
      if (!state) return 0;
      if (state.expired) return 0;
      if (now < state.delayUntil) return state.duration;
      return Math.max(0, Math.ceil((state.endAt - now) / 1000));
    }

    function getProgress(now) {
      if (!state) return 0;
      if (state.expired) return 100;
      if (now <= state.delayUntil) return 0;
      var elapsed = (now - state.delayUntil) / 1000;
      return Math.max(0, Math.min(100, (elapsed / state.duration) * 100));
    }

    function startTicking() {
      if (timerId) return;
      timerId = window.setInterval(function () {
        render();
      }, 250);
    }

    function stopTicking() {
      if (!timerId) return;
      window.clearInterval(timerId);
      timerId = null;
    }

    function startCycle(options) {
      if (cartCount < CART_THRESHOLD_FOR_TIMER) return;
      var now = Date.now();
      var duration = Math.max(60, Math.round(toFiniteNumber(options && options.duration, DEFAULT_SECONDS)));
      var startDelayMs = Math.max(0, Math.round(toFiniteNumber(options && options.startDelayMs, DEFAULT_DELAY_MS)));
      var delayUntil = now + startDelayMs;
      persistState({
        version: 3,
        duration: duration,
        delayUntil: delayUntil,
        endAt: delayUntil + duration * 1000,
        expired: false,
        cycleId: createEventId('reserve')
      });
      writeLastCartCount(cartCount);
      notifiedCycleId = '';
      stopTitleFlash();
      setModalOpen(false);
      startTicking();
      render();
    }

    function ensureState() {
      if (cartCount < CART_THRESHOLD_FOR_TIMER) {
        clearState();
        return;
      }
      if (!state) {
        startCycle({ startDelayMs: DEFAULT_DELAY_MS });
      }
    }

    function setCartCount(nextCount) {
      var previousCount = cartCount;
      cartCount = Math.max(0, Math.round(toFiniteNumber(nextCount, 0)));
      header.setAttribute('data-cart-count', String(cartCount));
      writeLastCartCount(cartCount);

      if (cartCount < CART_THRESHOLD_FOR_TIMER) {
        clearReservePanelNotice();
        clearState();
        stopTicking();
        clearPanelHideTimers();
        stopTitleFlash();
        setModalOpen(false);
        if (reservePanel) {
          reservePanel.hidden = true;
          reservePanel.classList.add('is-collapsed');
        }
        render();
        return;
      }

      if (cartCount > previousCount) {
        armReservePanelNotice();
        startCycle({ duration: DEFAULT_SECONDS, startDelayMs: 0 });
        maybeShowReservePanelForFreshAdd();
        return;
      }

      ensureState();
      startTicking();
      render();
    }

    function render() {
      var now = Date.now();
      var hasCart = cartCount >= CART_THRESHOLD_FOR_TIMER;
      var hasTimer = hasCart && !!state;

      header.classList.toggle('has-reserve-timer', hasTimer);
      if (timerLink) timerLink.hidden = !hasTimer;

      if (!hasTimer) {
        if (timerLink) timerLink.classList.remove('is-expiring', 'is-expired');
        clearPanelHideTimers();
        if (reservePanel) {
          reservePanel.hidden = true;
          reservePanel.classList.remove('is-collapsing', 'is-expired');
          reservePanel.classList.add('is-collapsed');
        }
        syncReservePanel(false);
        return;
      }

      if (!state.expired && now >= state.endAt) {
        state.expired = true;
        state.expiredAt = now;
        persistState(state);
      }

      var secondsLeft = getSecondsLeft(now);
      var progress = getProgress(now);

      if (timeNode) timeNode.textContent = formatTime(secondsLeft);
      setRingProgress(progress);

      if (state.expired) {
        if (timerLink) {
          timerLink.classList.add('is-expired');
          timerLink.classList.remove('is-expiring');
        }
        clearPanelHideTimers();
        if (reservePanel) {
          reservePanel.hidden = true;
          reservePanel.classList.remove('is-collapsing', 'is-expired');
          reservePanel.classList.add('is-collapsed');
        }
        syncReservePanel(false);
        setModalOpen(true);
        maybeSendExpiryNotification();
        return;
      }

      var isExpiring = secondsLeft <= 120 && now >= state.delayUntil;
      if (timerLink) {
        timerLink.classList.toggle('is-expiring', isExpiring);
        timerLink.classList.remove('is-expired');
      }
      syncReservePanel(false);
      setModalOpen(false);
    }

    function handleReset(event) {
      var fromReservePanel = !!(event && event.target && reservePanel && reservePanel.contains(event.target));
      if (event && typeof event.preventDefault === 'function') {
        event.preventDefault();
      }
      startCycle({ startDelayMs: 0 });
      if (fromReservePanel) {
        showReservePanelTemporarily();
      }
    }

    resetButtons.forEach(function (button) {
      button.addEventListener('click', handleReset);
    });

    if (modal) {
      modal.addEventListener('click', function (event) {
        if (!event || !event.target) return;
        var target = event.target;
        var dismissButton = target.closest ? target.closest('[data-nb-reserve-dismiss]') : null;
        if (dismissButton && modal.contains(dismissButton)) {
          event.preventDefault();
          event.stopPropagation();
          dismissExpiredModal();
          return;
        }

        var resetButton = target.closest ? target.closest('[data-nb-reserve-reset]') : null;
        if (resetButton && modal.contains(resetButton)) {
          handleReset(event);
          setModalOpen(false);
          return;
        }

        var checkoutLink = target.closest ? target.closest('[data-nb-reserve-checkout]') : null;
        if (checkoutLink && modal.contains(checkoutLink)) {
          setModalOpen(false);
          return;
        }

        var cartLink = target.closest ? target.closest('[data-nb-reserve-go-cart]') : null;
        if (cartLink && modal.contains(cartLink)) {
          if (event && typeof event.preventDefault === 'function') event.preventDefault();
          startCycle({ duration: DEFAULT_SECONDS, startDelayMs: 0 });
          setModalOpen(false);
          window.location.assign(cartLink.getAttribute('href') || '/cart');
          return;
        }

        if (!modalOpen) return;
        if (modalDialog && modalDialog.contains(target)) return;
        dismissExpiredModal();
      });
    }

    document.addEventListener('keydown', function (event) {
      if (!modalOpen) return;
      if (!event || event.key !== 'Escape') return;
      dismissExpiredModal();
    });

    document.addEventListener('nb:cart-count-updated', function (event) {
      var detail = event && event.detail ? event.detail : {};
      setCartCount(detail.count);
    });

    document.addEventListener('visibilitychange', function () {
      if (document.visibilityState === 'visible') {
        stopTitleFlash();
        if (state && state.expired && cartCount >= CART_THRESHOLD_FOR_TIMER) {
          setModalOpen(true);
        }
      }
    });

    window.addEventListener('storage', function (event) {
      if (!event || event.key !== STORAGE_KEY) return;
      state = readState();
      if (!state) {
        clearPanelHideTimers();
        setModalOpen(false);
        if (timerLink) timerLink.hidden = true;
        header.classList.remove('has-reserve-timer');
        stopTicking();
      } else {
        startTicking();
      }
      render();
    });

    applyPreviewPaths();
    requestNotificationPermissionOnIntent();
    var lastCartCount = readLastCartCount();
    if (cartCount >= CART_THRESHOLD_FOR_TIMER && lastCartCount !== null && cartCount > lastCartCount) {
      armReservePanelNotice();
      startCycle({ duration: DEFAULT_SECONDS, startDelayMs: 0 });
    } else {
      ensureState();
    }
    writeLastCartCount(cartCount);
    if (state && cartCount >= CART_THRESHOLD_FOR_TIMER) startTicking();
    render();
    maybeShowReservePanelForFreshAdd();
    maybeShowHomepageReservePanel();

    window.NordbeltTheme = window.NordbeltTheme || {};
    window.NordbeltTheme.reserveTimer = {
      reset: function () {
        startCycle({ startDelayMs: 0 });
      },
      start: function (seconds, delayMs) {
        startCycle({ duration: seconds, startDelayMs: delayMs });
      },
      clear: function () {
        clearState();
        render();
      },
      getState: function () {
        return state ? Object.assign({}, state) : null;
      }
    };
  }

  function initFiReviewProofGoogleLabelFallback(scope) {
    if (typeof window === 'undefined' || typeof document === 'undefined') return;
    var root = scope && scope.querySelectorAll ? scope : document;
    var langRaw = ((document.documentElement && document.documentElement.lang) || window.Shopify && window.Shopify.locale || '').toLowerCase();
    var langRoot = (langRaw.split('-')[0] || '').trim();
    var fallbackByLocale = {
      fi: 'Google-arvostelut',
      nl: 'Google reviews',
      de: 'Google-Bewertungen',
      fr: 'Avis Google',
      da: 'Google-anmeldelser',
      nb: 'Google-anmeldelser',
      sv: 'Google-recensioner',
      pt: 'Avaliações no Google',
      en: 'Google Reviews'
    };
    var fallbackLabel = fallbackByLocale[langRoot] || 'Google Reviews';
    var applyFallback = function () {
      var labels = root.querySelectorAll('.nb-review-proof-card--google .nb-review-proof-card__head strong');
      for (var i = 0; i < labels.length; i += 1) {
        var label = labels[i];
        var text = (label.textContent || '').trim();
        if (
          /translation missing:\s*[a-z-]+\.nb\.section\.review_proof\.google_label/i.test(text)
        ) {
          label.textContent = fallbackLabel;
        }
      }
    };

    applyFallback();
    var retries = 0;
    var retryTimer = window.setInterval(function () {
      retries += 1;
      applyFallback();
      if (retries >= 8) {
        window.clearInterval(retryTimer);
      }
    }, 250);

    if (root === document && window.MutationObserver && !window.__nbFiGoogleLabelObserver) {
      var observer = new MutationObserver(function () {
        applyFallback();
      });
      observer.observe(document.documentElement || document.body, {
        childList: true,
        subtree: true,
        characterData: true
      });
      window.__nbFiGoogleLabelObserver = observer;
      window.setTimeout(function () {
        if (window.__nbFiGoogleLabelObserver === observer) {
          observer.disconnect();
          window.__nbFiGoogleLabelObserver = null;
        }
      }, 6000);
    }
  }

  function normalizeLocaleCopyNodes(scope, replacements) {
    if (!scope || !replacements || !replacements.length) return;
    if (!window.NodeFilter || !document.createTreeWalker) return;
    var walker = document.createTreeWalker(scope, NodeFilter.SHOW_TEXT);
    var node;
    while ((node = walker.nextNode())) {
      if (!node || !node.parentElement) continue;
      var parentTag = (node.parentElement.tagName || '').toUpperCase();
      if (
        parentTag === 'SCRIPT' ||
        parentTag === 'STYLE' ||
        parentTag === 'NOSCRIPT' ||
        parentTag === 'TEMPLATE' ||
        parentTag === 'TEXTAREA'
      ) {
        continue;
      }
      var original = node.nodeValue || '';
      if (!original) continue;
      var normalized = original;
      for (var i = 0; i < replacements.length; i += 1) {
        var pair = replacements[i];
        normalized = normalized.replace(pair.pattern, pair.value);
      }
      if (normalized !== original) {
        node.nodeValue = normalized;
      }
    }
  }

  function fixNordicApparatusFenceImage(scope) {
    if (getCurrentArticleHandle() !== 'nordic-hamstring-curl-apparaat') return;

    var root = scope && scope.querySelectorAll ? scope : document;
    var oldImageNeedle = 'D752523_5d073e92-2bef-4749-b3b0-a70b6bf37e81.jpg';
    var newImageUrl = 'https://www.nordbelt.nl/cdn/shop/files/D753098.webp?v=1766439231';
    var altByLocale = {
      nl: 'Close-up van blauwe schoenen die met Nordbelt aan een nat metalen hek of verticale stang buiten zijn gefixeerd.',
      en: 'Close-up of blue shoes secured with Nordbelt to a wet metal fence or vertical bar outdoors.',
      fr: 'Gros plan sur des chaussures bleues fixees avec Nordbelt a une barriere metallique ou un point d ancrage bas dehors.',
      de: 'Nahaufnahme blauer Schuhe, die mit Nordbelt an einem nassen Metallzaun oder einer niedrigen Stange draussen fixiert sind.',
      sv: 'Narbild av bla skor som ar fixerade med Nordbelt vid ett metallstaket eller en lag fast punkt utomhus.',
      da: 'Nærbillede af blå sko fastgjort med Nordbelt til et vådt metalhegn eller lavt ankerpunkt udendørs.',
      nb: 'Nærbilde av blå sko festet med Nordbelt til et vått metallgjerde eller lavt ankerpunkt ute.',
      fi: 'Lähikuva sinisistä kengistä, jotka on kiinnitetty Nordbeltillä märkään metalliaitaan tai matalaan ankkuripisteeseen ulkona.',
      it: 'Primo piano di scarpe blu fissate con Nordbelt a una recinzione metallica o a un punto di ancoraggio basso all esterno.',
      es: 'Primer plano de zapatillas azules fijadas con Nordbelt a una valla metalica o punto de anclaje bajo en exterior.',
      pt: 'Plano aproximado de sapatilhas azuis fixas com Nordbelt numa vedacao metalica molhada ou numa barra vertical no exterior.',
      et: 'Lähivaade sinistele jalanõudele, mis on Nordbeltiga kinnitatud märja metallpiirde või madala ankrupunkti külge õues.'
    };
    var localeRoot = getLocaleRoot() || 'en';
    var nextAlt = altByLocale[localeRoot] || altByLocale.en;
    var images = root.querySelectorAll('img[src*="' + oldImageNeedle + '"], img[src*="D753098.webp"]');

    Array.prototype.forEach.call(images, function (image) {
      if (!image) return;
      var currentSrc = image.getAttribute('src') || '';
      var currentAlt = image.getAttribute('alt') || '';
      var isBadDoorAlt = /door|deur|dorr|dør|Tuer|porta|porte|puerta|ovi|uks|vagg|væg|vegg|wall|mur|parete|seina/i.test(currentAlt);
      if (currentSrc.indexOf(oldImageNeedle) !== -1) {
        image.setAttribute('src', newImageUrl);
        image.removeAttribute('srcset');
        image.setAttribute('alt', nextAlt);
      } else if (currentSrc.indexOf('D753098.webp') !== -1 && isBadDoorAlt) {
        image.setAttribute('alt', nextAlt);
      }
    });
  }

  function initBlogLocaleCopyHotfix(scope) {
    if (typeof document === 'undefined') return;
    var root = scope && scope.querySelectorAll ? scope : document;
    var langRaw = ((document.documentElement && document.documentElement.lang) || '').toLowerCase();
    var langRoot = (langRaw.split('-')[0] || '').trim();

    fixNordicApparatusFenceImage(root);

    if (langRoot === 'sv') {
      var svArticleBlocks = root.querySelectorAll ? root.querySelectorAll('.nb-article__rte') : [];
      for (var svIndex = 0; svIndex < svArticleBlocks.length; svIndex += 1) {
        var svBlock = svArticleBlocks[svIndex];
        if (!svBlock) continue;
        var svHtml = svBlock.innerHTML || '';
        var svNormalizedHtml = svHtml
          .replace(/hamstring exercises/gi, 'hamstringövningar')
          .replace(/hamstring workouts/gi, 'hamstringpass')
          .replace(
            /Visste du att(?:\\s|&nbsp;|<[^>]+>)*Nordbelt(?:\\s|&nbsp;|<[^>]+>)*ett viktigt hjälpmedel är vid hamstring-övningar\\?/gi,
            'Visste du att Nordbelt är ett viktigt hjälpmedel vid hamstringövningar?'
          );
        if (svNormalizedHtml !== svHtml) {
          svBlock.innerHTML = svNormalizedHtml;
        }
      }
      normalizeLocaleCopyNodes(root, [
        { pattern: /hamstring exercises/gi, value: 'hamstringövningar' },
        { pattern: /hamstring workouts/gi, value: 'hamstringpass' },
        { pattern: /beställ de/gi, value: 'beställ' },
        {
          pattern: /Visste du att\s*Nordbelt\s*ett viktigt hjälpmedel är vid hamstring-övningar\?/gi,
          value: 'Visste du att Nordbelt är ett viktigt hjälpmedel vid hamstringövningar?'
        }
      ]);
      return;
    }

    if (langRoot === 'it') {
      normalizeLocaleCopyNodes(root, [
        { pattern: /tendinopatia del tendine del ginocchio/gi, value: 'tendinopatia degli ischiocrurali' },
        { pattern: /tendinite del tendine del ginocchio/gi, value: 'tendinite degli ischiocrurali' },
        { pattern: /tendine del ginocchio/gi, value: 'ischiocrurali' },
        { pattern: /tendini del ginocchio/gi, value: 'ischiocrurali' }
      ]);
    }
  }

  function initBusinessPracticeNlCopyCleanup(scope) {
    if (!window.location || !/\/pages\/fysiopraktijken(?:\/)?$/.test(window.location.pathname)) return;
    var root = scope && scope.querySelectorAll ? scope : document;
    var platformName = 'Shop' + 'ify';
    var replacements = [
      [platformName + ' checkout · 30 dagen proberen', 'Veilig afrekenen · 30 dagen proberen'],
      ['actuele ' + platformName + '-prijs', 'actuele Nordbelt-prijs'],
      ['actuele ' + platformName + '-verkoopprijs', 'actuele Nordbelt-verkoopprijs'],
      ['automatisch uit ' + platformName + ' geladen', 'automatisch actueel gehouden op basis van de Nordbelt-productprijs'],
      ['Partnerzichtbaarheid of selectieve doorverwijzingen kunnen bij sommige grotere pakketten een aanvullende bonus zijn, maar zijn niet de hoofdreden om voor een pakket te kiezen.', 'Kies het pakket dat past bij je kamers, therapeuten, thuiscontinuatie en locaties. Bij passende partnerpakketten kan extra zichtbaarheid helpen om Nordbelt-klanten in jouw regio sneller naar je praktijk te leiden.'],
      ['Twijfel je tussen pakketten? Kies op basis van kamers, therapeuten, thuiscontinuatie en locaties — niet op basis van partnerextra’s.', 'Twijfel je tussen pakketten? Vergelijk kamers, therapeuten, thuiscontinuatie, locaties en zichtbaarheid bij passende partnerpakketten.'],
      ['Wat is partnerzichtbaarheid precies?', 'Hoe werkt zichtbaarheid bij Nordbelt-klanten?'],
      ['Dat is een optionele bonus bij sommige grotere trajecten. Zie het niet als hoofdreden om voor Nordbelt te kiezen; de kern blijft vaste beschikbaarheid in de praktijk, herkenbare thuiscontinuatie en schaalbare uitrol.', 'Bij passende partnerpakketten kunnen we je praktijk zichtbaar maken op Nordbelt-kanalen en meenemen wanneer klanten begeleiding of beoordeling in de buurt zoeken. We stemmen dit af op regio, hulpvraag en beschikbaarheid.'],
      ['Voor sommige grotere pakketten kunnen aanvullende zichtbaarheid of selectieve doorverwijzingen passend zijn. Zie dit als bonus, niet als hoofdreden om te bestellen.', 'Bij passende partnerpakketten kunnen we je praktijk zichtbaar maken op Nordbelt-kanalen en meenemen wanneer klanten begeleiding in de buurt zoeken.'],
      ['Bonus bij grotere trajecten, niet leidend in de keuze.', 'Word vindbaar voor Nordbelt-klanten in jouw regio.'],
      ['Bekijk mogelijke bonusopties', 'Bekijk zichtbaarheid'],
      ['Selectieve doorverwijzing', 'Relevante doorverwijzing'],
      ['Optionele partnerzichtbaarheid', 'Zichtbaarheid bij Nordbelt-klanten']
    ];

    function cleanValue(value) {
      if (!value) return value;
      var next = value;
      replacements.forEach(function (pair) {
        next = next.split(pair[0]).join(pair[1]);
      });
      return next;
    }

    root.querySelectorAll('script[type="application/ld+json"], script[type="application/json"]').forEach(function (script) {
      script.textContent = cleanValue(script.textContent);
    });

    var walkerRoot = root.body || root;
    if (!walkerRoot || !document.createTreeWalker) return;
    var walker = document.createTreeWalker(walkerRoot, NodeFilter.SHOW_TEXT);
    var nodes = [];
    var node;
    while ((node = walker.nextNode())) {
      if (node.nodeValue && node.nodeValue.trim()) nodes.push(node);
    }
    nodes.forEach(function (textNode) {
      var cleaned = cleanValue(textNode.nodeValue);
      if (cleaned !== textNode.nodeValue) textNode.nodeValue = cleaned;
    });
  }

  function initPracticeFunnelHeaderAndIdleCta() {
    var body = document.body;
    if (!body || body.getAttribute('data-page-handle') !== 'fysiopraktijken') return;

    var trialLink = document.querySelector('[data-nb-cta="business_page_hero_secondary"][href*="properties[_practice_segment]=practice"], [data-nb-cta="business_page_hero_primary"][href*="properties[_practice_segment]=practice"], [data-business-plan-key="trial-1"][href*="properties[_practice_segment]=practice"]');
    if (!trialLink) return;

    var trialHref = trialLink.getAttribute('href') || '';
    if (!trialHref) return;

    var path = (window.location.pathname || '').toLowerCase();
    var practiceTrialLabel = 'Bestel proef-Nordbelt';
    if (/^\/de(?:-|\/|$)/.test(path)) practiceTrialLabel = 'Test-Nordbelt bestellen';
    else if (/^\/en(?:-|\/|$)/.test(path)) practiceTrialLabel = 'Order trial Nordbelt';
    else if (/^\/fr(?:-|\/|$)/.test(path)) practiceTrialLabel = "Commander l'essai Nordbelt";
    else if (/^\/es(?:-|\/|$)/.test(path)) practiceTrialLabel = 'Pedir Nordbelt de prueba';
    else if (/^\/pt(?:-|\/|$)/.test(path)) practiceTrialLabel = 'Pedir Nordbelt de teste';
    else if (/^\/it(?:-|\/|$)/.test(path)) practiceTrialLabel = 'Ordina Nordbelt di prova';
    else if (/^\/fi(?:-|\/|$)/.test(path)) practiceTrialLabel = 'Tilaa testattava Nordbelt';
    else if (/^\/sv(?:-|\/|$)/.test(path)) practiceTrialLabel = 'Beställ test-Nordbelt';
    else if (/^\/da(?:-|\/|$)/.test(path)) practiceTrialLabel = 'Bestil test-Nordbelt';
    else if (/^\/nb(?:-|\/|$)/.test(path)) practiceTrialLabel = 'Bestill test-Nordbelt';
    else if (/^\/et(?:-|\/|$)/.test(path)) practiceTrialLabel = 'Telli test-Nordbelt';

    document.querySelectorAll('.nb-header__cta, .nb-mobile-quick-cta').forEach(function (link) {
      link.setAttribute('href', trialHref);
      var label = link.querySelector('span');
      if (label) label.textContent = practiceTrialLabel;
      else link.textContent = practiceTrialLabel;
      link.setAttribute('data-nb-cta', link.classList.contains('nb-mobile-quick-cta') ? 'header_practice_trial_mobile' : 'header_practice_trial');
    });

    var sticky = document.querySelector('[data-nb-practice-mobile-sticky]');
    if (!sticky || sticky.getAttribute('data-nb-idle-managed') === 'true') return;
    sticky.setAttribute('data-nb-idle-managed', 'true');
    body.classList.add('nb-practice-idle-sticky-managed');

    if (!document.getElementById('nb-practice-idle-sticky-style')) {
      var style = document.createElement('style');
      style.id = 'nb-practice-idle-sticky-style';
      style.textContent = '@media (max-width:840px){body.nb-practice-idle-sticky-managed{padding-bottom:0!important}body.nb-practice-idle-sticky-managed [data-nb-practice-mobile-sticky]{position:fixed!important;left:auto!important;right:.72rem!important;bottom:calc(env(safe-area-inset-bottom,0px) + .72rem)!important;z-index:38!important;width:auto!important;max-width:calc(100vw - 1.2rem)!important;transform:translateY(14px) scale(.98)!important;opacity:0!important;pointer-events:none!important;display:block!important;transition:transform 180ms ease,opacity 180ms ease!important}body.nb-practice-idle-sticky-managed [data-nb-practice-mobile-sticky].nb-practice-idle-visible{transform:translateY(0) scale(1)!important;opacity:1!important;pointer-events:auto!important}body.nb-practice-idle-sticky-managed [data-nb-practice-mobile-sticky] .nb-practice-mobile-sticky__button{display:inline-flex!important;align-items:center!important;justify-content:center!important;min-height:40px!important;padding:.53rem .76rem!important;border-radius:999px!important;border:1px solid rgba(255,255,255,.42)!important;background:linear-gradient(135deg,rgba(111,184,158,.98),rgba(50,112,146,.98)),#143a55!important;box-shadow:0 13px 28px rgba(10,33,51,.24)!important;color:#fff!important;font-family:\"Space Grotesk\",\"Avenir Next\",sans-serif!important;font-size:.78rem!important;font-weight:800!important;line-height:1!important;text-decoration:none!important;white-space:nowrap!important}}@media (min-width:841px){body.nb-practice-idle-sticky-managed [data-nb-practice-mobile-sticky]{display:none!important}}';
      document.head.appendChild(style);
    }

    while (sticky.firstChild) sticky.removeChild(sticky.firstChild);
    var stickyButton = document.createElement('a');
    stickyButton.className = 'nb-practice-mobile-sticky__button';
    stickyButton.href = trialHref;
    stickyButton.setAttribute('data-nb-cta', 'practice_mobile_idle_trial');
    stickyButton.textContent = practiceTrialLabel;
    sticky.appendChild(stickyButton);

    var media = window.matchMedia ? window.matchMedia('(max-width: 840px)') : null;
    var idleDelay = 4200;
    var idleTimer = 0;

    function setVisible(visible) {
      sticky.hidden = false;
      sticky.setAttribute('aria-hidden', visible ? 'false' : 'true');
      sticky.classList.toggle('nb-practice-idle-visible', visible);
      sticky.classList.toggle('is-visible', visible);
      body.classList.remove('has-practice-mobile-sticky');
    }

    function clearIdleTimer() {
      if (!idleTimer) return;
      window.clearTimeout(idleTimer);
      idleTimer = 0;
    }

    function isVisibleElement(element) {
      if (!element || sticky.contains(element)) return false;
      var rect = element.getBoundingClientRect();
      if (!rect.width || !rect.height) return false;
      return rect.bottom > 0 &&
        rect.top < (window.innerHeight || document.documentElement.clientHeight || 0) &&
        rect.right > 0 &&
        rect.left < (window.innerWidth || document.documentElement.clientWidth || 0);
    }

    function hasTrialCtaInView() {
      var candidates = document.querySelectorAll('a, button');
      for (var i = 0; i < candidates.length; i += 1) {
        var candidate = candidates[i];
        var text = (candidate.textContent || '').replace(/\s+/g, ' ').trim().toLowerCase();
        var href = (candidate.getAttribute('href') || '').toLowerCase();
        var looksLikeTrialCta = text.indexOf('bestel proef') !== -1 ||
          text.indexOf('test-nordbelt bestellen') !== -1 ||
          text.indexOf('order trial nordbelt') !== -1 ||
          text.indexOf("commander l'essai nordbelt") !== -1 ||
          text.indexOf('nordbelt de prueba') !== -1 ||
          text.indexOf('pedir nordbelt') !== -1 ||
          text.indexOf('nordbelt de teste') !== -1 ||
          text.indexOf('nordbelt di prova') !== -1 ||
          text.indexOf('testattava nordbelt') !== -1 ||
          text.indexOf('tilaa testattava') !== -1 ||
          text.indexOf('proef-nordbelt') !== -1 ||
          (href.indexOf('practice-trial') !== -1 && (
            text.indexOf('proef') !== -1 ||
            text.indexOf('test-nordbelt') !== -1 ||
            text.indexOf('trial nordbelt') !== -1 ||
            text.indexOf('essai nordbelt') !== -1 ||
            text.indexOf('prueba') !== -1 ||
            text.indexOf('teste') !== -1 ||
            text.indexOf('prova') !== -1 ||
            text.indexOf('testattava') !== -1
          ));
        if (looksLikeTrialCta && isVisibleElement(candidate)) return true;
      }
      return false;
    }

    function shouldShow() {
      return media && media.matches && !document.hidden && !hasTrialCtaInView();
    }

    function scheduleIdleReveal() {
      clearIdleTimer();
      if (!media || !media.matches) {
        setVisible(false);
        return;
      }
      idleTimer = window.setTimeout(function () {
        idleTimer = 0;
        if (shouldShow()) setVisible(true);
        else scheduleIdleReveal();
      }, idleDelay);
    }

    function registerActivity() {
      setVisible(false);
      scheduleIdleReveal();
    }

    setVisible(false);
    ['scroll', 'wheel', 'touchstart', 'touchmove', 'pointerdown', 'keydown'].forEach(function (eventName) {
      window.addEventListener(eventName, registerActivity, { passive: true });
    });
    window.addEventListener('resize', registerActivity, { passive: true });
    window.addEventListener('orientationchange', registerActivity, { passive: true });
    document.addEventListener('visibilitychange', registerActivity);
    scheduleIdleReveal();
  }

  function isMobileArticleRuntime() {
    var body = document.body;
    if (!body || body.getAttribute('data-page-type') !== 'article') return false;
    return !!(window.matchMedia && window.matchMedia('(max-width: 840px)').matches);
  }

  function scheduleRuntimeIdle(callback, delayMs, timeoutMs) {
    if (typeof callback !== 'function') return;
    window.setTimeout(function () {
      if ('requestIdleCallback' in window) {
        window.requestIdleCallback(callback, { timeout: Math.max(800, Number(timeoutMs || 2200)) });
      } else {
        window.setTimeout(callback, 16);
      }
    }, Math.max(0, Number(delayMs || 0)));
  }

  document.addEventListener('DOMContentLoaded', function () {
    var mobileArticleRuntime = isMobileArticleRuntime();
    initAdPlatformBridges();
    initCookieMiniBanner();
    initImageLoadingHints();
    localizeInternalAnchors(document);
    initSwedishKronaPriceFormatting();
    initConversionCtaRoutes();
    cleanupArticleEditorialNoise(document);
    initArticleHeroEnhancements(document);
    if (mobileArticleRuntime) {
      scheduleRuntimeIdle(function () {
        initArticleEditorialMedia(document);
        initArticleEditorialCallouts(document);
        initArticleTableOfContents(document);
      }, 260, 1800);
      scheduleRuntimeIdle(function () {
        initArticleInlineConversionBlocks(document);
        initArticleFaqEnhancements(document);
      }, 760, 2600);
      scheduleRuntimeIdle(function () {
        initArticleViewTracking(document);
        initArticleScrollDepthTracking(document);
        initCommercialSurfaceViewTracking(document);
        initCtaTracking();
        initBlogConversionTracking(document);
        initArticleInlineProductLinkTracking(document);
        initArticleMobileStickyCta(document);
        initBlogLocaleCopyHotfix(document);
      }, 1350, 4200);
    } else {
      initArticleEditorialMedia(document);
      initArticleEditorialCallouts(document);
      initArticleTableOfContents(document);
      initArticleInlineConversionBlocks(document);
      initArticleViewTracking(document);
      initArticleScrollDepthTracking(document);
      initArticleInlineProductLinkTracking(document);
    }
    initClarityRuntimeBridge();
    initViewItemTracking();
    initAtcTracking();
    initBeginCheckoutTracking();
    if (!mobileArticleRuntime) {
      initCommercialSurfaceViewTracking(document);
      initCtaTracking();
      initBlogConversionTracking(document);
    }
    initReveal();
    initMobileNav();
    initRuntimeSeoGuards();
    initAutoLocaleRouting();
    initAnnouncementAutoHide();
    initHeaderCompactState();
    initHeaderLocalization();
    restoreCartAfterLocaleSwitch();
    initFixedStackOffsets();
    if (!mobileArticleRuntime) initArticleFaqEnhancements(document);
    initFaq();
    injectHomepageFaqJsonLd(document);
    initArticleInlineProductLinkTracking(document);
    initGallery();
    initMobileStickyCta();
    initScrollTo();
    initGlobalMobileBuyCta();
    if (!mobileArticleRuntime) initArticleMobileStickyCta(document);
    initProductDescriptionToggle();
    initMobileProductDetailsToggle();
    initHeroAbRuntimeFix();
    initHeroTitleMaxLines(document);
    if (mobileArticleRuntime) {
      scheduleRuntimeIdle(function () {
        initFounderStoryMedia();
        initHomeGuideStepsRuntimePatch(document);
        initMobileVideoViewportAutoplay(document);
      }, 3200, 7000);
    } else {
      initFounderStoryMedia();
      initHomeGuideStepsRuntimePatch(document);
      initMobileVideoViewportAutoplay(document);
    }
    initBusinessPracticeNlCopyCleanup(document);
    initPracticeFunnelHeaderAndIdleCta();
    initFiReviewProofGoogleLabelFallback(document);
    if (!mobileArticleRuntime) initBlogLocaleCopyHotfix(document);
    initGlobalReserveTimer();
  });

  document.addEventListener('shopify:section:load', function (event) {
    if (!event || !event.target) return;
    initImageLoadingHints(event.target);
    localizeInternalAnchors(event.target);
    normalizeSwedishKronaPricesInScope(event.target);
    applyConversionCtaRoutes(event.target);
    applyConversionPreviewPaths(event.target);
    cleanupArticleEditorialNoise(event.target);
    initArticleEditorialMedia(event.target);
    initArticleHeroEnhancements(event.target);
    initArticleEditorialCallouts(event.target);
    initArticleTableOfContents(event.target);
    initArticleInlineConversionBlocks(event.target);
    initArticleViewTracking(event.target);
    initArticleScrollDepthTracking(event.target);
    initCtaTracking();
    initCommercialSurfaceViewTracking(event.target);
    initBlogConversionTracking(event.target);
    initArticleMobileStickyCta(event.target);
    initArticleFaqEnhancements(event.target);
    initFaq();
    injectHomepageFaqJsonLd(event.target);
    initArticleInlineProductLinkTracking(event.target);
    initHeroAbRuntimeFix();
    initHeroTitleMaxLines(event.target);
    initHomeGuideStepsRuntimePatch(event.target);
    initMobileVideoViewportAutoplay(event.target);
    initBusinessPracticeNlCopyCleanup(event.target);
    initPracticeFunnelHeaderAndIdleCta();
    try {
      initFiReviewProofGoogleLabelFallback(event.target);
    } catch (error) {
      // no-op
    }
    try {
      initBlogLocaleCopyHotfix(event.target);
    } catch (error) {
      // no-op
    }
  });

  function runReviewProofLabelSafety() {
    try {
      initFiReviewProofGoogleLabelFallback(document);
    } catch (error) {
      // no-op
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', runReviewProofLabelSafety, { once: true });
  } else {
    runReviewProofLabelSafety();
  }
  window.addEventListener('load', runReviewProofLabelSafety, { once: true });
})();

(function () {
  function isHomepage2Experience() {
    var root = document.documentElement;
    var body = document.body;
    if (root && root.getAttribute('data-nb-home-ab-variant') === 'b') return true;
    if (body && body.getAttribute('data-nb-home-ab-variant') === 'b') return true;
    if (body && body.getAttribute('data-page-handle') === 'homepage-2') return true;
    try {
      var params = new URLSearchParams(window.location.search || '');
      var forced = String(params.get('nb_home_ab') || params.get('nb_homepage_ab') || '').toLowerCase();
      if (forced === 'b' || forced === 'homepage2' || forced === 'homepage-2') return true;
    } catch (_error) {}
    return false;
  }

  function isArticlePageRuntime() {
    return !!(document.body && document.body.getAttribute('data-page-type') === 'article');
  }

  function getHomepage2Scope() {
    var panel = document.querySelector('[data-nb-home-ab-panel="b"], [data-nb-product-b-homepage2-panel], [data-nb-article-b-homepage2-panel]');
    if (panel) return panel;
    return document.querySelector('[id^="shopify-section-homepage-2"], [id^="nb-homepage-2-"]');
  }

  function ensureHomepage2MediaPreconnect() {
    if (!isHomepage2Experience()) return;
    return;
  }

  function bringHomepage2PanelForward(scope) {
    var panel = scope && scope.matches && scope.matches('[data-nb-home-ab-panel="b"]') ? scope : document.querySelector('[data-nb-home-ab-panel="b"]');
    var main = document.querySelector('main.nb-main-content');
    if (!panel || !main || main.firstElementChild === panel) return;
    try {
      main.insertBefore(panel, main.firstElementChild);
    } catch (_error) {}
  }

  function hydrateVideo(video) {
    if (!video) return;
    var changed = false;
    var sources = video.querySelectorAll('source');
    sources.forEach(function (source) {
      var src = source.getAttribute('data-nb-src') || source.getAttribute('data-src') || source.getAttribute('data-nb-home-ab-src') || '';
      if (src && source.getAttribute('src') !== src) {
        source.setAttribute('src', src);
        changed = true;
      }
    });
    video.muted = true;
    video.defaultMuted = true;
    video.playsInline = true;
    video.setAttribute('muted', '');
    video.setAttribute('playsinline', '');
    video.setAttribute('webkit-playsinline', 'true');
    video.setAttribute('data-nb-mobile-video-ignore', '');
    if (video.preload !== 'metadata') {
      video.preload = 'metadata';
      video.setAttribute('preload', 'metadata');
      changed = true;
    }
    if (changed || video.readyState < 3) {
      try { video.load(); } catch (_error) {}
    }
  }

  function isHomepage2PriorityVideo(video, index) {
    return !!(video && video.matches && video.matches('.nb-home2-step-video, [data-nb-home2-step-video], [data-nb-home2-guide-video], [data-nb-home2-team-video]'));
  }

  function prefersReducedHomepage2Media() {
    var connection = navigator.connection || navigator.mozConnection || navigator.webkitConnection;
    return !!(connection && connection.saveData);
  }

  function collectHomepage2Videos(scope) {
    var videos = Array.prototype.slice.call(scope ? scope.querySelectorAll('video') : []);
    var rankVideo = function (video) {
      if (!video || !video.matches) return 4;
      if (video.matches('.nb-home2-step-video, [data-nb-home2-step-video]')) return 0;
      if (video.matches('[data-nb-home2-guide-video]')) return 1;
      if (video.matches('[data-nb-home2-team-video]')) return 2;
      if (video.matches('[data-nb-home2-proof-video]')) return 3;
      return 3;
    };
    videos.sort(function (a, b) {
      var aPriority = rankVideo(a);
      var bPriority = rankVideo(b);
      if (aPriority !== bPriority) return aPriority - bPriority;
      var aTop = 0;
      var bTop = 0;
      try {
        aTop = a.getBoundingClientRect().top;
        bTop = b.getBoundingClientRect().top;
      } catch (_error) {}
      return aTop - bTop;
    });
    return videos;
  }

  function prewarmHomepage2GuideVideo() {
    if (!isHomepage2Experience() || prefersReducedHomepage2Media()) return;
    var scope = getHomepage2Scope();
    if (!scope || scope.getAttribute('data-nb-home2-guide-video-prewarmed') === 'true') return;
    var video = scope.querySelector('[data-nb-home2-guide-video]');
    if (!video) return;
    if (!isHomepage2VideoNearby(video)) return;
    bringHomepage2PanelForward(scope);
    scope.setAttribute('data-nb-home2-guide-video-prewarmed', 'true');
    hydrateVideo(video);
  }

  function isHomepage2VideoNearby(video) {
    var rect = video.getBoundingClientRect();
    var viewportHeight = window.innerHeight || document.documentElement.clientHeight || 0;
    if (rect.width <= 2 || rect.height <= 2) return false;
    return rect.top < viewportHeight + 320 && rect.bottom > -180;
  }

  function prewarmHomepage2Videos(mode) {
    if (!isHomepage2Experience()) return;
    var scope = getHomepage2Scope();
    if (!scope) return;
    bringHomepage2PanelForward(scope);
    var videos = collectHomepage2Videos(scope);
    if (!videos.length) return;
    var saveData = prefersReducedHomepage2Media();
    scope.setAttribute('data-nb-home2-video-prewarm-asset', 'true');
    videos.forEach(function (video, index) {
      var isPriority = isHomepage2PriorityVideo(video, index);
      if (saveData && !isPriority) return;
      if ((isPriority || mode === 'nearby') && isHomepage2VideoNearby(video)) hydrateVideo(video);
    });
  }

  function prewarmHomepage2AllVideosStaggered(force) {
    if (!isHomepage2Experience()) return;
    var scope = getHomepage2Scope();
    if (!scope || (!force && scope.getAttribute('data-nb-home2-all-videos-staggered') === 'true')) return;
    bringHomepage2PanelForward(scope);
    scope.setAttribute('data-nb-home2-all-videos-staggered', 'true');
    var videos = collectHomepage2Videos(scope);
    var saveData = prefersReducedHomepage2Media();
    var secondaryIndex = 0;
    videos.forEach(function (video, index) {
      var isPriority = isHomepage2PriorityVideo(video, index);
      if (saveData && !isPriority) return;
      var delay = isPriority ? Math.min(index * 140, 520) : 720 + (secondaryIndex * 340);
      if (!isPriority) secondaryIndex += 1;
      window.setTimeout(function () {
        if (!isHomepage2VideoNearby(video)) return;
        hydrateVideo(video);
      }, delay);
    });
  }

  function prewarmHomepage2ImagesStaggered() {
    if (!isHomepage2Experience()) return;
    var scope = getHomepage2Scope();
    if (!scope || scope.getAttribute('data-nb-home2-images-staggered') === 'true') return;
    scope.setAttribute('data-nb-home2-images-staggered', 'true');
    scope.nbHome2ImagePreloads = scope.nbHome2ImagePreloads || [];
    var images = scope.querySelectorAll('img');
    images.forEach(function (img, index) {
      window.setTimeout(function () {
        var dataSrc = img.getAttribute('data-src') || img.getAttribute('data-nb-src') || '';
        var dataSrcset = img.getAttribute('data-srcset') || img.getAttribute('data-nb-srcset') || '';
        img.loading = 'eager';
        img.setAttribute('loading', 'eager');
        img.decoding = 'async';
        try { img.fetchPriority = 'low'; } catch (_priorityErr) {}
        if (dataSrcset && !img.getAttribute('srcset')) img.setAttribute('srcset', dataSrcset);
        if (dataSrc && !img.getAttribute('src')) img.setAttribute('src', dataSrc);
        var src = img.currentSrc || img.getAttribute('src') || dataSrc;
        var srcset = img.getAttribute('srcset') || dataSrcset;
        if (src || srcset) {
          var preloader = new Image();
          preloader.decoding = 'async';
          try { preloader.fetchPriority = 'low'; } catch (_preloadPriorityErr) {}
          if (img.getAttribute('sizes')) preloader.sizes = img.getAttribute('sizes');
          if (srcset) preloader.srcset = srcset;
          if (src) preloader.src = src;
          scope.nbHome2ImagePreloads.push(preloader);
        }
        if (typeof img.decode === 'function') img.decode().catch(function () {});
      }, Math.min(index * 45, 1800));
    });
  }

  function afterHomepage2Lcp(callback, timeout) {
    var done = false;
    var observer = null;
    var finish = function () {
      if (done) return;
      done = true;
      try { if (observer) observer.disconnect(); } catch (_error) {}
      callback();
    };
    var timer = window.setTimeout(finish, timeout || 5200);
    if (!('PerformanceObserver' in window)) return;
    try {
      observer = new PerformanceObserver(function (list) {
        if (!list || !list.getEntries || !list.getEntries().length) return;
        window.clearTimeout(timer);
        window.setTimeout(finish, 120);
      });
      observer.observe({ type: 'largest-contentful-paint', buffered: true });
    } catch (_error) {}
  }

  function scheduleHomepage2AllMediaPrewarm() {
    if (!isHomepage2Experience()) return;
    var scope = getHomepage2Scope();
    if (!scope || scope.getAttribute('data-nb-home2-all-media-prewarm') === 'scheduled') return;
    scope.setAttribute('data-nb-home2-all-media-prewarm', 'scheduled');
    var run = function () {
      ensureHomepage2MediaPreconnect();
    };
    var runIdle = function () {
      if ('requestIdleCallback' in window) {
        window.requestIdleCallback(run, { timeout: 3200 });
      } else {
        window.setTimeout(run, 1800);
      }
    };
    if (document.readyState !== 'loading') {
      afterHomepage2Lcp(runIdle, 5200);
    } else {
      document.addEventListener('DOMContentLoaded', function () {
        afterHomepage2Lcp(runIdle, 5200);
      }, { once: true });
    }
    if (document.readyState === 'complete') {
      window.setTimeout(runIdle, 3600);
    } else {
      window.addEventListener('load', function () {
        window.setTimeout(runIdle, 3400);
      }, { once: true });
    }
    window.setTimeout(runIdle, 6500);
  }

  function observeHomepage2Videos() {
    if (!isHomepage2Experience() || !('IntersectionObserver' in window)) return;
    var scope = getHomepage2Scope();
    if (!scope || scope.getAttribute('data-nb-home2-video-observer-bound') === 'true') return;
    scope.setAttribute('data-nb-home2-video-observer-bound', 'true');
    var videos = scope.querySelectorAll('video');
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting && entry.intersectionRatio <= 0) return;
        var rect = entry.target.getBoundingClientRect();
        if (rect.width <= 2 || rect.height <= 2) return;
        hydrateVideo(entry.target);
        observer.unobserve(entry.target);
      });
    }, { rootMargin: '80px 0px 80px 0px', threshold: 0.01 });
    videos.forEach(function (video, index) {
      observer.observe(video);
    });
  }

  function scheduleHomepage2VideoPrewarm() {
    if (!isHomepage2Experience()) return;
    ensureHomepage2MediaPreconnect();
    var isArticlePage = isArticlePageRuntime();
    var runNearby = function () { prewarmHomepage2Videos('nearby'); };
    var runGuide = function () { prewarmHomepage2GuideVideo(); };
    window.setTimeout(observeHomepage2Videos, isArticlePage ? 1400 : 700);
    scheduleHomepage2AllMediaPrewarm();
    if (isArticlePage) return;
    ['scroll', 'pointerdown', 'touchstart', 'keydown'].forEach(function (eventName) {
      window.addEventListener(eventName, function () {
        runNearby();
        runGuide();
      }, { once: true, passive: true });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scheduleHomepage2VideoPrewarm, { once: true });
  } else {
    scheduleHomepage2VideoPrewarm();
  }
  window.addEventListener('nb:homepage-ab:rendered', scheduleHomepage2VideoPrewarm);
  window.addEventListener('nb:product-b-tail:rendered', scheduleHomepage2VideoPrewarm);
  window.addEventListener('nb:article-b-tail:rendered', scheduleHomepage2VideoPrewarm);
  window.addEventListener('pageshow', scheduleHomepage2VideoPrewarm);
})();

(function () {
  function isHomepage2() {
    var body = document.body;
    if (body && body.getAttribute('data-page-handle') === 'homepage-2') return true;
    return window.location && window.location.pathname.indexOf('/pages/homepage-2') !== -1;
  }

  function getLocaleRoot() {
    var pathPart = (window.location.pathname || '').replace(/^\/+/, '').split('/')[0].toLowerCase();
    if (pathPart.indexOf('-') !== -1) return pathPart.split('-')[0];
    if (/^(en|de|fr|es|pt|it|fi|sv|da|nb|et|nl)$/.test(pathPart)) return pathPart;
    var lang = (document.documentElement.getAttribute('lang') || 'nl').toLowerCase();
    return lang.split('-')[0] || 'nl';
  }

  function getReviewTitleHtml(localeRoot) {
    switch (localeRoot) {
      case 'en':
        return 'Check Nordbelt via <span class="nb-review-proof-fysio__title-accent">Trustpilot</span> and <span class="nb-review-proof-fysio__title-accent">Google Reviews</span>';
      case 'de':
        return 'Sehen Sie sich Nordbelt auf <span class="nb-review-proof-fysio__title-accent">Trustpilot</span> und <span class="nb-review-proof-fysio__title-accent">Google-Bewertungen</span> an';
      case 'fr':
        return 'Consultez Nordbelt sur <span class="nb-review-proof-fysio__title-accent">Trustpilot</span> et dans les <span class="nb-review-proof-fysio__title-accent">avis Google</span>';
      case 'sv':
        return 'Kontrollera Nordbelt via <span class="nb-review-proof-fysio__title-accent">Trustpilot</span> och <span class="nb-review-proof-fysio__title-accent">Google-recensioner</span>';
      case 'da':
        return 'Tjek Nordbelt via <span class="nb-review-proof-fysio__title-accent">Trustpilot</span> og <span class="nb-review-proof-fysio__title-accent">Google-anmeldelser</span>';
      case 'nb':
        return 'Sjekk Nordbelt på <span class="nb-review-proof-fysio__title-accent">Trustpilot</span> og i <span class="nb-review-proof-fysio__title-accent">Google-anmeldelser</span>';
      case 'fi':
        return 'Katso Nordbeltin arviot <span class="nb-review-proof-fysio__title-accent">Trustpilotissa</span> ja <span class="nb-review-proof-fysio__title-accent">Googlessa</span>';
      case 'pt':
        return 'Veja avaliações da Nordbelt no <span class="nb-review-proof-fysio__title-accent">Trustpilot</span> e no <span class="nb-review-proof-fysio__title-accent">Google</span>';
      case 'it':
        return 'Leggi le recensioni Nordbelt su <span class="nb-review-proof-fysio__title-accent">Trustpilot</span> e <span class="nb-review-proof-fysio__title-accent">Google</span>';
      case 'et':
        return 'Vaata Nordbelti arvustusi <span class="nb-review-proof-fysio__title-accent">Trustpilotis</span> ja <span class="nb-review-proof-fysio__title-accent">Google’is</span>';
      case 'es':
        return 'Consulta reseñas de Nordbelt en <span class="nb-review-proof-fysio__title-accent">Trustpilot</span> y <span class="nb-review-proof-fysio__title-accent">Google</span>';
      default:
        return 'Lees ervaringen op <span class="nb-review-proof-fysio__title-accent">Google</span> en <span class="nb-review-proof-fysio__title-accent">Trustpilot</span>';
    }
  }

  function syncHomepage2ReviewTitle(root) {
    if (!isHomepage2()) return;
    var scope = root && root.querySelector ? root : document;
    var section = scope.querySelector('#nb-review-proof-template--29456669180245__homepage_2_photo_backbone_r7, .nb-review-proof--fysio');
    if (!section) return;
    var title = section.querySelector('.nb-review-proof-fysio__title');
    if (title) {
      title.setAttribute('translate', 'no');
      title.setAttribute('data-no-translate', 'true');
      title.innerHTML = getReviewTitleHtml(getLocaleRoot());
    }
    Array.prototype.forEach.call(section.querySelectorAll('.practice-b2b-review-context'), function (node) {
      node.remove();
    });
  }

  function scheduleHomepage2ReviewTitleSync(root) {
    syncHomepage2ReviewTitle(root);
    window.setTimeout(function () { syncHomepage2ReviewTitle(root); }, 80);
    window.setTimeout(function () { syncHomepage2ReviewTitle(root); }, 450);
    window.setTimeout(function () { syncHomepage2ReviewTitle(root); }, 1200);
    window.setTimeout(function () { syncHomepage2ReviewTitle(root); }, 2600);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      scheduleHomepage2ReviewTitleSync(document);
    }, { once: true });
  } else {
    scheduleHomepage2ReviewTitleSync(document);
  }

  window.addEventListener('pageshow', function () {
    scheduleHomepage2ReviewTitleSync(document);
  });
  document.addEventListener('shopify:section:load', function (event) {
    scheduleHomepage2ReviewTitleSync(event && event.target ? event.target : document);
  });
})();

(function () {
  function getHomepage2Locale() {
    var first = (window.location.pathname || '').replace(/^\/+/, '').split('/')[0].toLowerCase();
    var root = first.split('-')[0];
    return /^(de|fr|es|pt|it|sv|da|nb|fi|et)$/.test(root) ? root : '';
  }

  function getHomepage2LocaleCopy(locale) {
    var copy = {
      de: ['Vor 17 Uhr bestellt: Versand noch heute', 'Sichere Zahlung', '20+ Physiopraxen', 'Für Praxen, Teams und Gruppen', 'Arbeitest du mit mehreren Sportlern?', 'Fordere einen Test-Nordbelt für deine Praxis an oder sieh dir Nordbelt für Sportvereine, Teams und Gyms an.', 'Physio', 'Für Physiopraxen', 'Nutze Nordbelt für Reha-Pläne, Performance-Blöcke und Nachbetreuung außerhalb des Behandlungsraums.', 'Test-Nordbelt für Physio anfragen', 'Für Sportvereine, Teams und Gyms', 'Mache Nordic Hamstring Curls skalierbar für Sportler, Kader und Gruppentraining ohne großes Setup.', 'Test-Nordbelt für Verein, Team oder Gym anfragen'],
      fr: ['Commandé avant 17 h : expédié aujourd’hui', 'Paiement sécurisé', '20+ cabinets de kiné', 'Pour cabinets, équipes et groupes', 'Tu travailles avec plusieurs sportifs ?', 'Demande un Nordbelt d’essai pour ton cabinet ou consulte Nordbelt pour clubs, équipes et salles.', 'Kiné', 'Pour cabinets de kiné', 'Utilise Nordbelt pour la rééducation, les blocs performance et le suivi hors cabinet.', 'Demander un Nordbelt d’essai pour kiné', 'Pour clubs, équipes et salles', 'Rends les Nordic Hamstring Curls pratiques pour sportifs, groupes et entraînements collectifs.', 'Demander un Nordbelt d’essai pour club, équipe ou salle'],
      es: ['Pedido hoy, entrega rápida', 'Pago seguro', '20+ clínicas de fisioterapia', 'Para clínicas, equipos y grupos', '¿Trabajas con varios deportistas?', 'Solicita un Nordbelt de prueba para tu clínica o consulta Nordbelt para clubes, equipos y gimnasios.', 'Fisio', 'Para clínicas de fisioterapia', 'Usa Nordbelt en rehabilitación, bloques de rendimiento y seguimiento fuera de la consulta.', 'Solicitar Nordbelt de prueba para fisio', 'Para clubes, equipos y gimnasios', 'Escala los Nordic Hamstring Curls para deportistas, plantillas y sesiones de grupo sin gran montaje.', 'Solicitar Nordbelt de prueba para club, equipo o gimnasio'],
      pt: ['Entrega rápida', 'Pagamento seguro', '20+ clínicas de fisioterapia', 'Para clínicas, equipas e grupos', 'Trabalha com vários atletas?', 'Peça um Nordbelt de teste para a sua clínica ou veja Nordbelt para clubes, equipas e ginásios.', 'Fisio', 'Para clínicas de fisioterapia', 'Use Nordbelt em reabilitação, blocos de performance e acompanhamento fora da sala de tratamento.', 'Pedir Nordbelt de teste para fisio', 'Para clubes, equipas e ginásios', 'Torne os Nordic Hamstring Curls escaláveis para atletas, equipas e treinos de grupo sem grande setup.', 'Pedir Nordbelt de teste para clube, equipa ou ginásio'],
      it: ['Consegna rapida', 'Pagamento sicuro', '20+ studi di fisioterapia', 'Per studi, squadre e gruppi', 'Lavori con più atleti?', 'Richiedi un Nordbelt di prova per il tuo studio o guarda Nordbelt per società sportive, squadre e palestre.', 'Fisio', 'Per studi di fisioterapia', 'Usa Nordbelt in percorsi di recupero, blocchi performance e follow-up fuori dallo studio.', 'Richiedi Nordbelt di prova per fisio', 'Per società sportive, squadre e palestre', 'Rendi i Nordic Hamstring Curl scalabili per atleti, squadre e sessioni di gruppo senza grandi attrezzature.', 'Richiedi Nordbelt di prova per società, squadra o palestra'],
      sv: ['Snabb leverans', 'Säker betalning', '20+ fysiokliniker', 'För kliniker, lag och grupper', 'Jobbar du med flera idrottare?', 'Be om en Nordbelt-test för din klinik eller se Nordbelt för klubbar, lag och gym.', 'Fysio', 'För fysiokliniker', 'Använd Nordbelt för rehabupplägg, prestationsblock och uppföljning utanför behandlingsrummet.', 'Be om test-Nordbelt för fysio', 'För klubbar, lag och gym', 'Skala Nordic Hamstring Curls för idrottare, trupper och gruppträning utan stor utrustning.', 'Be om test-Nordbelt för klubb, lag eller gym'],
      da: ['Hurtig levering', 'Sikker betaling', '20+ fysioterapiklinikker', 'Til klinikker, hold og grupper', 'Arbejder du med flere atleter?', 'Anmod om en test-Nordbelt til din klinik, eller se Nordbelt til klubber, hold og fitnesscentre.', 'Fysio', 'Til fysioterapiklinikker', 'Brug Nordbelt i genoptræningsforløb, performanceblokke og opfølgning uden for behandlingsrummet.', 'Anmod om test-Nordbelt til fysio', 'Til klubber, hold og fitnesscentre', 'Gør Nordic Hamstring Curls skalerbare for atleter, trupper og gruppetræning uden stort setup.', 'Anmod om test-Nordbelt til klub, hold eller fitnesscenter'],
      nb: ['Rask levering', 'Sikker betaling', '20+ fysioterapiklinikker', 'For klinikker, lag og grupper', 'Jobber du med flere utøvere?', 'Be om en prøve-Nordbelt til klinikken, eller se Nordbelt for klubber, lag og treningssentre.', 'Fysio', 'For fysioterapiklinikker', 'Bruk Nordbelt i rehabopplegg, prestasjonsblokker og oppfølging utenfor behandlingsrommet.', 'Be om prøve-Nordbelt for fysio', 'For klubber, lag og treningssentre', 'Skaler Nordic Hamstring Curls for utøvere, tropper og gruppetrening uten stort oppsett.', 'Be om prøve-Nordbelt for klubb, lag eller treningssenter'],
      fi: ['Nopea toimitus', 'Turvallinen maksu', '20+ fysioterapiaklinikkaa', 'Klinikoille, joukkueille ja ryhmille', 'Työskenteletkö useiden urheilijoiden kanssa?', 'Pyydä Nordbelt kokeiltavaksi klinikalle tai katso Nordbelt urheiluseuroille, joukkueille ja saleille.', 'Fysio', 'Fysioterapiaklinikoille', 'Käytä Nordbeltia kuntoutuksessa, suorituskykyjaksoissa ja seurannassa hoitohuoneen ulkopuolella.', 'Pyydä Nordbelt kokeiltavaksi fysiolle', 'Urheiluseuroille, joukkueille ja saleille', 'Skaalaa Nordic Hamstring Curlit urheilijoille, joukkueille ja ryhmäharjoitteluun ilman isoa laitteistoa.', 'Pyydä Nordbelt kokeiltavaksi seuralle, joukkueelle tai salille'],
      et: ['Kiire tarne', 'Turvaline makse', '20+ füsioteraapiakliinikut', 'Kliinikutele, tiimidele ja rühmadele', 'Töötad mitme sportlasega?', 'Küsi prooviks Nordbelt oma kliinikule või vaata Nordbelti spordiklubidele, tiimidele ja jõusaalidele.', 'Füsio', 'Füsioteraapiakliinikutele', 'Kasuta Nordbelti taastusravis, sooritusvõime plokkides ja järeltegevuses väljaspool raviruumi.', 'Küsi prooviks Nordbelt füsiolle', 'Spordiklubidele, tiimidele ja jõusaalidele', 'Tee Nordic Hamstring Curlid skaleeritavaks sportlastele, tiimidele ja rühmatreeningule ilma suure seadistuseta.', 'Küsi prooviks Nordbelt klubile, tiimile või jõusaalile']
    };
    var extra = {
      de: ['Lege den Nordbelt unter eine stabile Tür und führe ihn durch die Schnallen.', 'Schließe die Schnallen und stelle die Länge für die passende Passform ein.', 'Du bist fixiert. Zeit für Nordic Hamstring Curls und stärkere Hamstrings.', 'Sportphysio MSc'],
      fr: ['Place le Nordbelt sous une porte solide et fais-le passer dans les boucles.', 'Ferme les boucles et ajuste la longueur pour un bon maintien.', 'Tu es fixé. Place aux Nordic Hamstring Curls et à des ischios plus forts.', 'Kiné du sport MSc'],
      es: ['Coloca Nordbelt bajo una puerta resistente y pásalo por las hebillas.', 'Cierra las hebillas y ajusta la longitud para un ajuste correcto.', 'Ya estás sujeto. Hora de hacer Nordic Hamstring Curls y fortalecer los isquios.', 'Fisio deportivo MSc'],
      pt: ['Coloque o Nordbelt por baixo de uma porta resistente e passe-o pelas fivelas.', 'Feche as fivelas e ajuste o comprimento para um encaixe correto.', 'Está preso. Hora de fazer Nordic Hamstring Curls e fortalecer os isquiotibiais.', 'Fisio desportivo MSc'],
      it: ['Posiziona Nordbelt sotto una porta robusta e passalo attraverso le fibbie.', 'Chiudi le fibbie e regola la lunghezza per la vestibilità corretta.', 'Sei fissato. È il momento dei Nordic Hamstring Curl e di hamstring più forti.', 'Fisioterapista sportivo MSc'],
      sv: ['Placera Nordbelt under en stabil dörr och dra den genom spännena.', 'Klicka fast spännena och justera längden för rätt passform.', 'Du sitter fast. Dags för Nordic Hamstring Curls och starkare hamstrings.', 'Sportfysioterapeut MSc'],
      da: ['Placer Nordbelt under en stabil dør, og før den gennem spænderne.', 'Klik spænderne fast, og justér længden, så den passer.', 'Du sidder fast. Tid til Nordic Hamstring Curls og stærkere baglår.', 'Sportsfysioterapeut MSc'],
      nb: ['Plasser Nordbelt under en solid dør og trekk den gjennom spennene.', 'Klikk spennene fast og juster lengden for riktig passform.', 'Du sitter fast. Tid for Nordic Hamstring Curls og sterkere hamstrings.', 'Idrettsfysioterapeut MSc'],
      fi: ['Aseta Nordbelt tukevan oven alle ja pujota se solkien läpi.', 'Kiinnitä soljet ja säädä pituus sopivaksi.', 'Jalat ovat kiinni. Aika tehdä Nordic Hamstring Curleja ja vahvistaa takareisiä.', 'Urheilufysioterapeutti MSc'],
      et: ['Paiguta Nordbelt tugeva ukse alla ja tõmba see läbi pannalde.', 'Kinnita pandlad ja reguleeri pikkus sobivaks.', 'Oled fikseeritud. Aeg teha Nordic Hamstring Curle ja tugevdada tagareisi.', 'Spordifüsioterapeut MSc']
    };
    return copy[locale] && extra[locale] ? copy[locale].concat(extra[locale]) : copy[locale] || null;
  }

  function applyHomepage2LocaleCleanup(root) {
    var locale = getHomepage2Locale();
    var copy = getHomepage2LocaleCopy(locale);
    if (!root || !copy || !window.NodeFilter) return;
    var from = [
      'Voor 18:00 besteld, dezelfde dag verzonden',
      'Veilig betalen',
      '20+ fysiopraktijken',
      'For clinics, teams and groups',
      'Work with multiple athletes?',
      'Request a trial Nordbelt for your clinic or view Nordbelt for sports clubs, teams and gyms.',
      'Physio',
      'For physiotherapy clinics',
      'Use Nordbelt for rehab plans, performance blocks and follow-up outside the treatment room.',
      'Request trial Nordbelt for physio',
      'For sports clubs, teams and gyms',
      'Scale Nordic Hamstring Curls for athletes, squads and group training without a large setup.',
      'Request trial Nordbelt for sports club/team/gym',
      'Plaats de Nordbelt onder een stevige deur en trek deze door de gespen.',
      'Klik de gespen vast en stel de lengte af voor de perfecte pasvorm.',
      'Je zit vast. Tijd voor Nordic Hamstring Curls en sterke, blessurevrije hamstrings.',
      'Sportfysio MSc'
    ];
    var walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT);
    var nodes = [];
    while (walker.nextNode()) nodes.push(walker.currentNode);
    nodes.forEach(function (node) {
      var value = node.nodeValue;
      from.forEach(function (source, index) {
        if (value && value.indexOf(source) !== -1) value = value.split(source).join(copy[index]);
      });
      if (value !== node.nodeValue) node.nodeValue = value;
    });
  }

  function scheduleHomepage2LocaleCleanup(scope) {
    var root = (scope || document).querySelector('[id^="nb-homepage-2-"]');
    if (!root) return;
    applyHomepage2LocaleCleanup(root);
    window.setTimeout(function () { applyHomepage2LocaleCleanup(root); }, 180);
    window.setTimeout(function () { applyHomepage2LocaleCleanup(root); }, 900);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { scheduleHomepage2LocaleCleanup(document); }, { once: true });
  } else {
    scheduleHomepage2LocaleCleanup(document);
  }
  window.addEventListener('pageshow', function () { scheduleHomepage2LocaleCleanup(document); });
  document.addEventListener('shopify:section:load', function (event) { scheduleHomepage2LocaleCleanup(event && event.target ? event.target : document); });
})();

(function () {
  var fallbackTocIntervalId = 0;

  function text(value) {
    return String(value || '').replace(/\s+/g, ' ').trim();
  }

  function localeRoot() {
    var lang = String(document.documentElement.getAttribute('lang') || '').toLowerCase();
    if (lang) return lang.split('-')[0];
    var segment = String(window.location.pathname || '').split('/').filter(Boolean)[0] || '';
    return segment.toLowerCase().split('-')[0];
  }

  function labels() {
    var lang = localeRoot();
    var map = {
      nl: ['Leeswijzer', 'In dit artikel', 'Scan eerst de kernpunten en kies daarna je volgende stap.'],
      de: ['Überblick', 'In diesem Artikel', 'Scanne zuerst die wichtigsten Punkte und wähle dann deinen nächsten Schritt.'],
      fr: ['Repère', 'Dans cet article', 'Parcourez les points clés, puis choisissez votre prochaine étape.'],
      sv: ['Översikt', 'I den här artikeln', 'Skanna huvudpunkterna först och välj sedan nästa steg.'],
      da: ['Overblik', 'I denne artikel', 'Scan først hovedpunkterne og vælg derefter dit næste skridt.'],
      nb: ['Oversikt', 'I denne artikkelen', 'Skann hovedpunktene først og velg deretter neste steg.'],
      fi: ['Yleiskatsaus', 'Tässä artikkelissa', 'Silmäile ensin pääkohdat ja valitse seuraava askel.'],
      et: ['Ülevaade', 'Selles artiklis', 'Vaata esmalt põhipunkte ja vali seejärel järgmine samm.'],
      es: ['Guía rápida', 'En este artículo', 'Revisa primero los puntos clave y elige después el siguiente paso.'],
      it: ['Guida rapida', 'In questo articolo', 'Scorri prima i punti chiave e poi scegli il passo successivo.']
    };
    return map[lang] || ['Read guide', 'In this article', 'Scan the key points first, then choose your next step.'];
  }

  function slug(value, index) {
    var base = text(value)
      .toLowerCase()
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .replace(/[^a-z0-9]+/g, '-')
      .replace(/^-+|-+$/g, '');
    return base || ('article-section-' + String(index + 1));
  }

  function shortLabel(value) {
    var label = text(value).replace(/[.!?;:,]+$/g, '');
    if (label.length <= 38) return label;
    var candidate = label.split(/\s+(?:voor|van|over|bij|met|om|tegen|for|with|about|über|mit|für|sur|pour|med|til|con|per|para|sobre|di|del|della)\s+/i)[0];
    candidate = text(candidate);
    if (candidate.length >= 10 && candidate.length <= 38) return candidate;
    var trimmed = label.slice(0, 35);
    var lastSpace = trimmed.lastIndexOf(' ');
    if (lastSpace > 18) trimmed = trimmed.slice(0, lastSpace);
    return text(trimmed) + '…';
  }

  function ensureHeadingId(heading, index) {
    if (!heading) return '';
    var candidate = String(heading.id || '').trim() || ('article-' + slug(heading.textContent, index));
    var suffix = index + 1;
    while (candidate && document.getElementById(candidate) && document.getElementById(candidate) !== heading) {
      candidate = candidate.replace(/-\d+$/, '') + '-' + String(suffix);
      suffix += 1;
    }
    heading.id = candidate;
    heading.setAttribute('data-nb-article-anchor', '');
    return candidate;
  }

  function buildFallbackToc(articleRoot) {
    if (!articleRoot || articleRoot.querySelector('.nb-article-toc')) return;
    var rte = articleRoot.querySelector('[data-nb-article-rte], .nb-article__rte');
    if (!rte) return;
    var headings = Array.prototype.slice.call(rte.querySelectorAll('h2, h3')).filter(function (heading) {
      return !heading.closest('.nb-article-toc') && text(heading.textContent).length >= 3;
    });
    if (headings.length < 2) return;

    var selected = headings.filter(function (heading) {
      return String(heading.tagName || '').toUpperCase() === 'H2';
    });
    if (selected.length < 2) selected = headings.slice();
    selected = selected.slice(0, 6);

    var copy = labels();
    var toc = document.createElement('nav');
    toc.className = 'nb-card nb-article-toc nb-reveal is-visible is-rehab';
    toc.setAttribute('data-nb-generated', 'toc');
    toc.setAttribute('data-nb-toc-fallback', 'true');
    toc.setAttribute('aria-label', copy[1]);

    var header = document.createElement('div');
    header.className = 'nb-article-toc__header';
    var eyebrow = document.createElement('p');
    eyebrow.className = 'nb-article-toc__eyebrow';
    eyebrow.textContent = copy[0];
    var title = document.createElement('p');
    title.className = 'nb-article-toc__title';
    title.textContent = copy[1];
    var hint = document.createElement('p');
    hint.className = 'nb-article-toc__hint';
    hint.textContent = copy[2];
    header.appendChild(eyebrow);
    header.appendChild(title);
    header.appendChild(hint);
    toc.appendChild(header);

    var list = document.createElement('ol');
    list.className = 'nb-article-toc__list';
    selected.forEach(function (heading, index) {
      var targetId = ensureHeadingId(heading, index);
      if (!targetId) return;
      var item = document.createElement('li');
      item.className = 'nb-article-toc__item';
      var link = document.createElement('a');
      link.href = '#' + targetId;
      link.setAttribute('data-nb-article-toc-link', '');
      link.setAttribute('data-nb-cta', 'article_toc_jump');
      link.setAttribute('data-nb-slot-id', 'article_toc');
      link.setAttribute('data-nb-slot-type', 'toc');
      link.setAttribute('data-nb-slot-destination', 'article_section');
      link.setAttribute('data-nb-toc-target', targetId);
      var indexBadge = document.createElement('span');
      indexBadge.className = 'nb-article-toc__index';
      indexBadge.textContent = String(index + 1).padStart(2, '0');
      var label = document.createElement('span');
      label.className = 'nb-article-toc__label';
      label.textContent = shortLabel(heading.textContent);
      link.appendChild(indexBadge);
      link.appendChild(label);
      item.appendChild(link);
      list.appendChild(item);
    });
    if (!list.children.length) return;
    toc.appendChild(list);

    rte.insertBefore(toc, rte.firstElementChild || rte.firstChild);
    articleRoot.dataset.nbTocInjected = 'true';
  }

  function syncFallbackTocs(root) {
    var scope = root && root.querySelectorAll ? root : document;
    var roots = [];
    if (scope.matches && scope.matches('[data-nb-article-conversion]')) roots.push(scope);
    Array.prototype.push.apply(roots, scope.querySelectorAll('[data-nb-article-conversion]'));
    roots.forEach(function (articleRoot) {
      buildFallbackToc(articleRoot);
      if (!window.MutationObserver || articleRoot.getAttribute('data-nb-toc-fallback-observer') === 'true') return;
      articleRoot.setAttribute('data-nb-toc-fallback-observer', 'true');
      var scheduled = false;
      var observer = new MutationObserver(function () {
        if (scheduled) return;
        scheduled = true;
        window.setTimeout(function () {
          scheduled = false;
          buildFallbackToc(articleRoot);
        }, 80);
      });
      observer.observe(articleRoot, { childList: true, subtree: true });
      window.addEventListener('pagehide', function () {
        observer.disconnect();
      }, { once: true });
    });
  }

  function scheduleFallbackTocs(root) {
    syncFallbackTocs(root);
    window.setTimeout(function () { syncFallbackTocs(root); }, 150);
    window.setTimeout(function () { syncFallbackTocs(root); }, 900);
    window.setTimeout(function () { syncFallbackTocs(root); }, 2200);
    window.setTimeout(function () { syncFallbackTocs(root); }, 3800);
    window.setTimeout(function () { syncFallbackTocs(root); }, 6200);
    window.setTimeout(function () { syncFallbackTocs(root); }, 9000);
  }

  function runFallbackTocsDuringSettling() {
    if (fallbackTocIntervalId) return;
    var attempts = 0;
    fallbackTocIntervalId = window.setInterval(function () {
      attempts += 1;
      syncFallbackTocs(document);
      if (attempts >= 40 || !document.querySelector('[data-nb-article-conversion]')) {
        window.clearInterval(fallbackTocIntervalId);
        fallbackTocIntervalId = 0;
      }
    }, 500);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      scheduleFallbackTocs(document);
      runFallbackTocsDuringSettling();
    }, { once: true });
  } else {
    scheduleFallbackTocs(document);
    runFallbackTocsDuringSettling();
  }
  window.addEventListener('pageshow', function () {
    scheduleFallbackTocs(document);
    runFallbackTocsDuringSettling();
  });
  document.addEventListener('shopify:section:load', function (event) { scheduleFallbackTocs(event.target); });
})();

(function () {
  var DURATION_MS = 800;

  function getHeaderOffset() {
    var header = document.querySelector('.shopify-section-header, .nb-header, header');
    if (!header) return 10;
    var position = window.getComputedStyle(header).position;
    if (position !== 'fixed' && position !== 'sticky') return 10;
    return Math.max(10, Math.round(header.getBoundingClientRect().height) + 10);
  }

  function easeOutQuint(progress) {
    return 1 - Math.pow(1 - progress, 5);
  }

  function scrollWithCrescendo(destination) {
    var startY = window.scrollY || window.pageYOffset || 0;
    var distance = destination - startY;
    if (Math.abs(distance) < 2) return;
    var startTime = performance.now();

    function tick(now) {
      var progress = Math.min(1, (now - startTime) / DURATION_MS);
      window.scrollTo(0, startY + distance * easeOutQuint(progress));
      if (progress < 1) window.requestAnimationFrame(tick);
      else window.scrollTo(0, destination);
    }

    window.requestAnimationFrame(tick);
  }

  function initHomepage2StepsScroll(root) {
    var scope = root && root.querySelectorAll ? root : document;
    var sections = [];
    if (scope.matches && scope.matches('[id^="nb-homepage-2-"]')) sections.push(scope);
    Array.prototype.push.apply(sections, scope.querySelectorAll('[id^="nb-homepage-2-"]'));

    sections.forEach(function (section) {
      if (section.dataset.nbHome2StepsScrollBound === 'true') return;
      var target = section.querySelector('[id^="nb-home2-steps-"]');
      var triggers = section.querySelectorAll(
        'a[data-nb-cta="homepage_2_hero_steps"], a[data-nb-cta="homepage_2_mobile_steps"], a[data-nb-cta="homepage_2_final_steps"], a[href^="#nb-home2-steps-"]'
      );
      if (!target || !triggers.length) return;
      section.dataset.nbHome2StepsScrollBound = 'true';

      triggers.forEach(function (trigger) {
        trigger.addEventListener('click', function (event) {
          event.preventDefault();
          var pageY = window.scrollY || window.pageYOffset || 0;
          var destination = Math.max(0, pageY + target.getBoundingClientRect().top - getHeaderOffset());
          var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
          if (reduce) window.scrollTo(0, destination);
          else scrollWithCrescendo(destination);
        });
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initHomepage2StepsScroll(document); });
  } else {
    initHomepage2StepsScroll(document);
  }
  document.addEventListener('shopify:section:load', function (event) { initHomepage2StepsScroll(event.target); });
})();

(function () {
  var TARGET_SCORE = '4.3/5';
  var OLD_TRUSTPILOT_SCORE = '4.2/5';

  function isTrustpilotScoreNode(node) {
    if (!node) return false;
    if (node.matches && node.matches('[data-nb-proof-rating]')) return true;
    var trustpilotSummary = node.closest && node.closest('.nb-review-proof-fysio__summary-item--trustpilot');
    if (trustpilotSummary) return true;
    var trustpilotCard = node.closest && node.closest('[data-nb-review-card="trustpilot"], .nb-review-proof-card--trustpilot');
    if (trustpilotCard) return true;
    var ratingRow = node.closest && node.closest('.nb-rating-row');
    if (ratingRow) return true;
    return false;
  }

  function normalizeTrustpilotScores(root) {
    var scope = root && root.querySelectorAll ? root : document;
    var nodes = scope.querySelectorAll('.nb-review-proof-score, .nb-review-proof-fysio__summary-score, [data-nb-proof-rating], .nb-rating-row strong');
    nodes.forEach(function (node) {
      if (!isTrustpilotScoreNode(node)) return;
      if ((node.textContent || '').trim() === OLD_TRUSTPILOT_SCORE) {
        node.textContent = TARGET_SCORE;
      }
      if (node.getAttribute && node.getAttribute('data-variant-a') === OLD_TRUSTPILOT_SCORE) {
        node.setAttribute('data-variant-a', TARGET_SCORE);
      }
    });
  }

  function scheduleTrustpilotScoreNormalize(root) {
    normalizeTrustpilotScores(root);
    window.setTimeout(function () { normalizeTrustpilotScores(root); }, 80);
    window.setTimeout(function () { normalizeTrustpilotScores(root); }, 400);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { scheduleTrustpilotScoreNormalize(document); });
  } else {
    scheduleTrustpilotScoreNormalize(document);
  }
  window.addEventListener('pageshow', function () { scheduleTrustpilotScoreNormalize(document); });
  document.addEventListener('shopify:section:load', function (event) { scheduleTrustpilotScoreNormalize(event.target); });
})();

(function () {
  var ARTICLE_HANDLE = 'hamstring-training-protocol-fysiotherapie';
  var SOURCE_INTRO = 'A hamstring training protocol for physiotherapy should not be a rigid calendar plan';

  function normalizedText(value) {
    return String(value || '').replace(/\s+/g, ' ').trim();
  }

  function isSourceIntro(value) {
    return normalizedText(value).indexOf(SOURCE_INTRO) === 0;
  }

  function fixLocalizedArticleDeckFromBody() {
    var articleRoot = document.querySelector('[data-nb-article-slug="' + ARTICLE_HANDLE + '"]');
    if (!articleRoot) return;

    var deck = document.querySelector('.nb-article__deck');
    var bodyIntro = document.querySelector('.nb-article__rte p');
    if (!deck || !bodyIntro) return;

    var deckText = normalizedText(deck.textContent);
    var bodyText = normalizedText(bodyIntro.textContent);
    if (!deckText || !bodyText || isSourceIntro(bodyText)) return;
    if (isSourceIntro(deckText)) deck.textContent = bodyText;
  }

  function scheduleLocalizedArticleDeckFix() {
    fixLocalizedArticleDeckFromBody();
    window.setTimeout(fixLocalizedArticleDeckFromBody, 120);
    window.setTimeout(fixLocalizedArticleDeckFromBody, 700);
    window.setTimeout(fixLocalizedArticleDeckFromBody, 1800);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scheduleLocalizedArticleDeckFix, { once: true });
  } else {
    scheduleLocalizedArticleDeckFix();
  }
  window.addEventListener('pageshow', scheduleLocalizedArticleDeckFix);
  document.addEventListener('shopify:section:load', scheduleLocalizedArticleDeckFix);
})();

(function () {
  var LOCALIZED_ARTICLE_LANGS = {
    nl: true,
    de: true,
    fr: true,
    sv: true,
    da: true,
    nb: true,
    fi: true,
    pt: true,
    it: true,
    et: true,
    es: true
  };

  function normalizeTitleText(value) {
    return String(value || '').replace(/\s+/g, ' ').trim();
  }

  function firstPathSegment() {
    return String(window.location.pathname || '').split('/').filter(Boolean)[0] || '';
  }

  function routeLocaleRoot() {
    var segment = firstPathSegment().toLowerCase();
    if (!segment) return '';
    if (segment.indexOf('-') !== -1) return segment.split('-')[0];
    return segment;
  }

  function isLocalizedArticleRoute() {
    var host = String(window.location.hostname || '').toLowerCase();
    if (host.indexOf('nordbelt.nl') !== -1) return true;
    var localeRoot = routeLocaleRoot();
    return Boolean(localeRoot && localeRoot !== 'en' && LOCALIZED_ARTICLE_LANGS[localeRoot]);
  }

  function setTitleMeta(selector, value) {
    var nodes = document.querySelectorAll(selector);
    for (var i = 0; i < nodes.length; i += 1) {
      nodes[i].setAttribute('content', value);
    }
  }

  function syncLocalizedArticleDocumentTitle() {
    if (!isLocalizedArticleRoute()) return;
    var articleTitle = normalizeTitleText(document.querySelector('.nb-article__title') && document.querySelector('.nb-article__title').textContent);
    if (!articleTitle) return;
    var currentTitle = normalizeTitleText(document.title);
    if (currentTitle.toLowerCase().indexOf(articleTitle.toLowerCase()) === 0) return;

    var nextTitle = articleTitle + ' | Nordbelt™';
    document.title = nextTitle;
    setTitleMeta('meta[property="og:title"]', nextTitle);
    setTitleMeta('meta[name="twitter:title"]', nextTitle);
  }

  function scheduleLocalizedArticleDocumentTitleSync() {
    syncLocalizedArticleDocumentTitle();
    window.setTimeout(syncLocalizedArticleDocumentTitle, 120);
    window.setTimeout(syncLocalizedArticleDocumentTitle, 700);
    window.setTimeout(syncLocalizedArticleDocumentTitle, 1800);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scheduleLocalizedArticleDocumentTitleSync, { once: true });
  } else {
    scheduleLocalizedArticleDocumentTitleSync();
  }
  window.addEventListener('pageshow', scheduleLocalizedArticleDocumentTitleSync);
  document.addEventListener('shopify:section:load', scheduleLocalizedArticleDocumentTitleSync);
})();

(function () {
  var ARTICLE_HOME_TAIL_SECTION_PAIRS = [
    ['home_hero', 'hero'],
    ['home_proof', 'proof'],
    ['home_guide_steps', 'home_guide_steps'],
    ['home_objections', 'objections'],
    ['home_nhc_benefits_shield', 'nhc_benefits_shield'],
    ['home_reviews', 'reviews'],
    ['home_video_proof', 'video_proof'],
    ['home_benefits', 'benefits'],
    ['home_founder_story', 'founder_story'],
    ['home_guide_showcase_home', 'guide_showcase_home'],
    ['home_feature', 'feature'],
    ['home_mosaic', 'mosaic'],
    ['home_faq', 'faq']
  ];

  function normalizeArticleText(value) {
    return String(value || '').replace(/\s+/g, ' ').trim();
  }

  function isArticlePage() {
    return document.body && document.body.getAttribute('data-page-type') === 'article';
  }

  function hasArticleHomeTail() {
    if (!isArticlePage()) return true;
    return Boolean(document.querySelector('body[data-page-type="article"] .nb-main-content > .shopify-section[id*="__home_"], body[data-page-type="article"] main > .shopify-section[id*="__home_"]'));
  }

  function currentLocaleHomePath() {
    var parts = String(window.location.pathname || '').split('/').filter(Boolean);
    var first = String(parts[0] || '').toLowerCase();
    if (first && first !== 'blogs' && first !== 'blog-posts') return '/' + parts[0] + '/';
    return '/';
  }

  function homeTailTarget() {
    return document.querySelector('body[data-page-type="article"] .nb-main-content, body[data-page-type="article"] main');
  }

  function articleSectionPrefix() {
    var mainSection = document.querySelector('body[data-page-type="article"] .shopify-section[id*="__main"]');
    var id = mainSection && mainSection.id ? String(mainSection.id) : '';
    return id.replace(/__main$/, '') || 'shopify-section-template--article';
  }

  function findHomepageSection(doc, sourceKey) {
    var selectorKey = '__' + sourceKey;
    var sections = doc.querySelectorAll('.shopify-section[id*="__"]');
    for (var i = 0; i < sections.length; i += 1) {
      if (String(sections[i].id || '').indexOf(selectorKey) !== -1) return sections[i];
    }
    return null;
  }

  function appendHomepageTailFromHtml(html) {
    if (hasArticleHomeTail()) return false;
    var target = homeTailTarget();
    if (!target || !html) return false;

    var doc = new DOMParser().parseFromString(html, 'text/html');
    var prefix = articleSectionPrefix();
    var fragment = document.createDocumentFragment();
    var appended = 0;

    for (var i = 0; i < ARTICLE_HOME_TAIL_SECTION_PAIRS.length; i += 1) {
      var targetKey = ARTICLE_HOME_TAIL_SECTION_PAIRS[i][0];
      var sourceKey = ARTICLE_HOME_TAIL_SECTION_PAIRS[i][1];
      var source = findHomepageSection(doc, sourceKey);
      if (!source) continue;
      var clone = source.cloneNode(true);
      clone.id = prefix + '__' + targetKey;
      clone.setAttribute('data-nb-article-home-tail-fallback', 'true');
      fragment.appendChild(clone);
      appended += 1;
    }

    if (!appended) return false;
    target.appendChild(fragment);
    initCommercialSurfaceViewTracking(target);
    initBlogConversionTracking(target);
    document.documentElement.setAttribute('data-nb-article-home-tail-fallback', 'loaded');
    return true;
  }

  function installArticleHomeTailFallback() {
    if (!isArticlePage() || hasArticleHomeTail()) return;
    if (document.documentElement.getAttribute('data-nb-article-home-tail-fallback') === 'loading') return;
    if (document.documentElement.getAttribute('data-nb-article-home-tail-fallback') === 'loaded') return;
    if (!window.fetch || !window.DOMParser) return;

    document.documentElement.setAttribute('data-nb-article-home-tail-fallback', 'loading');
    var homeUrl = currentLocaleHomePath();
    var separator = homeUrl.indexOf('?') === -1 ? '?' : '&';
    window.fetch(homeUrl + separator + 'nb_article_home_tail=' + String(Date.now()), {
      credentials: 'same-origin'
    })
      .then(function (response) {
        return response && response.ok ? response.text() : '';
      })
      .then(function (html) {
        var loaded = appendHomepageTailFromHtml(html);
        if (!loaded) document.documentElement.removeAttribute('data-nb-article-home-tail-fallback');
      })
      .catch(function () {
        document.documentElement.removeAttribute('data-nb-article-home-tail-fallback');
      });
  }

  function removeRepeatedArticleHeroIntro() {
    var articleRoot = document.querySelector('[data-nb-article-conversion], .nb-article');
    if (!articleRoot) return;
    var rte = articleRoot.querySelector('.nb-article__rte');
    var deck = articleRoot.querySelector('.nb-article__deck');
    if (!rte || !deck) return;

    var deckText = normalizeArticleText(deck.textContent);
    if (!deckText) return;

    var children = Array.prototype.slice.call(rte.children || []).slice(0, 8);
    for (var i = 0; i < children.length; i += 1) {
      var block = children[i];
      if (!block || (block.classList && block.classList.contains('nb-article-toc'))) continue;
      var blockText = normalizeArticleText(block.textContent);
      if (!blockText) continue;
      if (deckText === blockText || deckText.indexOf(blockText) === 0 || blockText.indexOf(deckText) === 0) {
        block.remove();
        return;
      }
    }
  }

  function cleanupArticleTemplateCacheArtifacts(root) {
    removeRepeatedArticleHeroIntro();
  }

  function scheduleArticleTemplateCacheCleanup(root) {
    cleanupArticleTemplateCacheArtifacts(root);
    installArticleHomeTailFallback();
    window.setTimeout(function () {
      cleanupArticleTemplateCacheArtifacts(root);
      installArticleHomeTailFallback();
    }, 120);
    window.setTimeout(function () {
      cleanupArticleTemplateCacheArtifacts(root);
      installArticleHomeTailFallback();
    }, 700);
    window.setTimeout(function () {
      cleanupArticleTemplateCacheArtifacts(root);
      installArticleHomeTailFallback();
    }, 1800);
  }

  function installArticleTemplateCacheObserver() {
    if (!window.MutationObserver) return;
    var articleRoot = document.querySelector('[data-nb-article-conversion], .nb-article');
    if (!articleRoot || articleRoot.getAttribute('data-nb-template-cache-observer') === 'true') return;
    articleRoot.setAttribute('data-nb-template-cache-observer', 'true');
    var scheduled = false;
    var observer = new MutationObserver(function () {
      if (scheduled) return;
      scheduled = true;
      window.setTimeout(function () {
        scheduled = false;
        cleanupArticleTemplateCacheArtifacts(document);
      }, 40);
    });
    observer.observe(articleRoot, {
      childList: true,
      subtree: true,
      characterData: true
    });
    window.addEventListener('pagehide', function () {
      observer.disconnect();
    }, { once: true });
    window.setTimeout(function () {
      cleanupArticleTemplateCacheArtifacts(document);
    }, 3200);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      scheduleArticleTemplateCacheCleanup(document);
    }, { once: true });
  } else {
    scheduleArticleTemplateCacheCleanup(document);
  }
  installArticleTemplateCacheObserver();

  window.addEventListener('pageshow', function () {
    scheduleArticleTemplateCacheCleanup(document);
    installArticleTemplateCacheObserver();
  });
document.addEventListener('shopify:section:load', function (event) {
    scheduleArticleTemplateCacheCleanup(event && event.target ? event.target : document);
    installArticleTemplateCacheObserver();
  });
})();

(function () {
  var STYLE_ID = 'nb-home2-runtime-crop-20260618-r2';

  function isHomepage2() {
    return document.body && document.body.getAttribute('data-page-handle') === 'homepage-2';
  }

  function installHomepage2MobileHeroCrop() {
    if (!isHomepage2() || document.getElementById(STYLE_ID)) return;
    var style = document.createElement('style');
    style.id = STYLE_ID;
    style.textContent = [
      '@media (max-width:840px){',
      'html body.nb-theme[data-page-handle="homepage-2"] #nb-homepage-2-homepage-2-backbone-photo-r10.nb-home2 .nb-home2-hero__media,',
      'html body.nb-theme[data-page-handle="homepage-2"] .nb-home-ab-homepage2-panel[data-nb-home-ab-direct-b="true"] .nb-home2-hero__media{height:clamp(430px,112vw,470px)!important;margin-bottom:-6rem!important}',
      'html body.nb-theme[data-page-handle="homepage-2"] #nb-homepage-2-homepage-2-backbone-photo-r10.nb-home2 .nb-home2-hero__media::after,',
      'html body.nb-theme[data-page-handle="homepage-2"] .nb-home-ab-homepage2-panel[data-nb-home-ab-direct-b="true"] .nb-home2-hero__media::after{bottom:-30px!important;height:24%!important}',
      'html body.nb-theme[data-page-handle="homepage-2"] .nb-home-ab-homepage2-panel[data-nb-home-ab-direct-b="true"] .nb-home2-hero__media img{transform:translate3d(0,4px,0) scale(1.32)!important}',
      '}',
      '@media (min-width:841px) and (max-width:1079px){',
      'html body.nb-theme[data-page-handle="homepage-2"] #nb-homepage-2-homepage-2-backbone-photo-r10.nb-home2 .nb-home2-hero__media::before,',
      'html body.nb-theme[data-page-handle="homepage-2"] #nb-homepage-2-homepage-2-backbone-photo-r10.nb-home2 .nb-home2-hero__media::after,',
      'html body.nb-theme[data-page-handle="homepage-2"] #nb-homepage-2-homepage-2-backbone-photo-r9.nb-home2 .nb-home2-hero__media::before,',
      'html body.nb-theme[data-page-handle="homepage-2"] #nb-homepage-2-homepage-2-backbone-photo-r9.nb-home2 .nb-home2-hero__media::after,',
      'html body.nb-theme[data-page-handle="homepage-2"] .nb-home-ab-homepage2-panel[data-nb-home-ab-direct-b="true"] .nb-home2-hero__media::before,',
      'html body.nb-theme[data-page-handle="homepage-2"] .nb-home-ab-homepage2-panel[data-nb-home-ab-direct-b="true"] .nb-home2-hero__media::after{content:none!important;display:none!important;background:none!important;-webkit-mask-image:none!important;mask-image:none!important}',
      '}'
    ].join('');
    document.head.appendChild(style);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', installHomepage2MobileHeroCrop, { once: true });
  } else {
    installHomepage2MobileHeroCrop();
  }
  window.addEventListener('pageshow', installHomepage2MobileHeroCrop);
  document.addEventListener('shopify:section:load', installHomepage2MobileHeroCrop);
})();
